"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }// src/i18n/get-pluralized-form.ts
var get_pluralized_form_default = {
  /**
   * @param {number} count - Count of items
   * @returns {number}
   * 0 for 1, 21, ...
   * 1 for 2-4, 22-24, ...
   * 2 for 5-20, 25-30, ...
   */
  ru(count) {
    let remainder = count % 100;
    if (remainder >= 10 && remainder < 20) {
      return 2;
    }
    remainder = remainder % 10;
    if (remainder === 1) {
      return 0;
    }
    if (remainder > 1 && remainder < 5) {
      return 1;
    }
    return 2;
  },
  /**
   * @param {number} count - Count of items
   * @returns {number}
   * 0 for 1
   * 1 for 2-...
   */
  default(count) {
    return count === 1 ? 0 : 1;
  }
};

// src/i18n/translations.ts
var _flat = require('flat'); var _flat2 = _interopRequireDefault(_flat);

// src/i18n/surveys.json
var surveys_default = {
  am: {
    poll: {
      "attach.image.notLess": "\u121D\u1235\u1209\u1295 \u1262\u12EB\u1295\u1235 \u1208 %1 \u12ED\u1218\u120D\u12A8\u1271 \u12A5\u1293 \u1325\u1242\u1275 \u1325\u12EB\u1244\u12CE\u127D\u1295 \u12ED\u1218\u120D\u1231",
      "attach.image.notMore": "\u121D\u1235\u1209\u1295 \u1208 %1 \u12ED\u1218\u120D\u12A8\u1271 \u12A5\u1293 \u1325\u1242\u1275 \u1325\u12EB\u1244\u12CE\u127D\u1295 \u12ED\u1218\u120D\u1231",
      "attach.text.notLess": "\u133D\u1211\u1349\u1295 \u1262\u12EB\u1295\u1235 \u1208 %1 \u12ED\u1218\u120D\u12A8\u1271 \u12A5\u1293 \u1325\u1242\u1275 \u1325\u12EB\u1244\u12CE\u127D\u1295 \u12ED\u1218\u120D\u1231",
      "attach.text.notMore": "\u133D\u1211\u1349\u1295 \u1208 %1 \u12EB\u1295\u1265\u1261 \u12A5\u1293 \u1325\u1242\u1275 \u1325\u12EB\u1244\u12CE\u127D\u1295 \u12ED\u1218\u120D\u1231",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "\u126A\u12F2\u12EE\u12CD\u1295 \u1262\u12EB\u1295\u1235 \u1208 %1 \u12ED\u1218\u120D\u12A8\u1271 \u12A5\u1293 \u1325\u1242\u1275 \u1325\u12EB\u1244\u12CE\u127D\u1295 \u12ED\u1218\u120D\u1231",
      "attach.video.notMore": "\u126A\u12F2\u12EE\u12CD\u1295 \u1208 %1 \u12ED\u1218\u120D\u12A8\u1271 \u12A5\u1293 \u1325\u1242\u1275 \u1325\u12EB\u1244\u12CE\u127D\u1295 \u12ED\u1218\u120D\u1231",
      "attach.video.waitEnd": "\u126A\u12F2\u12EE\u12CD\u1295 \u12A5\u1235\u12A8 \u1218\u1328\u1228\u123B\u12CD \u12ED\u1218\u120D\u12A8\u1271 \u12A5\u1293 \u1325\u1242\u1275 \u1325\u12EB\u1244\u12CE\u127D\u1295 \u12ED\u1218\u120D\u1231",
      "attach.watch": "\u12ED\u1218\u120D\u12A8\u1271",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "\u120C\u120B \u1290\u1308\u122D",
      "commonComponents.choice.chooseLessEqualMore": [
        "\u12ED\u121D\u1228\u1321 %s \u1218\u120D\u1235",
        "\u12ED\u121D\u1228\u1321 %s \u1218\u120D\u1236\u127D",
        "\u12ED\u121D\u1228\u1321%\u1218\u120D\u1235",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "\u1262\u12EB\u1295\u1235 %s \u1218\u120D\u1235 \u12ED\u121D\u1228\u1321",
        "\u1262\u12EB\u1295\u1235 %s \u1218\u120D\u1236\u127D\u1295 \u12ED\u121D\u1228\u1321",
        "\u1262\u12EB\u1295\u1235 %s \u1218\u120D\u1236\u127D\u1295 \u12ED\u121D\u1228\u1321",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "\u12A8 %s \u12EB\u120B\u1290\u1230 \u12A5\u1293 \u12A8 %s \u12EB\u120D\u1260\u1208\u1320 \u12ED\u121D\u1228\u1321",
      "commonComponents.choice.chooseNoMore": [
        "\u12A5\u1263\u12AD\u1205 %s \u1218\u120D\u1235 \u1265\u127B \u12ED\u121D\u1228\u1321",
        "\u12A5\u1263\u12AD\u12CE \u12A8 %s \u12EB\u120D\u1260\u1208\u1321 \u1218\u120D\u1236\u127D\u1295 \u12ED\u121D\u1228\u1321",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "\u133D\u1211\u134D \u12EB\u1235\u1308\u1261",
      "commonComponents.choice.yourComment": "\u12A0\u1235\u1270\u12EB\u12E8\u1275\u12CE\u1295 \u12EB\u1235\u1308\u1261...",
      "commonComponents.scale.chooseRate": "\u12A5\u1263\u12AD\u12CE \u12F0\u1228\u1303 \u12ED\u1235\u1321",
      "commonComponents.scale.firstElement": "\u12E8\u1218\u1300\u1218\u122A\u12EB\u12CD \u12A0\u121B\u122B\u132D  %s  \u121B\u1208\u1275 \u1290\u12CD",
      "commonComponents.scale.lastElement": "\u12E8\u1218\u1328\u1228\u123B\u12CD \u12A0\u121B\u122B\u132D%s \u121B\u1208\u1275 \u1290\u12CD",
      "commonComponents.table.chooseNoMore": [
        "\u1260\u1270\u12A8\u1273\u1273\u12ED \u12A8 %s \u1260\u120B\u12ED \u1218\u120D\u1235 \u12A0\u12ED\u121D\u1228\u1321",
        "\u1260\u1270\u12A8\u1273\u1273\u12ED \u12A8 %s \u1260\u120B\u12ED \u1218\u120D\u1236\u127D\u1295 \u12A0\u12ED\u121D\u1228\u1321",
        "\u1260\u1270\u12A8\u1273\u1273\u12ED \u12A8 %s \u1260\u120B\u12ED \u1218\u120D\u1236\u127D\u1295 \u12A0\u12ED\u121D\u1228\u1321",
        ""
      ],
      "defaults.agree": "\u1219\u1209 \u1260\u1219\u1209 \u12A5\u1235\u121B\u121B\u1208\u1201",
      "defaults.back": "\u1270\u1218\u1208\u1235",
      "defaults.datePlaceholder": "\u1240\u1240.\u12C8\u12C8.\u12D3\u12D3\u12D3\u12D3",
      "defaults.disagree": "\u1219\u1209 \u1260\u1219\u1209 \u12A0\u120D\u1235\u121B\u121B\u121D",
      "defaults.dualChoice.label": "\u12A0\u1218\u120D\u12AB\u127D \u1233\u1325\u1295  ",
      "defaults.emoji1": "\u12A0\u1235\u1240\u12EB\u121A",
      "defaults.emoji2": "\u1218\u1325\u134E",
      "defaults.emoji3": "\u1218\u12F0\u1260\u129B",
      "defaults.emoji4": "\u1325\u1229",
      "defaults.emoji5": "\u134D\u1339\u121D",
      "defaults.next": "\u1240\u1323\u12ED",
      "defaults.noAnswer": "\u12A8\u120B\u12ED \u12A8\u1270\u1320\u1240\u1231\u1275 \u12CD\u1235\u1325 \u12A0\u1295\u12F3\u1278\u12CD\u121D \u12A0\u12ED\u12F0\u1209\u121D",
      "defaults.noOpinionAnswer": "\u12A5\u122D\u130D\u1320\u129B \u12A0\u12ED\u12F0\u1208\u1201\u121D",
      "defaults.otherAnswer": "\u120C\u120B",
      "defaults.otherAnswerWithText": "\u120C\u120B (\u1290\u133B \u121D\u120B\u123D)",
      "defaults.template.age.label": "\u12E8\u12A5\u122D\u1235\u12CE \u12A5\u12F5\u121C \u1235\u1295\u1275 \u1290\u12CD?",
      "defaults.template.age.option.age_17_under": "\u12A818 \u12D3\u1218\u1275 \u1260\u1273\u127D",
      "defaults.template.age.option.age_18_24": "\u12A818\u201324 \u12A0\u1218\u1275 \u12A5\u12F5\u121C",
      "defaults.template.age.option.age_25_34": "\u12A825\u201334 \u12A0\u1218\u1275 \u12A5\u12F5\u121C",
      "defaults.template.age.option.age_35_44": "\u12A835\u201344 \u12A0\u1218\u1275 \u12A5\u12F5\u121C",
      "defaults.template.age.option.age_45_54": "\u12A845\u201354 \u12A0\u1218\u1275 \u12A5\u12F5\u121C",
      "defaults.template.age.option.age_55_over": "55 \u12C8\u12ED\u121D \u12A8\u12DA\u12EB \u1260\u120B\u12ED \u12A5\u12F5\u121C",
      "defaults.template.sex.label": "\u12E8\u12A5\u122D\u1235\u12CE \u133E\u1273 \u121D\u1295\u12F5\u1295 \u1290\u12CD?",
      "defaults.template.sex.option.sex_female": "\u1234\u1275",
      "defaults.template.sex.option.sex_male": "\u12C8\u1295\u12F5",
      "defaults.widget.label": "Text",
      "errors.page.default": "\u12CD\u12ED\u1363 \u1235\u1205\u1270\u1275 \u1270\u1348\u1325\u122F\u120D",
      "errors.page.notFound": "\u1308\u1339 \u12A0\u120D\u1270\u1308\u1298\u121D",
      "errors.server.default": "\u12E8\u12A0\u1308\u120D\u130B\u12ED \u1235\u1205\u1270\u1275",
      "errors.survey.alreadyFinished": "\u12ED\u1205\u1295 \u12E8\u12F3\u1230\u1233 \u1325\u1293\u1275 \u12A0\u1235\u1240\u12F5\u1218\u12CD \u1328\u122D\u1230\u12CB\u120D",
      "errors.survey.closed": "\u12A5\u1295\u12F0 \u12A0\u1208\u1218\u1273\u12F0\u120D \u1206\u1296 \u12ED\u1205 \u1325\u1293\u1275 \u12A0\u1265\u1245\u1277\u120D",
      "errors.survey.notFound": "\u1308\u1339 \u12A0\u120D\u1270\u1308\u1298\u121D",
      "errors.survey.paused": "\u12E8\u12F3\u1230\u1233 \u1325\u1293\u1275 \u1263\u1208\u1260\u1275 \u1246\u121F\u120D",
      "final.thanks": "\u12A5\u1293\u1218\u1230\u130D\u1293\u1208\u1295!",
      "footer.default.confidential.text": "\u121A\u1235\u1325\u122B\u12CA \u1290\u12CD",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "\u121A\u1235\u1325\u122B\u12CA\u1290\u1275",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "\u12E8\u12F3\u1230\u1233 \u1325\u1293\u1271 \u1260Yandex Surveys technologies \u12E8\u1270\u130E\u1208\u1260\u1270 \u1290\u12CD",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Yandex \u12CD\u1235\u1323\u12CA \u12E8\u12F3\u1230\u1233 \u1325\u1293\u1275",
      "footer.default.responsibility": "\u12A0\u1295\u12F3\u1295\u12F5 \u12E8\u12F3\u1230\u1233 \u1325\u1293\u1276\u127D \u1260\u1236\u1235\u1270\u129B \u12C8\u1308\u1296\u127D \u12E8\u1270\u1348\u1320\u1229 \u1293\u1278\u12CD\u1362 Yandex \u12ED\u12D8\u1273\u1278\u12CD\u1295 \u12A0\u12ED\u1348\u1275\u123D\u121D \u12C8\u12ED\u121D \u12A0\u12EB\u1228\u130B\u130D\u1325\u121D\u1363 \u12A5\u1295\u12F2\u1201\u121D \u1208\u12A5\u1290\u1231 \u121D\u1295\u121D \u12A0\u12ED\u1290\u1275 \u1203\u120B\u134A\u1290\u1275 \u12A0\u12ED\u12C8\u1235\u12F5\u121D\u1362",
      "footer.default.termsofuse.text": "\u12E8\u12A0\u1320\u1243\u1240\u121D \u1218\u1218\u122A\u12EB",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "\u121A\u1235\u1325\u122B\u12CA\u1290\u1275",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "\u12E8\u12A0\u1320\u1243\u1240\u121D \u1218\u1218\u122A\u12EB",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "\u12E8\u12F3\u1230\u1233 \u1325\u1293\u1271 \u1270\u1320\u1293\u1245\u124B\u120D\u1362 \u12A5\u1293\u1218\u1230\u130D\u1293\u1208\u1295!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "\u1270\u1218\u1208\u1235",
      "page.buttonNext": "\u1240\u1323\u12ED",
      "page.buttonSkip": "\u12DD\u1208\u120D",
      "page.title": "\u12E8\u12F3\u1230\u1233 \u1325\u1293\u1271\u1295 \u12ED\u12CD\u1230\u12F1",
      "page.watermark": "\u12E8\u1245\u12F5\u1218-\u12A5\u12ED\u1273 \u1218\u120D\u1236\u127D \u12A8\u130D\u121D\u1275 \u12CD\u1235\u1325 \u12A0\u12ED\u1308\u1261\u121D \u12E8\u1245\u12F5\u1218-\u12A5\u12ED\u1273 \u1218\u120D\u1236\u127D \u12A8\u130D\u121D\u1275 \u12CD\u1235\u1325 \u12A0\u12ED\u1308\u1261\u121D \u12E8\u1245\u12F5\u1218-\u12A5\u12ED\u1273 \u1218\u120D\u1236\u127D \u12A8\u130D\u121D\u1275 \u12CD\u1235\u1325 \u12A0\u12ED\u1308\u1261\u121D",
      "placeholders.longText": "\u12A0\u1235\u1270\u12EB\u12E8\u1275\u12CE\u1295 \u12EB\u1235\u1308\u1261",
      "placeholders.shortText": "\u12A0\u1235\u1270\u12EB\u12E8\u1275\u12CE\u1295 \u12EB\u1235\u1308\u1261",
      "plural.answers.im": [
        "\u1218\u120D\u1235",
        "\u1218\u120D\u1236\u127D",
        "\u1218\u120D\u1236\u127D",
        "\u1218\u120D\u1236\u127D"
      ],
      "plural.answers.ro": [
        "\u1218\u120D\u1235",
        "\u1218\u120D\u1236\u127D",
        "\u1218\u120D\u1236\u127D",
        "\u1218\u120D\u1236\u127D"
      ],
      "plural.ratingStars.labels": [
        "\u12AE\u12A8\u1265",
        "\u12AE\u12A8\u1266\u127D",
        "\u12AE\u12A8\u1266\u127D",
        ""
      ],
      "plural.seconds.im": [
        "\u1230\u12A8\u1295\u12F5",
        "\u1230\u12A8\u1295\u12F6\u127D",
        "\u1230\u12A8\u1295\u12F6\u127D",
        "\u1230\u12A8\u1295\u12F6\u127D"
      ],
      "plural.seconds.ro": [
        "\u1230\u12A8\u1295\u12F6\u127D",
        "\u1230\u12A8\u1295\u12F6\u127D",
        "\u1230\u12A8\u1295\u12F6\u127D",
        "\u1230\u12A8\u1295\u12F6\u127D"
      ],
      "questionModel.awful": "\u12A0\u1235\u1240\u12EB\u121A",
      "questionModel.bad": "\u1218\u1325\u134E",
      "questionModel.dateLessThan": "\u1240\u1291 \u12A8 %s \u1260\u134A\u1275 \u1218\u1206\u1295 \u12A0\u12ED\u127D\u120D\u121D",
      "questionModel.dateMoreThan": "\u1240\u1291 \u12A8 %s \u1260\u128B\u120B \u1218\u1206\u1295 \u12A0\u12ED\u127D\u120D\u121D",
      "questionModel.datePlaceholder": "\u1240\u1295 \u12ED\u121D\u1228\u1321",
      "questionModel.insufficientAnswers": [
        "\u12A8 %s \u12EB\u1290\u1230 \u1218\u120D\u1235 \u1218\u122D\u1320\u12CB\u120D",
        "\u12A8 %s \u12EB\u1290\u1231 \u1218\u120D\u1236\u127D\u1295 \u1218\u122D\u1320\u12CB\u120D",
        "\u12A8 %s \u12EB\u1290\u1231 \u1218\u120D\u1236\u127D\u1295 \u1218\u122D\u1320\u12CB\u120D",
        ""
      ],
      "questionModel.lessThan": "\u1241\u1325\u1229 \u12A8 %s \u1260\u1273\u127D \u1218\u1206\u1295 \u12A0\u12ED\u127D\u120D\u121D",
      "questionModel.maxAnswerPerRowExceeded": "\u1260\u1270\u12A8\u1273\u1273\u12ED \u12A8\u121A\u1230\u1321\u1275 \u1218\u120D\u1236\u127D \u12A8\u134D\u1270\u129B\u12CD\u1295 \u1241\u1325\u122D \u12A0\u120D\u1348\u12CB\u120D",
      "questionModel.maxLenghtExceeded": "\u12E8\u1243\u120B\u1275 \u1308\u12F0\u1265 \u1235\u120B\u1208\u1348 \u12A5\u1263\u12AE\u1275\u1295 \u1218\u120D\u1235\u12CE\u1275\u1295 \u12EB\u1233\u1325\u1229\u1362",
      "questionModel.moreThan": "\u1241\u1325\u1229 \u12A8 %s \u1260\u120B\u12ED \u1218\u1206\u1295 \u12A0\u12ED\u127D\u120D\u121D",
      "questionModel.normally": "\u1218\u12F0\u1260\u129B",
      "questionModel.notDate": "\u120D\u12AD \u12EB\u120D\u1206\u1290 \u1240\u1295",
      "questionModel.notEmail": "\u12E8\u12A2\u121C\u12ED\u120D \u1245\u122D\u1338\u1271 \u130B\u122D \u1218\u12DB\u1218\u12F5 \u12A0\u1208\u1260\u1275",
      "questionModel.notFilled": "\u12A5\u1263\u12AD\u12CE \u1218\u120D\u1235\u12CE\u1295 \u12A5\u12DA\u1205 \u12EB\u1235\u1308\u1261",
      "questionModel.notNumber": "\u1241\u1325\u122E\u127D\u1295 \u1265\u127B \u1218\u12EB\u12DD \u12ED\u127D\u120B\u120D",
      "questionModel.perfectly": "\u134D\u1339\u121D",
      "questionModel.picture": "\u121D\u1235\u120D %s",
      "questionModel.requiredField": "\u12A5\u1263\u12AB\u12CE \u12ED\u1205\u1295 \u1325\u12EB\u1244 \u12EB\u1208 \u1218\u120D\u1235 \u12A0\u12ED\u1270\u12C9\u1275",
      "questionModel.tooManyAnswers": [
        "\u12A8 %s \u1260\u120B\u12ED \u1218\u120D\u1235 \u1270\u1218\u122D\u1327\u120D",
        "\u12A8 %s \u1260\u120B\u12ED \u1218\u120D\u1236\u127D \u1270\u1218\u122D\u1320\u12CB\u120D",
        "",
        ""
      ],
      "questionModel.well": "\u1325\u1229",
      "sidebyside.option": "\u12A0\u121B\u122B\u132D %s",
      "templates.options.age.age18_24": "\u12A818\u201324 \u12A0\u1218\u1275 \u12A5\u12F5\u121C",
      "templates.options.age.age25_34": "\u12A825\u201334 \u12A0\u1218\u1275 \u12A5\u12F5\u121C",
      "templates.options.age.age35_44": "\u12A835\u201344 \u12A0\u1218\u1275 \u12A5\u12F5\u121C",
      "templates.options.age.age45_54": "\u12A845\u201354 \u12A0\u1218\u1275 \u12A5\u12F5\u121C",
      "templates.options.age.age55_over": "55 \u12C8\u12ED\u121D \u12A8\u12DA\u12EB \u1260\u120B\u12ED \u12A5\u12F5\u121C",
      "templates.options.sex.sex_female": "\u1234\u1275",
      "templates.options.sex.sex_male": "\u12C8\u1295\u12F5",
      "templates.questions.age": "\u12E8\u12A5\u122D\u1235\u12CE \u12A5\u12F5\u121C \u1235\u1295\u1275 \u1290\u12CD?",
      "templates.questions.sex": "\u12E8\u12A5\u122D\u1235\u12CE \u133E\u1273 \u121D\u1295\u12F5\u1295 \u1290\u12CD?",
      "ux.stepPaginator.stepTitle": "\u12F0\u1228\u1303 %s \u12A8 %s",
      "video.holdBtn": "\u12E8\u121D\u122D\u1275 \u1235\u1219\u1295 \u1260\u121A\u12EB\u12E9\u1260\u1275 \u130A\u12DC \u1270\u132D\u1290\u12CD \u12ED\u12EB\u12D9",
      "video.statusBarTitle": "\u12E8\u121D\u122D\u1275 \u1235\u1219 \u12A8 %1 \u1230\u12A8\u1295\u12F5 \u12A5\u1235\u12A8 %2 \u1230\u12A8\u1295\u12F5 \u12F5\u1228\u1235 \u1273\u12ED\u1277\u120D"
    }
  },
  ar: {
    poll: {
      "attach.image.notLess": "\u0627\u0646\u0638\u0631 \u0625\u0644\u0649 \u0627\u0644\u0635\u0648\u0631\u0629 \u0644\u0645\u062F\u0629 %1 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0648\u0623\u062C\u0628 \u0639\u0646 \u0628\u0639\u0636 \u0627\u0644\u0623\u0633\u0626\u0644\u0629",
      "attach.image.notMore": "\u0627\u0646\u0638\u0631 \u0625\u0644\u0649 \u0627\u0644\u0635\u0648\u0631\u0629 \u0644\u0645\u062F\u0629 %1 \u0648\u0623\u062C\u0628 \u0639\u0646 \u0628\u0639\u0636 \u0627\u0644\u0623\u0633\u0626\u0644\u0629",
      "attach.text.notLess": "\u0627\u0646\u0638\u0631 \u0625\u0644\u0649 \u0627\u0644\u0646\u0635 \u0644\u0645\u062F\u0629 %1 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0648\u0623\u062C\u0628 \u0639\u0646 \u0628\u0639\u0636 \u0627\u0644\u0623\u0633\u0626\u0644\u0629",
      "attach.text.notMore": "\u0627\u0642\u0631\u0623 \u0646\u0635 \u0644\u0645\u062F\u0629 %1 \u0648\u0623\u062C\u0628 \u0639\u0646 \u0628\u0639\u0636 \u0627\u0644\u0623\u0633\u0626\u0644\u0629",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "\u0634\u0627\u0647\u062F \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0644\u0645\u062F\u0629 %1 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0648\u0623\u062C\u0628 \u0639\u0646 \u0628\u0639\u0636 \u0627\u0644\u0623\u0633\u0626\u0644\u0629",
      "attach.video.notMore": "\u0634\u0627\u0647\u062F \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0644\u0645\u062F\u0629 %1 \u0648\u0623\u062C\u0628 \u0639\u0646 \u0628\u0639\u0636 \u0627\u0644\u0623\u0633\u0626\u0644\u0629",
      "attach.video.waitEnd": "\u0634\u0627\u0647\u062F \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u062D\u062A\u0649 \u0646\u0647\u0627\u064A\u062A\u0647 \u0648\u0623\u062C\u0628 \u0639\u0646 \u0628\u0639\u0636 \u0627\u0644\u0623\u0633\u0626\u0644\u0629",
      "attach.watch": "\u0634\u0627\u0647\u062F",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "\u0634\u064A\u0621 \u0622\u062E\u0631",
      "commonComponents.choice.chooseLessEqualMore": [
        "\u0627\u062E\u062A\u0631 %s \u0625\u062C\u0627\u0628\u0629",
        "\u0627\u062E\u062A\u0631 %s \u0625\u062C\u0627\u0628\u0627\u062A",
        "\u0627\u062E\u062A\u0631 % \u0625\u062C\u0627\u0628\u0627\u062A",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "\u0627\u062E\u062A\u0631 \u0645\u0627 \u0644\u0627 \u064A\u0642\u0644 \u0639\u0646 %s \u062C\u0648\u0627\u0628\u064B\u0627",
        "\u0627\u062E\u062A\u0631 \u0645\u0627 \u0644\u0627 \u064A\u0642\u0644 \u0639\u0646 %s \u062C\u0648\u0627\u0628\u064B\u0627",
        "\u0627\u062E\u062A\u0631 \u0645\u0627 \u0644\u0627 \u064A\u0642\u0644 \u0639\u0646 %s \u062C\u0648\u0627\u0628\u064B\u0627",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "\u0627\u062E\u062A\u0631 \u0645\u0627 \u0644\u0627 \u064A\u0642\u0644 \u0639\u0646 %s \u0648\u0644\u0627 \u064A\u0632\u064A\u062F \u0639\u0646 %s \u062C\u0648\u0627\u0628\u064B\u0627",
      "commonComponents.choice.chooseNoMore": [
        "\u064A\u0631\u062C\u0649 \u0627\u062E\u062A\u064A\u0627\u0631 %s \u0625\u062C\u0627\u0628\u0629 \u0641\u0642\u0637",
        "\u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u0627\u062E\u062A\u064A\u0627\u0631 \u0623\u0643\u062B\u0631 \u0645\u0646 %s \u0625\u062C\u0627\u0628\u0627\u062A",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "\u0643\u062A\u0627\u0628\u0629 \u0627\u0644\u0646\u0635",
      "commonComponents.choice.yourComment": "\u0623\u062F\u062E\u0644 \u062A\u0639\u0644\u064A\u0642\u0643",
      "commonComponents.scale.chooseRate": "\u064A\u0631\u062C\u0649 \u0625\u0636\u0627\u0641\u0629 \u062A\u0642\u064A\u064A\u0645",
      "commonComponents.scale.firstElement": "\u0627\u0644\u062E\u064A\u0627\u0631 \u0627\u0644\u0623\u0648\u0644 \u064A\u0639\u0646\u064A %s",
      "commonComponents.scale.lastElement": "\u0627\u0644\u062E\u064A\u0627\u0631 \u0627\u0644\u0623\u062E\u064A\u0631 \u064A\u0639\u0646\u064A %s",
      "commonComponents.table.chooseNoMore": [
        "\u0627\u062E\u062A\u0631 \u0645\u0627 \u0644\u0627 \u064A\u0632\u064A\u062F  \u0639\u0646 %s \u062C\u0648\u0627\u0628\u064B\u0627 \u0641\u064A \u0627\u0644\u0633\u0637\u0631 \u0627\u0644\u0648\u0627\u062D\u062F",
        "\u0627\u062E\u062A\u0631 \u0645\u0627 \u0644\u0627 \u064A\u0632\u064A\u062F  \u0639\u0646 %s \u062C\u0648\u0627\u0628\u064B\u0627 \u0641\u064A \u0627\u0644\u0633\u0637\u0631 \u0627\u0644\u0648\u0627\u062D\u062F",
        "\u0627\u062E\u062A\u0631 \u0645\u0627 \u0644\u0627 \u064A\u0632\u064A\u062F  \u0639\u0646 %s \u062C\u0648\u0627\u0628\u064B\u0627 \u0641\u064A \u0627\u0644\u0633\u0637\u0631 \u0627\u0644\u0648\u0627\u062D\u062F",
        ""
      ],
      "defaults.agree": "\u0623\u062A\u0641\u0642 \u062A\u0645\u0627\u0645\u064B\u0627",
      "defaults.back": "\u0631\u062C\u0648\u0639",
      "defaults.datePlaceholder": "\u0627\u0644\u064A\u0648\u0645.\u0627\u0644\u0634\u0647\u0631.\u0627\u0644\u0633\u0646\u0629",
      "defaults.disagree": "\u0644\u0627 \u0623\u062A\u0641\u0642 \u0627\u0644\u0628\u062A\u0629",
      "defaults.dualChoice.label": "\u0645\u0631\u0628\u0639 \u0627\u062E\u062A\u064A\u0627\u0631",
      "defaults.emoji1": "\u0633\u064A\u0626\u0629 \u062C\u062F\u064B\u0627",
      "defaults.emoji2": "\u0633\u064A\u0626\u0629",
      "defaults.emoji3": "\u0639\u0627\u062F\u064A\u0629",
      "defaults.emoji4": "\u062C\u064A\u062F\u0629",
      "defaults.emoji5": "\u0645\u0645\u062A\u0627\u0632\u0629",
      "defaults.next": "\u0627\u0644\u062A\u0627\u0644\u064A",
      "defaults.noAnswer": "\u0644\u0627 \u0634\u064A\u0621 \u0645\u0645\u0627 \u0633\u0628\u0642",
      "defaults.noOpinionAnswer": "\u063A\u064A\u0631 \u0645\u062A\u0623\u0643\u062F",
      "defaults.otherAnswer": "\u0622\u062E\u0631",
      "defaults.otherAnswerWithText": "\u0622\u062E\u0631 (\u0623\u0643\u062A\u0628 \u0631\u062F\u0651\u0643)",
      "defaults.template.age.label": "\u0643\u0645 \u0639\u0645\u0631\u0643\u061F",
      "defaults.template.age.option.age_17_under": "\u0623\u0642\u0644 \u0645\u0646 18 \u0633\u0646\u0629",
      "defaults.template.age.option.age_18_24": "18-24 \u0633\u0646\u0629",
      "defaults.template.age.option.age_25_34": "25-34 \u0633\u0646\u0629",
      "defaults.template.age.option.age_35_44": "35-44 \u0633\u0646\u0629",
      "defaults.template.age.option.age_45_54": "45-54 \u0633\u0646\u0629",
      "defaults.template.age.option.age_55_over": "55 \u0633\u0646\u0629 \u0648\u0645\u0627 \u0641\u0648\u0642",
      "defaults.template.sex.label": "\u0645\u0627 \u0646\u0648\u0639 \u062C\u0646\u0633\u0643\u061F",
      "defaults.template.sex.option.sex_female": "\u0623\u0646\u062B\u0649",
      "defaults.template.sex.option.sex_male": "\u0630\u0643\u0631",
      "defaults.widget.label": "Text",
      "errors.page.default": "\u0639\u0630\u0631\u064B\u0627\u060C \u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627",
      "errors.page.notFound": "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629",
      "errors.server.default": "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u062E\u0627\u062F\u0645",
      "errors.survey.alreadyFinished": "\u0644\u0642\u062F \u0623\u0643\u0645\u0644\u062A \u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u062A\u0637\u0644\u0627\u0639 \u0633\u0627\u0628\u0642\u064B\u0627",
      "errors.survey.closed": "\u0644\u0644\u0623\u0633\u0641\u060C \u0627\u0646\u062A\u0647\u0649 \u0647\u0630\u0627 \u0627\u0644\u0628\u062D\u062B",
      "errors.survey.notFound": "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629",
      "errors.survey.paused": "\u062A\u0645 \u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0627\u0633\u062A\u0637\u0644\u0627\u0639 \u0645\u0624\u0642\u062A\u064B\u0627",
      "final.thanks": "\u0634\u0643\u0631\u064B\u0627 \u0644\u0643!",
      "footer.default.confidential.text": "\u0633\u0631\u064A",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "\u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "\u0623\u062C\u0631\u064A \u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062A\u0642\u0646\u064A\u0627\u062A Yandex Surveys",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u062F\u0627\u062E\u0644\u064A \u0644\u0634\u0631\u0643\u0629 Yandex",
      "footer.default.responsibility": "\u064A\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0628\u0639\u0636 \u0627\u0644\u0627\u0633\u062A\u0637\u0644\u0627\u0639\u0627\u062A \u0628\u0648\u0627\u0633\u0637\u0629 \u0623\u0637\u0631\u0627\u0641 \u062B\u0627\u0644\u062B\u0629. \u0644\u0627 \u062A\u062A\u0641\u0642\u062F Yandex \u0645\u062D\u062A\u0648\u064A\u0627\u062A\u0647\u0627 \u0623\u0648 \u062A\u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627\u060C \u0648\u0644\u0627 \u062A\u062A\u062D\u0645\u0644 \u0623\u064A \u0645\u0633\u0624\u0648\u0644\u064A\u0629 \u0639\u0646\u0647\u0627.",
      "footer.default.termsofuse.text": "\u0628\u0646\u0648\u062F \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "\u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "\u0628\u0646\u0648\u062F \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "\u0627\u0643\u062A\u0645\u0644 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646. \u0634\u0643\u0631\u064B\u0627 \u0644\u0643!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "\u0631\u062C\u0648\u0639",
      "page.buttonNext": "\u0627\u0644\u062A\u0627\u0644\u064A",
      "page.buttonSkip": "\u062A\u062E\u0637\u064A",
      "page.title": "\u0634\u0627\u0631\u0643 \u0641\u064A \u0627\u0644\u0627\u0633\u062A\u0637\u0644\u0627\u0639",
      "page.watermark": "\u0645\u0639\u0627\u064A\u0646\u0629 \u0627\u0644\u0625\u062C\u0627\u0628\u0627\u062A \u0644\u0627 \u062A\u0624\u062E\u0630 \u0641\u064A \u0627\u0644\u0627\u0639\u062A\u0628\u0627\u0631 \u0645\u0639\u0627\u064A\u0646\u0629 \u0627\u0644\u0625\u062C\u0627\u0628\u0627\u062A \u0644\u0627 \u062A\u0624\u062E\u0630 \u0641\u064A \u0627\u0644\u0627\u0639\u062A\u0628\u0627\u0631 \u0645\u0639\u0627\u064A\u0646\u0629 \u0627\u0644\u0625\u062C\u0627\u0628\u0627\u062A \u0644\u0627 \u062A\u0624\u062E\u0630 \u0641\u064A \u0627\u0644\u0627\u0639\u062A\u0628\u0627\u0631",
      "placeholders.longText": "\u0623\u062F\u062E\u0644 \u062A\u0639\u0644\u064A\u0642\u0643",
      "placeholders.shortText": "\u0623\u062F\u062E\u0644 \u062A\u0639\u0644\u064A\u0642\u0643",
      "plural.answers.im": [
        "\u062C\u0648\u0627\u0628",
        "\u0623\u062C\u0648\u0628\u0629",
        "\u0623\u062C\u0648\u0628\u0629",
        "\u0623\u062C\u0648\u0628\u0629"
      ],
      "plural.answers.ro": [
        "\u062C\u0648\u0627\u0628",
        "\u0623\u062C\u0648\u0628\u0629",
        "\u0623\u062C\u0648\u0628\u0629",
        "\u0623\u062C\u0648\u0628\u0629"
      ],
      "plural.ratingStars.labels": [
        "\u0646\u062C\u0645\u0629",
        "\u0646\u062C\u0648\u0645",
        "\u0646\u062C\u0648\u0645",
        ""
      ],
      "plural.seconds.im": [
        "\u062B\u0627\u0646\u064A\u0629",
        "\u062B\u0648\u0627\u0646\u064D",
        "\u062B\u0648\u0627\u0646\u064D",
        "\u062B\u0648\u0627\u0646\u064D"
      ],
      "plural.seconds.ro": [
        "\u062B\u0648\u0627\u0646\u064D",
        "\u062B\u0648\u0627\u0646\u064D",
        "\u062B\u0648\u0627\u0646\u064D",
        "\u062B\u0648\u0627\u0646\u064D"
      ],
      "questionModel.awful": "\u0633\u064A\u0626\u0629 \u062C\u062F\u064B\u0627",
      "questionModel.bad": "\u0633\u064A\u0626\u0629",
      "questionModel.dateLessThan": "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u0644\u0644\u062A\u0627\u0631\u064A\u062E \u0623\u0646 \u064A\u0643\u0648\u0646 \u0642\u0628\u0644 %s",
      "questionModel.dateMoreThan": "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u0644\u0644\u062A\u0627\u0631\u064A\u062E \u0623\u0646 \u064A\u0643\u0648\u0646 \u0628\u0639\u062F %s",
      "questionModel.datePlaceholder": "Select a date",
      "questionModel.insufficientAnswers": [
        "\u0644\u0642\u062F \u0627\u062E\u062A\u0631\u062A \u0623\u0642\u0644 \u0645\u0646 %s \u062C\u0648\u0627\u0628\u064B\u0627",
        "\u0644\u0642\u062F \u0627\u062E\u062A\u0631\u062A \u0623\u0642\u0644 \u0645\u0646 %s \u062C\u0648\u0627\u0628\u064B\u0627",
        "\u0644\u0642\u062F \u0627\u062E\u062A\u0631\u062A \u0623\u0642\u0644 \u0645\u0646 %s \u062C\u0648\u0627\u0628\u064B\u0627",
        ""
      ],
      "questionModel.lessThan": "\u064A\u062C\u0628 \u0623\u0644\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0631\u0642\u0645 \u0623\u0642\u0644 \u0645\u0646 %s",
      "questionModel.maxAnswerPerRowExceeded": "\u0644\u0642\u062F \u062A\u062C\u0627\u0648\u0632\u062A \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u0623\u062C\u0648\u0628\u0629 \u0639\u0644\u0649 \u0627\u0644\u062A\u0648\u0627\u0644\u064A",
      "questionModel.maxLenghtExceeded": "\u0639\u062F\u062F \u0627\u0644\u0623\u062D\u0631\u0641 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647\u060C \u064A\u0631\u062C\u0649 \u0627\u062E\u062A\u0635\u0627\u0631 \u0625\u062C\u0627\u0628\u062A\u0643.",
      "questionModel.moreThan": "\u064A\u062C\u0628 \u0623\u0644\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0631\u0642\u0645 \u0623\u0643\u062B\u0631 \u0645\u0646 %s",
      "questionModel.normally": "\u0639\u0627\u062F\u064A\u0629",
      "questionModel.notDate": "\u062A\u0627\u0631\u064A\u062E \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
      "questionModel.notEmail": "\u064A\u062C\u0628 \u0623\u0646 \u064A\u062A\u0637\u0627\u0628\u0642 \u0645\u0639 \u062A\u0646\u0633\u064A\u0642 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      "questionModel.notFilled": "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0625\u062C\u0627\u0628\u062A\u0643 \u0647\u0646\u0627",
      "questionModel.notNumber": "\u064A\u062C\u0628 \u0623\u0646 \u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0623\u0631\u0642\u0627\u0645 \u0641\u0642\u0637",
      "questionModel.perfectly": "\u0645\u0645\u062A\u0627\u0632\u0629",
      "questionModel.picture": "\u0627\u0644\u0635\u0648\u0631\u0629 %s",
      "questionModel.requiredField": "\u0627\u0644\u0631\u062C\u0627\u0621 \u0639\u062F\u0645 \u062A\u0631\u0643 \u0647\u0630\u0627 \u0627\u0644\u0633\u0624\u0627\u0644 \u062F\u0648\u0646 \u0625\u062C\u0627\u0628\u0629",
      "questionModel.tooManyAnswers": [
        "\u062A\u0645 \u0627\u062E\u062A\u064A\u0627\u0631 \u0623\u0643\u062B\u0631 \u0645\u0646 %s \u0645\u0646 \u0627\u0644\u0625\u062C\u0627\u0628\u0627\u062A",
        "\u062A\u0645 \u0627\u062E\u062A\u064A\u0627\u0631 \u0623\u0643\u062B\u0631 \u0645\u0646 %s \u0645\u0646 \u0627\u0644\u0625\u062C\u0627\u0628\u0627\u062A",
        "",
        ""
      ],
      "questionModel.well": "\u062C\u064A\u062F\u0629",
      "sidebyside.option": "\u0627\u0644\u062E\u064A\u0627\u0631 %s",
      "templates.options.age.age18_24": "18-24 \u0633\u0646\u0629",
      "templates.options.age.age25_34": "25-34 \u0633\u0646\u0629",
      "templates.options.age.age35_44": "35-44 \u0633\u0646\u0629",
      "templates.options.age.age45_54": "45-54 \u0633\u0646\u0629",
      "templates.options.age.age55_over": "55 \u0633\u0646\u0629 \u0648\u0645\u0627 \u0641\u0648\u0642",
      "templates.options.sex.sex_female": "\u0623\u0646\u062B\u0649",
      "templates.options.sex.sex_male": "\u0630\u0643\u0631",
      "templates.questions.age": "\u0643\u0645 \u0639\u0645\u0631\u0643\u061F",
      "templates.questions.sex": "\u0645\u0627 \u0646\u0648\u0639 \u062C\u0646\u0633\u0643\u061F",
      "ux.stepPaginator.stepTitle": "\u062E\u0637\u0648\u0629 %s \u0645\u0646 \u0623\u0635\u0644 %s",
      "video.holdBtn": "\u0627\u0636\u063A\u0637 \u0645\u0639 \u0627\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631 \u0623\u062B\u0646\u0627\u0621 \u0631\u0624\u064A\u0629 \u0627\u0644\u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629",
      "video.statusBarTitle": "\u0638\u0647\u0631\u062A \u0627\u0644\u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629 \u0645\u0646 \u0627\u0644\u062B\u0627\u0646\u064A\u0629 %1 \u0625\u0644\u0649 \u0627\u0644\u062B\u0627\u0646\u064A\u0629 %2"
    }
  },
  az: {
    poll: {
      "attach.image.notLess": "\u015E\u0259kl\u0259 \u0259n az\u0131 %1 bax\u0131n v\u0259 bir ne\xE7\u0259 suala cavab verin",
      "attach.image.notMore": "\u015E\u0259kl\u0259 %1 bax\u0131n v\u0259 bir ne\xE7\u0259 suala cavab verin",
      "attach.text.notLess": "M\u0259tn\u0259 \u0259n az\u0131 %1 bax\u0131n v\u0259 bir ne\xE7\u0259 suala cavab verin",
      "attach.text.notMore": "M\u0259tni %1 oxuyun v\u0259 bir ne\xE7\u0259 suala cavab verin",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "Video\xE7arxa \u0259n az\u0131 %1 bax\u0131n v\u0259 bir ne\xE7\u0259 suala cavab verin",
      "attach.video.notMore": "Video\xE7arxa %1 bax\u0131n v\u0259 bir ne\xE7\u0259 suala cavab verin",
      "attach.video.waitEnd": "Video\xE7arxa sonuna q\u0259d\u0259r basx\u0131n v\u0259 bir ne\xE7\u0259 suala cavab verin",
      "attach.watch": "Bax",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "Daha \xE7ox...",
      "commonComponents.choice.chooseLessEqualMore": [
        "%s cavab se\xE7in",
        "%s cavab se\xE7in",
        "% cavab se\xE7in",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "\u018Fn az\u0131 %s cavab se\xE7in",
        "\u018Fn az\u0131 %s cavab se\xE7in",
        "\u018Fn az\u0131 %s cavab se\xE7in",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "\u018Fn az\u0131 %s v\u0259 \u0259n \xE7oxu %s cavab se\xE7in",
      "commonComponents.choice.chooseNoMore": [
        "\u018Fn \xE7oxu %s cavab se\xE7\u0259 bil\u0259rsiniz",
        "\u018Fn \xE7oxu %s cavab se\xE7\u0259 bil\u0259rsiniz",
        "\u018Fn \xE7oxu %s cavab se\xE7\u0259 bil\u0259rsiniz",
        ""
      ],
      "commonComponents.choice.enterText": "M\u0259tni daxil edin",
      "commonComponents.choice.yourComment": "\u015E\u0259rhiniz...",
      "commonComponents.scale.chooseRate": "Qiym\u0259ti se\xE7in",
      "commonComponents.scale.firstElement": "Birinci variant %s m\u0259nas\u0131",
      "commonComponents.scale.lastElement": "Sonuncu variant %s m\u0259ns\u0131",
      "commonComponents.table.chooseNoMore": [
        "S\u0259tird\u0259 \u0259n \xE7oxu %s cavab se\xE7in",
        "S\u0259tird\u0259 \u0259n \xE7oxu %s cavab se\xE7in",
        "S\u0259tird\u0259 \u0259n \xE7oxu %s cavab se\xE7in",
        ""
      ],
      "defaults.agree": "Tamamil\u0259 raz\u0131yam",
      "defaults.back": "Geri",
      "defaults.datePlaceholder": "gg.aa.iiii",
      "defaults.disagree": "Q\u0259tiyy\u0259n raz\u0131 deyil\u0259m",
      "defaults.dualChoice.label": "T\u0259sdiq xanas\u0131",
      "defaults.emoji1": "\xC7ox pis",
      "defaults.emoji2": "Pis",
      "defaults.emoji3": "Normal",
      "defaults.emoji4": "Yax\u015F\u0131",
      "defaults.emoji5": "\u018Fla",
      "defaults.next": "\u0130r\u0259li",
      "defaults.noAnswer": "He\xE7 biri",
      "defaults.noOpinionAnswer": "Cavab verm\u0259kd\u0259 \xE7\u0259tinlik \xE7\u0259kir\u0259m",
      "defaults.otherAnswer": "Ba\u015Fqa",
      "defaults.otherAnswerWithText": "Ba\u015Fqa (variant\u0131n\u0131z\u0131 qeyd edin)",
      "defaults.template.age.label": "Ne\xE7\u0259 ya\u015F\u0131n\u0131z\u0131n tamam oldu\u011Funu qeyd edin",
      "defaults.template.age.option.age_17_under": "18 ya\u015Fdan az",
      "defaults.template.age.option.age_18_24": "18\u201324 ya\u015F",
      "defaults.template.age.option.age_25_34": "25\u201334 ya\u015F",
      "defaults.template.age.option.age_35_44": "35\u201344 ya\u015F",
      "defaults.template.age.option.age_45_54": "45\u201354 ya\u015F",
      "defaults.template.age.option.age_55_over": "55 ya\u015F v\u0259 daha yuxar\u0131",
      "defaults.template.sex.label": "Cinsinizi qeyd edin",
      "defaults.template.sex.option.sex_female": "Qad\u0131n",
      "defaults.template.sex.option.sex_male": "Ki\u015Fi",
      "defaults.widget.label": "Text",
      "errors.page.default": "X\u0259ta ba\u015F verdi :(",
      "errors.page.notFound": "S\u0259hif\u0259 tap\u0131lmad\u0131",
      "errors.server.default": "Server x\u0259tas\u0131",
      "errors.survey.alreadyFinished": "Bu anketi art\u0131q tamamlam\u0131s\u0131n\u0131z",
      "errors.survey.closed": "T\u0259\u0259ss\xFCf ki, sor\u011Fu art\u0131q ba\u015Fa \xE7at\u0131b",
      "errors.survey.notFound": "S\u0259hif\u0259 tap\u0131lmad\u0131",
      "errors.survey.paused": "Sor\u011Fu dayand\u0131r\u0131ld\u0131",
      "final.thanks": "T\u0259\u015F\u0259kk\xFCrl\u0259r!",
      "footer.default.confidential.text": "M\u0259xfi",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "M\u0259xfilik",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.default.copyright.text": '\xA9 %s  "Yandex" MMC',
      "footer.default.copyrightInternal.text": '\xA9 %s "Yandex" MMC',
      "footer.default.createby.text": "Sor\u011Fu Yandex Surveys texnologiyalar\u0131 t\u0259r\u0259find\u0259n haz\u0131rlan\u0131b",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Yandex-in daxili sor\u011Fusu",
      "footer.default.responsibility": "Yandex \xFC\xE7\xFCnc\xFC t\u0259r\u0259fl\u0259rin yaratd\u0131\u011F\u0131 sor\u011Fular il\u0259 \u0259laq\u0259li deyil v\u0259 onlar\u0131n m\u0259zmununa g\xF6r\u0259 m\u0259suliyy\u0259t da\u015F\u0131m\u0131r.",
      "footer.default.termsofuse.text": "\u0130stifad\u0259 \u015F\u0259rtl\u0259ri",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/",
      "footer.odnaco.confpolicy.text": "M\u0259xfilik siyas\u0259ti",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "\u0130stifad\u0259\xE7i m\xFCqavil\u0259si",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/index.html",
      "info.survey.thanks": "Sor\u011Fu tamamland\u0131. T\u0259\u015F\u0259kk\xFCrl\u0259r!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "Geri",
      "page.buttonNext": "\u0130r\u0259li",
      "page.buttonSkip": "\xD6t\xFCr",
      "page.title": "Sor\u011Fudan ke\xE7in",
      "page.watermark": "\xD6NBAXI\u015E CAVABLAR N\u018FZ\u018FR\u018F ALINMIR \xD6NBAXI\u015E CAVABLAR N\u018FZ\u018FR\u018F ALINMIR \xD6NBAXI\u015E CAVABLAR N\u018FZ\u018FR\u018F ALINMIR",
      "placeholders.longText": "\u015E\u0259rhiniz",
      "placeholders.shortText": "\u015E\u0259rhiniz",
      "plural.answers.im": [
        "cavab",
        "cavab",
        "cavab",
        "cavab"
      ],
      "plural.answers.ro": [
        "cavab",
        "cavab",
        "cavab",
        "cavab"
      ],
      "plural.ratingStars.labels": [
        "ulduz",
        "ulduz",
        "ulduz",
        ""
      ],
      "plural.seconds.im": [
        "saniy\u0259",
        "saniy\u0259",
        "saniy\u0259",
        "saniy\u0259"
      ],
      "plural.seconds.ro": [
        "saniy\u0259",
        "saniy\u0259",
        "saniy\u0259",
        "saniy\u0259"
      ],
      "questionModel.awful": "\xC7ox pis",
      "questionModel.bad": "Pis",
      "questionModel.dateLessThan": "Tarix %s tarixind\u0259n \u0259vv\u0259l ola bilm\u0259z",
      "questionModel.dateMoreThan": "Tarix %s tarixind\u0259n sonra ola bilm\u0259z",
      "questionModel.datePlaceholder": "Tarixi daxil edin",
      "questionModel.insufficientAnswers": [
        "%s\xA0cavabdan az se\xE7misiniz",
        "%s\xA0cavabdan az se\xE7misiniz",
        "%s\xA0cavabdan az se\xE7misiniz",
        ""
      ],
      "questionModel.lessThan": "Say %s say\u0131ndan az ola bilm\u0259z",
      "questionModel.maxAnswerPerRowExceeded": "Bir s\u0259tird\u0259 icaz\u0259 veril\u0259n maksimum cavab say\u0131 ",
      "questionModel.maxLenghtExceeded": "Simvol say\u0131 yolveril\u0259n maksimal h\u0259ddi a\u015F\u0131b, m\u0259tni q\u0131sald\u0131n",
      "questionModel.moreThan": "Say %s say\u0131ndan \xE7ox ola bilm\u0259z",
      "questionModel.normally": "Normal",
      "questionModel.notDate": "Yanl\u0131\u015F tarix daxil edilib",
      "questionModel.notEmail": "E-po\xE7t format\u0131na uy\u011Fun olmal\u0131d\u0131r",
      "questionModel.notFilled": "M\u0259tn daxil edilm\u0259lidir",
      "questionModel.notNumber": "Yaln\u0131z r\u0259q\u0259ml\u0259r ola bil\u0259r",
      "questionModel.perfectly": "\u018Fla",
      "questionModel.picture": "\u015E\u0259kil %s",
      "questionModel.requiredField": "Bu sual\u0131 cavabs\u0131z saxlamay\u0131n",
      "questionModel.tooManyAnswers": [
        "%s\xA0cavabdan \xE7ox se\xE7misiniz",
        "%s\xA0cavabdan \xE7ox se\xE7misiniz",
        "%s\xA0cavabdan \xE7ox se\xE7misiniz",
        ""
      ],
      "questionModel.well": "Yax\u015F\u0131",
      "sidebyside.option": "Variant %s",
      "templates.options.age.age18_24": "18\u201324 ya\u015F",
      "templates.options.age.age25_34": "25\u201334 ya\u015F",
      "templates.options.age.age35_44": "35\u201344 ya\u015F",
      "templates.options.age.age45_54": "45\u201354 ya\u015F",
      "templates.options.age.age55_over": "55 ya\u015F v\u0259 daha yuxar\u0131",
      "templates.options.sex.sex_female": "Qad\u0131n",
      "templates.options.sex.sex_male": "Ki\u015Fi",
      "templates.questions.age": "Ne\xE7\u0259 ya\u015F\u0131n\u0131z\u0131n tamam oldu\u011Funu qeyd edin",
      "templates.questions.sex": "Cinsinizi qeyd edin",
      "ux.stepPaginator.stepTitle": "Add\u0131m %s/%s",
      "video.holdBtn": "Brendi g\xF6rd\xFCy\xFCn\xFCz m\xFCdd\u0259td\u0259 saxlay\u0131n",
      "video.statusBarTitle": "Brend %1 saniy\u0259d\u0259n %2 saniy\u0259y\u0259d\u0259k g\xF6r\xFCn\xFCrd\xFC"
    }
  },
  be: {
    poll: {
      "attach.image.notLess": "\u041F\u0430\u0433\u043B\u044F\u0434\u0437\u0456\u0446\u0435 \u043D\u0430 \u0432\u044B\u044F\u0432\u0443 \u043D\u0435 \u043C\u0435\u043D\u0448 \u0437\u0430 %1 \u0456 \u0430\u0434\u043A\u0430\u0436\u044B\u0446\u0435 \u043D\u0430 \u043D\u0435\u043A\u0430\u043B\u044C\u043A\u0456 \u043F\u044B\u0442\u0430\u043D\u043D\u044F\u045E",
      "attach.image.notMore": "\u041F\u0430\u0433\u043B\u044F\u0434\u0437\u0456\u0446\u0435 \u043D\u0430 \u0432\u044B\u044F\u0432\u0443 \u043D\u0430 \u043F\u0440\u0430\u0446\u044F\u0433\u0443 %1 \u0456 \u0430\u0434\u043A\u0430\u0436\u044B\u0446\u0435 \u043D\u0430 \u043D\u0435\u043A\u0430\u043B\u044C\u043A\u0456 \u043F\u044B\u0442\u0430\u043D\u043D\u044F\u045E",
      "attach.text.notLess": "\u041F\u0430\u0433\u043B\u044F\u0434\u0437\u0456\u0446\u0435 \u043D\u0430 \u0442\u044D\u043A\u0441\u0442 \u043D\u0435 \u043C\u0435\u043D\u0448 \u0437\u0430 %1 \u0456 \u0430\u0434\u043A\u0430\u0436\u044B\u0446\u0435 \u043D\u0430 \u043D\u0435\u043A\u0430\u043B\u044C\u043A\u0456 \u043F\u044B\u0442\u0430\u043D\u043D\u044F\u045E",
      "attach.text.notMore": "\u041F\u0440\u0430\u0447\u044B\u0442\u0430\u0439\u0446\u0435 \u0442\u044D\u043A\u0441\u0442 \u0437\u0430 %1 \u0456 \u0430\u0434\u043A\u0430\u0436\u044B\u0446\u0435 \u043D\u0430 \u043D\u0435\u043A\u0430\u043B\u044C\u043A\u0456 \u043F\u044B\u0442\u0430\u043D\u043D\u044F\u045E",
      "attach.text.widgetHidden": "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "attach.video.notLess": "\u041F\u0440\u0430\u0433\u043B\u044F\u0434\u0437\u0456\u0446\u0435 \u0432\u0456\u0434\u044D\u0430\u0440\u043E\u043B\u0456\u043A \u043D\u0435 \u043C\u0435\u043D\u0448 \u0437\u0430 %1 \u0456 \u0430\u0434\u043A\u0430\u0436\u044B\u0446\u0435 \u043D\u0430 \u043D\u0435\u043A\u0430\u043B\u044C\u043A\u0456 \u043F\u044B\u0442\u0430\u043D\u043D\u044F\u045E",
      "attach.video.notMore": "\u041F\u0440\u0430\u0433\u043B\u044F\u0434\u0437\u0456\u0446\u0435 \u0432\u0456\u0434\u044D\u0430\u0440\u043E\u043B\u0456\u043A \u043D\u0430 \u043F\u0440\u0430\u0446\u044F\u0433\u0443 %1 \u0456 \u0430\u0434\u043A\u0430\u0436\u044B\u0446\u0435 \u043D\u0430 \u043D\u0435\u043A\u0430\u043B\u044C\u043A\u0456 \u043F\u044B\u0442\u0430\u043D\u043D\u044F\u045E",
      "attach.video.waitEnd": "\u041F\u0440\u0430\u0433\u043B\u044F\u0434\u0437\u0456\u0446\u0435 \u0432\u0456\u0434\u044D\u0430\u0440\u043E\u043B\u0456\u043A \u0434\u0430 \u043A\u0430\u043D\u0446\u0430 \u0456 \u0430\u0434\u043A\u0430\u0436\u044B\u0446\u0435 \u043D\u0430 \u043D\u0435\u043A\u0430\u043B\u044C\u043A\u0456 \u043F\u044B\u0442\u0430\u043D\u043D\u044F\u045E",
      "attach.watch": "\u0413\u043B\u044F\u0434\u0437\u0435\u0446\u044C",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "\u041D\u0435 \u043C\u043E\u0433\u0443 \u043D\u0430\u0437\u0432\u0430\u0442\u044C",
      "commonComponents.choice.anythingElse": "\u0427\u0442\u043E-\u0442\u043E \u0435\u0449\u0435...",
      "commonComponents.choice.chooseLessEqualMore": [
        "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 %s \u0430\u0434\u043A\u0430\u0437",
        "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 %s \u0430\u0434\u043A\u0430\u0437\u044B",
        "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 % \u0430\u0434\u043A\u0430\u0437\u0430\u045E",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u043D\u0435 \u043C\u0435\u043D\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437",
        "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u043D\u0435 \u043C\u0435\u043D\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437\u0430\u045E",
        "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u043D\u0435 \u043C\u0435\u043D\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437\u0430\u045E",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u043D\u0435 \u043C\u0435\u043D\u0448 \u0437\u0430 %s \u0456 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448 \u0437\u0430 %s",
      "commonComponents.choice.chooseNoMore": [
        "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437",
        "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437\u0430\u045E",
        "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437\u0430\u045E",
        ""
      ],
      "commonComponents.choice.enterText": "\u0423\u043F\u0456\u0448\u044B\u0446\u0435 \u0442\u044D\u043A\u0441\u0442",
      "commonComponents.choice.yourComment": "\u0412\u0430\u0448 \u043A\u0430\u043C\u0435\u043D\u0442\u0430\u0440\u044B\u0439",
      "commonComponents.scale.chooseRate": "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u0430\u0434\u0437\u043D\u0430\u043A\u0443",
      "commonComponents.scale.firstElement": "\u041F\u0435\u0440\u0448\u044B \u043A\u0440\u0430\u0439\u043D\u0456 \u0432\u0430\u0440\u044B\u044F\u043D\u0442 %s \u0430\u0437\u043D\u0430\u0447\u0430\u0435",
      "commonComponents.scale.lastElement": "\u0410\u043F\u043E\u0448\u043D\u0456 \u043A\u0440\u0430\u0439\u043D\u0456 \u0432\u0430\u0440\u044B\u044F\u043D\u0442 %s \u0430\u0437\u043D\u0430\u0447\u0430\u0435",
      "commonComponents.table.chooseNoMore": [
        "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437 \u0443 \u0440\u0430\u0434\u043A\u0443",
        "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437\u0430\u045E \u0443 \u0440\u0430\u0434\u043A\u0443",
        "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437\u0430\u045E \u0443 \u0440\u0430\u0434\u043A\u0443",
        ""
      ],
      "defaults.agree": "\u0426\u0430\u043B\u043A\u0430\u043C \u0437\u0433\u0430\u0434\u0436\u0430\u044E\u0441\u044F",
      "defaults.back": "\u041D\u0430\u0437\u0430\u0434",
      "defaults.datePlaceholder": "\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433",
      "defaults.disagree": "\u0426\u0430\u043B\u043A\u0430\u043C \u043D\u0435 \u0437\u0433\u0430\u0434\u0436\u0430\u044E\u0441\u044F",
      "defaults.dualChoice.label": "\u0427\u044D\u043A\u0431\u043E\u043A\u0441",
      "defaults.emoji1": "\u0416\u0430\u0445\u043B\u0456\u0432\u0430",
      "defaults.emoji2": "\u0414\u0440\u044D\u043D\u043D\u0430",
      "defaults.emoji3": "\u041D\u0430\u0440\u043C\u0430\u043B\u044C\u043D\u0430",
      "defaults.emoji4": "\u0414\u043E\u0431\u0440\u0430",
      "defaults.emoji5": "\u0412\u044B\u0434\u0430\u0442\u043D\u0430",
      "defaults.next": "\u0414\u0430\u043B\u0435\u0439",
      "defaults.noAnswer": "\u041D\u0456\u0447\u043E\u0433\u0430 \u0437 \u043F\u0435\u0440\u0430\u043B\u0456\u0447\u0430\u043D\u0430\u0433\u0430",
      "defaults.noOpinionAnswer": "\u041C\u043D\u0435 \u0446\u044F\u0436\u043A\u0430 \u0430\u0434\u043A\u0430\u0437\u0430\u0446\u044C",
      "defaults.otherAnswer": "\u0406\u043D\u0448\u0430\u0435",
      "defaults.otherAnswerWithText": "\u0406\u043D\u0448\u0430\u0435 (\u0443\u043F\u0456\u0448\u044B\u0446\u0435 \u0441\u0432\u043E\u0439 \u0432\u0430\u0440\u044B\u044F\u043D\u0442)",
      "defaults.template.age.label": "\u041F\u0430\u0437\u043D\u0430\u0447\u0446\u0435, \u043A\u043E\u043B\u044C\u043A\u0456 \u0432\u0430\u043C \u043F\u043E\u045E\u043D\u044B\u0445 \u0433\u0430\u0434\u043E\u045E",
      "defaults.template.age.option.age_17_under": "\u041C\u0435\u043D\u0448 \u0437\u0430 18 \u0433\u0430\u0434\u043E\u045E",
      "defaults.template.age.option.age_18_24": "18\u201324 \u0433\u0430\u0434\u044B",
      "defaults.template.age.option.age_25_34": "25\u201334 \u0433\u0430\u0434\u044B",
      "defaults.template.age.option.age_35_44": "35\u201344 \u0433\u0430\u0434\u044B",
      "defaults.template.age.option.age_45_54": "45\u201354 \u0433\u0430\u0434\u044B",
      "defaults.template.age.option.age_55_over": "55 \u0433\u0430\u0434\u043E\u045E \u0430\u0431\u043E \u0441\u0442\u0430\u0440\u044D\u0439\u0448\u044B\u044F",
      "defaults.template.sex.label": "\u041F\u0430\u0437\u043D\u0430\u0447\u0446\u0435 \u0432\u0430\u0448 \u043F\u043E\u043B",
      "defaults.template.sex.option.sex_female": "\u0416\u0430\u043D\u043E\u0447\u044B",
      "defaults.template.sex.option.sex_male": "\u041C\u0443\u0436\u0447\u044B\u043D\u0441\u043A\u0456",
      "defaults.widget.label": "\u0422\u0435\u043A\u0441\u0442",
      "errors.page.default": "\u0410\u0434\u0431\u044B\u043B\u0430\u0441\u044F \u043F\u0430\u043C\u044B\u043B\u043A\u0430 :(",
      "errors.page.notFound": "\u0421\u0442\u0430\u0440\u043E\u043D\u043A\u0430 \u043D\u0435 \u0437\u043D\u043E\u0439\u0434\u0437\u0435\u043D\u0430",
      "errors.server.default": "\u041F\u0430\u043C\u044B\u043B\u043A\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430",
      "errors.survey.alreadyFinished": "\u0412\u044B \u045E\u0436\u043E \u0441\u043A\u043E\u043D\u0447\u044B\u043B\u0456 \u0433\u044D\u0442\u0430\u0435 \u0430\u043F\u044B\u0442\u0430\u043D\u043D\u0435",
      "errors.survey.closed": "\u041D\u0430 \u0436\u0430\u043B\u044C, \u0434\u0430\u0441\u043B\u0435\u0434\u0430\u0432\u0430\u043D\u043D\u0435 \u045E\u0436\u043E \u0441\u043A\u043E\u043D\u0447\u0430\u043D\u0430",
      "errors.survey.notFound": "\u0421\u0442\u0430\u0440\u043E\u043D\u043A\u0430 \u043D\u0435 \u0437\u043D\u043E\u0439\u0434\u0437\u0435\u043D\u0430",
      "errors.survey.paused": "\u0410\u043F\u044B\u0442\u0430\u043D\u043D\u0435 \u043F\u0440\u044B\u043F\u044B\u043D\u0435\u043D\u0430",
      "final.thanks": "\u0414\u0437\u044F\u043A\u0443\u0439!",
      "footer.default.confidential.text": "\u041A\u0430\u043D\u0444\u0456\u0434\u044D\u043D\u0446\u044B\u044F\u043B\u044C\u043D\u0430",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "\u041A\u0430\u043D\u0444\u0456\u0434\u044D\u043D\u0446\u044B\u044F\u043B\u044C\u043D\u0430\u0441\u0446\u044C",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.default.copyright.text": "\xA9 %s \u0422\u0410\u0410 \xAB\u042F\u043D\u0434\u0435\u043A\u0441\xBB",
      "footer.default.copyrightInternal.text": "\xA9 %s \u0422\u0410\u0410 \xAB\u042F\u043D\u0434\u0435\u043A\u0441\xBB",
      "footer.default.createby.text": "\u0410\u043F\u044B\u0442\u0430\u043D\u043D\u0435 \u0437\u0440\u043E\u0431\u043B\u0435\u043D\u0430 \u043D\u0430 \u0442\u044D\u0445\u043D\u0430\u043B\u043E\u0433\u0456\u044F\u0445 \u042F\u043D\u0434\u044D\u043A\u0441 \u041F\u043E\u0433\u043B\u044F\u0434",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "\u0423\u043D\u0443\u0442\u0440\u0430\u043D\u0430\u0435 \u0430\u043F\u044B\u0442\u0430\u043D\u043D\u0435 \u042F\u043D\u0434\u044D\u043A\u0441\u0430",
      "footer.default.responsibility": "\u042F\u043D\u0434\u0435\u043A\u0441 \u043D\u0435 \u043C\u0430\u0435 \u0434\u0430\u0447\u044B\u043D\u0435\u043D\u043D\u044F \u0434\u0430 \u0430\u043F\u044B\u0442\u0430\u043D\u043D\u044F\u045E, \u0441\u0442\u0432\u043E\u0440\u0430\u043D\u044B\u0445 \u0442\u0440\u044D\u0446\u0456\u043C\u0456 \u0430\u0441\u043E\u0431\u0430\u043C\u0456, \u0456 \u043D\u0435 \u043D\u044F\u0441\u0435 \u0430\u0434\u043A\u0430\u0437\u043D\u0430\u0441\u0446\u0456 \u0437\u0430 \u0456\u0445 \u0437\u043C\u0435\u0441\u0442.",
      "footer.default.termsofuse.text": "\u0423\u043C\u043E\u0432\u044B \u0432\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043D\u043D\u044F",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/",
      "footer.odnaco.confpolicy.text": "\u041F\u0430\u043B\u0456\u0442\u044B\u043A\u0430 \u043A\u0430\u043D\u0444\u0456\u0434\u044D\u043D\u0446\u044B\u044F\u043B\u044C\u043D\u0430\u0441\u0446\u0456",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "\u041A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u0446\u043A\u0430\u0435 \u043F\u0430\u0433\u0430\u0434\u043D\u0435\u043D\u043D\u0435",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/index.html",
      "info.survey.thanks": "\u0410\u043F\u044B\u0442\u0430\u043D\u043D\u0435 \u0441\u043A\u043E\u043D\u0447\u0430\u043D\u0430. \u0414\u0437\u044F\u043A\u0443\u0439!",
      "labels.columnHidden": "\u0421\u0442\u043E\u043B\u0431\u0435\u0446 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.hiddenQuestionsActivated": "\u0421\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u044E\u0442\u0441\u044F",
      "labels.hiddenQuestionsDeactivated": "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0441\u043A\u0440\u044B\u0442\u044B\u0445 \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432 \u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
      "labels.optionHidden": "\u041E\u0442\u0432\u0435\u0442 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.page": "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
      "labels.questionHidden": "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.rotationGroup": "\u0413\u0440\u0443\u043F\u043F\u0430",
      "labels.rowHidden": "\u0421\u0442\u0440\u043E\u043A\u0430 \u0441\u043A\u0440\u044B\u0442\u0430 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.screening": "\u0421\u043A\u0440\u0438\u043D\u0438\u0440\u0443\u044E\u0449\u0438\u0439 \u0432\u043E\u043F\u0440\u043E\u0441",
      "labels.showHiddenQuestions": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
      "labels.widgetHidden": "\u0422\u0435\u043A\u0441\u0442 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "page.buttonBack": "\u041D\u0430\u0437\u0430\u0434",
      "page.buttonNext": "\u0414\u0430\u043B\u0435\u0439",
      "page.buttonSkip": "\u041F\u0440\u0430\u043F\u0443\u0441\u0446\u0456\u0446\u044C",
      "page.title": "\u041F\u0440\u0430\u0439\u0434\u0437\u0456\u0446\u0435 \u0430\u043F\u044B\u0442\u0430\u043D\u043D\u0435",
      "page.watermark": "\u041F\u0410\u041F\u042F\u0420\u042D\u0414\u041D\u0406 \u041F\u0420\u0410\u0413\u041B\u042F\u0414 \u0410\u0414\u041A\u0410\u0417\u042B \u041D\u0415 \u040E\u041B\u0406\u0427\u0412\u0410\u042E\u0426\u0426\u0410 \u041F\u0410\u041F\u042F\u0420\u042D\u0414\u041D\u0406 \u041F\u0420\u0410\u0413\u041B\u042F\u0414 \u0410\u0414\u041A\u0410\u0417\u042B \u041D\u0415 \u040E\u041B\u0406\u0427\u0412\u0410\u042E\u0426\u0426\u0410 \u041F\u0410\u041F\u042F\u0420\u042D\u0414\u041D\u0406 \u041F\u0420\u0410\u0413\u041B\u042F\u0414 \u0410\u0414\u041A\u0410\u0417\u042B \u041D\u0415 \u040E\u041B\u0406\u0427\u0412\u0410\u042E\u0426\u0426\u0410",
      "placeholders.longText": "\u0412\u0430\u0448 \u043A\u0430\u043C\u0435\u043D\u0442\u0430\u0440\u044B\u0439",
      "placeholders.shortText": "\u0412\u0430\u0448 \u043A\u0430\u043C\u0435\u043D\u0442\u0430\u0440\u044B\u0439",
      "plural.answers.im": [
        "\u0430\u0434\u043A\u0430\u0437",
        "\u0430\u0434\u043A\u0430\u0437\u0443",
        "\u0430\u0434\u043A\u0430\u0437\u0430\u045E",
        "\u0430\u0434\u043A\u0430\u0437\u0430\u045E"
      ],
      "plural.answers.ro": [
        "\u0430\u0434\u043A\u0430\u0437\u0443",
        "\u0430\u0434\u043A\u0430\u0437\u0430\u045E",
        "\u0430\u0434\u043A\u0430\u0437\u0430\u045E",
        "\u0430\u0434\u043A\u0430\u0437\u0430\u045E"
      ],
      "plural.ratingStars.labels": [
        "\u0437\u043E\u0440\u043A\u0430",
        "\u0437\u043E\u0440\u043A\u0456",
        "\u0437\u043E\u0440\u0430\u043A",
        ""
      ],
      "plural.seconds.im": [
        "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        "\u0441\u0435\u043A\u0443\u043D\u0434\u044B",
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434"
      ],
      "plural.seconds.ro": [
        "\u0441\u0435\u043A\u0443\u043D\u0434\u044B",
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434"
      ],
      "questionModel.awful": "\u0416\u0430\u0445\u043B\u0456\u0432\u0430",
      "questionModel.bad": "\u0414\u0440\u044D\u043D\u043D\u0430",
      "questionModel.dateLessThan": "\u0414\u0430\u0442\u0430 \u043D\u0435 \u043C\u043E\u0436\u0430 \u0431\u044B\u0446\u044C \u0440\u0430\u043D\u0435\u0439\u0448\u0430\u044F \u0437\u0430 %s",
      "questionModel.dateMoreThan": "\u0414\u0430\u0442\u0430 \u043D\u0435 \u043C\u043E\u0436\u0430 \u0431\u044B\u0446\u044C \u043F\u0430\u0437\u043D\u0435\u0439\u0448\u0430\u044F \u0437\u0430 %s",
      "questionModel.datePlaceholder": "\u0423\u0432\u044F\u0434\u0437\u0456\u0446\u0435 \u0434\u0430\u0442\u0443",
      "questionModel.insufficientAnswers": [
        "\u0412\u044B \u0432\u044B\u0431\u0440\u0430\u043B\u0456 \u043C\u0435\u043D\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437",
        "\u0412\u044B \u0432\u044B\u0431\u0440\u0430\u043B\u0456 \u043C\u0435\u043D\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437\u0430\u045E",
        "\u0412\u044B \u0432\u044B\u0431\u0440\u0430\u043B\u0456 \u043C\u0435\u043D\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437\u0430\u045E",
        ""
      ],
      "questionModel.lessThan": "\u041B\u0456\u0447\u0431\u0430 \u043D\u0435 \u043C\u043E\u0436\u0430 \u0431\u044B\u0446\u044C \u043C\u0435\u043D\u0448 \u0437\u0430 %s",
      "questionModel.maxAnswerPerRowExceeded": "\u041F\u0435\u0440\u0430\u0432\u044B\u0448\u0430\u043D\u0430 \u043A\u043E\u043B\u044C\u043A\u0430\u0441\u0446\u044C \u043C\u0430\u043A\u0441\u0456\u043C\u0430\u043B\u044C\u043D\u0430 \u0434\u0430\u043F\u0443\u0448\u0447\u0430\u043B\u044C\u043D\u044B\u0445 \u0430\u0434\u043A\u0430\u0437\u0430\u045E \u0443 \u0440\u0430\u0434\u043A\u0443",
      "questionModel.maxLenghtExceeded": "\u041A\u043E\u043B\u044C\u043A\u0430\u0441\u0446\u044C \u0437\u043D\u0430\u043A\u0430\u045E \u043F\u0435\u0440\u0430\u0432\u044B\u0448\u0430\u0435 \u043C\u0430\u043A\u0441\u0456\u043C\u0430\u043B\u044C\u043D\u0430 \u0434\u0430\u043F\u0443\u0448\u0447\u0430\u043B\u044C\u043D\u0443\u044E, \u043A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u0441\u043A\u0430\u0440\u0430\u0446\u0456\u0446\u0435 \u0442\u044D\u043A\u0441\u0442",
      "questionModel.moreThan": "\u041B\u0456\u0447\u0431\u0430 \u043D\u0435 \u043C\u043E\u0436\u0430 \u0431\u044B\u0446\u044C \u0431\u043E\u043B\u044C\u0448 \u0437\u0430 %s",
      "questionModel.normally": "\u041D\u0430\u0440\u043C\u0430\u043B\u044C\u043D\u0430",
      "questionModel.notDate": "\u0423\u0432\u0435\u0434\u0437\u0435\u043D\u0430 \u043D\u0435\u043A\u0430\u0440\u044D\u043A\u0442\u043D\u0430\u044F \u0434\u0430\u0442\u0430",
      "questionModel.notEmail": "\u041F\u0430\u0432\u0456\u043D\u0435\u043D \u0430\u0434\u043F\u0430\u0432\u044F\u0434\u0430\u0446\u044C \u0444\u0430\u0440\u043C\u0430\u0442\u0443 email",
      "questionModel.notFilled": "\u0422\u0440\u044D\u0431\u0430 \u045E\u0432\u0435\u0441\u0446\u0456 \u0442\u044D\u043A\u0441\u0442",
      "questionModel.notNumber": "\u041C\u043E\u0436\u0430 \u045E\u0442\u0440\u044B\u043C\u043B\u0456\u0432\u0430\u0446\u044C \u0442\u043E\u043B\u044C\u043A\u0456 \u043B\u0456\u0447\u0431\u044B",
      "questionModel.perfectly": "\u0412\u044B\u0434\u0430\u0442\u043D\u0430",
      "questionModel.picture": "\u0412\u044B\u044F\u0432\u0430 %s",
      "questionModel.requiredField": "\u041D\u0435 \u043F\u0430\u043A\u0456\u0434\u0430\u0439\u0446\u0435 \u0433\u044D\u0442\u0430 \u043F\u044B\u0442\u0430\u043D\u043D\u0435 \u0431\u0435\u0437 \u0430\u0434\u043A\u0430\u0437\u0443",
      "questionModel.tooManyAnswers": [
        "\u0412\u044B \u0432\u044B\u0431\u0440\u0430\u043B\u0456 \u0431\u043E\u043B\u044C\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437\u0443",
        "\u0412\u044B \u0432\u044B\u0431\u0440\u0430\u043B\u0456 \u0431\u043E\u043B\u044C\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437\u0430\u045E",
        "\u0412\u044B \u0432\u044B\u0431\u0440\u0430\u043B\u0456 \u0431\u043E\u043B\u044C\u0448 \u0437\u0430 %s \u0430\u0434\u043A\u0430\u0437\u0430\u045E",
        ""
      ],
      "questionModel.well": "\u0414\u043E\u0431\u0440\u0430",
      "sidebyside.option": "\u0412\u0430\u0440\u044B\u044F\u043D\u0442 %s",
      "templates.options.age.age18_24": "18\u201324 \u0433\u0430\u0434\u044B",
      "templates.options.age.age25_34": "25\u201334 \u0433\u0430\u0434\u044B",
      "templates.options.age.age35_44": "35\u201344 \u0433\u0430\u0434\u044B",
      "templates.options.age.age45_54": "45\u201354 \u0433\u0430\u0434\u044B",
      "templates.options.age.age55_over": "55 \u0433\u0430\u0434\u043E\u045E \u0430\u0431\u043E \u0441\u0442\u0430\u0440\u044D\u0439\u0448\u044B\u044F",
      "templates.options.sex.sex_female": "\u0416\u0430\u043D\u043E\u0447\u044B",
      "templates.options.sex.sex_male": "\u041C\u0443\u0436\u0447\u044B\u043D\u0441\u043A\u0456",
      "templates.questions.age": "\u041F\u0430\u0437\u043D\u0430\u0447\u0446\u0435, \u043A\u043E\u043B\u044C\u043A\u0456 \u0432\u0430\u043C \u043F\u043E\u045E\u043D\u044B\u0445 \u0433\u0430\u0434\u043E\u045E",
      "templates.questions.sex": "\u041F\u0430\u0437\u043D\u0430\u0447\u0446\u0435 \u0432\u0430\u0448 \u043F\u043E\u043B",
      "ux.stepPaginator.stepTitle": "\u041A\u0440\u043E\u043A %s/%s",
      "video.holdBtn": "\u0423\u0442\u0440\u044B\u043C\u043B\u0456\u0432\u0430\u0439\u0446\u0435, \u043F\u0430\u043A\u0443\u043B\u044C \u0431\u0430\u0447\u044B\u0446\u0435 \u0431\u0440\u044D\u043D\u0434",
      "video.statusBarTitle": "\u0411\u0440\u044D\u043D\u0434 \u0431\u044B\u043B\u043E \u0431\u0430\u0447\u043D\u0430 \u0430\u0434 %1 \u0441\u0435\u043A \u0434\u0430 %2 \u0441\u0435\u043A"
    }
  },
  de: {
    poll: {
      "attach.image.notLess": "Schau dir das Bild f\xFCr mindestens %1 an und beantworte ein paar Fragen",
      "attach.image.notMore": "Schau dir das Bild f\xFCr %1 an und beantworte ein paar Fragen",
      "attach.text.notLess": "Schau dir den Text f\xFCr mindestens %1 an und beantworte ein paar Fragen",
      "attach.text.notMore": "Lies den Text f\xFCr %1 an und beantworte ein paar Fragen",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "Schau dir das Video f\xFCr mindestens %1 an und beantworte ein paar Fragen",
      "attach.video.notMore": "Schau dir das Video f\xFCr %1 an und beantworte ein paar Fragen",
      "attach.video.waitEnd": "Schau dir das Video bis zum Ende an und beantworte ein paar Fragen",
      "attach.watch": "Anschauen",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "Sonst etwas...",
      "commonComponents.choice.chooseLessEqualMore": [
        "W\xE4hlen Sie %s Antwort",
        "W\xE4hlen Sie %s Antworten",
        "W\xE4hlen Sie % Antworten",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "W\xE4hlen Sie zumindest %s Antwort",
        "W\xE4hlen Sie zumindest %s Antworten",
        "W\xE4hlen Sie zumindest %s Antworten",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "W\xE4hlen Sie mindestens %s und maximal %s",
      "commonComponents.choice.chooseNoMore": [
        "Bitte w\xE4hle nur %s Antwort",
        "Bitte w\xE4hle nicht mehr als %s Antworten",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "Text eingeben",
      "commonComponents.choice.yourComment": "Kommentar abgeben...",
      "commonComponents.scale.chooseRate": "Bitte bewerten",
      "commonComponents.scale.firstElement": "Die erste Option %s bedeutet",
      "commonComponents.scale.lastElement": "Die letzte Option %s bedeutet",
      "commonComponents.table.chooseNoMore": [
        "W\xE4hlen Sie maximal %s Antwort pro Zeile",
        "W\xE4hlen Sie maximal %s Antworten pro Zeile",
        "W\xE4hlen Sie maximal %s Antworten pro Zeile",
        ""
      ],
      "defaults.agree": "V\xF6llig einverstanden",
      "defaults.back": "Zur\xFCck",
      "defaults.datePlaceholder": "dd.mm.yyyy",
      "defaults.disagree": "Ganz und gar nicht einverstanden",
      "defaults.dualChoice.label": "Kontrollk\xE4stchen",
      "defaults.emoji1": "Schrecklich",
      "defaults.emoji2": "Schlecht",
      "defaults.emoji3": "Normal",
      "defaults.emoji4": "Gut",
      "defaults.emoji5": "Perfekt",
      "defaults.next": "Weiter",
      "defaults.noAnswer": "Keine der obigen Optionen",
      "defaults.noOpinionAnswer": "Unsicher",
      "defaults.otherAnswer": "Andere",
      "defaults.otherAnswerWithText": "Sonstiges (freie Antwort)",
      "defaults.template.age.label": "Wie alt sind Sie?",
      "defaults.template.age.option.age_17_under": "Unter 18 Jahre",
      "defaults.template.age.option.age_18_24": "18\u201324 Jahre alt",
      "defaults.template.age.option.age_25_34": "25\u201334 Jahre alt",
      "defaults.template.age.option.age_35_44": "35\u201344 Jahre alt",
      "defaults.template.age.option.age_45_54": "45\u201354 Jahre alt",
      "defaults.template.age.option.age_55_over": "55 Jahre alt oder \xE4lter",
      "defaults.template.sex.label": "Was ist Ihr Geschlecht?",
      "defaults.template.sex.option.sex_female": "Weiblich",
      "defaults.template.sex.option.sex_male": "M\xE4nnlich",
      "defaults.widget.label": "Text",
      "errors.page.default": "Ups, ein Fehler ist aufgetreten",
      "errors.page.notFound": "Seite nicht gefunden",
      "errors.server.default": "Server-Fehler",
      "errors.survey.alreadyFinished": "Du hast diese Umfrage bereits ausgef\xFCllt",
      "errors.survey.closed": "Leider ist diese Forschung beendet",
      "errors.survey.notFound": "Seite nicht gefunden",
      "errors.survey.paused": "Umfrage pausiert",
      "final.thanks": "Vielen Dank!",
      "footer.default.confidential.text": "Vertraulich",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "Vertraulichkeit",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "Die Umfrage basiert auf Yandex Surveys Technologien",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Yandex-interne Umfrage",
      "footer.default.responsibility": "Einige Umfragen werden von Dritten erstellt. Yandex pr\xFCft oder verifiziert deren Inhalte nicht und \xFCbernimmt auch keine Verantwortung f\xFCr sie.",
      "footer.default.termsofuse.text": "Nutzungsbedingungen",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "Vertraulichkeit",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "Nutzungsbedingungen",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "Die Umfrage ist abgeschlossen. Danke!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "Zur\xFCck",
      "page.buttonNext": "Weiter",
      "page.buttonSkip": "\xDCberspringen",
      "page.title": "An der Umfrage teilnehmen",
      "page.watermark": "VORSCHAUANTWORTEN WERDEN NICHT BER\xDCCKSICHTIGT VORSCHAUANTWORTEN WERDEN NICHT BER\xDCCKSICHTIGT VORSCHAUANTWORTEN WERDEN NICHT BER\xDCCKSICHTIGT",
      "placeholders.longText": "Kommentar abgeben",
      "placeholders.shortText": "Kommentar abgeben",
      "plural.answers.im": [
        "Antwort",
        "Antworten",
        "Antworten",
        "Antworten"
      ],
      "plural.answers.ro": [
        "Antwort",
        "Antworten",
        "Antworten",
        "Antworten"
      ],
      "plural.ratingStars.labels": [
        "Stern",
        "Sterne",
        "Sterne",
        ""
      ],
      "plural.seconds.im": [
        "Sekunde",
        "Sekunden",
        "Sekunden",
        "Sekunden"
      ],
      "plural.seconds.ro": [
        "Sekunden",
        "Sekunden",
        "Sekunden",
        "Sekunden"
      ],
      "questionModel.awful": "Schrecklich",
      "questionModel.bad": "Schlecht",
      "questionModel.dateLessThan": "Das Datum darf nicht fr\xFCher als %s sein",
      "questionModel.dateMoreThan": "Das Datum darf nicht sp\xE4ter als %s sein",
      "questionModel.datePlaceholder": "W\xE4hle ein Datum",
      "questionModel.insufficientAnswers": [
        "Sie haben weniger als %s Antwort gew\xE4hlt",
        "Sie haben weniger als %s Antworten gew\xE4hlt",
        "Sie haben weniger als %s Antworten gew\xE4hlt",
        ""
      ],
      "questionModel.lessThan": "Die Zahl darf nicht kleiner als %s sein",
      "questionModel.maxAnswerPerRowExceeded": "Sie haben die maximale Anzahl an Antworten pro Zeile erreicht",
      "questionModel.maxLenghtExceeded": "Zu viele Zeichen! Bitte Text k\xFCrzen!",
      "questionModel.moreThan": "Die Zahl darf nicht gr\xF6\xDFer als %s sein",
      "questionModel.normally": "Normal",
      "questionModel.notDate": "Ung\xFCltiges Datum",
      "questionModel.notEmail": "Muss dem E-Mail-Format entsprechen",
      "questionModel.notFilled": "Bitte gib deine Antwort hier ein",
      "questionModel.notNumber": "Kann nur Zahlen enthalten",
      "questionModel.perfectly": "Perfekt",
      "questionModel.picture": "Bild %s",
      "questionModel.requiredField": "Bitte lass diese Frage nicht unbeantwortet",
      "questionModel.tooManyAnswers": [
        "Mehr als %s Antwort ausgew\xE4hlt",
        "Mehr als %s Antworten ausgew\xE4hlt",
        "",
        ""
      ],
      "questionModel.well": "Gut",
      "sidebyside.option": "Option %s",
      "templates.options.age.age18_24": "18\u201324 Jahre alt",
      "templates.options.age.age25_34": "25\u201334 Jahre alt",
      "templates.options.age.age35_44": "35\u201344 Jahre alt",
      "templates.options.age.age45_54": "45\u201354 Jahre alt",
      "templates.options.age.age55_over": "55 Jahre alt oder \xE4lter",
      "templates.options.sex.sex_female": "Weiblich",
      "templates.options.sex.sex_male": "M\xE4nnlich",
      "templates.questions.age": "Wie alt sind Sie?",
      "templates.questions.sex": "Was ist Ihr Geschlecht?",
      "ux.stepPaginator.stepTitle": "Schritt %s von %s",
      "video.holdBtn": "Dr\xFCcke und halte, w\xE4hrend du die Marke siehst",
      "video.statusBarTitle": "Die Marke war von der %1 Sekunde bis zur %2 Sekunde sichtbar"
    }
  },
  en: {
    poll: {
      "attach.image.notLess": "Look at the picture for at least %1 and answer a few questions",
      "attach.image.notMore": "Look at the picture for %1 and answer a few questions",
      "attach.text.notLess": "Look at the text for at least %1 and answer a few questions",
      "attach.text.notMore": "Read the text for %1 and answer a few questions",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "Watch the video for at least %1 and answer a few questions",
      "attach.video.notMore": "Watch the video for %1 and answer a few questions",
      "attach.video.waitEnd": "Watch the video to the end and answer a few questions",
      "attach.watch": "Watch",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "Something else...",
      "commonComponents.choice.chooseLessEqualMore": [
        "Choose %s answer",
        "Choose %s answers",
        "Choose % answers",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "Select at least %s answer",
        "Select at least %s answers",
        "Select at least %s answers",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "Select no less than %s and no more than %s",
      "commonComponents.choice.chooseNoMore": [
        "Please choose only %s answer",
        "Please choose no more than %s answers",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "Enter text",
      "commonComponents.choice.yourComment": "Enter your comment...",
      "commonComponents.scale.chooseRate": "Please rate",
      "commonComponents.scale.firstElement": "The first option %s means",
      "commonComponents.scale.lastElement": "The last option %s means",
      "commonComponents.table.chooseNoMore": [
        "Select no more than %s answer in a row",
        "Select no more than %s answers in a row",
        "Select no more than %s answers in a row",
        ""
      ],
      "defaults.agree": "Completely agree",
      "defaults.back": "Back",
      "defaults.datePlaceholder": "dd.mm.yyyy",
      "defaults.disagree": "Completely disagree",
      "defaults.dualChoice.label": "Checkbox",
      "defaults.emoji1": "Awful",
      "defaults.emoji2": "Bad",
      "defaults.emoji3": "Normal",
      "defaults.emoji4": "Good",
      "defaults.emoji5": "Perfect",
      "defaults.next": "Next",
      "defaults.noAnswer": "None of the above",
      "defaults.noOpinionAnswer": "Unsure",
      "defaults.otherAnswer": "Other",
      "defaults.otherAnswerWithText": "Other (free response)",
      "defaults.template.age.label": "What's your age?",
      "defaults.template.age.option.age_17_under": "Under 18",
      "defaults.template.age.option.age_18_24": "18\u201324 years old",
      "defaults.template.age.option.age_25_34": "25\u201334 years old",
      "defaults.template.age.option.age_35_44": "35\u201344 years old",
      "defaults.template.age.option.age_45_54": "45\u201354 years old",
      "defaults.template.age.option.age_55_over": "55 or older",
      "defaults.template.sex.label": "What's your gender?",
      "defaults.template.sex.option.sex_female": "Female",
      "defaults.template.sex.option.sex_male": "Male",
      "defaults.widget.label": "Text",
      "errors.page.default": "Oops, an error occurred",
      "errors.page.notFound": "Page not found",
      "errors.server.default": "Server error",
      "errors.survey.alreadyFinished": "You've already completed this survey",
      "errors.survey.closed": "Unfortunately, this research has ended",
      "errors.survey.notFound": "Page not found",
      "errors.survey.paused": "Survey paused",
      "final.thanks": "Thank you!",
      "footer.default.confidential.text": "Confidential",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "Confidentiality",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "The survey is powered by Yandex Surveys technologies",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Yandex internal survey",
      "footer.default.responsibility": "Some surveys are created by third parties. Yandex does not check or verify their contents, nor take any responsibility for them.",
      "footer.default.termsofuse.text": "Terms of Use",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "Confidentiality",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "Terms of Use",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "The survey is completed. Thanks!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "Back",
      "page.buttonNext": "Next",
      "page.buttonSkip": "Skip",
      "page.title": "Take the survey",
      "page.watermark": "PREVIEW ANSWERS ARE NOT TAKEN INTO ACCOUNT PREVIEW ANSWERS ARE NOT TAKEN INTO ACCOUNT PREVIEW ANSWERS ARE NOT TAKEN INTO ACCOUNT",
      "placeholders.longText": "Enter your comment",
      "placeholders.shortText": "Enter your comment",
      "plural.answers.im": [
        "answer",
        "answers",
        "answers",
        "answers"
      ],
      "plural.answers.ro": [
        "answer",
        "answers",
        "answers",
        "answers"
      ],
      "plural.ratingStars.labels": [
        "star",
        "stars",
        "stars",
        ""
      ],
      "plural.seconds.im": [
        "second",
        "seconds",
        "seconds",
        "seconds"
      ],
      "plural.seconds.ro": [
        "seconds",
        "seconds",
        "seconds",
        "seconds"
      ],
      "questionModel.awful": "Awful",
      "questionModel.bad": "Bad",
      "questionModel.dateLessThan": "The date can't be earlier than %s",
      "questionModel.dateMoreThan": "The date can't be later than %s",
      "questionModel.datePlaceholder": "Select a date",
      "questionModel.insufficientAnswers": [
        "You've selected less than %s answer",
        "You've selected less than %s answers",
        "You've selected less than %s answers",
        ""
      ],
      "questionModel.lessThan": "The number can't be less than %s",
      "questionModel.maxAnswerPerRowExceeded": "You've exceeded the maximum number of answers in a row",
      "questionModel.maxLenghtExceeded": "Character limit exceeded. Please shorten your answer.",
      "questionModel.moreThan": "The number can't be more than %s",
      "questionModel.normally": "Normal",
      "questionModel.notDate": "Invalid date",
      "questionModel.notEmail": "Must match email format",
      "questionModel.notFilled": "Please enter your answer here",
      "questionModel.notNumber": "Can only contain numbers",
      "questionModel.perfectly": "Perfect",
      "questionModel.picture": "Image %s",
      "questionModel.requiredField": "Please don't leave this question unanswered",
      "questionModel.tooManyAnswers": [
        "More than %s answer chosen",
        "More than %s answers chosen",
        "",
        ""
      ],
      "questionModel.well": "Good",
      "sidebyside.option": "Option %s",
      "templates.options.age.age18_24": "18\u201324 years old",
      "templates.options.age.age25_34": "25\u201334 years old",
      "templates.options.age.age35_44": "35\u201344 years old",
      "templates.options.age.age45_54": "45\u201354 years old",
      "templates.options.age.age55_over": "55 or older",
      "templates.options.sex.sex_female": "Female",
      "templates.options.sex.sex_male": "Male",
      "templates.questions.age": "What's your age?",
      "templates.questions.sex": "What's your gender?",
      "ux.stepPaginator.stepTitle": "Step %s of %s",
      "video.holdBtn": "Press and hold while you see the brand",
      "video.statusBarTitle": "The brand was visible from the %1 second to the %2 second"
    }
  },
  es: {
    poll: {
      "attach.image.notLess": "Mira la imagen durante al menos %1 y responde a algunas preguntas",
      "attach.image.notMore": "Mira la imagen durante %1 y responde a algunas preguntas",
      "attach.text.notLess": "Mira el texto durante al menos %1 y responde a algunas preguntas",
      "attach.text.notMore": "Lee el texto durante %1 y responde algunas preguntas",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "Ve el v\xEDdeo durante al menos %1 y responde algunas preguntas",
      "attach.video.notMore": "Ve el v\xEDdeo durante %1 y responde algunas preguntas",
      "attach.video.waitEnd": "Ve el v\xEDdeo hasta el final y responde algunas preguntas",
      "attach.watch": "Ver",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "Algo m\xE1s...",
      "commonComponents.choice.chooseLessEqualMore": [
        "Elige %s respuesta",
        "Elige %s respuestas",
        "Elige % respuestas",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "Selecciona al menos %s respuesta",
        "Selecciona al menos %s respuestas",
        "Selecciona al menos %s respuestas",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "Selecciona no menos de %s y no m\xE1s de %s",
      "commonComponents.choice.chooseNoMore": [
        "Por favor, elija solo %s respuesta.",
        "Por favor, no elija m\xE1s de %s respuestas.",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "Introducir texto",
      "commonComponents.choice.yourComment": "Introduce tu comentario...",
      "commonComponents.scale.chooseRate": "Indique su opini\xF3n",
      "commonComponents.scale.firstElement": "La primera opci\xF3n %s significa",
      "commonComponents.scale.lastElement": "La \xFAltima opci\xF3n %s significa",
      "commonComponents.table.chooseNoMore": [
        "No selecciones m\xE1s de %s respuesta seguida",
        "No selecciones m\xE1s de %s respuestas seguidas",
        "No selecciones m\xE1s de %s respuestas seguidas",
        ""
      ],
      "defaults.agree": "Totalmente de acuerdo",
      "defaults.back": "Volver",
      "defaults.datePlaceholder": "dd.mm.aaaa",
      "defaults.disagree": "Totalmente en desacuerdo",
      "defaults.dualChoice.label": "Casilla de verificaci\xF3n",
      "defaults.emoji1": "Horrible",
      "defaults.emoji2": "Malo",
      "defaults.emoji3": "Normal",
      "defaults.emoji4": "Bueno",
      "defaults.emoji5": "Perfecto",
      "defaults.next": "Siguiente",
      "defaults.noAnswer": "Ninguna de las anteriores",
      "defaults.noOpinionAnswer": "No estoy seguro/a",
      "defaults.otherAnswer": "Otro",
      "defaults.otherAnswerWithText": "Otro (respuesta libre)",
      "defaults.template.age.label": "\xBFCu\xE1ntos a\xF1os tienes?",
      "defaults.template.age.option.age_17_under": "Menor de 18",
      "defaults.template.age.option.age_18_24": "18-24 a\xF1os",
      "defaults.template.age.option.age_25_34": "25-34 a\xF1os",
      "defaults.template.age.option.age_35_44": "35-44 a\xF1os",
      "defaults.template.age.option.age_45_54": "45-54 a\xF1os",
      "defaults.template.age.option.age_55_over": "55 a\xF1os o m\xE1s",
      "defaults.template.sex.label": "\xBFCu\xE1l es tu g\xE9nero?",
      "defaults.template.sex.option.sex_female": "Femenino",
      "defaults.template.sex.option.sex_male": "Masculino",
      "defaults.widget.label": "Text",
      "errors.page.default": "Vaya, se ha producido un error",
      "errors.page.notFound": "P\xE1gina no encontrada",
      "errors.server.default": "Error del servidor",
      "errors.survey.alreadyFinished": "Ya ha realizado esta encuesta.",
      "errors.survey.closed": "Por desgracia, este estudio ha terminado",
      "errors.survey.notFound": "P\xE1gina no encontrada",
      "errors.survey.paused": "Encuesta pausada",
      "final.thanks": "\xA1Gracias!",
      "footer.default.confidential.text": "Confidencial",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "Confidencialidad",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "La encuesta utiliza la tecnolog\xEDa de Yandex Surveys",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Encuesta interna de Yandex",
      "footer.default.responsibility": "Algunas encuestas proceden de terceras partes. Yandex no comprueba o verifica sus contenidos, ni se responsabiliza de ninguna de ellas.",
      "footer.default.termsofuse.text": "Condiciones de uso",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "Confidencialidad",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "Condiciones de uso",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "La encuesta se ha completado. \xA1Gracias!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "Volver",
      "page.buttonNext": "Siguiente",
      "page.buttonSkip": "Saltar",
      "page.title": "Realizar la encuesta",
      "page.watermark": "VISTA PREVIA. LAS RESPUESTAS NO SE TIENEN EN CUENTA VISTA PREVIA. LAS RESPUESTAS NO SE TIENEN EN CUENTA VISTA PREVIA. LAS RESPUESTAS NO SE TIENEN EN CUENTA",
      "placeholders.longText": "Introduce tu comentario",
      "placeholders.shortText": "Introduce tu comentario",
      "plural.answers.im": [
        "respuesta",
        "respuestas",
        "respuestas",
        "respuestas"
      ],
      "plural.answers.ro": [
        "respuesta",
        "respuestas",
        "respuestas",
        "respuestas"
      ],
      "plural.ratingStars.labels": [
        "estrella",
        "estrellas",
        "estrellas",
        ""
      ],
      "plural.seconds.im": [
        "segundo",
        "segundos",
        "segundos",
        "segundos"
      ],
      "plural.seconds.ro": [
        "segundos",
        "segundos",
        "segundos",
        "segundos"
      ],
      "questionModel.awful": "Horrible",
      "questionModel.bad": "Malo",
      "questionModel.dateLessThan": "La fecha no puede ser anterior a %s",
      "questionModel.dateMoreThan": "La fecha no puede ser posterior a %s",
      "questionModel.datePlaceholder": "Select a date",
      "questionModel.insufficientAnswers": [
        "Has seleccionado menos de %s respuesta",
        "Has seleccionado menos de %s respuestas",
        "Has seleccionado menos de %s respuestas",
        ""
      ],
      "questionModel.lessThan": "El n\xFAmero no puede ser inferior a %s.",
      "questionModel.maxAnswerPerRowExceeded": "Has superado el n\xFAmero m\xE1ximo de respuestas seguidas",
      "questionModel.maxLenghtExceeded": "L\xEDmite de caracteres superado. Por favor, acorta tu respuesta.",
      "questionModel.moreThan": "El n\xFAmero no puede ser superior a %s.",
      "questionModel.normally": "Normal",
      "questionModel.notDate": "Fecha no v\xE1lida",
      "questionModel.notEmail": "El texto debe tener formato de correo electr\xF3nico.",
      "questionModel.notFilled": "Por favor, introduzca su respuesta aqu\xED.",
      "questionModel.notNumber": "Solo puede contener n\xFAmeros.",
      "questionModel.perfectly": "Perfecto",
      "questionModel.picture": "Imagen %s",
      "questionModel.requiredField": "Por favor, no deje esta pregunta sin responder",
      "questionModel.tooManyAnswers": [
        "Ha elegido m\xE1s de %s respuesta.",
        "Ha elegido m\xE1s de %s respuestas.",
        "",
        ""
      ],
      "questionModel.well": "Bueno",
      "sidebyside.option": "Opci\xF3n %s",
      "templates.options.age.age18_24": "18-24 a\xF1os",
      "templates.options.age.age25_34": "25-34 a\xF1os",
      "templates.options.age.age35_44": "35-44 a\xF1os",
      "templates.options.age.age45_54": "45-54 a\xF1os",
      "templates.options.age.age55_over": "55 a\xF1os o m\xE1s",
      "templates.options.sex.sex_female": "Femenino",
      "templates.options.sex.sex_male": "Masculino",
      "templates.questions.age": "\xBFCu\xE1ntos a\xF1os tienes?",
      "templates.questions.sex": "\xBFCu\xE1l es tu g\xE9nero?",
      "ux.stepPaginator.stepTitle": "Paso %s de %s",
      "video.holdBtn": "Mant\xE9n pulsada la tecla mientras veas la marca",
      "video.statusBarTitle": "La marca era visible desde el segundo %1 hasta el segundo %2"
    }
  },
  fi: {
    poll: {
      "attach.image.notLess": "Katso kuvaa v\xE4hint\xE4\xE4n %1 ja vastaa muutamaan kysymykseen",
      "attach.image.notMore": "Katso kuvaa %1 ja vastaa muutamaan kysymykseen",
      "attach.text.notLess": "Katso teksti\xE4 v\xE4hint\xE4\xE4n %1 ja vastaa muutamaan kysymykseen",
      "attach.text.notMore": "Lue teksti\xE4 %1 ja vastaa muutamaan kysymykseen",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "Katso videota v\xE4hint\xE4\xE4n %1 ja vastaa muutamaan kysymykseen",
      "attach.video.notMore": "Katso videota %1 ja vastaa muutamaan kysymykseen",
      "attach.video.waitEnd": "Katso video loppuun saakka ja vastaa muutamaan kysymykseen",
      "attach.watch": "Katso",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "Jotain muuta...",
      "commonComponents.choice.chooseLessEqualMore": [
        "Valitse %s vastaus",
        "Valitse %s vastausta",
        "Valitse % vastausta",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "Valitse v\xE4hint\xE4\xE4n %svastaus",
        "Valitse v\xE4hint\xE4\xE4n %svastausta",
        "Valitse v\xE4hint\xE4\xE4n %svastausta",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "Valitse v\xE4hint\xE4\xE4n %s ja enint\xE4\xE4n %s",
      "commonComponents.choice.chooseNoMore": [
        "Valitse vain %s vastaus",
        "Valitse korkeintaan %s vastausta",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "Sy\xF6t\xE4 vastaus",
      "commonComponents.choice.yourComment": "Sy\xF6t\xE4 kommenttisi...",
      "commonComponents.scale.chooseRate": "Arvostele",
      "commonComponents.scale.firstElement": "Ensimm\xE4inen vaihtoehto %s tarkoittaa",
      "commonComponents.scale.lastElement": "Viimeinen vaihtoehto %s tarkoittaa",
      "commonComponents.table.chooseNoMore": [
        "Valitse enint\xE4\xE4n %s vastaus rivist\xE4",
        "Valitse enint\xE4\xE4n %s vastausta rivist\xE4",
        "Valitse enint\xE4\xE4n %s vastausta rivist\xE4",
        ""
      ],
      "defaults.agree": "T\xE4ysin samaa mielt\xE4",
      "defaults.back": "Palaa",
      "defaults.datePlaceholder": "pp.kk.vvvv",
      "defaults.disagree": "T\xE4ysin eri mielt\xE4",
      "defaults.dualChoice.label": "Valintaruutu",
      "defaults.emoji1": "Kauhea",
      "defaults.emoji2": "Huono",
      "defaults.emoji3": "Normaali",
      "defaults.emoji4": "Hyv\xE4",
      "defaults.emoji5": "T\xE4ydellinen",
      "defaults.next": "Seuraava",
      "defaults.noAnswer": "Ei mik\xE4\xE4n edell\xE4 mainituista",
      "defaults.noOpinionAnswer": "Ep\xE4varma",
      "defaults.otherAnswer": "Muu",
      "defaults.otherAnswerWithText": "Muu (vapaa vastaus)",
      "defaults.template.age.label": "Kuinka vanha sin\xE4 olet?",
      "defaults.template.age.option.age_17_under": "Alle 18-vuotias",
      "defaults.template.age.option.age_18_24": "18-24 vuotta vanha",
      "defaults.template.age.option.age_25_34": "25\u201334 vuotta vanha",
      "defaults.template.age.option.age_35_44": "35\u201344 vuotta vanha",
      "defaults.template.age.option.age_45_54": "45\u201354 vuotta vanha",
      "defaults.template.age.option.age_55_over": "yli 55 vuotta vanha ",
      "defaults.template.sex.label": "Mit\xE4 sukupuolta olet?",
      "defaults.template.sex.option.sex_female": "Nainen",
      "defaults.template.sex.option.sex_male": "Mies",
      "defaults.widget.label": "Text",
      "errors.page.default": "Hups, tapahtui virhe",
      "errors.page.notFound": "Sivua ei l\xF6ydy",
      "errors.server.default": "Palvelinvirhe",
      "errors.survey.alreadyFinished": "Olet jo vastannut t\xE4h\xE4n kyselyyn",
      "errors.survey.closed": "Valitettavasti t\xE4m\xE4 tutkimus on p\xE4\xE4ttynyt",
      "errors.survey.notFound": "Sivua ei l\xF6ydy",
      "errors.survey.paused": "Kyselyyn vastaaminen pys\xE4ytetty",
      "final.thanks": "Kiitos!",
      "footer.default.confidential.text": "",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "Luottamuksellisuus",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "",
      "footer.default.responsibility": "Jotkin kyselyt ovat kolmansien osapuolin luomia. Yandex ei tarkasta tai varmista niiden sis\xE4lt\xF6\xE4 tai ota niist\xE4 mit\xE4\xE4n vastuuta.",
      "footer.default.termsofuse.text": "K\xE4ytt\xF6ehdot",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "Luottamuksellisuus",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "K\xE4ytt\xF6ehdot",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "Kysely on suoritettu. Kiitos!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "Palaa",
      "page.buttonNext": "Seuraava",
      "page.buttonSkip": "Ohita",
      "page.title": "Vastaa kyselyyn",
      "page.watermark": "ENNAKKOVASTAUKSIA EI OTETA HUOMIOON ENNAKKOVASTAUKSIA EI OTETA HUOMIOON ENNAKKOVASTAUKSIA EI OTETA HUOMIOON",
      "placeholders.longText": "Sy\xF6t\xE4 kommenttisi",
      "placeholders.shortText": "Sy\xF6t\xE4 kommenttisi",
      "plural.answers.im": [
        "vastaus",
        "vastaukset",
        "vastaukset",
        "vastaukset"
      ],
      "plural.answers.ro": [
        "vastaus",
        "vastaukset",
        "vastaukset",
        "vastaukset"
      ],
      "plural.ratingStars.labels": [
        "t\xE4hti",
        "t\xE4hdet",
        "t\xE4hdet",
        ""
      ],
      "plural.seconds.im": [
        "sekunti",
        "sekuntia",
        "sekuntia",
        "sekuntia"
      ],
      "plural.seconds.ro": [
        "sekuntia",
        "sekuntia",
        "sekuntia",
        "sekuntia"
      ],
      "questionModel.awful": "Kauhea",
      "questionModel.bad": "Huono",
      "questionModel.dateLessThan": "P\xE4iv\xE4m\xE4\xE4r\xE4 ei\xA0saa olla\xA0aikaisempi kuin\xA0 %s",
      "questionModel.dateMoreThan": "P\xE4iv\xE4m\xE4\xE4r\xE4 ei saa olla my\xF6h\xE4isempi kuin %s",
      "questionModel.datePlaceholder": "Select a date",
      "questionModel.insufficientAnswers": [
        "Olet valinnut alle %s vastaus",
        "Olet valinnut alle %s vastausta",
        "Olet valinnut alle %s vastausta",
        ""
      ],
      "questionModel.lessThan": "Numero ei voi olla pienempi kuin %s",
      "questionModel.maxAnswerPerRowExceeded": "Olet ylitt\xE4nyt vastausten enimm\xE4ism\xE4\xE4r\xE4n samassa riviss\xE4",
      "questionModel.maxLenghtExceeded": "Merkkirajoitus ylitetty. Lyhenn\xE4 vastaustasi.",
      "questionModel.moreThan": "Numero ei voi olla suurempi kuin %s",
      "questionModel.normally": "Normaali",
      "questionModel.notDate": "V\xE4\xE4r\xE4 p\xE4iv\xE4m\xE4\xE4r\xE4",
      "questionModel.notEmail": "Tulee vastata s\xE4hk\xF6postiosoitetta",
      "questionModel.notFilled": "Sy\xF6t\xE4 vastauksesi t\xE4h\xE4n",
      "questionModel.notNumber": "Voi sis\xE4lt\xE4\xE4 vain numeroita",
      "questionModel.perfectly": "T\xE4ydellinen",
      "questionModel.picture": "Kuva %s",
      "questionModel.requiredField": "Eth\xE4n j\xE4t\xE4 vastaamatta t\xE4h\xE4n kysymykseen",
      "questionModel.tooManyAnswers": [
        "Enemm\xE4n kuin %s vastaus valittu",
        "Yli %s vastausta valittu",
        "",
        ""
      ],
      "questionModel.well": "Hyv\xE4",
      "sidebyside.option": "Vaihtoehto %s",
      "templates.options.age.age18_24": "18-24 vuotta vanha",
      "templates.options.age.age25_34": "25\u201334 vuotta vanha",
      "templates.options.age.age35_44": "35\u201344 vuotta vanha",
      "templates.options.age.age45_54": "45\u201354 vuotta vanha",
      "templates.options.age.age55_over": "yli 55 vuotta vanha ",
      "templates.options.sex.sex_female": "Nainen",
      "templates.options.sex.sex_male": "Mies",
      "templates.questions.age": "Kuinka vanha sin\xE4 olet?",
      "templates.questions.sex": "Mit\xE4 sukupuolta olet?",
      "ux.stepPaginator.stepTitle": "Vaihe %s/%s",
      "video.holdBtn": "Paina ja pid\xE4 n\xE4hdess\xE4si br\xE4ndin",
      "video.statusBarTitle": "Br\xE4ndi oli n\xE4kyviss\xE4 %1 sekunnista %2 sekuntiin"
    }
  },
  fr: {
    poll: {
      "attach.image.notLess": "Regardez l\u2019image pendant au moins %1 et r\xE9pondez \xE0 quelques questions",
      "attach.image.notMore": "Regardez l\u2019image pendant %1 et r\xE9pondez \xE0 quelques questions",
      "attach.text.notLess": "Regardez le texte pendant au moins %1 et r\xE9pondez \xE0 quelques questions",
      "attach.text.notMore": "Regardez le texte pendant %1 et r\xE9pondez \xE0 quelques questions",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "Regardez la vid\xE9o pendant au moins %1 et r\xE9pondez \xE0 quelques questions",
      "attach.video.notMore": "Regardez la vid\xE9o pendant %1 et r\xE9pondez \xE0 quelques questions",
      "attach.video.waitEnd": "Regardez la vid\xE9o en entier et r\xE9pondez \xE0 quelques questions",
      "attach.watch": "Regarder",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "Autre chose...",
      "commonComponents.choice.chooseLessEqualMore": [
        "S\xE9lectionnez %s\xA0r\xE9ponse",
        "S\xE9lectionnez %s\xA0r\xE9ponses",
        "S\xE9lectionnez %\xA0r\xE9ponses",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "S\xE9lectionnez au moins %s r\xE9ponse",
        "S\xE9lectionnez au moins %s r\xE9ponses",
        "S\xE9lectionnez au moins %s r\xE9ponses",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "S\xE9lectionnez pas moins de %s et pas plus de %s",
      "commonComponents.choice.chooseNoMore": [
        "Veuillez choisir seulement %s r\xE9ponse",
        "Veuillez ne pas choisir plus de %s r\xE9ponses",
        "Veuillez ne pas choisir plus de %s r\xE9ponses",
        "Veuillez ne pas choisir plus de %s r\xE9ponses"
      ],
      "commonComponents.choice.enterText": "Saisir le texte",
      "commonComponents.choice.yourComment": "Saisissez votre commentaire...",
      "commonComponents.scale.chooseRate": "Veuillez \xE9valuer",
      "commonComponents.scale.firstElement": "La premi\xE8re option %s signifie",
      "commonComponents.scale.lastElement": "La derni\xE8re option %s signifie",
      "commonComponents.table.chooseNoMore": [
        "S\xE9lectionnez pas plus de %s r\xE9ponse cons\xE9cutive",
        "S\xE9lectionnez pas plus de %s r\xE9ponses cons\xE9cutives",
        "S\xE9lectionnez pas plus de %s r\xE9ponses cons\xE9cutives",
        ""
      ],
      "defaults.agree": "Compl\xE8tement d'accord",
      "defaults.back": "Retour",
      "defaults.datePlaceholder": "jj.mm.aaaa",
      "defaults.disagree": "Compl\xE8tement pas d'accord",
      "defaults.dualChoice.label": "Case \xE0 cocher",
      "defaults.emoji1": "\xC9pouvantable",
      "defaults.emoji2": "Mauvais",
      "defaults.emoji3": "Normal",
      "defaults.emoji4": "Bon",
      "defaults.emoji5": "Parfait",
      "defaults.next": "Suivant",
      "defaults.noAnswer": "Aucune de ces r\xE9ponses",
      "defaults.noOpinionAnswer": "Pas certain",
      "defaults.otherAnswer": "Autre",
      "defaults.otherAnswerWithText": "Autre (votre r\xE9ponse)",
      "defaults.template.age.label": "Veuillez\xA0indiquer\xA0votre\xA0\xE2ge.",
      "defaults.template.age.option.age_17_under": "Moins de 18\xA0an",
      "defaults.template.age.option.age_18_24": "18-24 ans",
      "defaults.template.age.option.age_25_34": "25-34 ans",
      "defaults.template.age.option.age_35_44": "35-44 ans",
      "defaults.template.age.option.age_45_54": "45-54 ans",
      "defaults.template.age.option.age_55_over": "55 ans ou plus",
      "defaults.template.sex.label": "Veuillez\xA0indiquer\xA0votre\xA0sexe.",
      "defaults.template.sex.option.sex_female": "F\xE9minin",
      "defaults.template.sex.option.sex_male": "Masculin",
      "defaults.widget.label": "Text",
      "errors.page.default": "Oups, une erreur s'est produite",
      "errors.page.notFound": "Page non trouv\xE9e",
      "errors.server.default": "Erreur de serveur",
      "errors.survey.alreadyFinished": "Vous avez d\xE9j\xE0 r\xE9pondu \xE0 cette enqu\xEAte",
      "errors.survey.closed": "Malheureusement, cette recherche est termin\xE9e.",
      "errors.survey.notFound": "Page non trouv\xE9e",
      "errors.survey.paused": "Enqu\xEAte mise en pause",
      "final.thanks": "Merci !",
      "footer.default.confidential.text": "Confidentiel",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "Confidentialit\xE9",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "L'enqu\xEAte est aliment\xE9e par les technologies Yandex Surveys",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Enqu\xEAte interne Yandex",
      "footer.default.responsibility": "Certaines enqu\xEAtes sont cr\xE9\xE9es par des tiers. Yandex ne contr\xF4le ni ne v\xE9rifie leur contenu, et n'en assume pas la responsabilit\xE9.",
      "footer.default.termsofuse.text": "Conditions d'utilisation",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "Confidentialit\xE9",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "Conditions d'utilisation",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "Le questionnaire est termin\xE9. Merci\xA0!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "Retour",
      "page.buttonNext": "Suivant",
      "page.buttonSkip": "Passer",
      "page.title": "R\xE9pondre \xE0 l'enqu\xEAte",
      "page.watermark": "LES R\xC9PONSES D'APER\xC7U NE SONT PAS PRISES EN COMPTE LES R\xC9PONSES D'APER\xC7U NE SONT PAS PRISES EN COMPTE LES R\xC9PONSES D'APER\xC7U NE SONT PAS PRISES EN COMPTE",
      "placeholders.longText": "Saisissez votre commentaire",
      "placeholders.shortText": "Saisissez votre commentaire",
      "plural.answers.im": [
        "r\xE9ponse",
        "r\xE9ponses",
        "r\xE9ponses",
        "r\xE9ponses"
      ],
      "plural.answers.ro": [
        "r\xE9ponse",
        "r\xE9ponses",
        "r\xE9ponses",
        "r\xE9ponses"
      ],
      "plural.ratingStars.labels": [
        "\xE9toile",
        "\xE9toiles",
        "\xE9toiles",
        ""
      ],
      "plural.seconds.im": [
        "seconde",
        "secondes",
        "secondes",
        "secondes"
      ],
      "plural.seconds.ro": [
        "secondes",
        "secondes",
        "secondes",
        "secondes"
      ],
      "questionModel.awful": "\xC9pouvantable",
      "questionModel.bad": "Mauvais",
      "questionModel.dateLessThan": "La date ne peut pas \xEAtre ant\xE9rieure \xE0 %s",
      "questionModel.dateMoreThan": "La date ne peut pas \xEAtre post\xE9rieure \xE0 %s",
      "questionModel.datePlaceholder": "Select a date",
      "questionModel.insufficientAnswers": [
        "Vous avez s\xE9lectionn\xE9 moins de %s r\xE9ponse",
        "Vous avez s\xE9lectionn\xE9 moins de %s r\xE9ponses",
        "Vous avez s\xE9lectionn\xE9 moins de %s r\xE9ponses",
        ""
      ],
      "questionModel.lessThan": "Le nombre ne peut pas \xEAtre inf\xE9rieur \xE0 %s",
      "questionModel.maxAnswerPerRowExceeded": "Vous avez d\xE9pass\xE9 le nombre maximum de r\xE9ponses cons\xE9cutives",
      "questionModel.maxLenghtExceeded": "Le nombre de caract\xE8res d\xE9passe le maximum autoris\xE9, veuillez raccourcir le texte",
      "questionModel.moreThan": "Le nombre ne peut pas \xEAtre sup\xE9rieur \xE0 %s",
      "questionModel.normally": "Normal",
      "questionModel.notDate": "Date invalide",
      "questionModel.notEmail": "Format d'adresse e-mail non valide",
      "questionModel.notFilled": "Veuillez entrer votre r\xE9ponse ici",
      "questionModel.notNumber": "Ne peut contenir que des chiffres",
      "questionModel.perfectly": "Parfait",
      "questionModel.picture": "Image %s",
      "questionModel.requiredField": "Ne laissez pas cette question sans r\xE9ponse",
      "questionModel.tooManyAnswers": [
        "Plus de %s r\xE9ponse choisie",
        "Plus de %s r\xE9ponses choisies",
        "Plus de %s r\xE9ponses choisies",
        "Plus de %s r\xE9ponses choisies"
      ],
      "questionModel.well": "Bon",
      "sidebyside.option": "Option %s",
      "templates.options.age.age18_24": "18-24 ans",
      "templates.options.age.age25_34": "25-34 ans",
      "templates.options.age.age35_44": "35-44 ans",
      "templates.options.age.age45_54": "45-54 ans",
      "templates.options.age.age55_over": "55 ans ou plus",
      "templates.options.sex.sex_female": "F\xE9minin",
      "templates.options.sex.sex_male": "Masculin",
      "templates.questions.age": "Veuillez\xA0indiquer\xA0votre\xA0\xE2ge.",
      "templates.questions.sex": "Veuillez\xA0indiquer\xA0votre\xA0sexe.",
      "ux.stepPaginator.stepTitle": "\xC9tape %s sur %s",
      "video.holdBtn": "Appuyez et maintenez lorsque vous voyez la marque",
      "video.statusBarTitle": "La marque \xE9tait visible de la seconde %1 \xE0 la seconde %2"
    }
  },
  he: {
    poll: {
      "attach.image.notLess": "\u05EA\u05E1\u05EA\u05DB\u05DC \u05E2\u05DC \u05D4\u05EA\u05DE\u05D5\u05E0\u05D4 \u05DC\u05DE\u05E9\u05DA \u05DC\u05E4\u05D7\u05D5\u05EA %1 \u05D5\u05E2\u05E0\u05D4 \u05E2\u05DC \u05DB\u05DE\u05D4 \u05E9\u05D0\u05DC\u05D5\u05EA",
      "attach.image.notMore": "\u05EA\u05E1\u05EA\u05DB\u05DC \u05E2\u05DC \u05D4\u05EA\u05DE\u05D5\u05E0\u05D4 \u05DC\u05DE\u05E9\u05DA %1 \u05D5\u05E2\u05E0\u05D4 \u05E2\u05DC \u05DB\u05DE\u05D4 \u05E9\u05D0\u05DC\u05D5\u05EA",
      "attach.text.notLess": "\u05EA\u05E1\u05EA\u05DB\u05DC \u05E2\u05DC \u05D4\u05D8\u05E7\u05E1\u05D8 \u05DC\u05DE\u05E9\u05DA \u05DC\u05E4\u05D7\u05D5\u05EA %1 \u05D5\u05E2\u05E0\u05D4 \u05E2\u05DC \u05DB\u05DE\u05D4 \u05E9\u05D0\u05DC\u05D5\u05EA",
      "attach.text.notMore": "\u05E7\u05E8\u05D0 \u05D0\u05EA \u05D4\u05D8\u05E7\u05E1\u05D8 \u05DC\u05DE\u05E9\u05DA %1 \u05D5\u05E2\u05E0\u05D4 \u05E2\u05DC \u05DB\u05DE\u05D4 \u05E9\u05D0\u05DC\u05D5\u05EA",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "\u05E6\u05E4\u05D4 \u05D1\u05D5\u05D9\u05D3\u05D0\u05D5 \u05DC\u05DE\u05E9\u05DA \u05DC\u05E4\u05D7\u05D5\u05EA %1 \u05D5\u05E2\u05E0\u05D4 \u05E2\u05DC \u05DB\u05DE\u05D4 \u05E9\u05D0\u05DC\u05D5\u05EA",
      "attach.video.notMore": "\u05E6\u05E4\u05D4 \u05D1\u05D5\u05D9\u05D3\u05D0\u05D5 \u05DC\u05DE\u05E9\u05DA %1 \u05D5\u05E2\u05E0\u05D4 \u05E2\u05DC \u05DB\u05DE\u05D4 \u05E9\u05D0\u05DC\u05D5\u05EA",
      "attach.video.waitEnd": "\u05E6\u05E4\u05D4 \u05D1\u05D5\u05D9\u05D3\u05D0\u05D5 \u05E2\u05D3 \u05D4\u05E1\u05D5\u05E3 \u05D5\u05E2\u05E0\u05D4 \u05E2\u05DC \u05DB\u05DE\u05D4 \u05E9\u05D0\u05DC\u05D5\u05EA",
      "attach.watch": "\u05E6\u05E4\u05D4",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "\u05DE\u05E9\u05D4\u05D5 \u05D0\u05D7\u05E8...",
      "commonComponents.choice.chooseLessEqualMore": [
        "\u05D1\u05D7\u05E8 %s \u05EA\u05E9\u05D5\u05D1\u05D4",
        "\u05D1\u05D7\u05E8 %s \u05EA\u05E9\u05D5\u05D1\u05D5\u05EA",
        "\u05D1\u05D7\u05E8 % \u05EA\u05E9\u05D5\u05D1\u05D5\u05EA",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "\u05D1\u05D7\u05E8 \u05DC\u05E4\u05D7\u05D5\u05EA %s \u05EA\u05E9\u05D5\u05D1\u05D4",
        "\u05D1\u05D7\u05E8 \u05DC\u05E4\u05D7\u05D5\u05EA %s \u05EA\u05E9\u05D5\u05D1\u05D5\u05EA",
        "\u05D1\u05D7\u05E8 \u05DC\u05E4\u05D7\u05D5\u05EA %s \u05EA\u05E9\u05D5\u05D1\u05D5\u05EA",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "\u05D1\u05D7\u05E8 \u05DC\u05D0 \u05E4\u05D7\u05D5\u05EA \u05DE %s \u05D5\u05DC\u05D0 \u05D9\u05D5\u05EA\u05E8 \u05DE %s",
      "commonComponents.choice.chooseNoMore": [
        "\u05D0\u05E4\u05E9\u05E8 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E8\u05E7 \u05EA\u05E9\u05D5\u05D1\u05D4 \u05D0\u05D7\u05EA",
        "\u05D0\u05D9 \u05D0\u05E4\u05E9\u05E8 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05D9\u05D5\u05EA\u05E8 \u05DE-%s \u05EA\u05E9\u05D5\u05D1\u05D5\u05EA",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "\u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D6\u05D9\u05DF \u05D8\u05E7\u05E1\u05D8",
      "commonComponents.choice.yourComment": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05D0\u05EA \u05D4\u05D4\u05E2\u05E8\u05D4 \u05E9\u05DC\u05DA...",
      "commonComponents.scale.chooseRate": "\u05E6\u05E8\u05D9\u05DA \u05DC\u05D3\u05E8\u05D2",
      "commonComponents.scale.firstElement": "\u05D4\u05DE\u05E9\u05DE\u05E2\u05D5\u05EA \u05E9\u05DC \u05D4\u05D0\u05E4\u05E9\u05E8\u05D5\u05EA \u05D4\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4 %s \u05D4\u05D9\u05D0",
      "commonComponents.scale.lastElement": "\u05D4\u05DE\u05E9\u05DE\u05E2\u05D5\u05EA \u05E9\u05DC \u05D4\u05D0\u05E4\u05E9\u05E8\u05D5\u05EA \u05D4\u05D0\u05D7\u05E8\u05D5\u05E0\u05D4 %s \u05D4\u05D9\u05D0",
      "commonComponents.table.chooseNoMore": [
        "\u05D1\u05D7\u05E8 \u05DC\u05D0 \u05D9\u05D5\u05EA\u05E8 \u05DE %s \u05EA\u05E9\u05D5\u05D1\u05D4 \u05D1\u05E8\u05E6\u05D9\u05E4\u05D5\u05EA",
        "\u05D1\u05D7\u05E8 \u05DC\u05D0 \u05D9\u05D5\u05EA\u05E8 \u05DE %s \u05EA\u05E9\u05D5\u05D1\u05D5\u05EA \u05D1\u05E8\u05E6\u05E3",
        "\u05D1\u05D7\u05E8 \u05DC\u05D0 \u05D9\u05D5\u05EA\u05E8 \u05DE %s \u05EA\u05E9\u05D5\u05D1\u05D5\u05EA \u05D1\u05E8\u05E6\u05E3",
        ""
      ],
      "defaults.agree": "\u05DE\u05E1\u05DB\u05D9\u05DD \u05DC\u05D7\u05DC\u05D5\u05D8\u05D9\u05DF",
      "defaults.back": "\u05D7\u05D6\u05E8\u05D4",
      "defaults.datePlaceholder": "dd.mm.yyyy ",
      "defaults.disagree": "\u05DC\u05D7\u05DC\u05D5\u05D8\u05D9\u05DF \u05DC\u05D0 \u05DE\u05E1\u05DB\u05D9\u05DD",
      "defaults.dualChoice.label": "\u05EA\u05D9\u05D1\u05EA \u05E1\u05D9\u05DE\u05D5\u05DF",
      "defaults.emoji1": "\u05D2\u05E8\u05D5\u05E2",
      "defaults.emoji2": "\u05E8\u05E2",
      "defaults.emoji3": "\u05D1\u05E1\u05D3\u05E8",
      "defaults.emoji4": "\u05D8\u05D5\u05D1",
      "defaults.emoji5": "\u05DE\u05D5\u05E9\u05DC\u05DD",
      "defaults.next": "\u05D4\u05D1\u05D0",
      "defaults.noAnswer": "\u05D0\u05E3 \u05D0\u05D7\u05D3 \u05DE\u05D4\u05D0\u05DE\u05D5\u05E8 \u05DC\u05E2\u05D9\u05DC",
      "defaults.noOpinionAnswer": "\u05DC\u05D0 \u05D1\u05D8\u05D5\u05D7",
      "defaults.otherAnswer": "\u05D0\u05D7\u05E8",
      "defaults.otherAnswerWithText": "\u05D0\u05D7\u05E8 (\u05DE\u05DC\u05DC \u05D7\u05D5\u05E4\u05E9\u05D9)",
      "defaults.template.age.label": "\u05D1\u05DF \u05DB\u05DE\u05D4 \u05D0\u05EA\u05D4?",
      "defaults.template.age.option.age_17_under": "\u05DE\u05EA\u05D7\u05EA \u05DC\u05D2\u05D9\u05DC 18",
      "defaults.template.age.option.age_18_24": "\u05D2\u05D9\u05DC 18-24",
      "defaults.template.age.option.age_25_34": "\u05D2\u05D9\u05DC 25-34 ",
      "defaults.template.age.option.age_35_44": "\u05D2\u05D9\u05DC 35-44 ",
      "defaults.template.age.option.age_45_54": "\u05D2\u05D9\u05DC 45-54 ",
      "defaults.template.age.option.age_55_over": "55 \u05D5\u05DE\u05E2\u05DC\u05D4",
      "defaults.template.sex.label": "\u05DE\u05D4 \u05D4\u05DE\u05D9\u05DF \u05E9\u05DC\u05DA?",
      "defaults.template.sex.option.sex_female": "\u05E0\u05E7\u05D1\u05D4",
      "defaults.template.sex.option.sex_male": "\u05D6\u05DB\u05E8",
      "defaults.widget.label": "Text",
      "errors.page.default": "\u05D0\u05D5\u05E4\u05E1, \u05D4\u05D9\u05D9\u05EA\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4",
      "errors.page.notFound": "\u05D4\u05D3\u05E3 \u05DC\u05D0 \u05E0\u05DE\u05E6\u05D0",
      "errors.server.default": "\u05E9\u05D2\u05D9\u05D0\u05EA \u05E9\u05E8\u05EA",
      "errors.survey.alreadyFinished": "\u05DB\u05D1\u05E8 \u05E2\u05E0\u05D9\u05EA \u05E2\u05DC \u05D4\u05E1\u05E7\u05E8 \u05D4\u05D6\u05D4",
      "errors.survey.closed": "\u05DC\u05E6\u05E2\u05E8\u05E0\u05D5 \u05D4\u05E1\u05E7\u05E8 \u05D4\u05D6\u05D4 \u05D4\u05E1\u05EA\u05D9\u05D9\u05DD.",
      "errors.survey.notFound": "\u05D4\u05D3\u05E3 \u05DC\u05D0 \u05E0\u05DE\u05E6\u05D0",
      "errors.survey.paused": "\u05D4\u05E1\u05E7\u05E8 \u05DE\u05D5\u05E9\u05D4\u05D4",
      "final.thanks": "\u05EA\u05D5\u05D3\u05D4!",
      "footer.default.confidential.text": "\u05D7\u05E1\u05D5\u05D9",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "\u05E1\u05D5\u05D3\u05D9\u05D5\u05EA",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "\u05D4\u05E1\u05E7\u05E8 \u05DE\u05D5\u05E4\u05E2\u05DC \u05E2\u05DC \u05D9\u05D3\u05D9 Yandex Surveys",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "\u05E1\u05E7\u05E8 \u05E4\u05E0\u05D9\u05DE\u05D9 \u05E9\u05DC Yandex\xA0",
      "footer.default.responsibility": "\u05D7\u05DC\u05E7 \u05DE\u05D4\u05E1\u05E7\u05E8\u05D9\u05DD \u05E0\u05D5\u05E6\u05E8\u05D9\u05DD \u05E2\u05DC \u05D9\u05D3\u05D9 \u05D2\u05D5\u05E4\u05D9\u05DD \u05D7\u05D9\u05E6\u05D5\u05E0\u05D9\u05D9\u05DD. Yandex \u05DC\u05D0 \u05D1\u05D5\u05D3\u05E7\u05EA \u05D0\u05D5 \u05DE\u05D0\u05DE\u05EA\u05EA \u05D0\u05EA \u05D4\u05EA\u05D5\u05DB\u05DF \u05D5\u05DC\u05D0 \u05E0\u05D5\u05E9\u05D0\u05EA \u05D1\u05D0\u05D7\u05E8\u05D9\u05D5\u05EA \u05DC\u05D4\u05DD.",
      "footer.default.termsofuse.text": "\u05EA\u05E0\u05D0\u05D9 \u05D4\u05E9\u05D9\u05DE\u05D5\u05E9",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "\u05E1\u05D5\u05D3\u05D9\u05D5\u05EA",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "\u05EA\u05E0\u05D0\u05D9 \u05D4\u05E9\u05D9\u05DE\u05D5\u05E9",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "\u05D4\u05E1\u05E7\u05E8 \u05D4\u05D5\u05E9\u05DC\u05DD. \u05EA\u05D5\u05D3\u05D4!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "\u05D7\u05D6\u05E8\u05D4",
      "page.buttonNext": "\u05DC\u05DE\u05E1\u05DA \u05D4\u05D1\u05D0",
      "page.buttonSkip": "\u05D3\u05DC\u05D2",
      "page.title": "\u05DC\u05DE\u05E2\u05E0\u05D4 \u05E2\u05DC \u05D4\u05E1\u05E7\u05E8",
      "page.watermark": "\u05EA\u05E9\u05D5\u05D1\u05D5\u05EA \u05DE\u05EA\u05E6\u05D5\u05D2\u05D4 \u05DE\u05E7\u05D3\u05D9\u05DE\u05D4 \u05D0\u05D9\u05E0\u05DF \u05E0\u05DC\u05E7\u05D7\u05D5\u05EA \u05D1\u05D7\u05E9\u05D1\u05D5\u05DF \u05EA\u05E9\u05D5\u05D1\u05D5\u05EA \u05DE\u05EA\u05E6\u05D5\u05D2\u05D4 \u05DE\u05E7\u05D3\u05D9\u05DE\u05D4 \u05D0\u05D9\u05E0\u05DF \u05E0\u05DC\u05E7\u05D7\u05D5\u05EA \u05D1\u05D7\u05E9\u05D1\u05D5\u05DF \u05EA\u05E9\u05D5\u05D1\u05D5\u05EA \u05DE\u05EA\u05E6\u05D5\u05D2\u05D4 \u05DE\u05E7\u05D3\u05D9\u05DE\u05D4 \u05D0\u05D9\u05E0\u05DF \u05E0\u05DC\u05E7\u05D7\u05D5\u05EA \u05D1\u05D7\u05E9\u05D1\u05D5\u05DF",
      "placeholders.longText": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05D0\u05EA \u05D4\u05D4\u05E2\u05E8\u05D4 \u05E9\u05DC\u05DA",
      "placeholders.shortText": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05D0\u05EA \u05D4\u05D4\u05E2\u05E8\u05D4 \u05E9\u05DC\u05DA",
      "plural.answers.im": [
        "\u05EA\u05E9\u05D5\u05D1\u05D4",
        "\u05EA\u05E9\u05D5\u05D1\u05D5\u05EA",
        "\u05EA\u05E9\u05D5\u05D1\u05D5\u05EA",
        "\u05EA\u05E9\u05D5\u05D1\u05D5\u05EA"
      ],
      "plural.answers.ro": [
        "\u05EA\u05E9\u05D5\u05D1\u05D4",
        "\u05EA\u05E9\u05D5\u05D1\u05D5\u05EA",
        "\u05EA\u05E9\u05D5\u05D1\u05D5\u05EA",
        "\u05EA\u05E9\u05D5\u05D1\u05D5\u05EA"
      ],
      "plural.ratingStars.labels": [
        "\u05DB\u05D5\u05DB\u05D1",
        "\u05DB\u05D5\u05DB\u05D1\u05D9\u05DD",
        "\u05DB\u05D5\u05DB\u05D1\u05D9\u05DD",
        ""
      ],
      "plural.seconds.im": [
        "\u05E9\u05E0\u05D9\u05D9\u05D4",
        "\u05E9\u05E0\u05D9\u05D5\u05EA",
        "\u05E9\u05E0\u05D9\u05D5\u05EA",
        "\u05E9\u05E0\u05D9\u05D5\u05EA"
      ],
      "plural.seconds.ro": [
        "\u05E9\u05E0\u05D9\u05D5\u05EA",
        "\u05E9\u05E0\u05D9\u05D5\u05EA",
        "\u05E9\u05E0\u05D9\u05D5\u05EA",
        "\u05E9\u05E0\u05D9\u05D5\u05EA"
      ],
      "questionModel.awful": "\u05D2\u05E8\u05D5\u05E2",
      "questionModel.bad": "\u05E8\u05E2",
      "questionModel.dateLessThan": "\u05D4\u05EA\u05D0\u05E8\u05D9\u05DA \u05DC\u05D0 \u05D9\u05DB\u05D5\u05DC \u05DC\u05D4\u05D9\u05D5\u05EA \u05DE\u05D5\u05E7\u05D3\u05DD \u05D9\u05D5\u05EA\u05E8 \u05DE%s",
      "questionModel.dateMoreThan": "\u05D4\u05EA\u05D0\u05E8\u05D9\u05DA \u05DC\u05D0 \u05D9\u05DB\u05D5\u05DC \u05DC\u05D4\u05D9\u05D5\u05EA \u05DE\u05D0\u05D5\u05D7\u05E8 \u05D9\u05D5\u05EA\u05E8 \u05DE%s",
      "questionModel.datePlaceholder": "Select a date",
      "questionModel.insufficientAnswers": [
        "\u05D1\u05D7\u05E8\u05EA \u05E4\u05D7\u05D5\u05EA \u05DE %s \u05EA\u05E9\u05D5\u05D1\u05D4",
        "\u05D1\u05D7\u05E8\u05EA \u05E4\u05D7\u05D5\u05EA \u05DE %s \u05EA\u05E9\u05D5\u05D1\u05D5\u05EA",
        "\u05D1\u05D7\u05E8\u05EA \u05E4\u05D7\u05D5\u05EA \u05DE %s \u05EA\u05E9\u05D5\u05D1\u05D5\u05EA",
        ""
      ],
      "questionModel.lessThan": "\u05D4\u05DE\u05E1\u05E4\u05E8 \u05DC\u05D0 \u05D9\u05DB\u05D5\u05DC \u05DC\u05D4\u05D9\u05D5\u05EA \u05E7\u05D8\u05DF \u05DE-%s",
      "questionModel.maxAnswerPerRowExceeded": "\u05D7\u05E8\u05D2\u05EA \u05DE\u05DE\u05E1\u05E4\u05E8 \u05D4\u05EA\u05E9\u05D5\u05D1\u05D5\u05EA \u05D4\u05DE\u05E7\u05E1\u05D9\u05DE\u05DC\u05D9 \u05E9\u05D0\u05E4\u05E9\u05E8 \u05DC\u05E2\u05E0\u05D5\u05EA \u05D1\u05E8\u05E6\u05D9\u05E4\u05D5\u05EA",
      "questionModel.maxLenghtExceeded": "\u05D7\u05E8\u05D9\u05D2\u05D4 \u05DE\u05DE\u05D2\u05D1\u05DC\u05EA \u05D4\u05EA\u05D5\u05D5\u05D9\u05DD \u05D0\u05E0\u05D0 \u05E7\u05E6\u05E8 \u05D0\u05EA \u05EA\u05E9\u05D5\u05D1\u05EA\u05DA.",
      "questionModel.moreThan": "\u05D4\u05DE\u05E1\u05E4\u05E8 \u05DC\u05D0 \u05D9\u05DB\u05D5\u05DC \u05DC\u05D4\u05D9\u05D5\u05EA \u05D2\u05D3\u05D5\u05DC \u05DE-%s",
      "questionModel.normally": "\u05D1\u05E1\u05D3\u05E8",
      "questionModel.notDate": "\u05EA\u05D0\u05E8\u05D9\u05DA \u05DC\u05D0 \u05D7\u05D5\u05E7\u05D9",
      "questionModel.notEmail": "\u05D4\u05DB\u05EA\u05D5\u05D1\u05EA \u05E6\u05E8\u05D9\u05DB\u05D4 \u05DC\u05D4\u05D9\u05D5\u05EA \u05D1\u05E4\u05D5\u05E8\u05DE\u05D8 \u05E9\u05DC \u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
      "questionModel.notFilled": "\u05DB\u05D0\u05DF \u05E6\u05E8\u05D9\u05DA \u05DC\u05DB\u05EA\u05D5\u05D1 \u05D0\u05EA \u05D4\u05EA\u05E9\u05D5\u05D1\u05D4",
      "questionModel.notNumber": "\u05D0\u05E4\u05E9\u05E8 \u05DC\u05D4\u05D6\u05D9\u05DF \u05E8\u05E7 \u05DE\u05E1\u05E4\u05E8\u05D9\u05DD",
      "questionModel.perfectly": "\u05DE\u05D5\u05E9\u05DC\u05DD",
      "questionModel.picture": "\u05EA\u05DE\u05D5\u05E0\u05D4 %s",
      "questionModel.requiredField": "\u05D7\u05D5\u05D1\u05D4 \u05DC\u05E2\u05E0\u05D5\u05EA \u05E2\u05DC \u05D4\u05E9\u05D0\u05DC\u05D4 \u05D4\u05D6\u05D5",
      "questionModel.tooManyAnswers": [
        "\u05D1\u05D7\u05E8\u05EA \u05D9\u05D5\u05EA\u05E8 \u05DE\u05EA\u05E9\u05D5\u05D1\u05D4 \u05D0\u05D7\u05EA",
        "\u05D1\u05D7\u05E8\u05EA \u05D9\u05D5\u05EA\u05E8 \u05DE-%s \u05EA\u05E9\u05D5\u05D1\u05D5\u05EA",
        "",
        ""
      ],
      "questionModel.well": "\u05D8\u05D5\u05D1",
      "sidebyside.option": "\u05D0\u05E4\u05E9\u05E8\u05D5\u05EA %s",
      "templates.options.age.age18_24": "\u05D2\u05D9\u05DC 18-24",
      "templates.options.age.age25_34": "\u05D2\u05D9\u05DC 25-34 ",
      "templates.options.age.age35_44": "\u05D2\u05D9\u05DC 35-44 ",
      "templates.options.age.age45_54": "\u05D2\u05D9\u05DC 45-54 ",
      "templates.options.age.age55_over": "55 \u05D5\u05DE\u05E2\u05DC\u05D4",
      "templates.options.sex.sex_female": "\u05E0\u05E7\u05D1\u05D4",
      "templates.options.sex.sex_male": "\u05D6\u05DB\u05E8",
      "templates.questions.age": "\u05D1\u05DF \u05DB\u05DE\u05D4 \u05D0\u05EA\u05D4?",
      "templates.questions.sex": "\u05DE\u05D4 \u05D4\u05DE\u05D9\u05DF \u05E9\u05DC\u05DA?",
      "ux.stepPaginator.stepTitle": "\u05E9\u05DC\u05D1 %s \u05DE\u05EA\u05D5\u05DA %s",
      "video.holdBtn": "\u05DC\u05D7\u05E5 \u05D5\u05D4\u05D7\u05D6\u05E7 \u05D1\u05D6\u05DE\u05DF \u05E9\u05D0\u05EA\u05D4 \u05E8\u05D5\u05D0\u05D4 \u05D0\u05EA \u05D4\u05DE\u05D5\u05EA\u05D2",
      "video.statusBarTitle": "\u05D4\u05DE\u05D5\u05EA\u05D2 \u05D4\u05D9\u05D4 \u05D2\u05DC\u05D5\u05D9 \u05DE\u05D4\u05E9\u05E0\u05D9\u05D9\u05D4 \u05D4- %1 \u05D5\u05E2\u05D3 \u05DC\u05E9\u05E0\u05D9\u05D9\u05D4 \u05D4- %2 "
    }
  },
  hi: {
    poll: {
      "attach.image.notLess": "\u0915\u092E \u0938\u0947 \u0915\u092E %1 \u0915\u0947 \u0932\u093F\u090F \u0907\u092E\u0947\u091C \u0926\u0947\u0916\u0947\u0902 \u0914\u0930 \u0915\u0941\u091B \u0938\u0935\u093E\u0932\u094B\u0902 \u0915\u0947 \u091C\u0935\u093E\u092C \u0926\u0947\u0902",
      "attach.image.notMore": "%1 \u0915\u0947 \u0932\u093F\u090F \u0907\u092E\u0947\u091C \u0926\u0947\u0916\u0947\u0902 \u0914\u0930 \u0915\u0941\u091B \u0938\u0935\u093E\u0932\u094B\u0902 \u0915\u0947 \u091C\u0935\u093E\u092C \u0926\u0947\u0902",
      "attach.text.notLess": "\u0915\u092E \u0938\u0947 \u0915\u092E %1 \u0915\u0947 \u0932\u093F\u090F \u091F\u0947\u0915\u094D\u0938\u094D\u091F \u0926\u0947\u0916\u0947\u0902 \u0914\u0930 \u0915\u0941\u091B \u0938\u0935\u093E\u0932\u094B\u0902 \u0915\u0947 \u091C\u0935\u093E\u092C \u0926\u0947\u0902",
      "attach.text.notMore": "%1 \u0915\u0947 \u0932\u093F\u090F \u091F\u0947\u0915\u094D\u0938\u094D\u091F \u092A\u095D\u0947\u0902 \u0914\u0930 \u0915\u0941\u091B \u0938\u0935\u093E\u0932\u094B\u0902 \u0915\u0947 \u091C\u0935\u093E\u092C \u0926\u0947\u0902",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "\u0915\u092E \u0938\u0947 \u0915\u092E %1 \u0915\u0947 \u0932\u093F\u090F \u0935\u0940\u0921\u093F\u092F\u094B \u0926\u0947\u0916\u0947\u0902 \u0914\u0930 \u0915\u0941\u091B \u0938\u0935\u093E\u0932\u094B\u0902 \u0915\u0947 \u091C\u0935\u093E\u092C \u0926\u0947\u0902",
      "attach.video.notMore": "%1 \u0915\u0947 \u0932\u093F\u090F \u0935\u0940\u0921\u093F\u092F\u094B \u0926\u0947\u0916\u0947\u0902 \u0914\u0930 \u0915\u0941\u091B \u0938\u0935\u093E\u0932\u094B\u0902 \u0915\u0947 \u091C\u0935\u093E\u092C \u0926\u0947\u0902",
      "attach.video.waitEnd": "\u0935\u0940\u0921\u093F\u092F\u094B \u0915\u094B \u0906\u0916\u093F\u0930 \u0924\u0915 \u0926\u0947\u0916\u0947\u0902 \u0914\u0930 \u0915\u0941\u091B \u0938\u0935\u093E\u0932\u094B\u0902 \u0915\u0947 \u091C\u0935\u093E\u092C \u0926\u0947\u0902",
      "attach.watch": "\u0926\u0947\u0916\u0947\u0902",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "\u0915\u0941\u091B \u0914\u0930",
      "commonComponents.choice.chooseLessEqualMore": [
        "%s \u0909\u0924\u094D\u0924\u0930 \u091A\u0941\u0928\u0947\u0902",
        "%s \u0909\u0924\u094D\u0924\u0930 \u091A\u0941\u0928\u0947\u0902",
        "% \u0909\u0924\u094D\u0924\u0930 \u091A\u0941\u0928\u0947\u0902",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "\u0915\u092E \u0938\u0947 \u0915\u092E %s \u0909\u0924\u094D\u0924\u0930 \u091A\u0941\u0928\u0947\u0902",
        "\u0915\u092E \u0938\u0947 \u0915\u092E %s \u0909\u0924\u094D\u0924\u0930\u094B\u0902 \u0915\u094B \u091A\u0941\u0928\u0947\u0902",
        "\u0915\u092E \u0938\u0947 \u0915\u092E %s \u0909\u0924\u094D\u0924\u0930\u094B\u0902 \u0915\u094B \u091A\u0941\u0928\u0947\u0902",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "%s \u0938\u0947 \u0915\u092E \u0928\u0939\u0940\u0902 \u0914\u0930 %s \u0938\u0947 \u0905\u0927\u093F\u0915 \u0928\u0939\u0940\u0902 \u091A\u0941\u0928\u0947\u0902",
      "commonComponents.choice.chooseNoMore": [
        "\u0915\u0943\u092A\u092F\u093E \u0915\u0947\u0935\u0932 %s \u091C\u0935\u093E\u092C \u091A\u0941\u0928\u0947\u0902",
        "\u0915\u0943\u092A\u092F\u093E \u0915\u0947\u0935\u0932 %s \u0938\u0947 \u095B\u094D\u092F\u093E\u0926\u093E \u091C\u0935\u093E\u092C \u0928 \u091A\u0941\u0928\u0947\u0902",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "\u091F\u0947\u0915\u094D\u0938\u094D\u091F \u0921\u093E\u0932\u0947\u0902",
      "commonComponents.choice.yourComment": "\u0905\u092A\u0928\u0940 \u091F\u093F\u092A\u094D\u092A\u0923\u0940 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902",
      "commonComponents.scale.chooseRate": "\u0915\u0943\u092A\u092F\u093E \u0930\u0947\u091F \u0915\u0930\u0947\u0902",
      "commonComponents.scale.firstElement": "\u092A\u0939\u0932\u0947 \u0935\u093F\u0915\u0932\u094D\u092A %s \u0915\u093E \u092E\u0924\u0932\u092C \u0939\u0948",
      "commonComponents.scale.lastElement": "\u0905\u0902\u0924\u093F\u092E \u0935\u093F\u0915\u0932\u094D\u092A %s \u0915\u093E \u092E\u0924\u0932\u092C \u0939\u0948",
      "commonComponents.table.chooseNoMore": [
        "\u090F\u0915 \u092A\u0902\u0915\u094D\u0924\u093F \u092E\u0947\u0902 %s \u0938\u0947 \u0905\u0927\u093F\u0915 \u0909\u0924\u094D\u0924\u0930 \u0928 \u091A\u0941\u0928\u0947\u0902",
        "\u090F\u0915 \u092A\u0902\u0915\u094D\u0924\u093F \u092E\u0947\u0902 %s \u0938\u0947 \u0905\u0927\u093F\u0915 \u0909\u0924\u094D\u0924\u0930\u094B\u0902 \u0915\u094B \u0928 \u091A\u0941\u0928\u0947\u0902",
        "\u090F\u0915 \u092A\u0902\u0915\u094D\u0924\u093F \u092E\u0947\u0902 %s \u0938\u0947 \u0905\u0927\u093F\u0915 \u0909\u0924\u094D\u0924\u0930\u094B\u0902 \u0915\u094B \u0928 \u091A\u0941\u0928\u0947\u0902",
        ""
      ],
      "defaults.agree": "\u092A\u0942\u0930\u094D\u0923 \u0930\u0942\u092A \u0938\u0947 \u0938\u0939\u092E\u0924",
      "defaults.back": "\u0935\u093E\u092A\u0938",
      "defaults.datePlaceholder": "\u0926\u093F\u0928\u093E\u0902\u0915 / \u092E\u093E\u0939 / \u0935\u0930\u094D\u0937",
      "defaults.disagree": "\u092A\u0942\u0930\u0940 \u0924\u0930\u0939 \u0905\u0938\u0939\u092E\u0924",
      "defaults.dualChoice.label": "\u091A\u0947\u0915\u092C\u0949\u0915\u094D\u0938",
      "defaults.emoji1": "\u0916\u0930\u093E\u092C",
      "defaults.emoji2": "\u092C\u0941\u0930\u093E",
      "defaults.emoji3": "\u0938\u093E\u092E\u093E\u0928\u094D\u092F",
      "defaults.emoji4": "\u092C\u095D\u093F\u092F\u093E",
      "defaults.emoji5": "\u092C\u0939\u0941\u0924 \u092C\u095D\u093F\u092F\u093E",
      "defaults.next": "\u0905\u0917\u0932\u093E",
      "defaults.noAnswer": "\u0907\u0928\u092E\u0947 \u0938\u0947 \u0915\u094B\u0908 \u092D\u0940 \u0928\u0939\u0940\u0902",
      "defaults.noOpinionAnswer": "\u0905\u0928\u093F\u0936\u094D\u091A\u093F\u0924",
      "defaults.otherAnswer": "\u0905\u0928\u094D\u092F",
      "defaults.otherAnswerWithText": "\u0905\u0928\u094D\u092F (\u0938\u094D\u0935\u0924\u0902\u0924\u094D\u0930 \u092A\u094D\u0930\u0924\u093F\u0915\u094D\u0930\u093F\u092F\u093E)",
      "defaults.template.age.label": "\u0906\u092A\u0915\u0947 \u0909\u092E\u094D\u0930 \u0915\u094D\u092F\u093E \u0939\u0948?",
      "defaults.template.age.option.age_17_under": "18 \u0938\u0947 \u0915\u092E",
      "defaults.template.age.option.age_18_24": "\u0967\u096E - \u0968\u096A \u0938\u093E\u0932 \u0915\u0940 \u0909\u092E\u094D\u0930",
      "defaults.template.age.option.age_25_34": "\u0968\u096B - \u0969\u096A \u0938\u093E\u0932 \u0915\u0940 \u0909\u092E\u094D\u0930",
      "defaults.template.age.option.age_35_44": "\u0969\u096B - \u096A\u096A \u0938\u093E\u0932 \u0915\u0940 \u0909\u092E\u094D\u0930",
      "defaults.template.age.option.age_45_54": "\u096A\u096B - \u096B\u096A \u0938\u093E\u0932 \u0915\u0940 \u0909\u092E\u094D\u0930",
      "defaults.template.age.option.age_55_over": "\u096B\u096B \u092F\u093E \u0909\u0938\u0938\u0947 \u0905\u0927\u093F\u0915 ",
      "defaults.template.sex.label": " \u0906\u092A\u0915\u0947 \u0932\u093F\u0902\u0917 \u0915\u094D\u092F\u093E \u0939\u0948?",
      "defaults.template.sex.option.sex_female": "\u092E\u0939\u093F\u0932\u093E",
      "defaults.template.sex.option.sex_male": "\u092A\u0941\u0930\u0941\u0937",
      "defaults.widget.label": "Text",
      "errors.page.default": "\u0913\u0939, \u0915\u094B\u0908 \u0924\u094D\u0930\u0941\u091F\u093F \u0939\u0941\u0908",
      "errors.page.notFound": "\u092A\u0947\u091C \u0928\u0939\u0940\u0902 \u092E\u093F\u0932\u093E",
      "errors.server.default": "\u0938\u0930\u094D\u0935\u0930 \u0924\u094D\u0930\u0941\u091F\u093F",
      "errors.survey.alreadyFinished": "\u0906\u092A \u092A\u0939\u0932\u0947 \u0939\u0940 \u092F\u0939 \u0938\u0930\u094D\u0935\u0947 \u092A\u0942\u0930\u093E \u0915\u0930 \u091A\u0941\u0915\u0947 \u0939\u0948\u0902",
      "errors.survey.closed": "\u0926\u0941\u0930\u094D\u092D\u093E\u0917\u094D\u092F\u0935\u0936, \u092F\u0939 \u0930\u093F\u0938\u0930\u094D\u091A \u0916\u0924\u094D\u092E \u0939\u094B \u0917\u0908 \u0939\u0948",
      "errors.survey.notFound": "\u092A\u0947\u091C \u0928\u0939\u0940\u0902 \u092E\u093F\u0932\u093E",
      "errors.survey.paused": "\u0938\u0930\u094D\u0935\u0947 \u0930\u094B\u0915\u093E \u0917\u092F\u093E",
      "final.thanks": "\u0927\u0928\u094D\u092F\u0935\u093E\u0926!",
      "footer.default.confidential.text": "\u0917\u094B\u092A\u0928\u0940\u092F",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "\u0917\u094B\u092A\u0928\u0940\u092F\u0924\u093E",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "\u092F\u0939 \u0938\u0930\u094D\u0935\u0947\u0915\u094D\u0937\u0923 \u092F\u093E\u0902\u0921\u0947\u0915\u094D\u0938 \u0938\u0930\u094D\u0935\u0947\u0915\u094D\u0937\u0923 \u092A\u094D\u0930\u094C\u0926\u094D\u092F\u094B\u0917\u093F\u0915\u093F\u092F\u094B\u0902 \u0926\u094D\u0935\u093E\u0930\u093E \u0938\u0902\u091A\u093E\u0932\u093F\u0924 \u0939\u0948",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "\u092F\u093E\u0902\u0921\u0947\u0915\u094D\u0938 \u0906\u0902\u0924\u0930\u093F\u0915 \u0938\u0930\u094D\u0935\u0947\u0915\u094D\u0937\u0923",
      "footer.default.responsibility": "\u0915\u0941\u091B \u0938\u0930\u094D\u0935\u0947 \u0924\u0943\u0924\u0940\u092F \u092A\u0915\u094D\u0937 \u0926\u094D\u0935\u093E\u0930\u093E \u092C\u0928\u093E\u090F \u0917\u090F \u0939\u0948\u0902. Yandex \u0909\u0928\u0915\u0940 \u0938\u093E\u092E\u0917\u094D\u0930\u0940 \u0915\u0940 \u091C\u093E\u0902\u091A \u092F\u093E \u0938\u0924\u094D\u092F\u093E\u092A\u0928 \u0928\u0939\u0940\u0902 \u0915\u0930\u0924\u093E \u0939\u0948, \u0928\u093E \u0939\u0940 \u0909\u0928\u0915\u0940 \u0915\u094B\u0908 \u095B\u093F\u092E\u094D\u092E\u0947\u0926\u093E\u0930\u0940 \u0932\u0947\u0924\u093E \u0939\u0948.",
      "footer.default.termsofuse.text": "\u0909\u092A\u092F\u094B\u0917 \u0915\u0940 \u0936\u0930\u094D\u0924\u0947\u0902",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "\u0917\u094B\u092A\u0928\u0940\u092F\u0924\u093E",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "\u0909\u092A\u092F\u094B\u0917 \u0915\u0940 \u0936\u0930\u094D\u0924\u0947\u0902",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "\u0938\u0930\u094D\u0935\u0947 \u092A\u0942\u0930\u093E \u0939\u0941\u0906. \u0927\u0928\u094D\u092F\u0935\u093E\u0926!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "\u0935\u093E\u092A\u0938",
      "page.buttonNext": "\u0905\u0917\u0932\u093E",
      "page.buttonSkip": "\u091B\u094B\u095C\u0947\u0902",
      "page.title": "\u0938\u0930\u094D\u0935\u0947 \u092E\u0947\u0902 \u092D\u093E\u0917 \u0932\u0947\u0902",
      "page.watermark": "\u092A\u0942\u0930\u094D\u0935\u093E\u0935\u0932\u094B\u0915\u0928 \u091C\u0935\u093E\u092C\u094B\u0902 \u092A\u0930 \u0927\u094D\u092F\u093E\u0928 \u0928\u0939\u0940\u0902 \u0926\u093F\u092F\u093E \u091C\u093E\u0924\u093E \u0939\u0948 \u092A\u0942\u0930\u094D\u0935\u093E\u0935\u0932\u094B\u0915\u0928 \u091C\u0935\u093E\u092C\u094B\u0902 \u092A\u0930 \u0927\u094D\u092F\u093E\u0928 \u0928\u0939\u0940\u0902 \u0926\u093F\u092F\u093E \u091C\u093E\u0924\u093E \u0939\u0948 \u092A\u0942\u0930\u094D\u0935\u093E\u0935\u0932\u094B\u0915\u0928 \u091C\u0935\u093E\u092C\u094B\u0902 \u092A\u0930 \u0927\u094D\u092F\u093E\u0928 \u0928\u0939\u0940\u0902 \u0926\u093F\u092F\u093E \u091C\u093E\u0924\u093E \u0939\u0948",
      "placeholders.longText": "\u0905\u092A\u0928\u0940 \u091F\u093F\u092A\u094D\u092A\u0923\u0940 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902",
      "placeholders.shortText": "\u0905\u092A\u0928\u0940 \u091F\u093F\u092A\u094D\u092A\u0923\u0940 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902",
      "plural.answers.im": [
        "\u0909\u0924\u094D\u0924\u0930",
        "\u0909\u0924\u094D\u0924\u0930",
        "\u0909\u0924\u094D\u0924\u0930",
        "\u0909\u0924\u094D\u0924\u0930"
      ],
      "plural.answers.ro": [
        "\u0909\u0924\u094D\u0924\u0930",
        "\u0909\u0924\u094D\u0924\u0930",
        "\u0909\u0924\u094D\u0924\u0930",
        "\u0909\u0924\u094D\u0924\u0930"
      ],
      "plural.ratingStars.labels": [
        "\u0938\u094D\u091F\u093E\u0930",
        "\u0938\u094D\u091F\u093E\u0930\u094D\u0938",
        "\u0938\u094D\u091F\u093E\u0930\u094D\u0938",
        ""
      ],
      "plural.seconds.im": [
        "\u0938\u0947\u0915\u0902\u0921",
        "\u0938\u0947\u0915\u0902\u0921",
        "\u0938\u0947\u0915\u0902\u0921",
        "\u0938\u0947\u0915\u0902\u0921"
      ],
      "plural.seconds.ro": [
        "\u0938\u0947\u0915\u0902\u0921",
        "\u0938\u0947\u0915\u0902\u0921",
        "\u0938\u0947\u0915\u0902\u0921",
        "\u0938\u0947\u0915\u0902\u0921"
      ],
      "questionModel.awful": "\u0916\u0930\u093E\u092C",
      "questionModel.bad": "\u092C\u0941\u0930\u093E",
      "questionModel.dateLessThan": "\u0924\u093E\u0930\u0940\u0916 \u0907\u0938\u0938\u0947 \u092A\u0939\u0932\u0947 \u0915\u0940 \u0928\u0939\u0940\u0902 \u0939\u094B \u0938\u0915\u0924\u0940 %s",
      "questionModel.dateMoreThan": "\u0924\u093E\u0930\u0940\u0916 \u0907\u0938\u0938\u0947 \u092C\u093E\u0926\xA0\u0915\u0940\xA0\u0928\u0939\u0940\u0902\xA0\u0939\u094B\xA0\u0938\u0915\u0924\u0940 %s",
      "questionModel.datePlaceholder": "Select a date",
      "questionModel.insufficientAnswers": [
        "\u0906\u092A\u0928\u0947 %s \u0938\u0947 \u0915\u092E \u0909\u0924\u094D\u0924\u0930 \u091A\u0941\u0928\u093E \u0939\u0948",
        "\u0906\u092A\u0928\u0947 %s \u0938\u0947 \u0915\u092E \u0909\u0924\u094D\u0924\u0930\u094B\u0902 \u0915\u094B \u091A\u0941\u0928\u093E \u0939\u0948",
        "\u0906\u092A\u0928\u0947 %s \u0938\u0947 \u0915\u092E \u0909\u0924\u094D\u0924\u0930\u094B\u0902 \u0915\u094B \u091A\u0941\u0928\u093E \u0939\u0948",
        ""
      ],
      "questionModel.lessThan": "\u0938\u0902\u0916\u094D\u092F\u093E %s \u0938\u0947 \u0915\u092E \u0928\u0939\u0940\u0902 \u0939\u094B \u0938\u0915\u0924\u0940",
      "questionModel.maxAnswerPerRowExceeded": "\u0906\u092A \u090F\u0915 \u092A\u0902\u0915\u094D\u0924\u093F \u092E\u0947\u0902 \u0909\u0924\u094D\u0924\u0930\u094B\u0902 \u0915\u0940 \u0905\u0927\u093F\u0915\u0924\u092E \u0938\u0902\u0916\u094D\u092F\u093E \u092A\u093E\u0930 \u0915\u0930 \u091A\u0941\u0915\u0947 \u0939\u0948\u0902",
      "questionModel.maxLenghtExceeded": "\u0935\u0930\u094D\u0923 \u0938\u0940\u092E\u093E \u092A\u093E\u0930 \u0939\u094B \u0917\u0908. \u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0928\u093E \u0909\u0924\u094D\u0924\u0930 \u091B\u094B\u091F\u093E \u0915\u0930\u0947\u0902\u0964",
      "questionModel.moreThan": "\u0938\u0902\u0916\u094D\u092F\u093E %s \u0938\u0947 \u095B\u094D\u092F\u093E\u0926\u093E \u0928\u0939\u0940\u0902 \u0939\u094B \u0938\u0915\u0924\u0940",
      "questionModel.normally": "\u0938\u093E\u092E\u093E\u0928\u094D\u092F",
      "questionModel.notDate": "\u0905\u092E\u093E\u0928\u094D\u092F \u0926\u093F\u0928\u093E\u0902\u0915",
      "questionModel.notEmail": "\u0908\u092E\u0947\u0932 \u095E\u0949\u0930\u094D\u092E\u0947\u091F \u0938\u0947 \u092E\u0947\u0932 \u0916\u093E\u0928\u093E \u091A\u093E\u0939\u093F\u090F",
      "questionModel.notFilled": "\u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0928\u093E \u091C\u0935\u093E\u092C \u092F\u0939\u093E\u0902 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902",
      "questionModel.notNumber": "\u0915\u0947\u0935\u0932 \u0938\u0902\u0916\u094D\u092F\u093E\u090F\u0902 \u0939\u094B \u0938\u0915\u0924\u0940 \u0939\u0948\u0902",
      "questionModel.perfectly": "\u092C\u0939\u0941\u0924 \u092C\u095D\u093F\u092F\u093E",
      "questionModel.picture": "\u0907\u092E\u0947\u091C %s",
      "questionModel.requiredField": "\u0915\u0943\u092A\u092F\u093E \u0907\u0938 \u0938\u0935\u093E\u0932 \u0915\u094B \u091C\u0935\u093E\u092C \u0926\u093F\u090F \u092C\u093F\u0928\u093E \u0928 \u091B\u094B\u095C\u0947\u0902",
      "questionModel.tooManyAnswers": [
        "%s \u0938\u0947 \u095B\u094D\u092F\u093E\u0926\u093E \u091C\u0935\u093E\u092C \u091A\u0941\u0928\u0947\u0902",
        "%s \u0938\u0947 \u095B\u094D\u092F\u093E\u0926\u093E \u091C\u0935\u093E\u092C \u091A\u0941\u0928\u0947\u0902",
        "",
        ""
      ],
      "questionModel.well": "\u092C\u095D\u093F\u092F\u093E",
      "sidebyside.option": "\u0935\u093F\u0915\u0932\u094D\u092A %s",
      "templates.options.age.age18_24": "\u0967\u096E - \u0968\u096A \u0938\u093E\u0932 \u0915\u0940 \u0909\u092E\u094D\u0930",
      "templates.options.age.age25_34": "\u0968\u096B - \u0969\u096A \u0938\u093E\u0932 \u0915\u0940 \u0909\u092E\u094D\u0930",
      "templates.options.age.age35_44": "\u0969\u096B - \u096A\u096A \u0938\u093E\u0932 \u0915\u0940 \u0909\u092E\u094D\u0930",
      "templates.options.age.age45_54": "\u096A\u096B - \u096B\u096A \u0938\u093E\u0932 \u0915\u0940 \u0909\u092E\u094D\u0930",
      "templates.options.age.age55_over": "\u096B\u096B \u092F\u093E \u0909\u0938\u0938\u0947 \u0905\u0927\u093F\u0915 ",
      "templates.options.sex.sex_female": "\u092E\u0939\u093F\u0932\u093E",
      "templates.options.sex.sex_male": "\u092A\u0941\u0930\u0941\u0937",
      "templates.questions.age": "\u0906\u092A\u0915\u0947 \u0909\u092E\u094D\u0930 \u0915\u094D\u092F\u093E \u0939\u0948?",
      "templates.questions.sex": " \u0906\u092A\u0915\u0947 \u0932\u093F\u0902\u0917 \u0915\u094D\u092F\u093E \u0939\u0948?",
      "ux.stepPaginator.stepTitle": "\u0915\u0941\u0932 %s \u0915\u093E \u091A\u0930\u0923 %s",
      "video.holdBtn": "\u092C\u094D\u0930\u093E\u0902\u0921 \u0926\u093F\u0916\u093E\u0908 \u0926\u0947\u0928\u0947 \u092A\u0930 \u0926\u092C\u093E\u090F\u0902 \u0930\u0916\u0947\u0902",
      "video.statusBarTitle": "\u092C\u094D\u0930\u093E\u0902\u0921 %1 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 %2 \u0938\u0947\u0915\u0902\u0921 \u0924\u0915 \u0926\u093F\u0916\u093E\u0908 \u0926\u093F\u092F\u093E \u0925\u093E"
    }
  },
  hy: {
    poll: {
      "attach.image.notLess": "\u0546\u0561\u0575\u0565\u0584 \u0576\u056F\u0561\u0580\u056B\u0576 \u0561\u057C\u0576\u057E\u0561\u0566\u0576 %1 \u0587 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0565\u0584 \u0574\u056B \u0584\u0561\u0576\u056B \u0570\u0561\u0580\u0581\u056B",
      "attach.image.notMore": "\u0546\u0561\u0575\u0565\u0584 \u0576\u056F\u0561\u0580\u056B\u0576 %1 \u0587 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0565\u0584 \u0574\u056B \u0584\u0561\u0576\u056B \u0570\u0561\u0580\u0581\u056B",
      "attach.text.notLess": "\u0546\u0561\u0575\u0565\u0584 \u057F\u0565\u0584\u057D\u057F\u056B\u0576 \u0561\u057C\u0576\u057E\u0561\u0566\u0576 %1 \u0587 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0565\u0584 \u0574\u056B \u0584\u0561\u0576\u056B \u0570\u0561\u0580\u0581\u056B",
      "attach.text.notMore": "\u053F\u0561\u0580\u0564\u0561\u0581\u0565\u0584 \u057F\u0565\u0584\u057D\u057F\u0568 %1\u0578\u0582\u0574 \u0587 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0565\u0584 \u0574\u056B \u0584\u0561\u0576\u056B \u0570\u0561\u0580\u0581\u056B",
      "attach.text.widgetHidden": "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "attach.video.notLess": "\u0534\u056B\u057F\u0565\u0584 \u057F\u0565\u057D\u0561\u0576\u0575\u0578\u0582\u0569\u0568 \u0561\u057C\u0576\u057E\u0561\u0566\u0576 %1 \u0587 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0565\u0584 \u0574\u056B \u0584\u0561\u0576\u056B \u0570\u0561\u0580\u0581\u056B",
      "attach.video.notMore": "\u0534\u056B\u057F\u0565\u0584 \u057F\u0565\u057D\u0561\u0576\u0575\u0578\u0582\u0569\u0568 %1 \u0587 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0565\u0584 \u0574\u056B \u0584\u0561\u0576\u056B \u0570\u0561\u0580\u0581\u056B",
      "attach.video.waitEnd": "\u0534\u056B\u057F\u0565\u0584 \u057F\u0565\u057D\u0561\u0576\u0575\u0578\u0582\u0569\u0568 \u0574\u056B\u0576\u0579\u0587 \u057E\u0565\u0580\u057B \u0587 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0565\u0584 \u0574\u056B \u0584\u0561\u0576\u056B \u0570\u0561\u0580\u0581\u056B",
      "attach.watch": "\u0534\u056B\u057F\u0565\u056C",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "\u041D\u0435 \u043C\u043E\u0433\u0443 \u043D\u0430\u0437\u0432\u0430\u0442\u044C",
      "commonComponents.choice.anythingElse": "\u0531\u057E\u0565\u056C\u056B\u0576...",
      "commonComponents.choice.chooseLessEqualMore": [
        "\u0538\u0576\u057F\u0580\u0565\u0584 %s \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u0538\u0576\u057F\u0580\u0565\u0584 %s \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u0538\u0576\u057F\u0580\u0565\u0584 % \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "\u0538\u0576\u057F\u0580\u0565\u0584 \u0576\u057E\u0561\u0566\u0561\u0563\u0578\u0582\u0575\u0576\u0568 %s \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u0538\u0576\u057F\u0580\u0565\u0584 \u0576\u057E\u0561\u0566\u0561\u0563\u0578\u0582\u0575\u0576\u0568 %s \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u0538\u0576\u057F\u0580\u0565\u0584 \u0576\u057E\u0561\u0566\u0561\u0563\u0578\u0582\u0575\u0576\u0568 %s \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "\u0538\u0576\u057F\u0580\u0565\u0584 \u0576\u057E\u0561\u0566\u0561\u0563\u0578\u0582\u0575\u0576\u0568 %s \u0587 \u0561\u057C\u0561\u057E\u0565\u056C\u0561\u0563\u0578\u0582\u0575\u0576\u0568 %s",
      "commonComponents.choice.chooseNoMore": [
        "\u0538\u0576\u057F\u0580\u0565\u0584 \u0578\u0579 \u0561\u057E\u0565\u056C\u056B, \u0584\u0561\u0576 %s \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u0538\u0576\u057F\u0580\u0565\u0584 \u0578\u0579 \u0561\u057E\u0565\u056C\u056B, \u0584\u0561\u0576 %s \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u0538\u0576\u057F\u0580\u0565\u0584 \u0578\u0579 \u0561\u057E\u0565\u056C\u056B, \u0584\u0561\u0576 %s \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        ""
      ],
      "commonComponents.choice.enterText": "\u0544\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u0584 \u057F\u0565\u0584\u057D\u057F\u0568",
      "commonComponents.choice.yourComment": "\u0541\u0565\u0580 \u0574\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568...",
      "commonComponents.scale.chooseRate": "\u0538\u0576\u057F\u0580\u0565\u0584 \u0563\u0576\u0561\u0570\u0561\u057F\u0561\u056F\u0561\u0576",
      "commonComponents.scale.firstElement": "\u0531\u057C\u0561\u057B\u056B\u0576 \u056E\u0561\u0575\u0580\u0561\u0570\u0565\u0572 \u057F\u0561\u0580\u0562\u0565\u0580\u0561\u056F\u0568 %s \u0576\u0577\u0561\u0576\u0561\u056F\u0578\u0582\u0574 \u0567",
      "commonComponents.scale.lastElement": "\u054E\u0565\u0580\u057B\u056B\u0576 \u056E\u0561\u0575\u0580\u0561\u0570\u0565\u0572 \u057F\u0561\u0580\u0562\u0565\u0580\u0561\u056F\u0568 %s \u0576\u0577\u0561\u0576\u0561\u056F\u0578\u0582\u0574 \u0567",
      "commonComponents.table.chooseNoMore": [
        "\u0538\u0576\u057F\u0580\u0565\u0584 \u0561\u057C\u0561\u057E\u0565\u056C\u0561\u0563\u0578\u0582\u0575\u0576\u0568 %s \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576 \u057F\u0578\u0572\u0578\u0582\u0574",
        "\u0538\u0576\u057F\u0580\u0565\u0584 \u0561\u057C\u0561\u057E\u0565\u056C\u0561\u0563\u0578\u0582\u0575\u0576\u0568 %s \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576 \u057F\u0578\u0572\u0578\u0582\u0574",
        "\u0538\u0576\u057F\u0580\u0565\u0584 \u0561\u057C\u0561\u057E\u0565\u056C\u0561\u0563\u0578\u0582\u0575\u0576\u0568 %s \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576 \u057F\u0578\u0572\u0578\u0582\u0574",
        ""
      ],
      "defaults.agree": "\u053C\u056B\u0578\u057E\u056B\u0576 \u0570\u0561\u0574\u0561\u0571\u0561\u0575\u0576 \u0565\u0574",
      "defaults.back": "\u0540\u0565\u057F",
      "defaults.datePlaceholder": "\u0585\u0585.\u0561\u0561.\u057F\u057F\u057F\u057F",
      "defaults.disagree": "\u0538\u0576\u0564\u0570\u0561\u0576\u0580\u0561\u057A\u0565\u057D \u0570\u0561\u0574\u0561\u0571\u0561\u0575\u0576 \u0579\u0565\u0574",
      "defaults.dualChoice.label": "\u0546\u0577\u0561\u057E\u0561\u0576\u0564\u0561\u056F",
      "defaults.emoji1": "\u054D\u0561\u0580\u057D\u0561\u0583\u0565\u056C\u056B \u0567",
      "defaults.emoji2": "\u054E\u0561\u057F \u0567",
      "defaults.emoji3": "\u0546\u0578\u0580\u0574\u0561\u056C \u0567",
      "defaults.emoji4": "\u053C\u0561\u057E \u0567",
      "defaults.emoji5": "\u0533\u0565\u0580\u0561\u0566\u0561\u0576\u0581 \u0567",
      "defaults.next": "\u0531\u057E\u0565\u056C\u056B\u0576",
      "defaults.noAnswer": "\u0539\u057E\u0561\u0580\u056F\u057E\u0561\u056E\u0576\u0565\u0580\u056B\u0581 \u0578\u0579 \u0574\u0565\u056F\u0568",
      "defaults.noOpinionAnswer": "\u0534\u056A\u057E\u0561\u0580\u0561\u0576\u0578\u0582\u0574 \u0565\u0574 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0565\u056C",
      "defaults.otherAnswer": "\u0531\u0575\u056C",
      "defaults.otherAnswerWithText": "\u0531\u0575\u056C (\u0574\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u0584 \u0571\u0565\u0580 \u057F\u0561\u0580\u0562\u0565\u0580\u0561\u056F\u0568)",
      "defaults.template.age.label": "\u0546\u0577\u0565\u0584 \u0571\u0565\u0580 \u057F\u0561\u0580\u056B\u0584\u0568",
      "defaults.template.age.option.age_17_under": "18 \u057F\u0561\u0580\u0565\u056F\u0561\u0576\u056B\u0581 \u0583\u0578\u0584\u0580",
      "defaults.template.age.option.age_18_24": "18\u201324 \u057F\u0561\u0580\u0565\u056F\u0561\u0576",
      "defaults.template.age.option.age_25_34": "25\u201334 \u057F\u0561\u0580\u0565\u056F\u0561\u0576",
      "defaults.template.age.option.age_35_44": "35\u201344 \u057F\u0561\u0580\u0565\u056F\u0561\u0576",
      "defaults.template.age.option.age_45_54": "45\u201354 \u057F\u0561\u0580\u0565\u056F\u0561\u0576",
      "defaults.template.age.option.age_55_over": "55 \u056F\u0561\u0574 \u0561\u057E\u0565\u056C\u056B \u057F\u0561\u0580\u0565\u056F\u0561\u0576",
      "defaults.template.sex.label": "\u0546\u0577\u0565\u0584 \u0571\u0565\u0580 \u057D\u0565\u057C\u0568",
      "defaults.template.sex.option.sex_female": "\u053B\u0563\u0561\u056F\u0561\u0576",
      "defaults.template.sex.option.sex_male": "\u0531\u0580\u0561\u056F\u0561\u0576",
      "defaults.widget.label": "\u0422\u0435\u043A\u0441\u0442",
      "errors.page.default": "\u054D\u056D\u0561\u056C \u0567 \u057F\u0565\u0572\u056B \u0578\u0582\u0576\u0565\u0581\u0565\u056C :(",
      "errors.page.notFound": "\u0537\u057B\u0568 \u0579\u056B \u0563\u057F\u0576\u057E\u0565\u056C",
      "errors.server.default": "\u054D\u0565\u0580\u057E\u0565\u0580\u056B \u057D\u056D\u0561\u056C",
      "errors.survey.alreadyFinished": "\u0534\u0578\u0582\u0584 \u0561\u0580\u0564\u0565\u0576 \u0561\u057E\u0561\u0580\u057F\u0565\u056C \u0565\u0584 \u0561\u0575\u057D \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0568",
      "errors.survey.closed": "\u0551\u0561\u057E\u0578\u0584, \u0570\u0565\u057F\u0561\u0566\u0578\u057F\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576 \u0561\u0580\u0564\u0565\u0576 \u0561\u057E\u0561\u0580\u057F\u057E\u0565\u056C \u0567",
      "errors.survey.notFound": "\u0537\u057B\u0568 \u0579\u056B \u0563\u057F\u0576\u057E\u0565\u056C",
      "errors.survey.paused": "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0568 \u0564\u0561\u0564\u0561\u0580\u0565\u0581\u057E\u0565\u056C \u0567",
      "final.thanks": "\u0547\u0576\u0578\u0580\u0570\u0561\u056F\u0561\u056C\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
      "footer.default.confidential.text": "\u053F\u0578\u0576\u0586\u056B\u0581\u0565\u0576\u0581\u056B\u0561\u056C",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "\u0533\u0561\u0572\u057F\u0576\u056B\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.default.copyright.text": "\xA9 %s  Yandex \u054D\u054A\u0538",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex \u054D\u054A\u0538",
      "footer.default.createby.text": "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576 \u0561\u0580\u057E\u0565\u056C \u0567 Yandex Surveys-\u056B \u057F\u0565\u056D\u0576\u0578\u056C\u0578\u0563\u056B\u0561\u0576\u0565\u0580\u056B \u0585\u0563\u0576\u0578\u0582\u0569\u0575\u0561\u0574\u0562",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Yandex-\u056B \u0576\u0565\u0580\u0584\u056B\u0576 \u0570\u0561\u0580\u0581\u0578\u0582\u0574",
      "footer.default.responsibility": "Yandex-\u0568 \u056F\u0561\u057A \u0579\u0578\u0582\u0576\u056B \u056F\u0578\u0572\u0574\u0576\u0561\u056F\u056B \u0561\u0576\u0571\u0561\u0576\u0581 \u056F\u0578\u0572\u0574\u056B\u0581 \u057D\u057F\u0565\u0572\u056E\u057E\u0561\u056E \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580\u056B \u0570\u0565\u057F \u0587 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0561\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u0579\u056B \u056F\u0580\u0578\u0582\u0574 \u0564\u0580\u0561\u0576\u0581 \u0562\u0578\u057E\u0561\u0576\u0564\u0561\u056F\u0578\u0582\u0569\u0575\u0561\u0576 \u0570\u0561\u0574\u0561\u0580\u0589",
      "footer.default.termsofuse.text": "\u0555\u0563\u057F\u0561\u0563\u0578\u0580\u056E\u0574\u0561\u0576 \u057A\u0561\u0575\u0574\u0561\u0576\u0576\u0565\u0580\u0568",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/",
      "footer.odnaco.confpolicy.text": "\u0533\u0561\u0572\u057F\u0576\u056B\u0578\u0582\u0569\u0575\u0561\u0576 \u0584\u0561\u0572\u0561\u0584\u0561\u056F\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "\u0555\u0563\u057F\u0561\u0563\u0578\u0580\u056E\u0574\u0561\u0576 \u0570\u0561\u0574\u0561\u0571\u0561\u0575\u0576\u0561\u0563\u056B\u0580",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/index.html",
      "info.survey.thanks": "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576 \u0561\u057E\u0561\u0580\u057F\u057E\u0561\u056E \u0567\u0589 \u0547\u0576\u0578\u0580\u0570\u0561\u056F\u0561\u056C\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
      "labels.columnHidden": "\u0421\u0442\u043E\u043B\u0431\u0435\u0446 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.hiddenQuestionsActivated": "\u0421\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u044E\u0442\u0441\u044F",
      "labels.hiddenQuestionsDeactivated": "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0441\u043A\u0440\u044B\u0442\u044B\u0445 \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432 \u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
      "labels.optionHidden": "\u041E\u0442\u0432\u0435\u0442 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.page": "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
      "labels.questionHidden": "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.rotationGroup": "\u0413\u0440\u0443\u043F\u043F\u0430",
      "labels.rowHidden": "\u0421\u0442\u0440\u043E\u043A\u0430 \u0441\u043A\u0440\u044B\u0442\u0430 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.screening": "\u0421\u043A\u0440\u0438\u043D\u0438\u0440\u0443\u044E\u0449\u0438\u0439 \u0432\u043E\u043F\u0440\u043E\u0441",
      "labels.showHiddenQuestions": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
      "labels.widgetHidden": "\u0422\u0435\u043A\u0441\u0442 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "page.buttonBack": "\u0540\u0565\u057F",
      "page.buttonNext": "\u0531\u057E\u0565\u056C\u056B\u0576",
      "page.buttonSkip": "\u0532\u0561\u0581 \u0569\u0578\u0572\u0576\u0565\u056C",
      "page.title": "\u0531\u0576\u0581\u0565\u0584 \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0568",
      "page.watermark": "\u0546\u0531\u053D\u0531\u0534\u053B\u054F\u0548\u0552\u0544 \u054A\u0531\u054F\u0531\u054D\u053D\u0531\u0546\u0546\u0535\u0550\u0538 \u0540\u0531\u0547\u054E\u053B \u0549\u0535\u0546 \u0531\u054C\u0546\u054E\u0548\u0552\u0544 \u0546\u0531\u053D\u0531\u0534\u053B\u054F\u0548\u0552\u0544 \u054A\u0531\u054F\u0531\u054D\u053D\u0531\u0546\u0546\u0535\u0550\u0538 \u0540\u0531\u0547\u054E\u053B \u0549\u0535\u0546 \u0531\u054C\u0546\u054E\u0548\u0552\u0544 \u0546\u0531\u053D\u0531\u0534\u053B\u054F\u0548\u0552\u0544 \u054A\u0531\u054F\u0531\u054D\u053D\u0531\u0546\u0546\u0535\u0550\u0538 \u0540\u0531\u0547\u054E\u053B \u0549\u0535\u0546 \u0531\u054C\u0546\u054E\u0548\u0552\u0544",
      "placeholders.longText": "\u0541\u0565\u0580 \u0574\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
      "placeholders.shortText": "\u0541\u0565\u0580 \u0574\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
      "plural.answers.im": [
        "\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576"
      ],
      "plural.answers.ro": [
        "\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576"
      ],
      "plural.ratingStars.labels": [
        "\u0561\u057D\u057F\u0572",
        "\u0561\u057D\u057F\u0572",
        "\u0561\u057D\u057F\u0572",
        ""
      ],
      "plural.seconds.im": [
        "\u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        "\u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        "\u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        "\u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
      ],
      "plural.seconds.ro": [
        "\u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        "\u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        "\u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        "\u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
      ],
      "questionModel.awful": "\u054D\u0561\u0580\u057D\u0561\u0583\u0565\u056C\u056B \u0567",
      "questionModel.bad": "\u054E\u0561\u057F \u0567",
      "questionModel.dateLessThan": "\u0531\u0574\u057D\u0561\u0569\u056B\u057E\u0568 \u0579\u056B \u056F\u0561\u0580\u0578\u0572 \u056C\u056B\u0576\u0565\u056C \u0561\u057E\u0565\u056C\u056B \u0577\u0578\u0582\u057F, \u0584\u0561\u0576 %s",
      "questionModel.dateMoreThan": "\u0531\u0574\u057D\u0561\u0569\u056B\u057E\u0568 \u0579\u056B \u056F\u0561\u0580\u0578\u0572 \u056C\u056B\u0576\u0565\u056C \u0561\u057E\u0565\u056C\u056B \u0578\u0582\u0577, \u0584\u0561\u0576 %s",
      "questionModel.datePlaceholder": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u0442\u0443",
      "questionModel.insufficientAnswers": [
        "\u0534\u0578\u0582\u0584 \u0568\u0576\u057F\u0580\u0565\u056C \u0565\u0584 %s-\u056B\u0581 \u0584\u056B\u0579 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u0534\u0578\u0582\u0584 \u0568\u0576\u057F\u0580\u0565\u056C \u0565\u0584 %s-\u056B\u0581 \u0584\u056B\u0579 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u0534\u0578\u0582\u0584 \u0568\u0576\u057F\u0580\u0565\u056C \u0565\u0584 %s-\u056B\u0581 \u0584\u056B\u0579 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        ""
      ],
      "questionModel.lessThan": "\u0539\u056B\u057E\u0568 \u0579\u056B \u056F\u0561\u0580\u0578\u0572 \u0583\u0578\u0584\u0580 \u056C\u056B\u0576\u0565\u056C %s-\u056B\u0581",
      "questionModel.maxAnswerPerRowExceeded": "\u054F\u0578\u0572\u0578\u0582\u0574 \u0561\u057C\u0561\u057E\u0565\u056C\u0561\u0563\u0578\u0582\u0575\u0576 \u0569\u0578\u0582\u0575\u056C\u0561\u057F\u0580\u0565\u056C\u056B \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580\u056B \u0584\u0561\u0576\u0561\u056F\u0568 \u0563\u0565\u0580\u0561\u0566\u0561\u0576\u0581\u057E\u0565\u056C \u0567",
      "questionModel.maxLenghtExceeded": "\u0546\u056B\u0577\u0565\u0580\u056B \u0584\u0561\u0576\u0561\u056F\u0568 \u0563\u0565\u0580\u0561\u0566\u0561\u0576\u0581\u0578\u0582\u0574 \u0567 \u0561\u057C\u0561\u057E\u0565\u056C\u0561\u0563\u0578\u0582\u0575\u0576 \u0569\u0578\u0582\u0575\u056C\u0561\u057F\u0580\u0565\u056C\u056B\u0576, \u056D\u0576\u0564\u0580\u0578\u0582\u0574 \u0565\u0576\u0584 \u056F\u0580\u0573\u0561\u057F\u0565\u056C \u057F\u0565\u0584\u057D\u057F\u0568",
      "questionModel.moreThan": "\u0539\u056B\u057E\u0568 \u0579\u056B \u056F\u0561\u0580\u0578\u0572 \u0574\u0565\u056E \u056C\u056B\u0576\u0565\u056C %s-\u056B\u0581",
      "questionModel.normally": "\u0546\u0578\u0580\u0574\u0561\u056C \u0567",
      "questionModel.notDate": "\u0531\u0576\u057E\u0561\u057E\u0565\u0580 \u0561\u0574\u057D\u0561\u0569\u056B\u057E \u0567 \u0574\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u057E\u0565\u056C",
      "questionModel.notEmail": "\u054A\u0565\u057F\u0584 \u0567 \u0570\u0561\u0574\u0561\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u056B \u0567\u056C\u0583\u0578\u057D\u057F\u056B \u0571\u0587\u0561\u0579\u0561\u0583\u056B\u0576",
      "questionModel.notFilled": "\u0531\u0576\u0570\u0580\u0561\u056A\u0565\u0577\u057F \u0567 \u0574\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u056C \u057F\u0565\u0584\u057D\u057F",
      "questionModel.notNumber": "\u053F\u0561\u0580\u0578\u0572 \u0567 \u057A\u0561\u0580\u0578\u0582\u0576\u0561\u056F\u0565\u056C \u0574\u056B\u0561\u0575\u0576 \u0569\u057E\u0565\u0580",
      "questionModel.perfectly": "\u0533\u0565\u0580\u0561\u0566\u0561\u0576\u0581 \u0567",
      "questionModel.picture": "\u0546\u056F\u0561\u0580 %s",
      "questionModel.requiredField": "\u0531\u0575\u057D \u0570\u0561\u0580\u0581\u0576 \u0561\u0576\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576 \u0574\u056B \u0569\u0578\u0572\u0565\u0584",
      "questionModel.tooManyAnswers": [
        "\u0534\u0578\u0582\u0584 \u0568\u0576\u057F\u0580\u0565\u056C \u0565\u0584 \u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 %s \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u0534\u0578\u0582\u0584 \u0568\u0576\u057F\u0580\u0565\u056C \u0565\u0584 \u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 %s \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        "\u0534\u0578\u0582\u0584 \u0568\u0576\u057F\u0580\u0565\u056C \u0565\u0584 \u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 %s \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        ""
      ],
      "questionModel.well": "\u053C\u0561\u057E \u0567",
      "sidebyside.option": "\u054F\u0561\u0580\u0562\u0565\u0580\u0561\u056F %s",
      "templates.options.age.age18_24": "18\u201324 \u057F\u0561\u0580\u0565\u056F\u0561\u0576",
      "templates.options.age.age25_34": "25\u201334 \u057F\u0561\u0580\u0565\u056F\u0561\u0576",
      "templates.options.age.age35_44": "35\u201344 \u057F\u0561\u0580\u0565\u056F\u0561\u0576",
      "templates.options.age.age45_54": "45\u201354 \u057F\u0561\u0580\u0565\u056F\u0561\u0576",
      "templates.options.age.age55_over": "55 \u056F\u0561\u0574 \u0561\u057E\u0565\u056C\u056B \u057F\u0561\u0580\u0565\u056F\u0561\u0576",
      "templates.options.sex.sex_female": "\u053B\u0563\u0561\u056F\u0561\u0576",
      "templates.options.sex.sex_male": "\u0531\u0580\u0561\u056F\u0561\u0576",
      "templates.questions.age": "\u0546\u0577\u0565\u0584 \u0571\u0565\u0580 \u057F\u0561\u0580\u056B\u0584\u0568",
      "templates.questions.sex": "\u0546\u0577\u0565\u0584 \u0571\u0565\u0580 \u057D\u0565\u057C\u0568",
      "ux.stepPaginator.stepTitle": "\u0554\u0561\u0575\u056C %s/%s",
      "video.holdBtn": "\u054A\u0561\u0570\u0565\u0584, \u0584\u0561\u0576\u056B \u0564\u0565\u057C \u057F\u0565\u057D\u0576\u0578\u0582\u0574 \u0565\u0584 \u0561\u057A\u0580\u0561\u0576\u0584\u0561\u0576\u056B\u0577\u0568",
      "video.statusBarTitle": "\u0531\u057A\u0580\u0561\u0576\u0584\u0561\u0576\u056B\u0577\u0568 \u057F\u0565\u057D\u0561\u0576\u0565\u056C\u056B \u0567\u0580 %1 \u057E\u0580\u056F-\u056B\u0581 \u0574\u056B\u0576\u0579\u0587 %2 \u057E\u0580\u056F"
    }
  },
  id: {
    poll: {
      "attach.image.notLess": "Perhatikan gambar setidaknya selama %1, lalu jawab beberapa pertanyaan",
      "attach.image.notMore": "Perhatikan gambar selama %1, lalu jawab beberapa pertanyaan",
      "attach.text.notLess": "Perhatikan teks setidaknya selama %1, lalu jawab beberapa pertanyaan",
      "attach.text.notMore": "Baca teks selama %1, lalu jawab beberapa pertanyaan",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "Tonton video setidaknya selama %1, lalu jawab beberapa pertanyaan",
      "attach.video.notMore": "Tonton video selama %1, lalu jawab beberapa pertanyaan",
      "attach.video.waitEnd": "Tonton video hingga selesai, lalu jawab beberapa pertanyaan",
      "attach.watch": "Tonton",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "Sesuatu yang lain...",
      "commonComponents.choice.chooseLessEqualMore": [
        "Pilih %s jawaban",
        "Pilih %s jawaban",
        "Pilih % jawaban",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "Pilih setidaknya %s jawaban",
        "Pilih setidaknya %s jawaban",
        "Pilih setidaknya %s jawaban",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "Pilih tidak kurang dari %s dan tidak lebih dari %s",
      "commonComponents.choice.chooseNoMore": [
        "Harap pilih %s jawaban saja",
        "Harap pilih tidak lebih dari %s jawaban",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "Masukkan teks",
      "commonComponents.choice.yourComment": "Masukkan komentar Anda...",
      "commonComponents.scale.chooseRate": "Berikan nilai",
      "commonComponents.scale.firstElement": "Opsi pertama %s berarti",
      "commonComponents.scale.lastElement": "Opsi terakhir %s berarti",
      "commonComponents.table.chooseNoMore": [
        "Pilih tidak lebih dari %s jawaban",
        "Pilih tidak lebih dari %s jawaban",
        "Pilih tidak lebih dari %s jawaban",
        ""
      ],
      "defaults.agree": "Sangat setuju",
      "defaults.back": "Kembali",
      "defaults.datePlaceholder": "hh.bb.tttt",
      "defaults.disagree": "Sangat tidak setuju",
      "defaults.dualChoice.label": "Kotak centang",
      "defaults.emoji1": "Sangat buruk",
      "defaults.emoji2": "Buruk",
      "defaults.emoji3": "Normal",
      "defaults.emoji4": "Bagus",
      "defaults.emoji5": "Sempurna",
      "defaults.next": "Selanjutnya",
      "defaults.noAnswer": "Tidak ada di atas",
      "defaults.noOpinionAnswer": "Tidak yakin",
      "defaults.otherAnswer": "Lainnya",
      "defaults.otherAnswerWithText": "Lainnya (jelaskan)",
      "defaults.template.age.label": "Berapa usia Anda?",
      "defaults.template.age.option.age_17_under": "Di bawah 18",
      "defaults.template.age.option.age_18_24": "18\u201324 tahun",
      "defaults.template.age.option.age_25_34": "25\u201334 tahun",
      "defaults.template.age.option.age_35_44": "35\u201344 tahun",
      "defaults.template.age.option.age_45_54": "45\u201354 tahun",
      "defaults.template.age.option.age_55_over": "55 tahun atau lebih",
      "defaults.template.sex.label": "Apa jenis kelamin Anda?",
      "defaults.template.sex.option.sex_female": "Perempuan",
      "defaults.template.sex.option.sex_male": "Laki-laki",
      "defaults.widget.label": "Text",
      "errors.page.default": "Maaf, terjadi kesalahan",
      "errors.page.notFound": "Halaman tidak ditemukan",
      "errors.server.default": "Server mengalami masalah",
      "errors.survey.alreadyFinished": "Anda sudah menyelesaikan survei ini",
      "errors.survey.closed": "Maaf, penelitian ini telah berakhir",
      "errors.survey.notFound": "Halaman tidak ditemukan",
      "errors.survey.paused": "Survei dijeda",
      "final.thanks": "Terima kasih!",
      "footer.default.confidential.text": "Rahasia",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "Kerahasiaan",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "Survei ini menggunakan teknologi Yandex Surveys",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Survei internal Yandex",
      "footer.default.responsibility": "Beberapa survei dibuat oleh pihak ketiga. Yandex tidak memeriksa atau memverifikasi, maupun bertanggung jawab atas isinya.",
      "footer.default.termsofuse.text": "Ketentuan Penggunaan",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "Kerahasiaan",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "Ketentuan Penggunaan",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "Survei selesai. Terima kasih!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "Kembali",
      "page.buttonNext": "Berikutnya",
      "page.buttonSkip": "Lewati",
      "page.title": "Ikuti survei",
      "page.watermark": "JAWABAN PRATINJAU TIDAK DIHITUNG JAWABAN PRATINJAU TIDAK DIHITUNG JAWABAN PRATINJAU TIDAK DIHITUNG",
      "placeholders.longText": "Masukkan komentar Anda",
      "placeholders.shortText": "Masukkan komentar Anda",
      "plural.answers.im": [
        "jawaban",
        "jawaban",
        "jawaban",
        "jawaban"
      ],
      "plural.answers.ro": [
        "jawaban",
        "jawaban",
        "jawaban",
        "jawaban"
      ],
      "plural.ratingStars.labels": [
        "bintang",
        "bintang",
        "bintang",
        ""
      ],
      "plural.seconds.im": [
        "detik",
        "detik",
        "detik",
        "detik"
      ],
      "plural.seconds.ro": [
        "detik",
        "detik",
        "detik",
        "detik"
      ],
      "questionModel.awful": "Sangat buruk",
      "questionModel.bad": "Buruk",
      "questionModel.dateLessThan": "Tanggal tidak boleh lebih awal dari %s",
      "questionModel.dateMoreThan": "Tanggal tidak boleh lebih\xA0lama dari %s",
      "questionModel.datePlaceholder": "Select a date",
      "questionModel.insufficientAnswers": [
        "Anda memilih kurang dari %s jawaban",
        "Anda memilih kurang dari %s jawaban",
        "Anda memilih kurang dari %s jawaban",
        ""
      ],
      "questionModel.lessThan": "Angka tidak boleh kurang dari %s",
      "questionModel.maxAnswerPerRowExceeded": "Anda melampaui jumlah jawaban maksimum",
      "questionModel.maxLenghtExceeded": "Batas karakter terlampaui. Harap persingkat jawaban Anda.",
      "questionModel.moreThan": "Angka tidak boleh lebih dari %s",
      "questionModel.normally": "Normal",
      "questionModel.notDate": "Tanggal yang salah",
      "questionModel.notEmail": "Harus sesuai dengan format email",
      "questionModel.notFilled": "Harap masukkan jawaban Anda di sini",
      "questionModel.notNumber": "Hanya boleh berisi angka",
      "questionModel.perfectly": "Sempurna",
      "questionModel.picture": "Gambar %s",
      "questionModel.requiredField": "Harap tidak mengosongkan pertanyaan ini",
      "questionModel.tooManyAnswers": [
        "Lebih dari %s jawaban dipilih",
        "Lebih dari %s jawaban dipilih",
        "",
        ""
      ],
      "questionModel.well": "Bagus",
      "sidebyside.option": "Opsi %s",
      "templates.options.age.age18_24": "18\u201324 tahun",
      "templates.options.age.age25_34": "25\u201334 tahun",
      "templates.options.age.age35_44": "35\u201344 tahun",
      "templates.options.age.age45_54": "45\u201354 tahun",
      "templates.options.age.age55_over": "55 tahun atau lebih",
      "templates.options.sex.sex_female": "Perempuan",
      "templates.options.sex.sex_male": "Laki-laki",
      "templates.questions.age": "Berapa usia Anda?",
      "templates.questions.sex": "Apa jenis kelamin Anda?",
      "ux.stepPaginator.stepTitle": "Langkah %s dari %s",
      "video.holdBtn": "Tekan dan tahan saat Anda melihat merek",
      "video.statusBarTitle": "Merek terlihat mulai detik %1 hingga detik %2"
    }
  },
  it: {
    poll: {
      "attach.image.notLess": "Osserva l'immagine almeno %1 e rispondi ad alcune domande",
      "attach.image.notMore": "Osserva l'immagine per %1 e rispondi ad alcune domande",
      "attach.text.notLess": "Osserva il testo per almeno %1 e rispondi ad alcune domande",
      "attach.text.notMore": "Leggi il testo in %1 e rispondi ad alcune domande",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "Guarda il video per almeno %1 e rispondi ad alcune domande",
      "attach.video.notMore": "Guarda il video per %1 e rispondi ad alcune domande",
      "attach.video.waitEnd": "Guarda il video fino alla fine e rispondi ad alcune domande",
      "attach.watch": "Guarda",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "Altro...",
      "commonComponents.choice.chooseLessEqualMore": [
        "Scegli %s la risposta",
        "Scegli %s le risposte",
        "Scegli  % risposte",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "Selezionare almeno %s risposta",
        "Selezionare almeno %s risposte",
        "Selezionare almeno %s risposte",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "Selezionare non meno di %s e non pi\xF9 di %s",
      "commonComponents.choice.chooseNoMore": [
        "Scegli non pi\xF9 di %s risposta",
        "Scegli non pi\xF9 di %s risposte",
        "Scegli non pi\xF9 di %s risposte",
        ""
      ],
      "commonComponents.choice.enterText": "Inserisci il testo",
      "commonComponents.choice.yourComment": "Inserisci il tuo commento...",
      "commonComponents.scale.chooseRate": "Seleziona una valutazione",
      "commonComponents.scale.firstElement": "La prima opzione %s significa",
      "commonComponents.scale.lastElement": "L\u2019ultima opzione %s significa",
      "commonComponents.table.chooseNoMore": [
        "Selezionare non pi\xF9 di %s risposta in una riga",
        "Selezionare non pi\xF9 di %s risposte in una riga",
        "Selezionare non pi\xF9 di %s risposte in una riga",
        ""
      ],
      "defaults.agree": "Totalmente d'accordo",
      "defaults.back": "Indietro",
      "defaults.datePlaceholder": "gg.mm.aaaa",
      "defaults.disagree": "Totalmente in disaccordo",
      "defaults.dualChoice.label": "Casella di controllo",
      "defaults.emoji1": "Terribile",
      "defaults.emoji2": "Male",
      "defaults.emoji3": "Normale",
      "defaults.emoji4": "Bene",
      "defaults.emoji5": "Ottimo",
      "defaults.next": "Successivo",
      "defaults.noAnswer": "Nessuna delle seguenti",
      "defaults.noOpinionAnswer": "Non so",
      "defaults.otherAnswer": "Altro",
      "defaults.otherAnswerWithText": "Altro (inserisci la tua opzione)",
      "defaults.template.age.label": "Quanti anni hai?",
      "defaults.template.age.option.age_17_under": "Under 18",
      "defaults.template.age.option.age_18_24": "18-24 anni",
      "defaults.template.age.option.age_25_34": "25-34 anni",
      "defaults.template.age.option.age_35_44": "35-44 anni",
      "defaults.template.age.option.age_45_54": "45-54 anni",
      "defaults.template.age.option.age_55_over": "55 anni o pi\xF9",
      "defaults.template.sex.label": "Di che sesso sei?",
      "defaults.template.sex.option.sex_female": "Femmina",
      "defaults.template.sex.option.sex_male": "Maschio",
      "defaults.widget.label": "Text",
      "errors.page.default": "Si \xE8 verificato un errore :(",
      "errors.page.notFound": "Pagina non trovata",
      "errors.server.default": "Errore del server",
      "errors.survey.alreadyFinished": "Hai gi\xE0 completato questo sondaggio",
      "errors.survey.closed": "Sfortunatamente l'indagine \xE8 gi\xE0 stata completata",
      "errors.survey.notFound": "Pagina non trovata",
      "errors.survey.paused": "Sondaggio sospeso",
      "final.thanks": "Grazie!",
      "footer.default.confidential.text": "Riservato",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "Riservatezza",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s  OOO \xABYandex\xBB",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "Il sondaggio \xE8 offerto dai servizi Yandex Surveys",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Sondaggio interno Yandex",
      "footer.default.responsibility": "Yandex non ha alcuna relazione con i sondaggi creati da terze parti e non \xE8 responsabile del loro contenuto.",
      "footer.default.termsofuse.text": "Modalit\xE0 d'uso",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "Informativa sulla privacy",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "Condizioni d'uso",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "Sondaggio completato. Grazie!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "Indietro",
      "page.buttonNext": "Successivo",
      "page.buttonSkip": "Salta",
      "page.title": "Partecipa al sondaggio",
      "page.watermark": "ANTEPRIMA LE RISPOSTE NON CONTANO ANTEPRIMA LE RISPOSTE NON CONTANO ANTEPRIMA LE RISPOSTE NON CONTANO",
      "placeholders.longText": "Inserisci il tuo commento",
      "placeholders.shortText": "Inserisci il tuo commento",
      "plural.answers.im": [
        "risposta",
        "risposte",
        "risposte",
        "risposte"
      ],
      "plural.answers.ro": [
        "risposta",
        "risposte",
        "risposte",
        "risposte"
      ],
      "plural.ratingStars.labels": [
        "stella",
        "stelle",
        "stelle",
        ""
      ],
      "plural.seconds.im": [
        "secondo",
        "secondi",
        "secondi",
        "secondi"
      ],
      "plural.seconds.ro": [
        "secondi",
        "secondi",
        "secondi",
        "secondi"
      ],
      "questionModel.awful": "Terribile",
      "questionModel.bad": "Male",
      "questionModel.dateLessThan": "La data non pu\xF2 essere antecedente a %s",
      "questionModel.dateMoreThan": "La data non pu\xF2 essere successiva a %s",
      "questionModel.datePlaceholder": "Inserisci la data",
      "questionModel.insufficientAnswers": [
        "Hai selezionato meno di %s risposta",
        "Hai selezionato meno di %s risposte",
        "Hai selezionato meno di %s risposte",
        ""
      ],
      "questionModel.lessThan": "Il numero non pu\xF2 essere inferiore a %s",
      "questionModel.maxAnswerPerRowExceeded": "Hai superato il numero massimo di risposte in una riga",
      "questionModel.maxLenghtExceeded": "Il numero di caratteri supera il massimo consentito, si prega di abbreviare il testo",
      "questionModel.moreThan": "Il numero non pu\xF2 essere maggiore di %s",
      "questionModel.normally": "Normale",
      "questionModel.notDate": "Data inserita non valida",
      "questionModel.notEmail": "Deve corrispondere al formato email",
      "questionModel.notFilled": "\xC8 necessario inserire il testo",
      "questionModel.notNumber": "Pu\xF2 contenere solo numeri",
      "questionModel.perfectly": "Ottimo",
      "questionModel.picture": "Immagine %s",
      "questionModel.requiredField": "Non lasciare questa domanda senza risposta",
      "questionModel.tooManyAnswers": [
        "Hai scelto pi\xF9 di %s risposta",
        "Hai scelto pi\xF9 di %s risposte",
        "Hai scelto pi\xF9 di %s risposte",
        ""
      ],
      "questionModel.well": "Bene",
      "sidebyside.option": "Versione %s",
      "templates.options.age.age18_24": "18-24 anni",
      "templates.options.age.age25_34": "25-34 anni",
      "templates.options.age.age35_44": "35-44 anni",
      "templates.options.age.age45_54": "45-54 anni",
      "templates.options.age.age55_over": "55 anni o pi\xF9",
      "templates.options.sex.sex_female": "Femmina",
      "templates.options.sex.sex_male": "Maschio",
      "templates.questions.age": "Quanti anni hai?",
      "templates.questions.sex": "Di che sesso sei?",
      "ux.stepPaginator.stepTitle": "Passo %s di %s",
      "video.holdBtn": "Aspetta finch\xE9 non vedi il marchio",
      "video.statusBarTitle": "Il marchio \xE8 visibile da %1 sec a %2 sec"
    }
  },
  ka: {
    poll: {
      "attach.image.notLess": "\u10E8\u10D4\u10EE\u10D4\u10D3\u10D4\u10D7 \u10E1\u10E3\u10E0\u10D0\u10D7\u10E1 \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB %1-\u10D8\u10E1 \u10D2\u10D0\u10DC\u10DB\u10D0\u10D5\u10DA\u10DD\u10D1\u10D0\u10E8\u10D8 \u10D3\u10D0 \u10E3\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D7 \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0\u10E1",
      "attach.image.notMore": "\u10E8\u10D4\u10EE\u10D4\u10D3\u10D4\u10D7 \u10E1\u10E3\u10E0\u10D0\u10D7\u10E1 %1-\u10D8\u10E1 \u10D2\u10D0\u10DC\u10DB\u10D0\u10D5\u10DA\u10DD\u10D1\u10D0\u10E8\u10D8 \u10D3\u10D0 \u10E3\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D7 \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0\u10E1",
      "attach.text.notLess": "\u10E8\u10D4\u10EE\u10D4\u10D3\u10D4\u10D7 \u10E2\u10D4\u10E5\u10E1\u10E2\u10E1 \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB %1-\u10D8\u10E1 \u10D2\u10D0\u10DC\u10DB\u10D0\u10D5\u10DA\u10DD\u10D1\u10D0\u10E8\u10D8 \u10D3\u10D0 \u10E3\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D7 \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0\u10E1",
      "attach.text.notMore": "\u10EC\u10D0\u10D8\u10D9\u10D8\u10D7\u10EE\u10D4\u10D7 \u10E2\u10D4\u10E5\u10E1\u10E2\u10D8 %1-\u10D8\u10E1 \u10D2\u10D0\u10DC\u10DB\u10D0\u10D5\u10DA\u10DD\u10D1\u10D0\u10E8\u10D8 \u10D3\u10D0 \u10E3\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D7 \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0\u10E1",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "\u10E3\u10E7\u10E3\u10E0\u10D4\u10D7 \u10D5\u10D8\u10D3\u10D4\u10DD\u10E1 \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB %1-\u10D8\u10E1 \u10D2\u10D0\u10DC\u10DB\u10D0\u10D5\u10DA\u10DD\u10D1\u10D0\u10E8\u10D8 \u10D3\u10D0 \u10E3\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D7 \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0\u10E1",
      "attach.video.notMore": "\u10E8\u10D4\u10EE\u10D4\u10D3\u10D4\u10D7 \u10D5\u10D8\u10D3\u10D4\u10DD\u10E0\u10D2\u10DD\u10DA\u10E1 %1-\u10D8\u10E1 \u10D2\u10D0\u10DC\u10DB\u10D0\u10D5\u10DA\u10DD\u10D1\u10D0\u10E8\u10D8 \u10D3\u10D0 \u10E3\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D7 \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0\u10E1",
      "attach.video.waitEnd": "\u10E8\u10D4\u10EE\u10D4\u10D3\u10D4\u10D7 \u10D5\u10D8\u10D3\u10D4\u10DD\u10E0\u10D2\u10DD\u10DA\u10E1 \u10D1\u10DD\u10DA\u10DD\u10DB\u10D3\u10D4 \u10D3\u10D0 \u10E3\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D7 \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0\u10E1",
      "attach.watch": "\u10DC\u10D0\u10EE\u10D5\u10D0",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "\u10D3\u10D0 \u10D9\u10D8\u10D3\u10D4\u10D5 \u10E0\u10D0\u10E6\u10D0\u10EA...",
      "commonComponents.choice.chooseLessEqualMore": [
        "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 %s \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8",
        "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 %s \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8",
        "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 % \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB %s \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8",
        "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB %s \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8",
        "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB %s \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB %s \u10D3\u10D0 \u10D0\u10E0\u10D0\u10E3\u10DB\u10D4\u10E2\u10D4\u10E1 %s",
      "commonComponents.choice.chooseNoMore": [
        "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D0\u10E0\u10D0\u10E3\u10DB\u10D4\u10E2\u10D4\u10E1%s \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8",
        "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D0\u10E0\u10D0\u10E3\u10DB\u10D4\u10E2\u10D4\u10E1%s \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8",
        "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D0\u10E0\u10D0\u10E3\u10DB\u10D4\u10E2\u10D4\u10E1%s \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8",
        ""
      ],
      "commonComponents.choice.enterText": "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10E2\u10D4\u10E5\u10E1\u10E2\u10D8",
      "commonComponents.choice.yourComment": "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8",
      "commonComponents.scale.chooseRate": "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E0\u10D4\u10D8\u10E2\u10D8\u10DC\u10D2\u10D8",
      "commonComponents.scale.firstElement": "\u10DE\u10D8\u10E0\u10D5\u10D4\u10DA\u10D8 \u10E3\u10D9\u10D8\u10D3\u10E3\u10E0\u10D4\u10E1\u10D8 \u10D5\u10D0\u10E0\u10D8\u10D0\u10DC\u10E2\u10D8 %s \u10DC\u10D8\u10E8\u10DC\u10D0\u10D5\u10E1",
      "commonComponents.scale.lastElement": "\u10D1\u10DD\u10DA\u10DD \u10E3\u10D9\u10D8\u10D3\u10E3\u10E0\u10D4\u10E1\u10D8 \u10D5\u10D0\u10E0\u10D8\u10D0\u10DC\u10E2\u10D8 %s \u10DC\u10D8\u10E8\u10DC\u10D0\u10D5\u10E1",
      "commonComponents.table.chooseNoMore": [
        "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D0\u10E0\u10D0\u10E3\u10DB\u10D4\u10E2\u10D4\u10E1 %s \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10EE\u10D0\u10D6\u10E8\u10D8",
        "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D0\u10E0\u10D0\u10E3\u10DB\u10D4\u10E2\u10D4\u10E1 %s \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10EE\u10D0\u10D6\u10E8\u10D8",
        "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D0\u10E0\u10D0\u10E3\u10DB\u10D4\u10E2\u10D4\u10E1 %s \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10EE\u10D0\u10D6\u10E8\u10D8",
        ""
      ],
      "defaults.agree": "\u10E1\u10E0\u10E3\u10DA\u10D0\u10D3 \u10D5\u10D4\u10D7\u10D0\u10DC\u10EE\u10DB\u10D4\u10D1\u10D8",
      "defaults.back": "\u10E3\u10D9\u10D0\u10DC",
      "defaults.datePlaceholder": "\u10D3\u10D3.\u10D7\u10D7.\u10EC\u10EC\u10EC\u10EC",
      "defaults.disagree": "\u10E1\u10D0\u10D4\u10E0\u10D7\u10DD\u10D3 \u10D0\u10E0 \u10D5\u10D4\u10D7\u10D0\u10DC\u10EE\u10DB\u10D4\u10D1\u10D8",
      "defaults.dualChoice.label": "\u10E9\u10D4\u10D9\u10D1\u10DD\u10E5\u10E1\u10D8",
      "defaults.emoji1": "\u10E1\u10D0\u10E8\u10D8\u10DC\u10D4\u10DA\u10D4\u10D1\u10D0\u10D0",
      "defaults.emoji2": "\u10EA\u10E3\u10D3\u10D8\u10D0",
      "defaults.emoji3": "\u10E9\u10D5\u10D4\u10E3\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8\u10D0",
      "defaults.emoji4": "\u10D9\u10D0\u10E0\u10D2\u10D8\u10D0",
      "defaults.emoji5": "\u10DB\u10E8\u10D5\u10D4\u10DC\u10D8\u10D4\u10E0\u10D8\u10D0",
      "defaults.next": "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8",
      "defaults.noAnswer": "\u10D0\u10E0\u10EA\u10D4\u10E0\u10D7\u10D8 \u10D6\u10D4\u10DB\u10DD\u10D7 \u10E9\u10D0\u10DB\u10DD\u10D7\u10D5\u10DA\u10D8\u10DA\u10D7\u10D0\u10D2\u10D0\u10DC",
      "defaults.noOpinionAnswer": "\u10DB\u10D8\u10ED\u10D8\u10E0\u10E1 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10D2\u10D0\u10EA\u10D4\u10DB\u10D0",
      "defaults.otherAnswer": "\u10E1\u10EE\u10D5\u10D0",
      "defaults.otherAnswerWithText": "\u10E1\u10EE\u10D5\u10D0 (\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D5\u10D4\u10E0\u10E1\u10D8\u10D0)",
      "defaults.template.age.label": "\u10DB\u10D8\u10E3\u10D7\u10D8\u10D7\u10D4\u10D7 \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8 \u10EC\u10DA\u10D8\u10E1 \u10EE\u10D0\u10E0\u10D7",
      "defaults.template.age.option.age_17_under": "18 \u10EC\u10DA\u10D0\u10DB\u10D3\u10D4",
      "defaults.template.age.option.age_18_24": "18-24 \u10EC\u10DA\u10D8\u10E1",
      "defaults.template.age.option.age_25_34": "25-34 \u10EC\u10DA\u10D8\u10E1",
      "defaults.template.age.option.age_35_44": "35-44 \u10EC\u10DA\u10D8\u10E1",
      "defaults.template.age.option.age_45_54": "45-54 \u10EC\u10DA\u10D8\u10E1",
      "defaults.template.age.option.age_55_over": "55 \u10EC\u10DA\u10D8\u10E1 \u10D0\u10DC \u10E3\u10E4\u10E0\u10DD\u10E1\u10D8",
      "defaults.template.sex.label": "\u10DB\u10D8\u10E3\u10D7\u10D8\u10D7\u10D4\u10D7 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10E1\u10E5\u10D4\u10E1\u10D8",
      "defaults.template.sex.option.sex_female": "\u10DB\u10D3\u10D4\u10D3\u10E0\u10DD\u10D1\u10D8\u10D7\u10D8",
      "defaults.template.sex.option.sex_male": "\u10DB\u10D0\u10DB\u10E0\u10DD\u10D1\u10D8\u10D7\u10D8",
      "defaults.widget.label": "Text",
      "errors.page.default": "\u10D3\u10D0\u10E4\u10D8\u10E5\u10E1\u10D8\u10E0\u10D3\u10D0 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0 :(",
      "errors.page.notFound": "\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0",
      "errors.server.default": "\u10E1\u10D4\u10E0\u10D5\u10D4\u10E0\u10D8\u10E1 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0",
      "errors.survey.alreadyFinished": "\u10D7\u10E5\u10D5\u10D4\u10DC \u10E3\u10D9\u10D5\u10D4 \u10D3\u10D0\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D7 \u10D4\u10E1 \u10D9\u10D5\u10DA\u10D4\u10D5\u10D0",
      "errors.survey.closed": "\u10E1\u10D0\u10DB\u10EC\u10E3\u10EE\u10D0\u10E0\u10DD\u10D3, \u10D9\u10D5\u10DA\u10D4\u10D5\u10D0 \u10E3\u10D9\u10D5\u10D4 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0",
      "errors.survey.notFound": "\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0",
      "errors.survey.paused": "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D0 \u10E8\u10D4\u10E9\u10D4\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0",
      "final.thanks": "\u10DB\u10D0\u10D3\u10DA\u10DD\u10D1\u10D0!",
      "footer.default.confidential.text": "\u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10D8",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "\u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D0",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.default.copyright.text": "\xA9 %s  \u10E8\u10DE\u10E1 Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s \u10E8\u10DE\u10E1 Yandex",
      "footer.default.createby.text": "\u10D9\u10D5\u10DA\u10D4\u10D5\u10D0 \u10D4\u10E4\u10E3\u10EB\u10DC\u10D4\u10D1\u10D0 Yandex View \u10E2\u10D4\u10E5\u10DC\u10DD\u10DA\u10DD\u10D2\u10D8\u10D4\u10D1\u10E1",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Yandex-\u10D8\u10E1 \u10E8\u10D8\u10D3\u10D0 \u10D9\u10D5\u10DA\u10D4\u10D5\u10D0",
      "footer.default.responsibility": "Yandex-\u10E1 \u10D0\u10E0\u10D0\u10DC\u10D0\u10D8\u10E0\u10D8 \u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D8 \u10D0\u10E0 \u10D0\u10E5\u10D5\u10E1 \u10DB\u10D4\u10E1\u10D0\u10DB\u10D4 \u10DB\u10EE\u10D0\u10E0\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA \u10D9\u10D5\u10DA\u10D4\u10D5\u10D4\u10D1\u10D7\u10D0\u10DC \u10D3\u10D0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10D4\u10DA\u10D8 \u10DB\u10D0\u10D7 \u10E8\u10D8\u10DC\u10D0\u10D0\u10E0\u10E1\u10D6\u10D4.",
      "footer.default.termsofuse.text": "\u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/",
      "footer.odnaco.confpolicy.text": "\u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "\u10E1\u10D0\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10DD \u10E8\u10D4\u10D7\u10D0\u10DC\u10EE\u10DB\u10D4\u10D1\u10D0",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/index.html",
      "info.survey.thanks": "\u10D9\u10D5\u10DA\u10D4\u10D5\u10D0 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0. \u10DB\u10D0\u10D3\u10DA\u10DD\u10D1\u10D0!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "\u10E3\u10D9\u10D0\u10DC",
      "page.buttonNext": "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8",
      "page.buttonSkip": "\u10D2\u10D0\u10DB\u10DD\u10E2\u10DD\u10D5\u10D4\u10D1\u10D0",
      "page.title": "\u10D9\u10D5\u10DA\u10D4\u10D5\u10D0\u10E8\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EC\u10D8\u10DA\u10D4\u10DD\u10D1\u10D8\u10E1 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D0",
      "page.watermark": "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D8\u10DC\u10D0\u10E1\u10EC\u10D0\u10E0\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D4\u10D3\u10D5\u10D0 \u10D0\u10E0 \u10D8\u10E5\u10DC\u10D4\u10D1\u10D0 \u10D2\u10D0\u10D7\u10D5\u10D0\u10DA\u10D8\u10E1\u10EC\u10D8\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D8\u10DC\u10D0\u10E1\u10EC\u10D0\u10E0\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D4\u10D3\u10D5\u10D0 \u10D0\u10E0 \u10D8\u10E5\u10DC\u10D4\u10D1\u10D0 \u10D2\u10D0\u10D7\u10D5\u10D0\u10DA\u10D8\u10E1\u10EC\u10D8\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D8\u10DC\u10D0\u10E1\u10EC\u10D0\u10E0\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D4\u10D3\u10D5\u10D0 \u10D0\u10E0 \u10D8\u10E5\u10DC\u10D4\u10D1\u10D0 \u10D2\u10D0\u10D7\u10D5\u10D0\u10DA\u10D8\u10E1\u10EC\u10D8\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8",
      "placeholders.longText": "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8",
      "placeholders.shortText": "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8",
      "plural.answers.im": [
        "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8",
        "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D6\u10D4",
        "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D6\u10D4",
        "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D6\u10D4"
      ],
      "plural.answers.ro": [
        "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D6\u10D4",
        "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D6\u10D4",
        "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D6\u10D4",
        "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D6\u10D4"
      ],
      "plural.ratingStars.labels": [
        "\u10D5\u10D0\u10E0\u10E1\u10D9\u10D5\u10DA\u10D0\u10D5\u10D8",
        "\u10D5\u10D0\u10E0\u10E1\u10D9\u10D5\u10DA\u10D0\u10D5\u10D4\u10D1\u10D8",
        "\u10D5\u10D0\u10E0\u10E1\u10D9\u10D5\u10DA\u10D0\u10D5\u10D8",
        ""
      ],
      "plural.seconds.im": [
        "\u10EC\u10D0\u10DB\u10D8",
        "\u10EC\u10D0\u10DB\u10D8",
        "\u10EC\u10D0\u10DB\u10D8",
        "\u10EC\u10D0\u10DB\u10D8"
      ],
      "plural.seconds.ro": [
        "\u10EC\u10D0\u10DB\u10D8",
        "\u10EC\u10D0\u10DB\u10D8",
        "\u10EC\u10D0\u10DB\u10D8",
        "\u10EC\u10D0\u10DB\u10D8"
      ],
      "questionModel.awful": "\u10E1\u10D0\u10E8\u10D8\u10DC\u10D4\u10DA\u10D4\u10D1\u10D0\u10D0",
      "questionModel.bad": "\u10EA\u10E3\u10D3\u10D8\u10D0",
      "questionModel.dateLessThan": "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10D0\u10E0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D8\u10E7\u10DD\u10E1 %s-\u10D6\u10D4 \u10D0\u10D3\u10E0\u10D4",
      "questionModel.dateMoreThan": "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10D0\u10E0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D8\u10E7\u10DD\u10E1 %s-\u10D6\u10D4 \u10D2\u10D5\u10D8\u10D0\u10DC",
      "questionModel.datePlaceholder": "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8",
      "questionModel.insufficientAnswers": [
        "\u10D7\u10E5\u10D5\u10D4\u10DC \u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 %s \u10DE\u10D0\u10E1\u10E3\u10EE\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        "\u10D7\u10E5\u10D5\u10D4\u10DC \u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 %s \u10DE\u10D0\u10E1\u10E3\u10EE\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        "\u10D7\u10E5\u10D5\u10D4\u10DC \u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 %s \u10DE\u10D0\u10E1\u10E3\u10EE\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        ""
      ],
      "questionModel.lessThan": "\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8 \u10D0\u10E0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D8\u10E7\u10DD\u10E1 %s-\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
      "questionModel.maxAnswerPerRowExceeded": "\u10DB\u10D0\u10E5\u10E1\u10D8\u10DB\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DC\u10D4\u10D1\u10D0\u10D3\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8\u10E1 \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0 \u10D7\u10D8\u10D7\u10DD\u10D4\u10E3\u10DA \u10EE\u10D0\u10D6\u10D6\u10D4 \u10D2\u10D0\u10D3\u10D0\u10ED\u10D0\u10E0\u10D1\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0",
      "questionModel.maxLenghtExceeded": "\u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD\u10D4\u10D1\u10D8\u10E1 \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0 \u10D0\u10E6\u10D4\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0 \u10D3\u10D0\u10E8\u10D5\u10D4\u10D1\u10E3\u10DA \u10DB\u10D0\u10E5\u10E1\u10D8\u10DB\u10D0\u10DA\u10E3\u10E0 \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0\u10E1, \u10D2\u10D7\u10EE\u10DD\u10D5\u10D7 \u10E8\u10D4\u10D0\u10DB\u10EA\u10D8\u10E0\u10DD\u10D7 \u10E2\u10D4\u10E5\u10E1\u10E2\u10D8",
      "questionModel.moreThan": "\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8 \u10D0\u10E0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D8\u10E7\u10DD\u10E1 %s-\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
      "questionModel.normally": "\u10E9\u10D5\u10D4\u10E3\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8\u10D0",
      "questionModel.notDate": "\u10D0\u10E0\u10D0\u10E1\u10EC\u10DD\u10E0\u10D8 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7",
      "questionModel.notEmail": "\u10E3\u10DC\u10D3\u10D0 \u10E8\u10D4\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D4\u10D1\u10DD\u10D3\u10D4\u10E1 \u10D4\u10DA. \u10E4\u10DD\u10E1\u10E2\u10D8\u10E1 \u10E4\u10DD\u10E0\u10DB\u10D0\u10E2\u10E1",
      "questionModel.notFilled": "\u10D7\u10E5\u10D5\u10D4\u10DC \u10E3\u10DC\u10D3\u10D0 \u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10DD\u10D7 \u10E2\u10D4\u10E5\u10E1\u10E2\u10D8",
      "questionModel.notNumber": "\u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10E8\u10D4\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10E0\u10D8\u10EA\u10EE\u10D5\u10D4\u10D1\u10E1",
      "questionModel.perfectly": "\u10DB\u10E8\u10D5\u10D4\u10DC\u10D8\u10D4\u10E0\u10D8\u10D0",
      "questionModel.picture": "\u10E1\u10E3\u10E0\u10D0\u10D7\u10D8 %s",
      "questionModel.requiredField": "\u10DC\u10E3 \u10D3\u10D0\u10E2\u10DD\u10D5\u10D4\u10D1\u10D7 \u10D0\u10DB \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0\u10E1 \u10E3\u10DE\u10D0\u10E1\u10E3\u10EE\u10DD\u10D3",
      "questionModel.tooManyAnswers": [
        "\u10D7\u10E5\u10D5\u10D4\u10DC \u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 %s-\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8",
        "\u10D7\u10E5\u10D5\u10D4\u10DC \u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 %s-\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8",
        "\u10D7\u10E5\u10D5\u10D4\u10DC \u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 %s-\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8",
        ""
      ],
      "questionModel.well": "\u10D9\u10D0\u10E0\u10D2\u10D8\u10D0",
      "sidebyside.option": "\u10D5\u10D0\u10E0\u10D8\u10D0\u10DC\u10E2\u10D8 %s",
      "templates.options.age.age18_24": "18-24 \u10EC\u10DA\u10D8\u10E1",
      "templates.options.age.age25_34": "25-34 \u10EC\u10DA\u10D8\u10E1",
      "templates.options.age.age35_44": "35-44 \u10EC\u10DA\u10D8\u10E1",
      "templates.options.age.age45_54": "45-54 \u10EC\u10DA\u10D8\u10E1",
      "templates.options.age.age55_over": "55 \u10EC\u10DA\u10D8\u10E1 \u10D0\u10DC \u10E3\u10E4\u10E0\u10DD\u10E1\u10D8",
      "templates.options.sex.sex_female": "\u10DB\u10D3\u10D4\u10D3\u10E0\u10DD\u10D1\u10D8\u10D7\u10D8",
      "templates.options.sex.sex_male": "\u10DB\u10D0\u10DB\u10E0\u10DD\u10D1\u10D8\u10D7\u10D8",
      "templates.questions.age": "\u10DB\u10D8\u10E3\u10D7\u10D8\u10D7\u10D4\u10D7 \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8 \u10EC\u10DA\u10D8\u10E1 \u10EE\u10D0\u10E0\u10D7",
      "templates.questions.sex": "\u10DB\u10D8\u10E3\u10D7\u10D8\u10D7\u10D4\u10D7 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10E1\u10E5\u10D4\u10E1\u10D8",
      "ux.stepPaginator.stepTitle": "\u10DC\u10D0\u10D1\u10D8\u10EF\u10D8 %s/%s",
      "video.holdBtn": "\u10D2\u10D4\u10ED\u10D8\u10E0\u10DD\u10D7 \u10E1\u10D0\u10DC\u10D0\u10DB \u10D3\u10D0\u10D8\u10DC\u10D0\u10EE\u10D0\u10D5\u10D7 \u10D1\u10E0\u10D4\u10DC\u10D3\u10E1",
      "video.statusBarTitle": "\u10D1\u10E0\u10D4\u10DC\u10D3\u10D8 \u10E9\u10D0\u10DC\u10D3\u10D0 %1 \u10EC\u10DB-\u10D3\u10D0\u10DC %2 \u10EC\u10DB-\u10DB\u10D3\u10D4"
    }
  },
  kk: {
    poll: {
      "attach.image.notLess": "\u0421\u0443\u0440\u0435\u0442\u043A\u0435 \u043A\u0435\u043C \u0434\u0435\u0433\u0435\u043D\u0434\u0435 %1 \u049B\u0430\u0440\u0430\u04A3\u044B\u0437 \u0436\u04D9\u043D\u0435 \u0431\u0456\u0440\u043D\u0435\u0448\u0435 \u0441\u04B1\u0440\u0430\u049B\u049B\u0430 \u0436\u0430\u0443\u0430\u043F \u0431\u0435\u0440\u0456\u04A3\u0456\u0437",
      "attach.image.notMore": "\u0421\u0443\u0440\u0435\u0442\u043A\u0435 %1 \u0456\u0448\u0456\u043D\u0434\u0435 \u049B\u0430\u0440\u0430\u04A3\u044B\u0437 \u0436\u04D9\u043D\u0435 \u0431\u0456\u0440\u043D\u0435\u0448\u0435 \u0441\u04B1\u0440\u0430\u049B\u049B\u0430 \u0436\u0430\u0443\u0430\u043F \u0431\u0435\u0440\u0456\u04A3\u0456\u0437",
      "attach.text.notLess": "\u041C\u04D9\u0442\u0456\u043D\u0433\u0435 \u043A\u0435\u043C \u0434\u0435\u0433\u0435\u043D\u0434\u0435 %1 \u049B\u0430\u0440\u0430\u04A3\u044B\u0437 \u0436\u04D9\u043D\u0435 \u0431\u0456\u0440\u043D\u0435\u0448\u0435 \u0441\u04B1\u0440\u0430\u049B\u049B\u0430 \u0436\u0430\u0443\u0430\u043F \u0431\u0435\u0440\u0456\u04A3\u0456\u0437",
      "attach.text.notMore": "%1 \u0456\u0448\u0456\u043D\u0434\u0435 \u043C\u04D9\u0442\u0456\u043D\u0434\u0456 \u043E\u049B\u044B\u043F \u0448\u044B\u0493\u044B\u04A3\u044B\u0437 \u0436\u04D9\u043D\u0435 \u0431\u0456\u0440\u043D\u0435\u0448\u0435 \u0441\u04B1\u0440\u0430\u049B\u049B\u0430 \u0436\u0430\u0443\u0430\u043F \u0431\u0435\u0440\u0456\u04A3\u0456\u0437",
      "attach.text.widgetHidden": "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "attach.video.notLess": "\u0411\u0435\u0439\u043D\u0435\u0440\u043E\u043B\u0438\u043A\u0442\u0456 \u043A\u0435\u043C \u0434\u0435\u0433\u0435\u043D\u0434\u0435 %1 \u049B\u0430\u0440\u0430\u04A3\u044B\u0437 \u0436\u04D9\u043D\u0435 \u0431\u0456\u0440\u043D\u0435\u0448\u0435 \u0441\u04B1\u0440\u0430\u049B\u049B\u0430 \u0436\u0430\u0443\u0430\u043F \u0431\u0435\u0440\u0456\u04A3\u0456\u0437",
      "attach.video.notMore": "\u0411\u0435\u0439\u043D\u0435\u0440\u043E\u043B\u0438\u043A\u043A\u0435 %1 \u0456\u0448\u0456\u043D\u0434\u0435 \u049B\u0430\u0440\u0430\u04A3\u044B\u0437 \u0436\u04D9\u043D\u0435 \u0431\u0456\u0440\u043D\u0435\u0448\u0435 \u0441\u04B1\u0440\u0430\u049B\u049B\u0430 \u0436\u0430\u0443\u0430\u043F \u0431\u0435\u0440\u0456\u04A3\u0456\u0437",
      "attach.video.waitEnd": "\u0411\u0435\u0439\u043D\u0435\u0440\u043E\u043B\u0438\u043A\u0442\u0456 \u0441\u043E\u04A3\u044B\u043D\u0430 \u0434\u0435\u0439\u0456\u043D \u049B\u0430\u0440\u0430\u04A3\u044B\u0437 \u0436\u04D9\u043D\u0435 \u0431\u0456\u0440\u043D\u0435\u0448\u0435 \u0441\u04B1\u0440\u0430\u049B\u049B\u0430 \u0436\u0430\u0443\u0430\u043F \u0431\u0435\u0440\u0456\u04A3\u0456\u0437",
      "attach.watch": "\u049A\u0430\u0440\u0430\u0443",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "\u041D\u0435 \u043C\u043E\u0433\u0443 \u043D\u0430\u0437\u0432\u0430\u0442\u044C",
      "commonComponents.choice.anythingElse": "\u0422\u0430\u0493\u044B \u0431\u0456\u0440\u0434\u0435\u04A3\u0435...",
      "commonComponents.choice.chooseLessEqualMore": [
        "%s \u0436\u0430\u0443\u0430\u043F\u0442\u044B \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
        "%s \u0436\u0430\u0443\u0430\u043F\u0442\u044B \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
        "% \u0436\u0430\u0443\u0430\u043F\u0442\u044B \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "\u041A\u0435\u043C \u0434\u0435\u0433\u0435\u043D\u0434\u0435 %s \u0436\u0430\u0443\u0430\u043F \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
        "\u041A\u0435\u043C \u0434\u0435\u0433\u0435\u043D\u0434\u0435 %s \u0436\u0430\u0443\u0430\u043F \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
        "\u041A\u0435\u043C \u0434\u0435\u0433\u0435\u043D\u0434\u0435 %s \u0436\u0430\u0443\u0430\u043F \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "\u041A\u0435\u043C \u0434\u0435\u0433\u0435\u043D\u0434\u0435 %s \u0436\u04D9\u043D\u0435 \u0435\u04A3 \u043A\u04E9\u0431\u0456 %s \u0436\u0430\u0443\u0430\u043F \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
      "commonComponents.choice.chooseNoMore": [
        "%s \u0436\u0430\u0443\u0430\u043F\u0442\u0430\u043D \u0430\u0440\u0442\u044B\u049B \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
        "%s \u0436\u0430\u0443\u0430\u043F\u0442\u0430\u043D \u0430\u0440\u0442\u044B\u049B \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
        "%s \u0436\u0430\u0443\u0430\u043F\u0442\u0430\u043D \u0430\u0440\u0442\u044B\u049B \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
        ""
      ],
      "commonComponents.choice.enterText": "\u041C\u04D9\u0442\u0456\u043D\u0434\u0456 \u043A\u0456\u0440\u0456\u0441\u0442\u0456\u0440\u0456\u04A3\u0456\u0437",
      "commonComponents.choice.yourComment": "\u0421\u0456\u0437\u0434\u0456\u04A3 \u043F\u0456\u043A\u0456\u0440\u0456\u04A3\u0456\u0437...",
      "commonComponents.scale.chooseRate": "\u0411\u0430\u0493\u0430\u043D\u044B \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
      "commonComponents.scale.firstElement": "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0448\u0435\u0442\u043A\u0456 \u043D\u04B1\u0441\u049B\u0430 %s \u0431\u0456\u043B\u0434\u0456\u0440\u0435\u0434\u0456",
      "commonComponents.scale.lastElement": "\u0421\u043E\u04A3\u0493\u044B \u0448\u0435\u0442\u043A\u0456 \u043D\u04B1\u0441\u049B\u0430 %s \u0431\u0456\u043B\u0434\u0456\u0440\u0435\u0434\u0456",
      "commonComponents.table.chooseNoMore": [
        "\u0422\u0430\u0440\u043C\u0430\u049B\u0442\u0430 \u0435\u04A3 \u043A\u04E9\u0431\u0456 %s \u0436\u0430\u0443\u0430\u043F \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
        "\u0422\u0430\u0440\u043C\u0430\u049B\u0442\u0430 \u0435\u04A3 \u043A\u04E9\u0431\u0456 %s \u0436\u0430\u0443\u0430\u043F \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
        "\u0422\u0430\u0440\u043C\u0430\u049B\u0442\u0430 \u0435\u04A3 \u043A\u04E9\u0431\u0456 %s \u0436\u0430\u0443\u0430\u043F \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
        ""
      ],
      "defaults.agree": "\u0422\u043E\u043B\u044B\u0493\u044B\u043C\u0435\u043D \u043A\u0435\u043B\u0456\u0441\u0435\u043C\u0456\u043D",
      "defaults.back": "\u0410\u0440\u0442\u049B\u0430",
      "defaults.datePlaceholder": "\u043A\u043A.\u0430\u0430.\u0436\u0436\u0436\u0436",
      "defaults.disagree": "\u041C\u04AF\u043B\u0434\u0435\u043C \u043A\u0435\u043B\u0456\u0441\u043F\u0435\u0439\u043C\u0456\u043D",
      "defaults.dualChoice.label": "\u0427\u0435\u043A\u0431\u043E\u043A\u0441",
      "defaults.emoji1": "\u041D\u0430\u0448\u0430\u0440",
      "defaults.emoji2": "\u0416\u0430\u043C\u0430\u043D",
      "defaults.emoji3": "\u049A\u0430\u043B\u044B\u043F\u0442\u044B",
      "defaults.emoji4": "\u0416\u0430\u049B\u0441\u044B",
      "defaults.emoji5": "\u041A\u0435\u0440\u0435\u043C\u0435\u0442",
      "defaults.next": "\u04D8\u0440\u0456 \u049B\u0430\u0440\u0430\u0439",
      "defaults.noAnswer": "\u0416\u043E\u0493\u0430\u0440\u044B\u0434\u0430 \u0430\u0439\u0442\u044B\u043B\u0493\u0430\u043D\u0434\u0430\u0440\u0434\u044B\u04A3 \u0435\u0448\u049B\u0430\u0439\u0441\u044B\u0441\u044B \u0436\u043E\u049B",
      "defaults.noOpinionAnswer": "\u0416\u0430\u0443\u0430\u043F \u0431\u0435\u0440\u0443\u0433\u0435 \u049B\u0438\u043D\u0430\u043B\u0430\u043C\u044B\u043D",
      "defaults.otherAnswer": "\u0411\u0430\u0441\u049B\u0430",
      "defaults.otherAnswerWithText": "\u0411\u0430\u0441\u049B\u0430 (\u04E9\u0437 \u043D\u04B1\u0441\u049B\u0430\u04A3\u044B\u0437\u0434\u044B \u0436\u0430\u0437\u044B\u04A3\u044B\u0437)",
      "defaults.template.age.label": "\u0422\u043E\u043B\u044B\u049B \u0436\u0430\u0441\u044B\u04A3\u044B\u0437 \u043D\u0435\u0448\u0435\u0434\u0435",
      "defaults.template.age.option.age_17_under": "18 \u0436\u0430\u0441\u049B\u0430 \u0442\u043E\u043B\u043C\u0430\u0493\u0430\u043D",
      "defaults.template.age.option.age_18_24": "18\u201324 \u0436\u0430\u0441",
      "defaults.template.age.option.age_25_34": "25\u201334 \u0436\u0430\u0441",
      "defaults.template.age.option.age_35_44": "35\u201344 \u0436\u0430\u0441",
      "defaults.template.age.option.age_45_54": "45\u201354 \u0436\u0430\u0441",
      "defaults.template.age.option.age_55_over": "55 \u0436\u0430\u0441 \u0436\u04D9\u043D\u0435 \u043E\u0434\u0430\u043D \u0436\u043E\u0493\u0430\u0440\u044B",
      "defaults.template.sex.label": "\u0416\u044B\u043D\u044B\u0441\u044B\u04A3\u044B\u0437\u0434\u044B \u043A\u04E9\u0440\u0441\u0435\u0442\u0456\u04A3\u0456\u0437",
      "defaults.template.sex.option.sex_female": "\u04D8\u0439\u0435\u043B",
      "defaults.template.sex.option.sex_male": "\u0415\u0440",
      "defaults.widget.label": "\u0422\u0435\u043A\u0441\u0442",
      "errors.page.default": "\u049A\u0430\u0442\u0435 \u043E\u0440\u044B\u043D \u0430\u043B\u0434\u044B :(",
      "errors.page.notFound": "\u041F\u0430\u0440\u0430\u049B\u0448\u0430 \u0442\u0430\u0431\u044B\u043B\u0493\u0430\u043D \u0436\u043E\u049B",
      "errors.server.default": "\u0421\u0435\u0440\u0432\u0435\u0440 \u049B\u0430\u0442\u0435\u0441\u0456",
      "errors.survey.alreadyFinished": "\u041E\u0441\u044B \u0441\u0430\u0443\u0430\u043B\u043D\u0430\u043C\u0430\u043D\u044B \u0430\u044F\u049B\u0442\u0430\u0434\u044B\u04A3\u044B\u0437",
      "errors.survey.closed": "\u04E8\u043A\u0456\u043D\u0456\u0448\u043A\u0435 \u049B\u0430\u0440\u0430\u0439, \u0437\u0435\u0440\u0442\u0442\u0435\u0443 \u0430\u044F\u049B\u0442\u0430\u043B\u0434\u044B",
      "errors.survey.notFound": "\u041F\u0430\u0440\u0430\u049B\u0448\u0430 \u0442\u0430\u0431\u044B\u043B\u0493\u0430\u043D \u0436\u043E\u049B",
      "errors.survey.paused": "\u0421\u0430\u0443\u0430\u043B\u043D\u0430\u043C\u0430 \u0442\u043E\u049B\u0442\u0430\u0442\u044B\u043B\u0434\u044B",
      "final.thanks": "\u0420\u0430\u049B\u043C\u0435\u0442!",
      "footer.default.confidential.text": "\u049A\u04B1\u043F\u0438\u044F",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "\u049A\u04B1\u043F\u0438\u044F\u043B\u044B\u043B\u044B\u049B",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.default.copyright.text": "\xA9 %s  \xAB\u042F\u043D\u0434\u0435\u043A\u0441\xBB \u0416\u0428\u049A",
      "footer.default.copyrightInternal.text": "\xA9 %s \xAB\u042F\u043D\u0434\u0435\u043A\u0441\xBB \u0416\u0428\u049A",
      "footer.default.createby.text": "\u0421\u0430\u0443\u0430\u043B\u043D\u0430\u043C\u0430 \u042F\u043D\u0434\u0435\u043A\u0441 \u0412\u0437\u0433\u043B\u044F\u0434 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u044F\u043B\u0430\u0440\u044B\u043D\u0434\u0430 \u0436\u0430\u0441\u0430\u043B\u0434\u044B",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "\u042F\u043D\u0434\u0435\u043A\u0441\u0442\u0456\u04A3 \u0456\u0448\u043A\u0456 \u0441\u0430\u0443\u0430\u043B\u043D\u0430\u043C\u0430\u0441\u044B",
      "footer.default.responsibility": "\u042F\u043D\u0434\u0435\u043A\u0441 \u04AF\u0448\u0456\u043D\u0448\u0456 \u0442\u04B1\u043B\u0493\u0430\u043B\u0430\u0440\u043C\u0435\u043D \u049B\u04B1\u0440\u044B\u043B\u0493\u044B\u043B\u0430\u0440\u043C\u0435\u043D \u049B\u04B1\u0440\u044B\u043B\u0493\u0430\u043D \u0441\u0430\u0443\u0430\u043B\u043D\u0430\u043C\u0430\u043B\u0430\u0440\u0493\u0430 \u049B\u0430\u0442\u044B\u0441\u044B \u0436\u043E\u049B \u0436\u04D9\u043D\u0435 \u043E\u043B\u0430\u0440\u0434\u044B\u04A3 \u049B\u04B1\u0440\u0430\u043C\u044B\u043D\u0430 \u0436\u0430\u0443\u0430\u043F \u0431\u0435\u0440\u043C\u0435\u0439\u0434\u0456.",
      "footer.default.termsofuse.text": "\u041F\u0430\u0439\u0434\u0430\u043B\u0430\u043D\u0443 \u0448\u0430\u0440\u0442\u0442\u0430\u0440\u044B",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/",
      "footer.odnaco.confpolicy.text": "\u049A\u04B1\u043F\u0438\u044F\u043B\u044B\u043B\u044B\u049B \u0441\u0430\u044F\u0441\u0430\u0442\u044B",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "\u041F\u0430\u0439\u0434\u0430\u043B\u0430\u043D\u0443\u0448\u044B \u043A\u0435\u043B\u0456\u0441\u0456\u043C\u0456",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/index.html",
      "info.survey.thanks": "\u0421\u0430\u0443\u0430\u043B\u043D\u0430\u043C\u0430 \u0430\u044F\u049B\u0442\u0430\u043B\u0434\u044B. \u0420\u0430\u049B\u043C\u0435\u0442!",
      "labels.columnHidden": "\u0421\u0442\u043E\u043B\u0431\u0435\u0446 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.hiddenQuestionsActivated": "\u0421\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u044E\u0442\u0441\u044F",
      "labels.hiddenQuestionsDeactivated": "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0441\u043A\u0440\u044B\u0442\u044B\u0445 \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432 \u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
      "labels.optionHidden": "\u041E\u0442\u0432\u0435\u0442 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.page": "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
      "labels.questionHidden": "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.rotationGroup": "\u0413\u0440\u0443\u043F\u043F\u0430",
      "labels.rowHidden": "\u0421\u0442\u0440\u043E\u043A\u0430 \u0441\u043A\u0440\u044B\u0442\u0430 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.screening": "\u0421\u043A\u0440\u0438\u043D\u0438\u0440\u0443\u044E\u0449\u0438\u0439 \u0432\u043E\u043F\u0440\u043E\u0441",
      "labels.showHiddenQuestions": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
      "labels.widgetHidden": "\u0422\u0435\u043A\u0441\u0442 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "page.buttonBack": "\u0410\u0440\u0442\u049B\u0430",
      "page.buttonNext": "\u04D8\u0440\u0456 \u049B\u0430\u0440\u0430\u0439",
      "page.buttonSkip": "\u04E8\u0442\u043A\u0456\u0437\u0456\u043F \u0436\u0456\u0431\u0435\u0440\u0443",
      "page.title": "\u0421\u0430\u0443\u0430\u043B\u043D\u0430\u043C\u0430\u043D\u044B \u04E9\u0442\u0456\u04A3\u0456\u0437",
      "page.watermark": "\u0410\u041B\u0414\u042B\u041D \u0410\u041B\u0410 \u049A\u0410\u0420\u0410\u041B\u042B\u041C \u0416\u0410\u0423\u0410\u041F\u0422\u0410\u0420 \u0415\u0421\u0415\u041F\u041A\u0415 \u0410\u041B\u042B\u041D\u0411\u0410\u0419\u0414\u042B \u0410\u041B\u0414\u042B\u041D \u0410\u041B\u0410 \u049A\u0410\u0420\u0410\u041B\u042B\u041C \u0416\u0410\u0423\u0410\u041F\u0422\u0410\u0420 \u0415\u0421\u0415\u041F\u041A\u0415 \u0410\u041B\u042B\u041D\u0411\u0410\u0419\u0414\u042B \u0410\u041B\u0414\u042B\u041D \u0410\u041B\u0410 \u049A\u0410\u0420\u0410\u041B\u042B\u041C \u0416\u0410\u0423\u0410\u041F\u0422\u0410\u0420 \u0415\u0421\u0415\u041F\u041A\u0415 \u0410\u041B\u042B\u041D\u0411\u0410\u0419\u0414\u042B",
      "placeholders.longText": "\u0421\u0456\u0437\u0434\u0456\u04A3 \u043F\u0456\u043A\u0456\u0440\u0456\u04A3\u0456\u0437",
      "placeholders.shortText": "\u0421\u0456\u0437\u0434\u0456\u04A3 \u043F\u0456\u043A\u0456\u0440\u0456\u04A3\u0456\u0437",
      "plural.answers.im": [
        "\u0436\u0430\u0443\u0430\u043F",
        "\u0436\u0430\u0443\u0430\u043F",
        "\u0436\u0430\u0443\u0430\u043F",
        "\u0436\u0430\u0443\u0430\u043F"
      ],
      "plural.answers.ro": [
        "\u0436\u0430\u0443\u0430\u043F",
        "\u0436\u0430\u0443\u0430\u043F",
        "\u0436\u0430\u0443\u0430\u043F",
        "\u0436\u0430\u0443\u0430\u043F"
      ],
      "plural.ratingStars.labels": [
        "\u0436\u04B1\u043B\u0434\u044B\u0437",
        "\u0436\u04B1\u043B\u0434\u044B\u0437",
        "\u0436\u04B1\u043B\u0434\u044B\u0437",
        ""
      ],
      "plural.seconds.im": [
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434"
      ],
      "plural.seconds.ro": [
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434"
      ],
      "questionModel.awful": "\u041D\u0430\u0448\u0430\u0440",
      "questionModel.bad": "\u0416\u0430\u043C\u0430\u043D",
      "questionModel.dateLessThan": "\u041A\u04AF\u043D\u0456 %s \u0443\u0430\u049B\u044B\u0442\u0442\u0430\u043D \u0435\u0440\u0442\u0435 \u0431\u043E\u043B\u043C\u0430\u0443\u044B \u043A\u0435\u0440\u0435\u043A",
      "questionModel.dateMoreThan": "\u041A\u04AF\u043D\u0456 %s \u0443\u0430\u049B\u044B\u0442\u0442\u0430\u043D \u0436\u0430\u0439 \u0431\u043E\u043B\u043C\u0430\u0443\u044B \u043A\u0435\u0440\u0435\u043A",
      "questionModel.datePlaceholder": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u0442\u0443",
      "questionModel.insufficientAnswers": [
        "\u0421\u0456\u0437 %s \u0436\u0430\u0443\u0430\u043F\u0442\u0430\u043D \u0430\u0437 \u0442\u0430\u04A3\u0434\u0430\u0434\u044B\u04A3\u044B\u0437",
        "\u0421\u0456\u0437 %s \u0436\u0430\u0443\u0430\u043F\u0442\u0430\u043D \u0430\u0437 \u0442\u0430\u04A3\u0434\u0430\u0434\u044B\u04A3\u044B\u0437",
        "\u0421\u0456\u0437 %s \u0436\u0430\u0443\u0430\u043F\u0442\u0430\u043D \u0430\u0437 \u0442\u0430\u04A3\u0434\u0430\u0434\u044B\u04A3\u044B\u0437",
        ""
      ],
      "questionModel.lessThan": "\u0421\u0430\u043D\u044B %s \u043A\u0435\u043C \u0431\u043E\u043B\u043C\u0430\u0443\u044B \u043A\u0435\u0440\u0435\u043A",
      "questionModel.maxAnswerPerRowExceeded": "\u0422\u0430\u0440\u043C\u0430\u049B\u0442\u0430 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u0434\u044B \u0440\u04B1\u049B\u0441\u0430\u0442 \u0435\u0442\u0456\u043B\u0433\u0435\u043D \u0436\u0430\u0443\u0430\u043F\u0442\u0430\u0440 \u0441\u0430\u043D\u044B \u0448\u0435\u0433\u0456\u043D\u0435\u043D \u0430\u0441\u044B\u043F \u043A\u0435\u0442\u0442\u0456",
      "questionModel.maxLenghtExceeded": "\u0422\u0430\u04A3\u0431\u0430\u043B\u0430\u0440 \u0441\u0430\u043D\u044B \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u0434\u044B \u0448\u0435\u0433\u0456\u043D\u0435\u043D \u0430\u0441\u044B\u043F \u043A\u0435\u0442\u0442\u0456. \u041C\u04D9\u0442\u0456\u043D\u0434\u0456 \u049B\u044B\u0441\u049B\u0430\u0440\u0442\u0443\u044B\u04A3\u044B\u0437\u0434\u044B \u0441\u04B1\u0440\u0430\u0439\u043C\u044B\u0437",
      "questionModel.moreThan": "\u0421\u0430\u043D\u044B %s \u0430\u0440\u0442\u044B\u049B \u0431\u043E\u043B\u043C\u0430\u0443\u044B \u043A\u0435\u0440\u0435\u043A",
      "questionModel.normally": "\u049A\u0430\u043B\u044B\u043F\u0442\u044B",
      "questionModel.notDate": "\u041A\u04AF\u043D \u049B\u0430\u0442\u0435 \u0435\u043D\u0433\u0456\u0437\u0456\u043B\u0434\u0456",
      "questionModel.notEmail": "email \u0444\u043E\u0440\u043C\u0430\u0442\u044B\u043D\u0430 \u0441\u04D9\u0439\u043A\u0435\u0441 \u043A\u0435\u043B\u0443\u0456 \u043A\u0435\u0440\u0435\u043A",
      "questionModel.notFilled": "\u041C\u04D9\u0442\u0456\u043D\u0434\u0456 \u0435\u043D\u0433\u0456\u0437\u0443 \u049B\u0430\u0436\u0435\u0442",
      "questionModel.notNumber": "\u0422\u0435\u043A \u0441\u0430\u043D\u0434\u0430\u0440\u0434\u0430\u043D \u0442\u04B1\u0440\u0443 \u043C\u04AF\u043C\u043A\u0456\u043D",
      "questionModel.perfectly": "\u041A\u0435\u0440\u0435\u043C\u0435\u0442",
      "questionModel.picture": "%s \u0441\u0443\u0440\u0435\u0442\u0456",
      "questionModel.requiredField": "\u0411\u04B1\u043B \u0441\u04B1\u0440\u0430\u049B\u0442\u044B \u0436\u0430\u0443\u0430\u043F\u0441\u044B\u0437 \u049B\u0430\u043B\u0434\u044B\u0440\u043C\u0430\u04A3\u044B\u0437",
      "questionModel.tooManyAnswers": [
        "%s \u0436\u0430\u0443\u0430\u043F\u0442\u0430\u043D \u043A\u04E9\u043F \u0442\u0430\u04A3\u0434\u0430\u0434\u044B\u04A3\u044B\u0437",
        "%s \u0436\u0430\u0443\u0430\u043F\u0442\u0430\u043D \u043A\u04E9\u043F \u0442\u0430\u04A3\u0434\u0430\u0434\u044B\u04A3\u044B\u0437",
        "%s \u0436\u0430\u0443\u0430\u043F\u0442\u0430\u043D \u043A\u04E9\u043F \u0442\u0430\u04A3\u0434\u0430\u0434\u044B\u04A3\u044B\u0437",
        ""
      ],
      "questionModel.well": "\u0416\u0430\u049B\u0441\u044B",
      "sidebyside.option": "%s \u043D\u04B1\u0441\u049B\u0430\u0441\u044B",
      "templates.options.age.age18_24": "18\u201324 \u0436\u0430\u0441",
      "templates.options.age.age25_34": "25\u201334 \u0436\u0430\u0441",
      "templates.options.age.age35_44": "35\u201344 \u0436\u0430\u0441",
      "templates.options.age.age45_54": "45\u201354 \u0436\u0430\u0441",
      "templates.options.age.age55_over": "55 \u0436\u0430\u0441 \u0436\u04D9\u043D\u0435 \u043E\u0434\u0430\u043D \u0436\u043E\u0493\u0430\u0440\u044B",
      "templates.options.sex.sex_female": "\u04D8\u0439\u0435\u043B",
      "templates.options.sex.sex_male": "\u0415\u0440",
      "templates.questions.age": "\u0422\u043E\u043B\u044B\u049B \u0436\u0430\u0441\u044B\u04A3\u044B\u0437 \u043D\u0435\u0448\u0435\u0434\u0435",
      "templates.questions.sex": "\u0416\u044B\u043D\u044B\u0441\u044B\u04A3\u044B\u0437\u0434\u044B \u043A\u04E9\u0440\u0441\u0435\u0442\u0456\u04A3\u0456\u0437",
      "ux.stepPaginator.stepTitle": "\u049A\u0430\u0434\u0430\u043C %s/%s",
      "video.holdBtn": "\u0411\u0440\u0435\u043D\u0434\u0442\u0456 \u043A\u04E9\u0440\u0456\u043F \u0442\u04B1\u0440\u0493\u0430\u043D\u0434\u0430 \u04B1\u0441\u0442\u0430\u043F \u0442\u04B1\u0440\u044B\u04A3\u044B\u0437",
      "video.statusBarTitle": "\u0411\u0440\u0435\u043D\u0434 %1 \u0441\u0435\u043A - %2 \u0441\u0435\u043A \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430 \u043A\u04E9\u0440\u0456\u043D\u0434\u0456"
    }
  },
  ky: {
    poll: {
      "attach.image.notLess": "\u0421\u04AF\u0440\u04E9\u0442\u0442\u04AF \u043A\u0435\u043C\u0438\u043D\u0434\u0435 %1 \u043A\u0430\u0440\u0430\u043F, \u0431\u0438\u0440 \u043D\u0435\u0447\u0435 \u0441\u0443\u0440\u043E\u043E\u0433\u043E \u0436\u043E\u043E\u043F \u0431\u0435\u0440\u0438\u04A3\u0438\u0437",
      "attach.image.notMore": "\u0421\u04AF\u0440\u04E9\u0442\u0442\u04AF %1 \u043A\u0430\u0440\u0430\u043F, \u0431\u0438\u0440 \u043D\u0435\u0447\u0435 \u0441\u0443\u0440\u043E\u043E\u0433\u043E \u0436\u043E\u043E\u043F \u0431\u0435\u0440\u0438\u04A3\u0438\u0437",
      "attach.text.notLess": "\u0422\u0435\u043A\u0441\u0442\u0442\u0438 \u043A\u0435\u043C\u0438\u043D\u0434\u0435 %1 \u043A\u0430\u0440\u0430\u043F, \u0431\u0438\u0440 \u043D\u0435\u0447\u0435 \u0441\u0443\u0440\u043E\u043E\u0433\u043E \u0436\u043E\u043E\u043F \u0431\u0435\u0440\u0438\u04A3\u0438\u0437",
      "attach.text.notMore": "\u0422\u0435\u043A\u0441\u0442\u0442\u0438 %1 \u0438\u0447\u0438\u043D\u0434\u0435 \u043E\u043A\u0443\u043F \u0447\u044B\u0433\u044B\u043F, \u0431\u0438\u0440 \u043D\u0435\u0447\u0435 \u0441\u0443\u0440\u043E\u043E\u0433\u043E \u0436\u043E\u043E\u043F \u0431\u0435\u0440\u0438\u04A3\u0438\u0437",
      "attach.text.widgetHidden": "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "attach.video.notLess": "\u0412\u0438\u0434\u0435\u043E\u0440\u043E\u043B\u0438\u043A\u0442\u0438 \u043A\u0435\u043C\u0438\u043D\u0434\u0435 %1 \u043A\u04E9\u0440\u04AF\u043F, \u0431\u0438\u0440 \u043D\u0435\u0447\u0435 \u0441\u0443\u0440\u043E\u043E\u0433\u043E \u0436\u043E\u043E\u043F \u0431\u0435\u0440\u0438\u04A3\u0438\u0437",
      "attach.video.notMore": "\u0412\u0438\u0434\u0435\u043E\u0440\u043E\u043B\u0438\u043A\u0442\u0438 %1 \u043A\u04E9\u0440\u04AF\u043F, \u0431\u0438\u0440 \u043D\u0435\u0447\u0435 \u0441\u0443\u0440\u043E\u043E\u0433\u043E \u0436\u043E\u043E\u043F \u0431\u0435\u0440\u0438\u04A3\u0438\u0437",
      "attach.video.waitEnd": "\u0412\u0438\u0434\u0435\u043E\u0440\u043E\u043B\u0438\u043A\u0442\u0438 \u0430\u044F\u0433\u044B\u043D\u0430 \u0447\u0435\u0439\u0438\u043D \u043A\u04E9\u0440\u04AF\u043F, \u0431\u0438\u0440 \u043D\u0435\u0447\u0435 \u0441\u0443\u0440\u043E\u043E\u0433\u043E \u0436\u043E\u043E\u043F \u0431\u0435\u0440\u0438\u04A3\u0438\u0437",
      "attach.watch": "\u041A\u04E9\u0440\u04AF\u04AF",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "\u041D\u0435 \u043C\u043E\u0433\u0443 \u043D\u0430\u0437\u0432\u0430\u0442\u044C",
      "commonComponents.choice.anythingElse": "\u0427\u0442\u043E-\u0442\u043E \u0435\u0449\u0435...",
      "commonComponents.choice.chooseLessEqualMore": [
        "%s \u0436\u043E\u043E\u043F\u0442\u0443 \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
        "%s \u0436\u043E\u043E\u043F\u0442\u0443 \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
        "% \u0436\u043E\u043E\u043F\u0442\u0443 \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "\u041A\u0435\u043C\u0438\u043D\u0434\u0435 %s \u0436\u043E\u043E\u043F \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
        "\u041A\u0435\u043C\u0438\u043D\u0434\u0435 %s \u0436\u043E\u043E\u043F \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
        "\u041A\u0435\u043C\u0438\u043D\u0434\u0435 %s \u0436\u043E\u043E\u043F \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "\u041A\u0435\u043C\u0438\u043D\u0434\u0435 %s \u0436\u0430\u043D\u0430 \u044D\u04A3 \u043A\u04E9\u043F \u0434\u0435\u0433\u0435\u043D\u0434\u0435 %s \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
      "commonComponents.choice.chooseNoMore": [
        "%s \u0436\u043E\u043E\u043F\u043A\u043E \u0447\u0435\u0439\u0438\u043D \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
        "%s \u0436\u043E\u043E\u043F\u043A\u043E \u0447\u0435\u0439\u0438\u043D \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
        "%s \u0436\u043E\u043E\u043F\u043A\u043E \u0447\u0435\u0439\u0438\u043D \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
        ""
      ],
      "commonComponents.choice.enterText": "\u0422\u0435\u043A\u0441\u0442\u0442\u0438 \u0436\u0430\u0437\u044B\u04A3\u044B\u0437",
      "commonComponents.choice.yourComment": "\u042D\u0437\u043E\u04B3\u0438 \u0448\u0443\u043C\u043E",
      "commonComponents.scale.chooseRate": "\u0411\u0430\u0430\u043D\u044B \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
      "commonComponents.scale.firstElement": "\u0411\u0438\u0440\u0438\u043D\u0447\u0438 \u0441\u043E\u04A3\u043A\u0443 \u0432\u0430\u0440\u0438\u0430\u043D\u0442 %s \u0431\u0438\u043B\u0434\u0438\u0440\u0435\u0442",
      "commonComponents.scale.lastElement": "\u0410\u043A\u044B\u0440\u043A\u044B \u0441\u043E\u04A3\u043A\u0443 \u0432\u0430\u0440\u0438\u0430\u043D\u0442 %s \u0431\u0438\u043B\u0434\u0438\u0440\u0435\u0442",
      "commonComponents.table.chooseNoMore": [
        "\u0421\u0430\u043F\u0442\u0430 \u044D\u04A3 \u043A\u04E9\u043F \u0434\u0435\u0433\u0435\u043D\u0434\u0435 %s \u0436\u043E\u043E\u043F \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
        "\u0421\u0430\u043F\u0442\u0430 \u044D\u04A3 \u043A\u04E9\u043F \u0434\u0435\u0433\u0435\u043D\u0434\u0435 %s \u0436\u043E\u043E\u043F \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
        "\u0421\u0430\u043F\u0442\u0430 \u044D\u04A3 \u043A\u04E9\u043F \u0434\u0435\u0433\u0435\u043D\u0434\u0435 %s \u0436\u043E\u043E\u043F \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
        ""
      ],
      "defaults.agree": "\u0422\u043E\u043B\u0443\u0433\u0443 \u043C\u0435\u043D\u0435\u043D \u043C\u0430\u043A\u0443\u043B\u043C\u0443\u043D",
      "defaults.back": "\u0410\u0440\u0442\u043A\u0430",
      "defaults.datePlaceholder": "\u043A\u043A.\u0430\u0430.\u0436\u0436\u0436\u0436",
      "defaults.disagree": "\u0422\u0430\u043A\u044B\u0440 \u043C\u0430\u043A\u0443\u043B \u044D\u043C\u0435\u0441\u043C\u0438\u043D",
      "defaults.dualChoice.label": "\u0427\u0435\u043A\u0431\u043E\u043A\u0441",
      "defaults.emoji1": "\u04E8\u0442\u04E9 \u0436\u0430\u043C\u0430\u043D",
      "defaults.emoji2": "\u041D\u0430\u0447\u0430\u0440",
      "defaults.emoji3": "\u0416\u0430\u0440\u0430\u0439\u0442",
      "defaults.emoji4": "\u0416\u0430\u0440\u0430\u0439\u0442",
      "defaults.emoji5": "\u0421\u043E\u043D\u0443\u043D",
      "defaults.next": "\u041A\u0438\u0439\u0438\u043D\u043A\u0438",
      "defaults.noAnswer": "\u0410\u0439\u0442\u044B\u043B\u0433\u0430\u043D\u0434\u0430\u0440\u0434\u044B\u043D \u044D\u0447 \u0431\u0438\u0440\u0438",
      "defaults.noOpinionAnswer": "\u0416\u043E\u043E\u043F \u0431\u0435\u0440\u0435 \u0430\u043B\u0431\u0430\u0439\u043C",
      "defaults.otherAnswer": "\u0411\u0430\u0448\u043A\u0430",
      "defaults.otherAnswerWithText": "\u0411\u0430\u0448\u043A\u0430 (\u04E9\u0437 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u044B\u04A3\u044B\u0437\u0434\u044B \u0436\u0430\u0437\u044B\u04A3\u044B\u0437)",
      "defaults.template.age.label": "\u0422\u043E\u043B\u0443\u043A \u0436\u0430\u0448\u044B\u04A3\u044B\u0437\u0434\u044B \u043A\u04E9\u0440\u0441\u04E9\u0442\u04AF\u04A3\u04AF\u0437",
      "defaults.template.age.option.age_17_under": "18 \u0436\u0430\u0448\u043A\u0430 \u0447\u044B\u0433\u0430 \u044D\u043B\u0435\u043A",
      "defaults.template.age.option.age_18_24": "18-24 \u0436\u0430\u0448",
      "defaults.template.age.option.age_25_34": "25\u201334 \u0436\u0430\u0448",
      "defaults.template.age.option.age_35_44": "35\u201344 \u0436\u0430\u0448",
      "defaults.template.age.option.age_45_54": "45\u201354 \u0436\u0430\u0448",
      "defaults.template.age.option.age_55_over": "55 \u0436\u0435 \u0430\u043D\u0434\u0430\u043D \u0443\u043B\u0443\u0443",
      "defaults.template.sex.label": "\u0416\u044B\u043D\u044B\u0441\u044B\u04A3\u044B\u0437\u0434\u044B \u043A\u04E9\u0440\u0441\u04E9\u0442\u04AF\u04A3\u04AF\u0437",
      "defaults.template.sex.option.sex_female": "\u0410\u044F\u043B",
      "defaults.template.sex.option.sex_male": "\u042D\u0440\u043A\u0435\u043A",
      "defaults.widget.label": "\u0422\u0435\u043A\u0441\u0442",
      "errors.page.default": "\u041A\u0430\u0442\u0430 \u043A\u0435\u0442\u0442\u0438 :(",
      "errors.page.notFound": "\u0411\u0430\u0440\u0430\u043A\u0447\u0430 \u0442\u0430\u0431\u044B\u043B\u0433\u0430\u043D \u0436\u043E\u043A",
      "errors.server.default": "\u0421\u0435\u0440\u0432\u0435\u0440 \u043A\u0430\u0442\u0430\u0441\u044B",
      "errors.survey.alreadyFinished": "\u0411\u0443\u043B \u0441\u0443\u0440\u0430\u043C\u0436\u044B\u043B\u043E\u043E\u0433\u043E \u0436\u043E\u043E\u043F \u0431\u0435\u0440\u0434\u0438\u04A3\u0438\u0437",
      "errors.survey.closed": "\u0422\u0438\u043B\u0435\u043A\u043A\u0435 \u043A\u0430\u0440\u0448\u044B, \u0438\u0437\u0438\u043B\u0434\u04E9\u04E9 \u0430\u044F\u0433\u044B\u043D\u0430 \u0447\u044B\u043A\u0442\u044B",
      "errors.survey.notFound": "\u0411\u0430\u0440\u0430\u043A\u0447\u0430 \u0442\u0430\u0431\u044B\u043B\u0433\u0430\u043D \u0436\u043E\u043A",
      "errors.survey.paused": "\u0421\u0443\u0440\u0430\u043C\u0436\u044B\u043B\u043E\u043E \u0442\u044B\u043D\u0434\u044B\u0440\u044B\u043B\u0434\u044B",
      "final.thanks": "\u0420\u0430\u0445\u043C\u0430\u0442!",
      "footer.default.confidential.text": "\u041A\u0443\u043F\u0443\u044F",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "\u041A\u0443\u043F\u0443\u044F\u043B\u044B\u043A",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.default.copyright.text": "\xA9 %s  \u041E\u0441\u041E\u041E \xAB\u042F\u043D\u0434\u0435\u043A\u0441.\u0417\u0430\u043F\u0440\u0430\u0432\u043A\u0438 \u041A\u0435\u0439 \u0414\u0436\u0438\xBB.",
      "footer.default.copyrightInternal.text": "\xA9 %s \u041E\u041E\u041E \xAB\u042F\u043D\u0434\u0435\u043A\u0441\xBB",
      "footer.default.createby.text": "\u0421\u0443\u0440\u0430\u043C\u0436\u044B\u043B\u043E\u043E \u042F\u043D\u0434\u0435\u043A\u0441 \u041A\u04E9\u0437-\u043A\u0430\u0440\u0430\u0448 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u044F\u043B\u0430\u0440\u044B\u043D\u0434\u0430 \u0442\u04AF\u0437\u04AF\u043B\u0434\u04AF",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "\u042F\u043D\u0434\u0435\u043A\u0441\u0442\u0438\u043D \u0438\u0447\u043A\u0438 \u0441\u0443\u0440\u0430\u043C\u0436\u044B\u043B\u043E\u043E\u0441\u0443",
      "footer.default.responsibility": "\u042F\u043D\u0434\u0435\u043A\u0441'\u0442\u0438\u043D \u04AF\u0447\u04AF\u043D\u0447\u04AF \u0442\u0430\u0440\u0430\u043F\u0442\u044B\u043D \u0441\u0443\u0440\u0430\u043C\u0436\u044B\u043B\u043E\u043E\u043B\u043E\u0440\u0443\u043D\u0430 \u0442\u0438\u0435\u0448\u0435\u0441\u0438 \u0436\u043E\u043A \u0436\u0430\u043D\u0430 \u0430\u043B\u0430\u0440\u0434\u044B\u043D \u043C\u0430\u0437\u043C\u0443\u043D\u0443 \u04AF\u0447\u04AF\u043D \u0436\u043E\u043E\u043F\u0442\u0443\u0443 \u044D\u043C\u0435\u0441.",
      "footer.default.termsofuse.text": "\u041A\u043E\u043B\u0434\u043E\u043D\u0443\u0443 \u0448\u0430\u0440\u0442\u0442\u0430\u0440\u044B",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/",
      "footer.odnaco.confpolicy.text": "\u041A\u0443\u043F\u0443\u044F\u043B\u044B\u043A \u0441\u0430\u044F\u0441\u0430\u0442\u044B",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "\u041A\u043E\u043B\u0434\u043E\u043D\u0443\u0443 \u043A\u0435\u043B\u0438\u0448\u0438\u043C\u0438",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/index.html",
      "info.survey.thanks": "\u0421\u0443\u0440\u0430\u043C\u0436\u044B\u043B\u043E\u043E \u0431\u04AF\u0442\u0442\u04AF. \u0420\u0430\u0445\u043C\u0430\u0442!",
      "labels.columnHidden": "\u0421\u0442\u043E\u043B\u0431\u0435\u0446 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.hiddenQuestionsActivated": "\u0421\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u044E\u0442\u0441\u044F",
      "labels.hiddenQuestionsDeactivated": "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0441\u043A\u0440\u044B\u0442\u044B\u0445 \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432 \u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
      "labels.optionHidden": "\u041E\u0442\u0432\u0435\u0442 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.page": "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
      "labels.questionHidden": "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.rotationGroup": "\u0413\u0440\u0443\u043F\u043F\u0430",
      "labels.rowHidden": "\u0421\u0442\u0440\u043E\u043A\u0430 \u0441\u043A\u0440\u044B\u0442\u0430 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.screening": "\u0421\u043A\u0440\u0438\u043D\u0438\u0440\u0443\u044E\u0449\u0438\u0439 \u0432\u043E\u043F\u0440\u043E\u0441",
      "labels.showHiddenQuestions": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
      "labels.widgetHidden": "\u0422\u0435\u043A\u0441\u0442 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "page.buttonBack": "\u0410\u0440\u0442\u043A\u0430",
      "page.buttonNext": "\u041A\u0438\u0439\u0438\u043D\u043A\u0438",
      "page.buttonSkip": "\u04E8\u0442\u043A\u04E9\u0440\u04AF\u043F \u0436\u0438\u0431\u0435\u0440\u04AF\u04AF",
      "page.title": "\u0421\u0443\u0440\u0430\u043C\u0436\u044B\u043B\u043E\u043E\u0433\u043E \u0436\u043E\u043E\u043F \u0431\u0435\u0440\u0438\u04A3\u0438\u0437",
      "page.watermark": "\u0410\u041B\u0414\u042B\u041D \u0410\u041B\u0410 \u041A\u04E8\u0420\u04AE\u04AE \u0416\u041E\u041E\u041F\u0422\u041E\u0420 \u042D\u0421\u0415\u041F\u0422\u0415\u041B\u0411\u0415\u0419\u0422         \u0410\u041B\u0414\u042B\u041D \u0410\u041B\u0410 \u041A\u04E8\u0420\u04AE\u04AE \u0416\u041E\u041E\u041F\u0422\u041E\u0420 \u042D\u0421\u0415\u041F\u0422\u0415\u041B\u0411\u0415\u0419\u0422         \u0410\u041B\u0414\u042B\u041D \u0410\u041B\u0410 \u041A\u04E8\u0420\u04AE\u04AE \u0416\u041E\u041E\u041F\u0422\u041E\u0420 \u042D\u0421\u0415\u041F\u0422\u0415\u041B\u0411\u0415\u0419\u0422",
      "placeholders.longText": "\u042D\u0437\u043E\u04B3\u0438 \u0448\u0443\u043C\u043E",
      "placeholders.shortText": "\u042D\u0437\u043E\u04B3\u0438 \u0448\u0443\u043C\u043E",
      "plural.answers.im": [
        "\u0436\u043E\u043E\u043F",
        "\u0436\u043E\u043E\u043F",
        "\u0436\u043E\u043E\u043F",
        "\u0436\u043E\u043E\u043F"
      ],
      "plural.answers.ro": [
        "\u0436\u043E\u043E\u043F",
        "\u0436\u043E\u043E\u043F",
        "\u0436\u043E\u043E\u043F",
        "\u0436\u043E\u043E\u043F"
      ],
      "plural.ratingStars.labels": [
        "\u0436\u044B\u043B\u0434\u044B\u0437",
        "\u0436\u044B\u043B\u0434\u044B\u0437",
        "\u0436\u044B\u043B\u0434\u044B\u0437",
        ""
      ],
      "plural.seconds.im": [
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434"
      ],
      "plural.seconds.ro": [
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434"
      ],
      "questionModel.awful": "\u04E8\u0442\u04E9 \u0436\u0430\u043C\u0430\u043D",
      "questionModel.bad": "\u041D\u0430\u0447\u0430\u0440",
      "questionModel.dateLessThan": "\u0414\u0430\u0442\u0430 %s \u043A\u0438\u0439\u0438\u043D \u0431\u043E\u043B\u0443\u0448\u0443 \u043A\u0435\u0440\u0435\u043A",
      "questionModel.dateMoreThan": "\u0414\u0430\u0442\u0430 %s \u0447\u0435\u0439\u0438\u043D \u0431\u043E\u043B\u0443\u0448\u0443 \u043A\u0435\u0440\u0435\u043A",
      "questionModel.datePlaceholder": "\u0414\u0430\u0442\u0430\u043D\u044B \u0436\u0430\u0437\u044B\u04A3\u044B\u0437",
      "questionModel.insufficientAnswers": [
        "%s \u0430\u0437 \u0436\u043E\u043E\u043F \u0442\u0430\u043D\u0434\u0430\u0434\u044B\u04A3\u044B\u0437",
        "%s \u0430\u0437 \u0436\u043E\u043E\u043F \u0442\u0430\u043D\u0434\u0430\u0434\u044B\u04A3\u044B\u0437",
        "%s \u0430\u0437 \u0436\u043E\u043E\u043F \u0442\u0430\u043D\u0434\u0430\u0434\u044B\u04A3\u044B\u0437",
        ""
      ],
      "questionModel.lessThan": "\u0421\u0430\u043D %s \u043A\u0438\u0447\u0438\u043D\u0435 \u0431\u043E\u043B\u0431\u043E\u0448\u0443 \u043A\u0435\u0440\u0435\u043A",
      "questionModel.maxAnswerPerRowExceeded": "\u0421\u0430\u043F\u0442\u0430\u0433\u044B \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u0434\u0443\u0443 \u0436\u043E\u043B \u0431\u0435\u0440\u0438\u043B\u0433\u0435\u043D \u0436\u043E\u043E\u043F\u0442\u043E\u0440\u0434\u0443\u043D \u0441\u0430\u043D\u044B \u0447\u0435\u043A\u0442\u0435\u043D \u0430\u0448\u0442\u044B",
      "questionModel.maxLenghtExceeded": "\u0421\u0438\u043C\u0432\u043E\u043B\u0434\u043E\u0440\u0434\u0443\u043D \u0441\u0430\u043D\u044B \u0436\u043E\u043B \u0431\u0435\u0440\u0438\u043B\u0433\u0435\u043D \u0447\u0435\u043A\u0442\u0435\u043D \u0430\u0448\u0430\u0442, \u0442\u0435\u043A\u0441\u0442\u0442\u0438 \u043A\u044B\u0441\u043A\u0430\u0440\u0442\u044B\u04A3\u044B\u0437",
      "questionModel.moreThan": "\u0421\u0430\u043D %s \u0447\u043E\u04A3 \u0431\u043E\u043B\u0431\u043E\u0448\u0443 \u043A\u0435\u0440\u0435\u043A",
      "questionModel.normally": "\u0416\u0430\u0440\u0430\u0439\u0442",
      "questionModel.notDate": "\u0422\u0443\u0443\u0440\u0430 \u044D\u043C\u0435\u0441 \u0434\u0430\u0442\u0430 \u0436\u0430\u0437\u044B\u043B\u0434\u044B",
      "questionModel.notEmail": "email \u0444\u043E\u0440\u043C\u0430\u0442\u044B\u043D\u0430 \u0442\u0443\u0443\u0440\u0430 \u043A\u0435\u043B\u0438\u0448\u0438 \u043A\u0435\u0440\u0435\u043A",
      "questionModel.notFilled": "\u0422\u0435\u043A\u0441\u0442 \u0436\u0430\u0437\u0443\u0443 \u043A\u0435\u0440\u0435\u043A",
      "questionModel.notNumber": "\u0421\u0430\u043D\u0434\u0430\u0440 \u0433\u0430\u043D\u0430 \u043A\u0430\u043C\u0442\u044B\u043B\u044B\u0448\u044B \u043A\u0435\u0440\u0435\u043A",
      "questionModel.perfectly": "\u0421\u043E\u043D\u0443\u043D",
      "questionModel.picture": "%s \u0441\u04AF\u0440\u04E9\u0442\u04AF",
      "questionModel.requiredField": "\u0411\u0443\u043B \u0441\u0443\u0440\u043E\u043E\u0433\u043E \u0436\u043E\u043E\u043F \u0431\u0435\u0440\u0438\u04A3\u0438\u0437",
      "questionModel.tooManyAnswers": [
        "%s \u0430\u0448\u0443\u0443\u043D \u0436\u043E\u043E\u043F \u0442\u0430\u043D\u0434\u0430\u0434\u044B\u04A3\u044B\u0437",
        "%s \u0430\u0448\u0443\u0443\u043D \u0436\u043E\u043E\u043F \u0442\u0430\u043D\u0434\u0430\u0434\u044B\u04A3\u044B\u0437",
        "%s \u0430\u0448\u0443\u0443\u043D \u0436\u043E\u043E\u043F \u0442\u0430\u043D\u0434\u0430\u0434\u044B\u04A3\u044B\u0437",
        ""
      ],
      "questionModel.well": "\u0416\u0430\u0440\u0430\u0439\u0442",
      "sidebyside.option": "%s-\u0432\u0430\u0440\u0438\u0430\u043D\u0442",
      "templates.options.age.age18_24": "18-24 \u0436\u0430\u0448",
      "templates.options.age.age25_34": "25\u201334 \u0436\u0430\u0448",
      "templates.options.age.age35_44": "35\u201344 \u0436\u0430\u0448",
      "templates.options.age.age45_54": "45\u201354 \u0436\u0430\u0448",
      "templates.options.age.age55_over": "55 \u0436\u0435 \u0430\u043D\u0434\u0430\u043D \u0443\u043B\u0443\u0443",
      "templates.options.sex.sex_female": "\u0410\u044F\u043B",
      "templates.options.sex.sex_male": "\u042D\u0440\u043A\u0435\u043A",
      "templates.questions.age": "\u0422\u043E\u043B\u0443\u043A \u0436\u0430\u0448\u044B\u04A3\u044B\u0437\u0434\u044B \u043A\u04E9\u0440\u0441\u04E9\u0442\u04AF\u04A3\u04AF\u0437",
      "templates.questions.sex": "\u0416\u044B\u043D\u044B\u0441\u044B\u04A3\u044B\u0437\u0434\u044B \u043A\u04E9\u0440\u0441\u04E9\u0442\u04AF\u04A3\u04AF\u0437",
      "ux.stepPaginator.stepTitle": "%s \u0438\u0447\u0438\u043D\u0435\u043D %s-\u043A\u0430\u0434\u0430\u043C",
      "video.holdBtn": "\u0411\u0440\u0435\u043D\u0434 \u043A\u04E9\u0440\u04AF\u043D\u04AF\u043F \u0442\u0443\u0440\u0433\u0430\u043D\u0434\u0430 \u043A\u043E\u0451 \u0431\u0435\u0440\u0431\u0435\u0439 \u043A\u0430\u0440\u043C\u0430\u043F \u0442\u0443\u0440\u0443\u04A3\u0443\u0437",
      "video.statusBarTitle": "\u0411\u0440\u0435\u043D\u0434 %1 \u0441\u0435\u043A. \u2014 %2 \u0441\u0435\u043A. \u043E\u0440\u0442\u043E\u0441\u0443\u043D\u0434\u0430 \u043A\u04E9\u0440\u04AF\u043D\u04AF\u043F \u0442\u0443\u0440\u0434\u0443"
    }
  },
  no: {
    poll: {
      "attach.image.notLess": "Se p\xE5 bildet i minst %1 og svar p\xE5 noen sp\xF8rsm\xE5l",
      "attach.image.notMore": "Se p\xE5 bildet i %1 og svar p\xE5 noen sp\xF8rsm\xE5l",
      "attach.text.notLess": "Se p\xE5 teksten i minst %1 og svar p\xE5 noen sp\xF8rsm\xE5l",
      "attach.text.notMore": "Les teksten i %1 og svar p\xE5 noen sp\xF8rsm\xE5l",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "Se p\xE5 videoen i minst %1 og svar p\xE5 noen sp\xF8rsm\xE5l",
      "attach.video.notMore": "Se p\xE5 videoen i %1 og svar p\xE5 noen sp\xF8rsm\xE5l",
      "attach.video.waitEnd": "Se p\xE5 videoen til den er ferdig og svar p\xE5 noen sp\xF8rsm\xE5l",
      "attach.watch": "Se",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "Noe annet...",
      "commonComponents.choice.chooseLessEqualMore": [
        "Velg %s svar",
        "Velg %s svar",
        "Velg % svar",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "Velg minst%s swar",
        "Velg mins%s swar",
        "Velg mins%s swar",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "Velg ikke mindre enn %s og ikke mer enn%s",
      "commonComponents.choice.chooseNoMore": [
        "Velg kun %s svar",
        "Ikke velg mer enn %s svar",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "Oppgi tekst",
      "commonComponents.choice.yourComment": "Skriv inn din kommentar...",
      "commonComponents.scale.chooseRate": "Vurder",
      "commonComponents.scale.firstElement": "Det f\xF8rste alternativet %s betyr",
      "commonComponents.scale.lastElement": "Det siste alternativet %s betyr",
      "commonComponents.table.chooseNoMore": [
        "Velg ikke mer enn %s svar p\xE5 rad",
        "Velg ikke mer enn %s svar p\xE5 rad",
        "Velg ikke mer enn %s svar p\xE5 rad",
        ""
      ],
      "defaults.agree": "Helt enig",
      "defaults.back": "Tilbake",
      "defaults.datePlaceholder": "dd.mm.\xE5\xE5\xE5\xE5",
      "defaults.disagree": "Helt uenig",
      "defaults.dualChoice.label": "Avmerkingsboks",
      "defaults.emoji1": "Fryktelig",
      "defaults.emoji2": "D\xE5rlig",
      "defaults.emoji3": "Normal",
      "defaults.emoji4": "Bra",
      "defaults.emoji5": "Perfekt",
      "defaults.next": "Neste",
      "defaults.noAnswer": "Ingen ovenfor",
      "defaults.noOpinionAnswer": "Usikker",
      "defaults.otherAnswer": "Annet",
      "defaults.otherAnswerWithText": "Annet (svar fritt)",
      "defaults.template.age.label": "Hva er din alder?",
      "defaults.template.age.option.age_17_under": "Under 18",
      "defaults.template.age.option.age_18_24": "Aldersgrense 18-24 \xE5r",
      "defaults.template.age.option.age_25_34": "Aldersgruppen 25-34 \xE5r",
      "defaults.template.age.option.age_35_44": "Aldersgruppen 35-44 \xE5r",
      "defaults.template.age.option.age_45_54": "Aldersgruppen 45-54 \xE5r",
      "defaults.template.age.option.age_55_over": "55 \xE5r eller eldre",
      "defaults.template.sex.label": "Hva er ditt kj\xF8nn?",
      "defaults.template.sex.option.sex_female": "Kvinnelig",
      "defaults.template.sex.option.sex_male": "Mannlig",
      "defaults.widget.label": "Text",
      "errors.page.default": "NB, en feil oppstod",
      "errors.page.notFound": "Side ikke funnet",
      "errors.server.default": "Serverfeil",
      "errors.survey.alreadyFinished": "Du har allerede fullf\xF8rt denne sp\xF8rreunders\xF8kelsen",
      "errors.survey.closed": "Beklager, denne unders\xF8kelsen er avsluttet",
      "errors.survey.notFound": "Side ikke funnet",
      "errors.survey.paused": "Sp\xF8rreunders\xF8kelse pauset",
      "final.thanks": "Mange takk!",
      "footer.default.confidential.text": "Konfidensiell",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "Konfidensialitet",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "Unders\xF8kelsen er drevet av Yandex Unders\xF8kelser teknologi",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Yandex intern unders\xF8kelse",
      "footer.default.responsibility": "Noen unders\xF8kelser er laget av tredjeparter. Yandex verken kontrollerer eller verifiserer innholdet deres, og tar heller ikke noe ansvar for dem.",
      "footer.default.termsofuse.text": "Bruksvilk\xE5r",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "Konfidensialitet",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "Bruksvilk\xE5r",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "Denne sp\xF8rreunders\xF8kelsen er fullf\xF8rt. Takk!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "Tilbake",
      "page.buttonNext": "Neste",
      "page.buttonSkip": "Hopp over",
      "page.title": "Utf\xF8r sp\xF8rreunders\xF8kelsen",
      "page.watermark": "FORH\xC5NDSVISTE SVAR ER IKKE TATT I BETRAKTNING FORH\xC5NDSVISTE SVAR ER IKKE TATT I BETRAKTNING FORH\xC5NDSVISTE SVAR ER IKKE TATT I BETRAKTNING",
      "placeholders.longText": "Skriv inn din kommentar",
      "placeholders.shortText": "Skriv inn din kommentar",
      "plural.answers.im": [
        "swar",
        "swar",
        "swar",
        "swar"
      ],
      "plural.answers.ro": [
        "swar",
        "swar",
        "swar",
        "swar"
      ],
      "plural.ratingStars.labels": [
        "stjerne",
        "stjerner",
        "stjerner",
        ""
      ],
      "plural.seconds.im": [
        "sekund",
        "sekunder",
        "sekunder",
        "sekunder"
      ],
      "plural.seconds.ro": [
        "sekunder",
        "sekunder",
        "sekunder",
        "sekunder"
      ],
      "questionModel.awful": "Fryktelig",
      "questionModel.bad": "D\xE5rlig",
      "questionModel.dateLessThan": "Datoen kan ikke v\xE6re tidligere enn %s",
      "questionModel.dateMoreThan": "Datoen kan ikke v\xE6re senere enn %s",
      "questionModel.datePlaceholder": "Velg en dato",
      "questionModel.insufficientAnswers": [
        "Du har valgt mindre enn %s swar",
        "Du har valgt mindre enn %s swar",
        "Du har valgt mindre enn %s swar",
        ""
      ],
      "questionModel.lessThan": "Tallet kan ikke v\xE6re mindre enn %s",
      "questionModel.maxAnswerPerRowExceeded": "Du har overskredet maksimalt antall svar p\xE5 rad",
      "questionModel.maxLenghtExceeded": "Tegngrensen er overskredet. Forkort vennligst svaret.",
      "questionModel.moreThan": "Tallet kan ikke v\xE6re mer enn %s",
      "questionModel.normally": "Normal",
      "questionModel.notDate": "Ugyldig dato",
      "questionModel.notEmail": "M\xE5 samsvare med dette e-postformatet",
      "questionModel.notFilled": "Oppgi svarene dine her",
      "questionModel.notNumber": "Kan kun inneholde tall",
      "questionModel.perfectly": "Perfekt",
      "questionModel.picture": "Bilde %s",
      "questionModel.requiredField": "Ikke la dette sp\xF8rsm\xE5let v\xE6re ubesvart",
      "questionModel.tooManyAnswers": [
        "Mer enn %s svar valgt",
        "Mer enn %s svar valgt",
        "",
        ""
      ],
      "questionModel.well": "Bra",
      "sidebyside.option": "Alternativ %s",
      "templates.options.age.age18_24": "Aldersgrense 18-24 \xE5r",
      "templates.options.age.age25_34": "Aldersgruppen 25-34 \xE5r",
      "templates.options.age.age35_44": "Aldersgruppen 35-44 \xE5r",
      "templates.options.age.age45_54": "Aldersgruppen 45-54 \xE5r",
      "templates.options.age.age55_over": "55 \xE5r eller eldre",
      "templates.options.sex.sex_female": "Kvinnelig",
      "templates.options.sex.sex_male": "Mannlig",
      "templates.questions.age": "Hva er din alder?",
      "templates.questions.sex": "Hva er ditt kj\xF8nn?",
      "ux.stepPaginator.stepTitle": "Trinn %sav%s",
      "video.holdBtn": "Trykk og hold n\xE5r du ser merket",
      "video.statusBarTitle": "Merket var synlig fra %1 sekund til %2 sekunder"
    }
  },
  pl: {
    poll: {
      "attach.image.notLess": "Przygl\u0105daj\xA0si\u0119 zdj\u0119ciu przez co\xA0najmniej %1 i\xA0odpowiedz na\xA0kilka pyta\u0144",
      "attach.image.notMore": "Przygl\u0105daj\xA0si\u0119 zdj\u0119ciu przez %1 i\xA0odpowiedz na\xA0kilka pyta\u0144",
      "attach.text.notLess": "Czytaj tekst przez co\xA0najmniej %1 i\xA0odpowiedz na\xA0kilka pyta\u0144",
      "attach.text.notMore": "Czytaj tekst przez %1 i\xA0odpowiedz na\xA0kilka pyta\u0144",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "Ogl\u0105daj film przez co\xA0najmniej %1 i\xA0odpowiedz na\xA0kilka pyta\u0144",
      "attach.video.notMore": "Ogl\u0105daj film przez %1 i\xA0odpowiedz na\xA0kilka pyta\u0144",
      "attach.video.waitEnd": "Obejrzyj film do\xA0ko\u0144ca i\xA0odpowiedz na\xA0kilka pyta\u0144",
      "attach.watch": "Obejrzyj",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "Co\u015B innego\u2026",
      "commonComponents.choice.chooseLessEqualMore": [
        "Wybierz %s odpowied\u017A",
        "Wybierz %s odpowiedzi",
        "Wybierz % odpowiedzi",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "Zaznacz przynajmniej %s odpowied\u017A",
        "Zaznacz przynajmniej %s odpowiedzi",
        "Zaznacz przynajmniej %s odpowiedzi",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "Zaznacz od %s do %s odpowiedzi",
      "commonComponents.choice.chooseNoMore": [
        "Wybierz tylko %s odpowied\u017A",
        "Wybierz nie\xA0wi\u0119cej ni\u017C %s odpowiedzi",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "Wprowad\u017A tekst",
      "commonComponents.choice.yourComment": "Wpisz komentarz...",
      "commonComponents.scale.chooseRate": "Oce\u0144",
      "commonComponents.scale.firstElement": "Pierwsza opcja %s oznacza",
      "commonComponents.scale.lastElement": "Ostatnia opcja %s oznacza",
      "commonComponents.table.chooseNoMore": [
        "Zaznacz maksymalnie %s odpowiedzi w jednym rz\u0119dzie",
        "Zaznacz maksymalnie %s odpowiedzi w jednym rz\u0119dzie",
        "Zaznacz maksymalnie %s odpowiedzi w jednym rz\u0119dzie",
        ""
      ],
      "defaults.agree": "Zgadzam\xA0si\u0119 w\xA0pe\u0142ni",
      "defaults.back": "Powr\xF3t",
      "defaults.datePlaceholder": "dd.mm.rrrr",
      "defaults.disagree": "Zupe\u0142nie\xA0si\u0119 nie\xA0zgadzam",
      "defaults.dualChoice.label": "Pole wyboru",
      "defaults.emoji1": "Koszmarne",
      "defaults.emoji2": "Z\u0142e",
      "defaults.emoji3": "Zwyk\u0142e",
      "defaults.emoji4": "Dobre",
      "defaults.emoji5": "Idealne",
      "defaults.next": "Dalej",
      "defaults.noAnswer": "\u017Badne z\xA0powy\u017Cszych",
      "defaults.noOpinionAnswer": "Nie\xA0mam pewno\u015Bci",
      "defaults.otherAnswer": "Inne",
      "defaults.otherAnswerWithText": "Inne (swobodna wypowied\u017A)",
      "defaults.template.age.label": "Tw\xF3j wiek",
      "defaults.template.age.option.age_17_under": "Poni\u017Cej 18 lat",
      "defaults.template.age.option.age_18_24": "18\u201324 lata",
      "defaults.template.age.option.age_25_34": "25\u201334 lata",
      "defaults.template.age.option.age_35_44": "35\u201344 lata",
      "defaults.template.age.option.age_45_54": "45\u201354 lata",
      "defaults.template.age.option.age_55_over": "55 lub wi\u0119cej lat",
      "defaults.template.sex.label": "Twoja p\u0142e\u0107",
      "defaults.template.sex.option.sex_female": "Kobieta",
      "defaults.template.sex.option.sex_male": "M\u0119\u017Cczyzna",
      "defaults.widget.label": "Text",
      "errors.page.default": "Niestety, wyst\u0105pi\u0142 b\u0142\u0105d",
      "errors.page.notFound": "Nie\xA0znaleziono strony",
      "errors.server.default": "B\u0142\u0105d serwera",
      "errors.survey.alreadyFinished": "Uko\u0144czono ju\u017C t\u0119\xA0ankiet\u0119",
      "errors.survey.closed": "Niestety, to\xA0badanie zosta\u0142o zako\u0144czone",
      "errors.survey.notFound": "Nie\xA0znaleziono strony",
      "errors.survey.paused": "Ankieta wstrzymana",
      "final.thanks": "Dzi\u0119kujemy.",
      "footer.default.confidential.text": "Poufne",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "Poufno\u015B\u0107",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "Ankieta stworzona z wykorzystaniem technologii Yandex Surveys",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Ankieta wewn\u0119trzna Yandex",
      "footer.default.responsibility": "Niekt\xF3re ankiety zosta\u0142y opracowane przez strony trzecie. Firma Yandex nie\xA0sprawdza ani nie\xA0weryfikuje ich zawarto\u015Bci, a\xA0tak\u017Ce nie\xA0ponosi odpowiedzialno\u015Bci za\xA0nie.",
      "footer.default.termsofuse.text": "Warunki u\u017Cytkowania",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "Poufno\u015B\u0107",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "Warunki u\u017Cytkowania",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "Ankieta zosta\u0142a uko\u0144czona. Dzi\u0119kujemy.",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "Powr\xF3t",
      "page.buttonNext": "Dalej",
      "page.buttonSkip": "Pomi\u0144",
      "page.title": "Wype\u0142nij ankiet\u0119",
      "page.watermark": "ODPOWIEDZI WST\u0118PNE NIE\xA0B\u0118D\u0104 UWZGL\u0118DNIANE ODPOWIEDZI WST\u0118PNE NIE\xA0B\u0118D\u0104 UWZGL\u0118DNIANE ODPOWIEDZI WST\u0118PNE NIE\xA0B\u0118D\u0104 UWZGL\u0118DNIANE",
      "placeholders.longText": "Wpisz komentarz",
      "placeholders.shortText": "Wpisz komentarz",
      "plural.answers.im": [
        "odpowied\u017A",
        "odpowiedzi",
        "odpowiedzi",
        "odpowiedzi"
      ],
      "plural.answers.ro": [
        "odpowied\u017A",
        "odpowiedzi",
        "odpowiedzi",
        "odpowiedzi"
      ],
      "plural.ratingStars.labels": [
        "gwiazdka",
        "gwiazdki",
        "gwiazdek",
        ""
      ],
      "plural.seconds.im": [
        "sekunda",
        "sekundy",
        "sekund",
        "sekund"
      ],
      "plural.seconds.ro": [
        "sekund",
        "sekundy",
        "sekund",
        "sekund"
      ],
      "questionModel.awful": "Koszmarne",
      "questionModel.bad": "Z\u0142e",
      "questionModel.dateLessThan": "Data nie\xA0mo\u017Ce by\u0107 wcze\u015Bniejsza od\xA0%s",
      "questionModel.dateMoreThan": "Data nie\xA0mo\u017Ce by\u0107 p\xF3\u017Aniejsza od\xA0%s",
      "questionModel.datePlaceholder": "Wybierz dat\u0119",
      "questionModel.insufficientAnswers": [
        "Zaznaczono mniej ni\u017C %s odpowied\u017A",
        "Zaznaczono mniej ni\u017C %s odpowiedzi",
        "Zaznaczono mniej ni\u017C %s odpowiedzi",
        ""
      ],
      "questionModel.lessThan": "Numer nie\xA0mo\u017Ce by\u0107 mniejszy od\xA0%s",
      "questionModel.maxAnswerPerRowExceeded": "Maksymalna liczna odpowiedzi w rz\u0119dzie zosta\u0142a przekroczona",
      "questionModel.maxLenghtExceeded": "Liczba symboli przekracza limit, prosz\u0119 skr\xF3ci\u0107 tekst",
      "questionModel.moreThan": "Numer nie\xA0mo\u017Ce by\u0107 wi\u0119kszy od\xA0%s",
      "questionModel.normally": "Zwyk\u0142e",
      "questionModel.notDate": "Nieprawid\u0142owa data",
      "questionModel.notEmail": "Musi by\u0107 zgodne z\xA0formatem adresu e-mail",
      "questionModel.notFilled": "Tutaj wprowad\u017A swoj\u0105 odpowied\u017A",
      "questionModel.notNumber": "Mo\u017Ce zawiera\u0107 tylko liczby",
      "questionModel.perfectly": "Idealne",
      "questionModel.picture": "Zdj\u0119cie %s",
      "questionModel.requiredField": "Nie\xA0zostawiaj tego pytania bez odpowiedzi",
      "questionModel.tooManyAnswers": [
        "Wybrano wi\u0119cej ni\u017C %s odpowied\u017A",
        "Wybrano wi\u0119cej ni\u017C %s odpowiedzi",
        "",
        ""
      ],
      "questionModel.well": "Dobre",
      "sidebyside.option": "Opcja %s",
      "templates.options.age.age18_24": "18\u201324 lata",
      "templates.options.age.age25_34": "25\u201334 lata",
      "templates.options.age.age35_44": "35\u201344 lata",
      "templates.options.age.age45_54": "45\u201354 lata",
      "templates.options.age.age55_over": "55 lub wi\u0119cej lat",
      "templates.options.sex.sex_female": "Kobieta",
      "templates.options.sex.sex_male": "M\u0119\u017Cczyzna",
      "templates.questions.age": "Tw\xF3j wiek",
      "templates.questions.sex": "Twoja p\u0142e\u0107",
      "ux.stepPaginator.stepTitle": "Krok %s z %s",
      "video.holdBtn": "Naci\u015Bnij i\xA0przytrzymaj przez czas, gdy widzisz mark\u0119",
      "video.statusBarTitle": "Marka by\u0142a widoczna od\xA0%1 do\xA0%2 sekundy"
    }
  },
  "pt-br": {
    poll: {
      "attach.image.notLess": "Olhe para a imagem por pelo menos %1 e responda a algumas perguntas",
      "attach.image.notMore": "Olhe para a imagem por %1 e responda a algumas perguntas",
      "attach.text.notLess": "Olhe para o texto por pelo menos %1 e responda a algumas perguntas",
      "attach.text.notMore": "Leia o texto por %1 e responda a algumas perguntas",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "Assista ao v\xEDdeo por pelo menos %1 e responda a algumas perguntas",
      "attach.video.notMore": "Assista o v\xEDdeo por %1 e responda a algumas perguntas",
      "attach.video.waitEnd": "Assista ao v\xEDdeo at\xE9 o final e responda a algumas perguntas",
      "attach.watch": "Assistir",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "Outra coisa...",
      "commonComponents.choice.chooseLessEqualMore": [
        "Escolha %s resposta",
        "Escolha %s respostas",
        "Escolha % respostas",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "Selecione pelo menos %s resposta",
        "Selecione pelo menos %s respostas",
        "Selecione pelo menos %s respostas",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "Selecione no m\xEDnimo %s e no m\xE1ximo %s",
      "commonComponents.choice.chooseNoMore": [
        "Por favor, escolha apenas %s resposta",
        "Por favor, escolha n\xE3o mais do que %s respostas",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "Digite o texto",
      "commonComponents.choice.yourComment": "Digite seu coment\xE1rio...",
      "commonComponents.scale.chooseRate": "Favor avaliar",
      "commonComponents.scale.firstElement": "A primeira op\xE7\xE3o %s significa",
      "commonComponents.scale.lastElement": "A \xFAltima op\xE7\xE3o %s significa",
      "commonComponents.table.chooseNoMore": [
        "N\xE3o selecione mais do que %s resposta seguida",
        "N\xE3o selecione mais do que %s respostas seguidas",
        "N\xE3o selecione mais do que %s respostas seguidas",
        ""
      ],
      "defaults.agree": "Concordo plenamente",
      "defaults.back": "Voltar",
      "defaults.datePlaceholder": "dd. mm. AAAA",
      "defaults.disagree": "Discordo completamente",
      "defaults.dualChoice.label": "Caixa de sele\xE7\xE3o",
      "defaults.emoji1": "Terr\xEDvel",
      "defaults.emoji2": "Mau",
      "defaults.emoji3": "Normal",
      "defaults.emoji4": "Bom",
      "defaults.emoji5": "Perfeito",
      "defaults.next": "Pr\xF3ximo",
      "defaults.noAnswer": "Nenhuma das anteriores",
      "defaults.noOpinionAnswer": "N\xE3o tenho certeza",
      "defaults.otherAnswer": "Outro",
      "defaults.otherAnswerWithText": "Outro (resposta livre)",
      "defaults.template.age.label": "Qual \xE9 a sua idade?",
      "defaults.template.age.option.age_17_under": "Menor de 18 anos",
      "defaults.template.age.option.age_18_24": "18-24 anos",
      "defaults.template.age.option.age_25_34": "25\u201334 anos",
      "defaults.template.age.option.age_35_44": "35\u201344 anos",
      "defaults.template.age.option.age_45_54": "45\u201354 anos",
      "defaults.template.age.option.age_55_over": "55 anos ou mais",
      "defaults.template.sex.label": "Qual \xE9 o seu g\xEAnero?",
      "defaults.template.sex.option.sex_female": "Feminino",
      "defaults.template.sex.option.sex_male": "Masculino",
      "defaults.widget.label": "Text",
      "errors.page.default": "Ops, ocorreu um erro",
      "errors.page.notFound": "P\xE1gina n\xE3o encontrada",
      "errors.server.default": "Erro do servidor",
      "errors.survey.alreadyFinished": "Voc\xEA j\xE1 completou esta pesquisa",
      "errors.survey.closed": "Infelizmente, esta pesquisa terminou",
      "errors.survey.notFound": "P\xE1gina n\xE3o encontrada",
      "errors.survey.paused": "Pesquisa pausada",
      "final.thanks": "Obrigados!",
      "footer.default.confidential.text": "Confidencial",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "Confidencialidade",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "A pesquisa \xE9 alimentada pela tecnologia da Yandex Surveys",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Pesquisa interna da Yandex",
      "footer.default.responsibility": "Algumas pesquisas s\xE3o criadas por terceiros. A Yandex n\xE3o verifica ou verifica seu conte\xFAdo, nem assume qualquer responsabilidade por elas.",
      "footer.default.termsofuse.text": "Termos de uso",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "Confidencialidade",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "Termos de uso",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "A pesquisa est\xE1 conclu\xEDda. Obrigados!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "Voltar",
      "page.buttonNext": "Pr\xF3ximo",
      "page.buttonSkip": "Ignorar",
      "page.title": "Responder a pesquisa",
      "page.watermark": "AS RESPOSTAS DE PR\xC9-VISUALIZA\xC7\xC3O N\xC3O S\xC3O TIDAS EM CONTA AS RESPOSTAS DE PR\xC9-VISUALIZA\xC7\xC3O N\xC3O S\xC3O TIDAS EM CONTA AS RESPOSTAS DE PR\xC9-VISUALIZA\xC7\xC3O N\xC3O S\xC3O TIDAS EM CONTA",
      "placeholders.longText": "Digite seu coment\xE1rio",
      "placeholders.shortText": "Digite seu coment\xE1rio",
      "plural.answers.im": [
        "resposta",
        "respostas",
        "respostas",
        "respostas"
      ],
      "plural.answers.ro": [
        "resposta",
        "respostas",
        "respostas",
        "respostas"
      ],
      "plural.ratingStars.labels": [
        "estrela",
        "estrelas",
        "estrelas",
        ""
      ],
      "plural.seconds.im": [
        "segundo",
        "segundos",
        "segundos",
        "segundos"
      ],
      "plural.seconds.ro": [
        "segundos",
        "segundos",
        "segundos",
        "segundos"
      ],
      "questionModel.awful": "Terr\xEDvel",
      "questionModel.bad": "Mau",
      "questionModel.dateLessThan": "A data n\xE3o pode ser anterior a %s",
      "questionModel.dateMoreThan": "A data n\xE3o pode ser posterior a %s",
      "questionModel.datePlaceholder": "Select a date",
      "questionModel.insufficientAnswers": [
        "Voc\xEA selecionou menos de %s resposta",
        "Voc\xEA selecionou menos de %s respostas",
        "Voc\xEA selecionou menos de %s respostas",
        ""
      ],
      "questionModel.lessThan": "O n\xFAmero n\xE3o pode ser inferior a %s",
      "questionModel.maxAnswerPerRowExceeded": "Voc\xEA excedeu o n\xFAmero m\xE1ximo de respostas seguidas",
      "questionModel.maxLenghtExceeded": "Limite de caracteres excedido. Por favor, encurte sua resposta.",
      "questionModel.moreThan": "O n\xFAmero n\xE3o pode ser superior a %s",
      "questionModel.normally": "Normal",
      "questionModel.notDate": "Data inv\xE1lida",
      "questionModel.notEmail": "Deve corresponder ao formato de e-mail",
      "questionModel.notFilled": "Por favor, digite sua resposta aqui",
      "questionModel.notNumber": "S\xF3 pode conter n\xFAmeros",
      "questionModel.perfectly": "Perfeito",
      "questionModel.picture": "Imagem %s",
      "questionModel.requiredField": "Por favor, n\xE3o deixe esta pergunta sem resposta",
      "questionModel.tooManyAnswers": [
        "Mais de %s resposta escolhida",
        "Mais de %s respostas escolhidas",
        "",
        ""
      ],
      "questionModel.well": "Bom",
      "sidebyside.option": "Op\xE7\xE3o %s",
      "templates.options.age.age18_24": "18-24 anos",
      "templates.options.age.age25_34": "25\u201334 anos",
      "templates.options.age.age35_44": "35\u201344 anos",
      "templates.options.age.age45_54": "45\u201354 anos",
      "templates.options.age.age55_over": "55 anos ou mais",
      "templates.options.sex.sex_female": "Feminino",
      "templates.options.sex.sex_male": "Masculino",
      "templates.questions.age": "Qual \xE9 a sua idade?",
      "templates.questions.sex": "Qual \xE9 o seu g\xEAnero?",
      "ux.stepPaginator.stepTitle": "Etapa %s de %s",
      "video.holdBtn": "Pressione e segure enquanto v\xEA a marca",
      "video.statusBarTitle": "A marca era vis\xEDvel do segundo %1 para o segundo %2"
    }
  },
  ro: {
    poll: {
      "attach.image.notLess": "Prive\u0219te imaginea timp de cel pu\u021Bin %1 \u0219i r\u0103spunde la c\xE2teva \xEEntreb\u0103ri",
      "attach.image.notMore": "Prive\u0219te imaginea timp de %1 \u0219i r\u0103spunde la c\xE2teva \xEEntreb\u0103ri",
      "attach.text.notLess": "Prive\u0219te textul timp de cel pu\u021Bin %1 \u0219i r\u0103spunde la c\xE2teva \xEEntreb\u0103ri",
      "attach.text.notMore": "Cite\u0219te textul timp de %1 \u0219i r\u0103spunde la c\xE2teva \xEEntreb\u0103ri",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "Vizioneaz\u0103 videoclipul timp de cel pu\u021Bin %1 \u0219i r\u0103spunde la c\xE2teva \xEEntreb\u0103ri",
      "attach.video.notMore": "Vizioneaz\u0103 videoclipul timp de %1 \u0219i r\u0103spunde la c\xE2teva \xEEntreb\u0103ri",
      "attach.video.waitEnd": "Vizioneaz\u0103 videoclipul p\xE2n\u0103 la sf\xE2r\u0219it \u0219i r\u0103spunde la c\xE2teva \xEEntreb\u0103ri",
      "attach.watch": "Vizioneaz\u0103",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "Altceva...",
      "commonComponents.choice.chooseLessEqualMore": [
        "Alege\u021Bi %s r\u0103spuns",
        "Alege\u021Bi %s r\u0103spuns",
        "Alege\u021Bi % r\u0103spunsuri",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "Selecta\u021Bi cel pu\u021Bin %s r\u0103spuns",
        "Selecta\u021Bi cel pu\u021Bin %s r\u0103spunsuri",
        "Selecta\u021Bi cel pu\u021Bin %s r\u0103spunsuri",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "Selecta\u021Bi nu mai pu\u021Bin de %s \u0219i nu mai mult de %s",
      "commonComponents.choice.chooseNoMore": [
        "Alege doar %s r\u0103spuns",
        "Nu alege mai mult de %s (de) r\u0103spunsuri",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "Introdu textul",
      "commonComponents.choice.yourComment": "Introduce\u021Bi comentariul ddumneavoastra",
      "commonComponents.scale.chooseRate": "Evalueaz\u0103",
      "commonComponents.scale.firstElement": "Prima op\u021Biune %s \xEEnseamn\u0103",
      "commonComponents.scale.lastElement": "Ultima op\u021Biune %s \xEEnseamn\u0103",
      "commonComponents.table.chooseNoMore": [
        "Selecta\u021Bi nu mai mult de %s r\u0103spuns la r\xE2nd",
        "Selecta\u021Bi nu mai mult de %s r\u0103spunsuri la r\xE2nd",
        "Selecta\u021Bi nu mai mult de %s r\u0103spunsuri la r\xE2nd",
        ""
      ],
      "defaults.agree": "Acord total",
      "defaults.back": "\xCEnapoi",
      "defaults.datePlaceholder": "zz.ll.aaaa",
      "defaults.disagree": "Dezacord total",
      "defaults.dualChoice.label": "Caset\u0103",
      "defaults.emoji1": "Foarte slab",
      "defaults.emoji2": "Slab",
      "defaults.emoji3": "Normal",
      "defaults.emoji4": "Bun",
      "defaults.emoji5": "Perfect",
      "defaults.next": "Urm\u0103torul",
      "defaults.noAnswer": "Niciunul de mai sus",
      "defaults.noOpinionAnswer": "Nu sunt sigur",
      "defaults.otherAnswer": "Altele",
      "defaults.otherAnswerWithText": "Altele (r\u0103spuns liber)",
      "defaults.template.age.label": "Care este v\xE2rsta dvs.",
      "defaults.template.age.option.age_17_under": "Sub 18",
      "defaults.template.age.option.age_18_24": "18\u201324 de ani",
      "defaults.template.age.option.age_25_34": "25\u201334 de ani",
      "defaults.template.age.option.age_35_44": "35\u201344 de ani",
      "defaults.template.age.option.age_45_54": "45\u201354 de ani",
      "defaults.template.age.option.age_55_over": "55 sau mai \xEEn v\xE2rst\u0103",
      "defaults.template.sex.label": "Care este genul dsv.?",
      "defaults.template.sex.option.sex_female": "Feminin",
      "defaults.template.sex.option.sex_male": "Masculin",
      "defaults.widget.label": "Text",
      "errors.page.default": "Ups, a ap\u0103rut o eroare",
      "errors.page.notFound": "Pagina nu a fost g\u0103sit\u0103",
      "errors.server.default": "Eroare server",
      "errors.survey.alreadyFinished": "Ai completat deja acest sondaj",
      "errors.survey.closed": "Din p\u0103cate, acest studiu s-a \xEEncheiat",
      "errors.survey.notFound": "Pagina nu a fost g\u0103sit\u0103",
      "errors.survey.paused": "Sondaj \xEEntrerupt",
      "final.thanks": "\xCE\u021Bi mul\u021Bumim!",
      "footer.default.confidential.text": "Confiden\u0163ial",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "Confiden\u021Bialitate",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "Sondajul este alimentat de tehnologiile Yandex Surveys",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Sondaj intern Yandex",
      "footer.default.responsibility": "Unele sondaje sunt create de ter\u021Bi. Yandex nu verific\u0103 \u0219i nu controleaz\u0103 con\u021Binutul acestora, nici nu \xEE\u0219i asum\u0103 responsabilitatea pentru acestea.",
      "footer.default.termsofuse.text": "Condi\u021Bii de utilizare",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "Confiden\u021Bialitate",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "Condi\u021Bii de utilizare",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "Sondajul este completat. Mul\u021Bumim!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "\xCEnapoi",
      "page.buttonNext": "Urm\u0103torul",
      "page.buttonSkip": "Omite",
      "page.title": "Completeaz\u0103 sondajul",
      "page.watermark": "R\u0102SPUNSURILE PREVIZUALIZATE NU SUNT LUATE \xCEN CONSIDERARE R\u0102SPUNSURILE PREVIZUALIZATE NU SUNT LUATE \xCEN CONSIDERARE R\u0102SPUNSURILE PREVIZUALIZATE NU SUNT LUATE \xCEN CONSIDERARE",
      "placeholders.longText": "Introduce\u021Bi comentariul ddumneavoastra",
      "placeholders.shortText": "Introduce\u021Bi comentariul ddumneavoastra",
      "plural.answers.im": [
        "r\u0103spuns",
        "r\u0103spunsuri",
        "r\u0103spunsuri",
        "r\u0103spunsuri"
      ],
      "plural.answers.ro": [
        "r\u0103spuns",
        "r\u0103spunsuri",
        "r\u0103spunsuri",
        "r\u0103spunsuri"
      ],
      "plural.ratingStars.labels": [
        "stea",
        "stele",
        "stele",
        ""
      ],
      "plural.seconds.im": [
        "secund\u0103",
        "(de) secunde",
        "(de) secunde",
        "(de) secunde"
      ],
      "plural.seconds.ro": [
        "(de) secunde",
        "(de) secunde",
        "(de) secunde",
        "(de) secunde"
      ],
      "questionModel.awful": "Foarte slab",
      "questionModel.bad": "Slab",
      "questionModel.dateLessThan": "Data nu poate fi \xEEnainte de %s",
      "questionModel.dateMoreThan": "Data nu poate fi dup\u0103 %s",
      "questionModel.datePlaceholder": "Selecteaz\u0103 o dat\u0103",
      "questionModel.insufficientAnswers": [
        "A\u021Bi selectat mai pu\u021Bin de %s r\u0103spuns",
        "A\u021Bi selectat mai pu\u021Bin de %s r\u0103spunsuri",
        "A\u021Bi selectat mai pu\u021Bin de %s r\u0103spunsuri",
        ""
      ],
      "questionModel.lessThan": "Num\u0103rul nu poate fi mai mic de %s",
      "questionModel.maxAnswerPerRowExceeded": "A\u021Bi dep\u0103\u0219it num\u0103rul maxim de r\u0103spunsuri la r\xE2nd",
      "questionModel.maxLenghtExceeded": "Num\u0103rul de caractere dep\u0103\u0219e\u0219te maximul permis, v\u0103 rug\u0103m s\u0103 scurta\u021Bi textul",
      "questionModel.moreThan": "Num\u0103rul nu poate fi mai mare de %s",
      "questionModel.normally": "Normal",
      "questionModel.notDate": "Dat\u0103 nevalid\u0103",
      "questionModel.notEmail": "Trebuie s\u0103 coincid\u0103 cu formatul de e-mail",
      "questionModel.notFilled": "Introdu r\u0103spunsul aici",
      "questionModel.notNumber": "Poate con\u021Bine doar numere",
      "questionModel.perfectly": "Perfect",
      "questionModel.picture": "Imagine %s",
      "questionModel.requiredField": "Completeaz\u0103 un r\u0103spuns la aceast\u0103 \xEEntrebare",
      "questionModel.tooManyAnswers": [
        "A fost ales mai mult de %s r\u0103spuns",
        "Au fost alese mai mult de %s (de) r\u0103spunsuri",
        "",
        ""
      ],
      "questionModel.well": "Bun",
      "sidebyside.option": "Op\u021Biune %s",
      "templates.options.age.age18_24": "18\u201324 de ani",
      "templates.options.age.age25_34": "25\u201334 de ani",
      "templates.options.age.age35_44": "35\u201344 de ani",
      "templates.options.age.age45_54": "45\u201354 de ani",
      "templates.options.age.age55_over": "55 sau mai \xEEn v\xE2rst\u0103",
      "templates.options.sex.sex_female": "Feminin",
      "templates.options.sex.sex_male": "Masculin",
      "templates.questions.age": "Care este v\xE2rsta dvs.",
      "templates.questions.sex": "Care este genul dsv.?",
      "ux.stepPaginator.stepTitle": "Pasul %s din %s",
      "video.holdBtn": "Men\u021Bine ap\u0103sat c\xE2t timp vezi brandul",
      "video.statusBarTitle": "Brandul a fost vizibil din secunda %1 p\xE2n\u0103 \xEEn secunda %2"
    }
  },
  ru: {
    poll: {
      "attach.image.notLess": "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u043D\u0430 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0443 \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 %1 \u0438 \u043E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432",
      "attach.image.notMore": "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u043D\u0430 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0443 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 %1 \u0438 \u043E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432",
      "attach.text.notLess": "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u043D\u0430 \u0442\u0435\u043A\u0441\u0442 \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 %1 \u0438 \u043E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432",
      "attach.text.notMore": "\u041F\u0440\u043E\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u0442\u0435\u043A\u0441\u0442 \u0437\u0430 %1 \u0438 \u043E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432",
      "attach.text.widgetHidden": "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "attach.video.notLess": "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0432\u0438\u0434\u0435\u043E\u0440\u043E\u043B\u0438\u043A \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 %1 \u0438 \u043E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432",
      "attach.video.notMore": "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0432\u0438\u0434\u0435\u043E\u0440\u043E\u043B\u0438\u043A \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 %1 \u0438 \u043E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432",
      "attach.video.waitEnd": "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0432\u0438\u0434\u0435\u043E\u0440\u043E\u043B\u0438\u043A \u0434\u043E \u043A\u043E\u043D\u0446\u0430 \u0438 \u043E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432",
      "attach.watch": "\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "\u041D\u0435 \u043C\u043E\u0433\u0443 \u043D\u0430\u0437\u0432\u0430\u0442\u044C",
      "commonComponents.choice.anythingElse": "\u0427\u0442\u043E-\u0442\u043E \u0435\u0449\u0435...",
      "commonComponents.choice.chooseLessEqualMore": [
        "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 %s \u043E\u0442\u0432\u0435\u0442",
        "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 %s \u043E\u0442\u0432\u0435\u0442\u0430",
        "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 % \u043E\u0442\u0432\u0435\u0442\u043E\u0432",
        null
      ],
      "commonComponents.choice.chooseNoLess": [
        "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0435 \u043C\u0435\u043D\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u0430",
        "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0435 \u043C\u0435\u043D\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u043E\u0432",
        "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0435 \u043C\u0435\u043D\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u043E\u0432",
        null
      ],
      "commonComponents.choice.chooseNoLessNoMore": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0435 \u043C\u0435\u043D\u044C\u0448\u0435 %s \u0438 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 %s",
      "commonComponents.choice.chooseNoMore": [
        "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u0430",
        "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u043E\u0432",
        "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u043E\u0432",
        ""
      ],
      "commonComponents.choice.enterText": "\u0412\u043F\u0438\u0448\u0438\u0442\u0435 \u0442\u0435\u043A\u0441\u0442",
      "commonComponents.choice.yourComment": "\u0412\u0430\u0448 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439...",
      "commonComponents.scale.chooseRate": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0446\u0435\u043D\u043A\u0443",
      "commonComponents.scale.firstElement": "\u041F\u0435\u0440\u0432\u044B\u0439 \u043A\u0440\u0430\u0439\u043D\u0438\u0439 \u0432\u0430\u0440\u0438\u0430\u043D\u0442 %s \u043E\u0437\u043D\u0430\u0447\u0430\u0435\u0442",
      "commonComponents.scale.lastElement": "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u043A\u0440\u0430\u0439\u043D\u0438\u0439 \u0432\u0430\u0440\u0438\u0430\u043D\u0442 %s \u043E\u0437\u043D\u0430\u0447\u0430\u0435\u0442",
      "commonComponents.table.chooseNoMore": [
        "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u0430 \u0432 \u0441\u0442\u0440\u043E\u043A\u0435",
        "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u043E\u0432 \u0432 \u0441\u0442\u0440\u043E\u043A\u0435",
        "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u043E\u0432 \u0432 \u0441\u0442\u0440\u043E\u043A\u0435",
        null
      ],
      "defaults.agree": "\u041F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D(\u0430)",
      "defaults.back": "\u041D\u0430\u0437\u0430\u0434",
      "defaults.datePlaceholder": "\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433",
      "defaults.disagree": "\u0421\u043E\u0432\u0441\u0435\u043C \u043D\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D(\u0430)",
      "defaults.dualChoice.label": "\u0427\u0435\u043A\u0431\u043E\u043A\u0441",
      "defaults.emoji1": "\u0423\u0436\u0430\u0441\u043D\u043E",
      "defaults.emoji2": "\u041F\u043B\u043E\u0445\u043E",
      "defaults.emoji3": "\u041D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E",
      "defaults.emoji4": "\u0425\u043E\u0440\u043E\u0448\u043E",
      "defaults.emoji5": "\u041E\u0442\u043B\u0438\u0447\u043D\u043E",
      "defaults.next": "\u0414\u0430\u043B\u0435\u0435",
      "defaults.noAnswer": "\u041D\u0438\u0447\u0435\u0433\u043E \u0438\u0437 \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u043E\u0433\u043E",
      "defaults.noOpinionAnswer": "\u0417\u0430\u0442\u0440\u0443\u0434\u043D\u044F\u044E\u0441\u044C \u043E\u0442\u0432\u0435\u0442\u0438\u0442\u044C",
      "defaults.otherAnswer": "\u0414\u0440\u0443\u0433\u043E\u0435",
      "defaults.otherAnswerWithText": "\u0414\u0440\u0443\u0433\u043E\u0435 (\u0432\u043F\u0438\u0448\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u0432\u0430\u0440\u0438\u0430\u043D\u0442)",
      "defaults.template.age.label": "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u0430\u043C \u043F\u043E\u043B\u043D\u044B\u0445 \u043B\u0435\u0442",
      "defaults.template.age.option.age_17_under": "\u041C\u0435\u043D\u044C\u0448\u0435 18 \u043B\u0435\u0442",
      "defaults.template.age.option.age_18_24": "18\u201324 \u0433\u043E\u0434\u0430",
      "defaults.template.age.option.age_25_34": "25\u201334 \u0433\u043E\u0434\u0430",
      "defaults.template.age.option.age_35_44": "35\u201344 \u0433\u043E\u0434\u0430",
      "defaults.template.age.option.age_45_54": "45\u201354 \u0433\u043E\u0434\u0430",
      "defaults.template.age.option.age_55_over": "55 \u043B\u0435\u0442 \u0438\u043B\u0438 \u0441\u0442\u0430\u0440\u0448\u0435",
      "defaults.template.sex.label": "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0432\u0430\u0448 \u043F\u043E\u043B",
      "defaults.template.sex.option.sex_female": "\u0416\u0435\u043D\u0441\u043A\u0438\u0439",
      "defaults.template.sex.option.sex_male": "\u041C\u0443\u0436\u0441\u043A\u043E\u0439",
      "defaults.widget.label": "\u0422\u0435\u043A\u0441\u0442",
      "errors.page.default": "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 :(",
      "errors.page.notFound": "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430",
      "errors.server.default": "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430",
      "errors.survey.alreadyFinished": "\u0412\u044B \u0443\u0436\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u043B\u0438 \u044D\u0442\u043E\u0442 \u043E\u043F\u0440\u043E\u0441",
      "errors.survey.closed": "\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u0438\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u0435 \u0443\u0436\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
      "errors.survey.notFound": "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430",
      "errors.survey.paused": "\u041E\u043F\u0440\u043E\u0441 \u043F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D",
      "final.thanks": "\u0421\u043F\u0430\u0441\u0438\u0431\u043E!",
      "footer.default.confidential.text": "\u041A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "\u041A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.default.copyright.text": "\xA9 %s  \u041E\u041E\u041E \xAB\u042F\u043D\u0434\u0435\u043A\u0441\xBB",
      "footer.default.copyrightInternal.text": "\xA9 %s  \u041E\u041E\u041E \xAB\u042F\u043D\u0434\u0435\u043A\u0441\xBB",
      "footer.default.createby.text": "\u041E\u043F\u0440\u043E\u0441 \u0441\u0434\u0435\u043B\u0430\u043D \u043D\u0430 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u044F\u0445 \u042F\u043D\u0434\u0435\u043A\u0441 \u0412\u0437\u0433\u043B\u044F\u0434",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "\u0412\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0439 \u043E\u043F\u0440\u043E\u0441 \u042F\u043D\u0434\u0435\u043A\u0441\u0430",
      "footer.default.responsibility": "\u042F\u043D\u0434\u0435\u043A\u0441 \u043D\u0435 \u0438\u043C\u0435\u0435\u0442 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u044F \u043A \u043E\u043F\u0440\u043E\u0441\u0430\u043C, \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u043C \u0442\u0440\u0435\u0442\u044C\u0438\u043C\u0438 \u043B\u0438\u0446\u0430\u043C\u0438, \u0438 \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u0438\u0445 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435.",
      "footer.default.termsofuse.text": "\u0423\u0441\u043B\u043E\u0432\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/",
      "footer.odnaco.confpolicy.text": "\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/index.html",
      "info.survey.thanks": "\u041E\u043F\u0440\u043E\u0441 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D. \u0421\u043F\u0430\u0441\u0438\u0431\u043E!",
      "labels.columnHidden": "\u0421\u0442\u043E\u043B\u0431\u0435\u0446 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.hiddenQuestionsActivated": "\u0421\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u044E\u0442\u0441\u044F",
      "labels.hiddenQuestionsDeactivated": "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0441\u043A\u0440\u044B\u0442\u044B\u0445 \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432 \u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
      "labels.optionHidden": "\u041E\u0442\u0432\u0435\u0442 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.page": "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
      "labels.questionHidden": "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.rotationGroup": "\u0413\u0440\u0443\u043F\u043F\u0430",
      "labels.rowHidden": "\u0421\u0442\u0440\u043E\u043A\u0430 \u0441\u043A\u0440\u044B\u0442\u0430 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.screening": "\u0421\u043A\u0440\u0438\u043D\u0438\u0440\u0443\u044E\u0449\u0438\u0439 \u0432\u043E\u043F\u0440\u043E\u0441",
      "labels.showHiddenQuestions": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
      "labels.widgetHidden": "\u0422\u0435\u043A\u0441\u0442 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "page.buttonBack": "\u041D\u0430\u0437\u0430\u0434",
      "page.buttonNext": "\u0414\u0430\u043B\u0435\u0435",
      "page.buttonSkip": "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u044C",
      "page.title": "\u041F\u0440\u043E\u0439\u0434\u0438\u0442\u0435 \u043E\u043F\u0440\u043E\u0441",
      "page.watermark": "\u041F\u0420\u0415\u0414\u041F\u0420\u041E\u0421\u041C\u041E\u0422\u0420 \u041E\u0422\u0412\u0415\u0422\u042B \u041D\u0415 \u0423\u0427\u0418\u0422\u042B\u0412\u0410\u042E\u0422\u0421\u042F \u041F\u0420\u0415\u0414\u041F\u0420\u041E\u0421\u041C\u041E\u0422\u0420 \u041E\u0422\u0412\u0415\u0422\u042B \u041D\u0415 \u0423\u0427\u0418\u0422\u042B\u0412\u0410\u042E\u0422\u0421\u042F \u041F\u0420\u0415\u0414\u041F\u0420\u041E\u0421\u041C\u041E\u0422\u0420 \u041E\u0422\u0412\u0415\u0422\u042B \u041D\u0415 \u0423\u0427\u0418\u0422\u042B\u0412\u0410\u042E\u0422\u0421\u042F",
      "placeholders.longText": "\u0412\u0430\u0448 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439",
      "placeholders.shortText": "\u0412\u0430\u0448 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439",
      "plural.answers.im": [
        "\u043E\u0442\u0432\u0435\u0442",
        "\u043E\u0442\u0432\u0435\u0442\u0430",
        "\u043E\u0442\u0432\u0435\u0442\u043E\u0432",
        "\u043E\u0442\u0432\u0435\u0442\u043E\u0432"
      ],
      "plural.answers.ro": [
        "\u043E\u0442\u0432\u0435\u0442\u0430",
        "\u043E\u0442\u0432\u0435\u0442\u043E\u0432",
        "\u043E\u0442\u0432\u0435\u0442\u043E\u0432",
        "\u043E\u0442\u0432\u0435\u0442\u043E\u0432"
      ],
      "plural.ratingStars.labels": [
        "\u0437\u0432\u0435\u0437\u0434\u0430",
        "\u0437\u0432\u0435\u0437\u0434\u044B",
        "\u0437\u0432\u0435\u0437\u0434",
        ""
      ],
      "plural.seconds.im": [
        "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        "\u0441\u0435\u043A\u0443\u043D\u0434\u044B",
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434"
      ],
      "plural.seconds.ro": [
        "\u0441\u0435\u043A\u0443\u043D\u0434\u044B",
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434",
        "\u0441\u0435\u043A\u0443\u043D\u0434"
      ],
      "questionModel.awful": "\u0423\u0436\u0430\u0441\u043D\u043E",
      "questionModel.bad": "\u041F\u043B\u043E\u0445\u043E",
      "questionModel.dateLessThan": "\u0414\u0430\u0442\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0440\u0430\u043D\u044C\u0448\u0435 %s",
      "questionModel.dateMoreThan": "\u0414\u0430\u0442\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u043E\u0437\u0436\u0435 %s",
      "questionModel.datePlaceholder": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u0442\u0443",
      "questionModel.insufficientAnswers": [
        "\u0412\u044B \u0432\u044B\u0431\u0440\u0430\u043B\u0438 \u043C\u0435\u043D\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u0430",
        "\u0412\u044B \u0432\u044B\u0431\u0440\u0430\u043B\u0438 \u043C\u0435\u043D\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u043E\u0432",
        "\u0412\u044B \u0432\u044B\u0431\u0440\u0430\u043B\u0438 \u043C\u0435\u043D\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u043E\u0432",
        null
      ],
      "questionModel.lessThan": "\u0427\u0438\u0441\u043B\u043E \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435 %s",
      "questionModel.maxAnswerPerRowExceeded": "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0445 \u043E\u0442\u0432\u0435\u0442\u043E\u0432 \u0432 \u0441\u0442\u0440\u043E\u043A\u0435",
      "questionModel.maxLenghtExceeded": "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0435\u0442 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u043E\u0435, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u043E\u043A\u0440\u0430\u0442\u0438\u0442\u0435 \u0442\u0435\u043A\u0441\u0442",
      "questionModel.moreThan": "\u0427\u0438\u0441\u043B\u043E \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 %s",
      "questionModel.normally": "\u041D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E",
      "questionModel.notDate": "\u0412\u0432\u0435\u0434\u0435\u043D\u0430 \u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0430\u044F \u0434\u0430\u0442\u0430",
      "questionModel.notEmail": "\u0414\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u0444\u043E\u0440\u043C\u0430\u0442\u0443 email",
      "questionModel.notFilled": "\u041D\u0443\u0436\u043D\u043E \u0432\u0432\u0435\u0441\u0442\u0438 \u0442\u0435\u043A\u0441\u0442",
      "questionModel.notNumber": "\u041C\u043E\u0436\u0435\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0446\u0438\u0444\u0440\u044B",
      "questionModel.perfectly": "\u041E\u0442\u043B\u0438\u0447\u043D\u043E",
      "questionModel.picture": "\u041A\u0430\u0440\u0442\u0438\u043D\u043A\u0430 %s",
      "questionModel.requiredField": "\u041D\u0435 \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0439\u0442\u0435 \u044D\u0442\u043E\u0442 \u0432\u043E\u043F\u0440\u043E\u0441 \u0431\u0435\u0437 \u043E\u0442\u0432\u0435\u0442\u0430",
      "questionModel.tooManyAnswers": [
        "\u0412\u044B \u0432\u044B\u0431\u0440\u0430\u043B\u0438 \u0431\u043E\u043B\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u0430",
        "\u0412\u044B \u0432\u044B\u0431\u0440\u0430\u043B\u0438 \u0431\u043E\u043B\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u043E\u0432",
        "\u0412\u044B \u0432\u044B\u0431\u0440\u0430\u043B\u0438 \u0431\u043E\u043B\u044C\u0448\u0435 %s \u043E\u0442\u0432\u0435\u0442\u043E\u0432",
        ""
      ],
      "questionModel.well": "\u0425\u043E\u0440\u043E\u0448\u043E",
      "sidebyside.option": "\u0412\u0430\u0440\u0438\u0430\u043D\u0442 %s",
      "templates.options.age.age18_24": "18\u201324 \u0433\u043E\u0434\u0430",
      "templates.options.age.age25_34": "25\u201334 \u0433\u043E\u0434\u0430",
      "templates.options.age.age35_44": "35\u201344 \u0433\u043E\u0434\u0430",
      "templates.options.age.age45_54": "45\u201354 \u0433\u043E\u0434\u0430",
      "templates.options.age.age55_over": "55 \u043B\u0435\u0442 \u0438\u043B\u0438 \u0441\u0442\u0430\u0440\u0448\u0435",
      "templates.options.sex.sex_female": "\u0416\u0435\u043D\u0441\u043A\u0438\u0439",
      "templates.options.sex.sex_male": "\u041C\u0443\u0436\u0441\u043A\u043E\u0439",
      "templates.questions.age": "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u0430\u043C \u043F\u043E\u043B\u043D\u044B\u0445 \u043B\u0435\u0442",
      "templates.questions.sex": "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0432\u0430\u0448 \u043F\u043E\u043B",
      "ux.stepPaginator.stepTitle": "\u0428\u0430\u0433 %s/%s",
      "video.holdBtn": "\u0423\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0439\u0442\u0435 \u043F\u043E\u043A\u0430 \u0432\u0438\u0434\u0438\u0442\u0435 \u0431\u0440\u0435\u043D\u0434",
      "video.statusBarTitle": "\u0411\u0440\u0435\u043D\u0434 \u0431\u044B\u043B\u043E \u0432\u0438\u0434\u043D\u043E \u0441 %1 \u0441\u0435\u043A \u0434\u043E %2 \u0441\u0435\u043A"
    }
  },
  sr: {
    poll: {
      "attach.image.notLess": "Gledajte sliku najmanje %1 i odgovorite na nekoliko pitanja",
      "attach.image.notMore": "Gledajte sliku %1 i odgovorite na nekoliko pitanja",
      "attach.text.notLess": "Gledajte tekst najmanje %1 i odgovorite na nekoliko pitanja",
      "attach.text.notMore": "Pro\u010Ditajte tekst %1 i odgovorite na nekoliko pitanja",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "Gledajte video najmanje %1 i odgovorite na nekoliko pitanja",
      "attach.video.notMore": "Gledajte video %1 i odgovorite na nekoliko pitanja",
      "attach.video.waitEnd": "Gledajte video do kraja i odgovorite na nekoliko pitanja",
      "attach.watch": "Gledajte",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "Ne\u0161to drugo...",
      "commonComponents.choice.chooseLessEqualMore": [
        "Izaberite %s odgovor",
        "Izaberite %s odgovora",
        "Izaberite % odgovora",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "Izaberite najmanje %s odgovor",
        "Izaberite najmanje %s odgovora",
        "Izaberite najmanje %s odgovora",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "Izaberite ne manje od %si ne vi\u0161e od %s",
      "commonComponents.choice.chooseNoMore": [
        "Odaberite samo %s odgovor",
        "Nemojte odabrati vi\u0161e od %s odgovora",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "Unesite tekst",
      "commonComponents.choice.yourComment": "Unesite svoj komentar...",
      "commonComponents.scale.chooseRate": "Ocenite",
      "commonComponents.scale.firstElement": "Prva opcija %s zna\u010Di",
      "commonComponents.scale.lastElement": "Poslednja opcija %s zna\u010Di",
      "commonComponents.table.chooseNoMore": [
        "Izaberite ne vi\u0161e od %s odgovora u redu ",
        "Izaberite ne vi\u0161e od %s odgovora u redu ",
        "Izaberite ne vi\u0161e od %s odgovora u redu ",
        ""
      ],
      "defaults.agree": "Potpuno se sla\u017Eem",
      "defaults.back": "Nazad",
      "defaults.datePlaceholder": "dd.mm.gggg",
      "defaults.disagree": "Apsolutno se ne sla\u017Eem",
      "defaults.dualChoice.label": "Okvir za potvrdu",
      "defaults.emoji1": "U\u017Easno",
      "defaults.emoji2": "Lo\u0161e",
      "defaults.emoji3": "Normalno",
      "defaults.emoji4": "Dobro",
      "defaults.emoji5": "Savr\u0161eno",
      "defaults.next": "Dalje",
      "defaults.noAnswer": "Nijedan od ponu\u0111enih odgovora",
      "defaults.noOpinionAnswer": "Nisam siguran(-na)",
      "defaults.otherAnswer": "Drugo",
      "defaults.otherAnswerWithText": "Drugo (navedeno u komentaru)",
      "defaults.template.age.label": "Koliko imate godina?",
      "defaults.template.age.option.age_17_under": "Ispod 18",
      "defaults.template.age.option.age_18_24": "18-24 godine",
      "defaults.template.age.option.age_25_34": "25-34 godine",
      "defaults.template.age.option.age_35_44": "35-44 godine",
      "defaults.template.age.option.age_45_54": "45-54 godine",
      "defaults.template.age.option.age_55_over": "55 godina ili vi\u0161e",
      "defaults.template.sex.label": "Kojeg ste pola?",
      "defaults.template.sex.option.sex_female": "\u017Denski",
      "defaults.template.sex.option.sex_male": "Mu\u0161ki",
      "defaults.widget.label": "Text",
      "errors.page.default": "Ups, do\u0161lo je do gre\u0161ke",
      "errors.page.notFound": "Stranica nije prona\u0111ena",
      "errors.server.default": "Gre\u0161ka servera",
      "errors.survey.alreadyFinished": "Ve\u0107 ste dovr\u0161ili ovu anketu",
      "errors.survey.closed": "Na\u017Ealost, ovo istra\u017Eivanje je zavr\u0161eno",
      "errors.survey.notFound": "Stranica nije prona\u0111ena",
      "errors.survey.paused": "Anketa je pauzirana",
      "final.thanks": "Hvala vam!",
      "footer.default.confidential.text": "Poverljivo",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "Poverljivost",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "Anketa je napravljena pomo\u0107u tehnologija Yandex Survey",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Interno anketiranje Yandex",
      "footer.default.responsibility": "Neke ankete kreiraju tre\u0107e strane. Yandex ne proverava niti verifikuje njihov sadr\u017Eaj, niti preuzima bilo kakvu odgovornost za njih.",
      "footer.default.termsofuse.text": "Uslovi kori\u0161\u0107enja",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "Poverljivost",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "Uslovi kori\u0161\u0107enja",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "Anketa je dovr\u0161ena. Hvala!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "Nazad",
      "page.buttonNext": "Slede\u0107e",
      "page.buttonSkip": "Presko\u010Di",
      "page.title": "Popunite anketu",
      "page.watermark": "ODGOVORI PREGLEDA SE NE UZIMAJU U OBZIR ODGOVORI PREGLEDA SE NE UZIMAJU U OBZIR ODGOVORI PREGLEDA SE NE UZIMAJU U OBZIR",
      "placeholders.longText": "Unesite svoj komentar",
      "placeholders.shortText": "Unesite svoj komentar",
      "plural.answers.im": [
        "odgovor",
        "odgovora",
        "odgovora",
        "odgovora"
      ],
      "plural.answers.ro": [
        "odgovor",
        "odgovora",
        "odgovora",
        "odgovora"
      ],
      "plural.ratingStars.labels": [
        "zvezdica",
        "zvezdice",
        "zvezdica",
        ""
      ],
      "plural.seconds.im": [
        "sekunda",
        "sekunde",
        "sekunde",
        "sekunde"
      ],
      "plural.seconds.ro": [
        "sekunde",
        "sekunde",
        "sekunde",
        "sekunde"
      ],
      "questionModel.awful": "U\u017Easno",
      "questionModel.bad": "Lo\u0161e",
      "questionModel.dateLessThan": "Datum ne mo\u017Ee biti pre %s",
      "questionModel.dateMoreThan": "Datum ne mo\u017Ee biti posle %s",
      "questionModel.datePlaceholder": "Select a date",
      "questionModel.insufficientAnswers": [
        "Izabrali ste manje od %s odgovor",
        "Izabrali ste manje od %s odgovora",
        "Izabrali ste manje od %s odgovora",
        ""
      ],
      "questionModel.lessThan": "Broj ne sme biti manji od %s",
      "questionModel.maxAnswerPerRowExceeded": "Prema\u0161ili ste maksimalan broj odgovora za red",
      "questionModel.maxLenghtExceeded": "Broj znakova prema\u0161uje maksimalno dozvoljeni broj, skratite tekst",
      "questionModel.moreThan": "Broj ne sme biti ve\u0107i od %s",
      "questionModel.normally": "Normalno",
      "questionModel.notDate": "Neva\u017Eec\u0301i datum",
      "questionModel.notEmail": "Mora da odgovara imejl formatu",
      "questionModel.notFilled": "Ovde unesite odgovor",
      "questionModel.notNumber": "Mo\u017Ee da sadr\u017Ei samo brojeve",
      "questionModel.perfectly": "Savr\u0161eno",
      "questionModel.picture": "Slika %s",
      "questionModel.requiredField": "Nemojte ostaviti ovo pitanje bez odgovora",
      "questionModel.tooManyAnswers": [
        "Odabrano je vi\u0161e od %s odgovora",
        "Odabrano je vi\u0161e od %s odgovora",
        "",
        ""
      ],
      "questionModel.well": "Dobro",
      "sidebyside.option": "Opcija %s",
      "templates.options.age.age18_24": "18-24 godine",
      "templates.options.age.age25_34": "25-34 godine",
      "templates.options.age.age35_44": "35-44 godine",
      "templates.options.age.age45_54": "45-54 godine",
      "templates.options.age.age55_over": "55 godina ili vi\u0161e",
      "templates.options.sex.sex_female": "\u017Denski",
      "templates.options.sex.sex_male": "Mu\u0161ki",
      "templates.questions.age": "Koliko imate godina?",
      "templates.questions.sex": "Kojeg ste pola?",
      "ux.stepPaginator.stepTitle": "Korak %s od %s",
      "video.holdBtn": "Pritisnite i zadr\u017Eite dok pregledate brend",
      "video.statusBarTitle": "Brend je vidljiv od %1 sekunde do %2 sekunde"
    }
  },
  tg: {
    poll: {
      "attach.image.notLess": "\u0411\u0430 \u0442\u0430\u0441\u0432\u0438\u0440 \u043D\u0430 \u043A\u0430\u043C\u0442\u0430\u0440 \u0430\u0437 %1 \u043D\u0438\u0433\u043E\u04B3 \u043A\u0443\u043D\u0435\u0434 \u0432\u0430 \u0431\u0430 \u044F\u043A\u0447\u0430\u043D\u0434 \u0441\u0430\u0432\u043E\u043B\u04B3\u043E \u04B7\u0430\u0432\u043E\u0431 \u0434\u0438\u04B3\u0435\u0434",
      "attach.image.notMore": "\u0411\u0430 \u0442\u0430\u0441\u0432\u0438\u0440 \u0434\u0430\u0440 \u0434\u0430\u0432\u043E\u043C\u0438 %1 \u043D\u0438\u0433\u043E\u04B3 \u043A\u0443\u043D\u0435\u0434 \u0432\u0430 \u0431\u0430 \u044F\u043A\u0447\u0430\u043D\u0434 \u0441\u0430\u0432\u043E\u043B\u04B3\u043E \u04B7\u0430\u0432\u043E\u0431 \u0434\u0438\u04B3\u0435\u0434",
      "attach.text.notLess": "\u0411\u0430 \u043C\u0430\u0442\u043D \u043D\u0430 \u043A\u0430\u043C\u0442\u0430\u0440 \u0430\u0437 %1 \u043D\u0438\u0433\u043E\u04B3 \u043A\u0443\u043D\u0435\u0434 \u0432\u0430 \u0431\u0430 \u044F\u043A\u0447\u0430\u043D\u0434 \u0441\u0430\u0432\u043E\u043B\u04B3\u043E \u04B7\u0430\u0432\u043E\u0431 \u0434\u0438\u04B3\u0435\u0434",
      "attach.text.notMore": "\u041C\u0430\u0442\u043D\u0440\u043E \u0434\u0430\u0440 \u0434\u0430\u0432\u043E\u043C\u0438 %1 \u0445\u043E\u043D\u0435\u0434 \u0432\u0430 \u0431\u0430 \u044F\u043A\u0447\u0430\u043D\u0434 \u0441\u0430\u0432\u043E\u043B\u04B3\u043E \u04B7\u0430\u0432\u043E\u0431 \u0434\u0438\u04B3\u0435\u0434",
      "attach.text.widgetHidden": "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "attach.video.notLess": "\u0412\u0438\u0434\u0435\u043E\u0440\u043E\u043B\u0438\u043A\u0440\u043E \u043D\u0430 \u043A\u0430\u043C\u0442\u0430\u0440 \u0430\u0437 %1 \u0442\u0430\u043C\u043E\u0448\u043E \u043A\u0443\u043D\u0435\u0434 \u0432\u0430 \u0431\u0430 \u044F\u043A\u0447\u0430\u043D\u0434 \u0441\u0430\u0432\u043E\u043B\u04B3\u043E \u04B7\u0430\u0432\u043E\u0431 \u0434\u0438\u04B3\u0435\u0434",
      "attach.video.notMore": "\u0412\u0438\u0434\u0435\u043E\u0440\u043E\u043B\u0438\u043A\u0440\u043E \u0434\u0430\u0440 \u0434\u0430\u0432\u043E\u043C\u0438 %1 \u0442\u0430\u043C\u043E\u0448\u043E \u043A\u0443\u043D\u0435\u0434 \u0432\u0430 \u0431\u0430 \u044F\u043A\u0447\u0430\u043D\u0434 \u0441\u0430\u0432\u043E\u043B\u04B3\u043E \u04B7\u0430\u0432\u043E\u0431 \u0434\u0438\u04B3\u0435\u0434",
      "attach.video.waitEnd": "\u0412\u0438\u0434\u0435\u043E\u0440\u043E\u043B\u0438\u043A\u0440\u043E \u0442\u043E \u043E\u0445\u0438\u0440 \u0442\u0430\u043C\u043E\u0448\u043E \u043A\u0443\u043D\u0435\u0434 \u0432\u0430 \u0431\u0430 \u044F\u043A\u0447\u0430\u043D\u0434 \u0441\u0430\u0432\u043E\u043B\u04B3\u043E \u04B7\u0430\u0432\u043E\u0431 \u0434\u0438\u04B3\u0435\u0434",
      "attach.watch": "\u0422\u0430\u043C\u043E\u0448\u043E \u043A\u0430\u0440\u0434\u0430\u043D",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "\u041D\u0435 \u043C\u043E\u0433\u0443 \u043D\u0430\u0437\u0432\u0430\u0442\u044C",
      "commonComponents.choice.anythingElse": "\u0427\u0442\u043E-\u0442\u043E \u0435\u0449\u0435...",
      "commonComponents.choice.chooseLessEqualMore": [
        "%s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
        "%s \u04B7\u0430\u0432\u043E\u0431\u04B3\u043E\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
        "% \u04B7\u0430\u0432\u043E\u0431\u04B3\u043E\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "\u041D\u0430 \u043A\u0430\u043C\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
        "\u041D\u0430 \u043A\u0430\u043C\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
        "\u041D\u0430 \u043A\u0430\u043C\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "\u041D\u0430 \u043A\u0430\u043C\u0442\u0430\u0440 \u0430\u0437 %s \u0432\u0430 \u043D\u0430 \u0431\u0435\u0448\u0442\u0430\u0440 \u0430\u0437 %s-\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
      "commonComponents.choice.chooseNoMore": [
        "\u041D\u0430 \u0431\u0435\u0448\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
        "\u041D\u0430 \u0431\u0435\u0448\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
        "\u041D\u0430 \u0431\u0435\u0448\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
        ""
      ],
      "commonComponents.choice.enterText": "\u041C\u0430\u0442\u043D\u0440\u043E \u043D\u0430\u0432\u0438\u0441\u0435\u0434",
      "commonComponents.choice.yourComment": "\u042D\u0437\u043E\u04B3\u0438 \u0448\u0443\u043C\u043E...",
      "commonComponents.scale.chooseRate": "\u0411\u0430\u04B3\u043E\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
      "commonComponents.scale.firstElement": "\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u0438 \u044F\u043A\u0443\u043C\u0438 \u043A\u0430\u043D\u043E\u0440\u04E3 %s \u043C\u0430\u044A\u043D\u043E\u0438 \u043E\u043D\u0440\u043E \u0434\u043E\u0440\u0430\u0434, \u043A\u0438",
      "commonComponents.scale.lastElement": "\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u0438 \u043E\u0445\u0438\u0440\u043E\u043D\u0438 \u043A\u0430\u043D\u043E\u0440\u04E3 %s \u043C\u0430\u044A\u043D\u043E\u0438 \u043E\u043D\u0440\u043E \u0434\u043E\u0440\u0430\u0434, \u043A\u0438",
      "commonComponents.table.chooseNoMore": [
        "\u0414\u0430\u0440 \u0441\u0430\u0442\u0440 \u043D\u0430 \u0431\u0435\u0448\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
        "\u0414\u0430\u0440 \u0441\u0430\u0442\u0440 \u043D\u0430 \u0431\u0435\u0448\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
        "\u0414\u0430\u0440 \u0441\u0430\u0442\u0440 \u043D\u0430 \u0431\u0435\u0448\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
        ""
      ],
      "defaults.agree": "\u041F\u0443\u0440\u0440\u0430 \u0440\u043E\u0437\u0438\u044F\u043C",
      "defaults.back": "\u0411\u0430 \u049B\u0430\u0444\u043E",
      "defaults.datePlaceholder": "\u0440\u0440.\u043C\u043C.\u0441\u0441\u0441\u0441",
      "defaults.disagree": "\u0422\u0430\u043C\u043E\u043C\u0430\u043D \u0440\u043E\u0437\u04E3 \u043D\u0435\u0441\u0442\u0430\u043C",
      "defaults.dualChoice.label": "\u0427\u0435\u043A\u0431\u043E\u043A\u0441",
      "defaults.emoji1": "\u0414\u0430\u04B3\u0448\u0430\u0442\u043D\u043E\u043A",
      "defaults.emoji2": "\u0411\u0430\u0434",
      "defaults.emoji3": "\u041C\u0443\u049B\u0430\u0440\u0440\u0430\u0440\u04E3",
      "defaults.emoji4": "\u0425\u0443\u0431",
      "defaults.emoji5": "\u0410\u044A\u043B\u043E",
      "defaults.next": "\u0411\u0430\u044A\u0434\u0430\u043D",
      "defaults.noAnswer": "\u041D\u0430 \u044F\u0433\u043E\u043D \u0430\u0437 \u043D\u043E\u043C\u0431\u0430\u0440\u0433\u0430\u0440\u0434\u0438\u0434\u0430",
      "defaults.noOpinionAnswer": "\u04B6\u0430\u0432\u043E\u0431\u0434\u0438\u04B3\u04E3 \u043C\u0443\u0448\u043A\u0438\u043B \u0430\u0441\u0442",
      "defaults.otherAnswer": "\u0414\u0438\u0433\u0430\u0440",
      "defaults.otherAnswerWithText": "\u0414\u0438\u0433\u0430\u0440 (\u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0438 \u0445\u0443\u0434\u0440\u043E \u043D\u0430\u0432\u0438\u0441\u0435\u0434)",
      "defaults.template.age.label": "\u0421\u0438\u043D\u043D\u0443 \u0441\u043E\u043B\u0438 \u043F\u0443\u0440\u0440\u0430\u0438 \u0445\u0443\u0434\u0440\u043E \u043D\u0438\u0448\u043E\u043D \u0434\u0438\u04B3\u0435\u0434",
      "defaults.template.age.option.age_17_under": "\u0425\u0443\u0440\u0434\u0442\u0430\u0440 \u0430\u0437 18 \u0441\u043E\u043B\u0430",
      "defaults.template.age.option.age_18_24": "18\u201324 \u0441\u043E\u043B\u0430",
      "defaults.template.age.option.age_25_34": "25\u201334 \u0441\u043E\u043B\u0430",
      "defaults.template.age.option.age_35_44": "35\u201344 \u0441\u043E\u043B\u0430",
      "defaults.template.age.option.age_45_54": "45\u201354 \u0441\u043E\u043B\u0430",
      "defaults.template.age.option.age_55_over": "55 \u0441\u043E\u043B\u0430 \u0451 \u043A\u0438 \u043A\u0430\u043B\u043E\u043D\u0442\u0430\u0440",
      "defaults.template.sex.label": "\u04B6\u0438\u043D\u0441\u0438 \u0445\u0443\u0434\u0440\u043E \u043D\u0438\u0448\u043E\u043D \u0434\u0438\u04B3\u0435\u0434",
      "defaults.template.sex.option.sex_female": "\u0417\u0430\u043D\u043E\u043D\u0430",
      "defaults.template.sex.option.sex_male": "\u041C\u0430\u0440\u0434\u043E\u043D\u0430",
      "defaults.widget.label": "\u0422\u0435\u043A\u0441\u0442",
      "errors.page.default": "\u0425\u0430\u0442\u043E\u0433\u04E3 \u0440\u0443\u0445 \u0434\u043E\u0434 :(",
      "errors.page.notFound": "\u0421\u0430\u04B3\u0438\u0444\u0430 \u0451\u0444\u0442 \u043D\u0430\u0448\u0443\u0434",
      "errors.server.default": "\u0425\u0430\u0442\u043E\u0433\u0438\u0438 \u0441\u0435\u0440\u0432\u0435\u0440",
      "errors.survey.alreadyFinished": "\u0428\u0443\u043C\u043E \u0430\u043B\u043B\u0430\u043A\u0430\u0439 \u0438\u043D \u043F\u0443\u0440\u0441\u0438\u0448\u0440\u043E \u0431\u0430 \u0430\u043D\u04B7\u043E\u043C \u0440\u0430\u0441\u043E\u043D\u0438\u0434\u0435\u0434",
      "errors.survey.closed": "\u041C\u0443\u0442\u0430\u0430\u0441\u0441\u0438\u0444\u043E\u043D\u0430, \u0442\u0430\u0434\u049B\u0438\u049B\u043E\u0442 \u0430\u043B\u043B\u0430\u043A\u0430\u0439 \u0431\u0430 \u0430\u043D\u04B7\u043E\u043C \u0440\u0430\u0441\u0438\u0434\u0430\u0430\u0441\u0442",
      "errors.survey.notFound": "\u0421\u0430\u04B3\u0438\u0444\u0430 \u0451\u0444\u0442 \u043D\u0430\u0448\u0443\u0434",
      "errors.survey.paused": "\u041F\u0443\u0440\u0441\u0438\u0448 \u0431\u043E\u0437 \u0434\u043E\u0448\u0442\u0430 \u0448\u0443\u0434\u0430\u0430\u0441\u0442",
      "final.thanks": "\u0422\u0430\u0448\u0430\u043A\u043A\u0443\u0440!",
      "footer.default.confidential.text": "\u041C\u0430\u0445\u0444\u04E3",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "\u041C\u0430\u0445\u0444\u0438\u044F\u0442",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.default.copyright.text": "\xA9 %s  \u04B6\u0414\u041C\u041C \xAB\u042F\u043D\u0434\u0435\u043A\u0441\xBB",
      "footer.default.copyrightInternal.text": "\xA9 %s \u04B6\u0414\u041C\u041C \xAB\u042F\u043D\u0434\u0435\u043A\u0441\xBB",
      "footer.default.createby.text": "\u041F\u0443\u0440\u0441\u0438\u0448 \u0434\u0430\u0440 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u044F\u04B3\u043E\u0438 \u042F\u043D\u0434\u0435\u043A\u0441 \u0412\u0437\u0433\u043B\u044F\u0434 \u043A\u0430\u0440\u0434\u0430 \u0448\u0443\u0434\u0430\u0430\u0441\u0442",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "\u041F\u0443\u0440\u0441\u0438\u0448\u0438 \u0434\u043E\u0445\u0438\u043B\u0438\u0438 \u042F\u043D\u0434\u0435\u043A\u0441",
      "footer.default.responsibility": "\u042F\u043D\u0434\u0435\u043A\u0441 \u0431\u0430 \u043F\u0443\u0440\u0441\u0438\u0448\u04B3\u043E\u0438 \u0430\u0437 \u04B7\u043E\u043D\u0438\u0431\u0438 \u0448\u0430\u0445\u0441\u043E\u043D\u0438 \u0441\u0435\u044E\u043C \u043E\u0444\u0430\u0440\u0438\u0434\u0430\u0448\u0443\u0434\u0430 \u043C\u0443\u043D\u043E\u0441\u0438\u0431\u0430\u0442 \u043D\u0430\u0434\u043E\u0440\u0430\u0434, \u0432\u0430 \u0431\u0430\u0440\u043E\u0438 \u0442\u0430\u0440\u043A\u0438\u0431\u0438 \u043E\u043D\u04B3\u043E \u04B7\u0430\u0432\u043E\u0431\u0433\u0430\u0440\u04E3 \u043D\u0430\u0434\u043E\u0440\u0430\u0434",
      "footer.default.termsofuse.text": "\u0428\u0430\u0440\u0442\u04B3\u043E\u0438 \u0438\u0441\u0442\u0438\u0444\u043E\u0434\u0430\u0431\u0430\u0440\u04E3",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/",
      "footer.odnaco.confpolicy.text": "\u0421\u0438\u0451\u0441\u0430\u0442\u0438 \u043C\u0430\u0445\u0444\u0438\u044F\u0442",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "\u0421\u043E\u0437\u0438\u0448\u043D\u043E\u043C\u0430\u0438 \u0438\u0441\u0442\u0438\u0444\u043E\u0434\u0430\u0431\u0430\u0440\u0430\u043D\u0434\u0430",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/index.html",
      "info.survey.thanks": "\u041F\u0443\u0440\u0441\u0438\u0448 \u0431\u0430 \u0430\u043D\u04B7\u043E\u043C \u0440\u0430\u0441\u0438\u0434. \u0422\u0430\u0448\u0430\u043A\u043A\u0443\u0440!",
      "labels.columnHidden": "\u0421\u0442\u043E\u043B\u0431\u0435\u0446 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.hiddenQuestionsActivated": "\u0421\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u044E\u0442\u0441\u044F",
      "labels.hiddenQuestionsDeactivated": "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0441\u043A\u0440\u044B\u0442\u044B\u0445 \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432 \u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
      "labels.optionHidden": "\u041E\u0442\u0432\u0435\u0442 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.page": "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
      "labels.questionHidden": "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.rotationGroup": "\u0413\u0440\u0443\u043F\u043F\u0430",
      "labels.rowHidden": "\u0421\u0442\u0440\u043E\u043A\u0430 \u0441\u043A\u0440\u044B\u0442\u0430 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.screening": "\u0421\u043A\u0440\u0438\u043D\u0438\u0440\u0443\u044E\u0449\u0438\u0439 \u0432\u043E\u043F\u0440\u043E\u0441",
      "labels.showHiddenQuestions": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
      "labels.widgetHidden": "\u0422\u0435\u043A\u0441\u0442 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "page.buttonBack": "\u0411\u0430 \u049B\u0430\u0444\u043E",
      "page.buttonNext": "\u0411\u0430\u044A\u0434\u0430\u043D",
      "page.buttonSkip": "\u041F\u0430\u0441\u0438 \u0441\u0430\u0440 \u043A\u0430\u0440\u0434\u0430\u043D",
      "page.title": "\u0410\u0437 \u043F\u0443\u0440\u0441\u0438\u0448 \u0433\u0443\u0437\u0430\u0440\u0435\u0434",
      "page.watermark": "\u041F\u0415\u0428\u0410\u041A\u04E2 \u0414\u0418\u0414\u0410\u041D \u04B6\u0410\u0412\u041E\u0411\u04B2\u041E \u0411\u0410 \u04B2\u0418\u0421\u041E\u0411 \u0413\u0418\u0420\u0418\u0424\u0422\u0410 \u041D\u0410\u041C\u0415\u0428\u0410\u0412\u0410\u041D\u0414 \u041F\u0415\u0428\u0410\u041A\u04E2 \u0414\u0418\u0414\u0410\u041D \u04B6\u0410\u0412\u041E\u0411\u04B2\u041E \u0411\u0410 \u04B2\u0418\u0421\u041E\u0411 \u0413\u0418\u0420\u0418\u0424\u0422\u0410 \u041D\u0410\u041C\u0415\u0428\u0410\u0412\u0410\u041D\u0414 \u041F\u0415\u0428\u0410\u041A\u04E2 \u0414\u0418\u0414\u0410\u041D \u04B6\u0410\u0412\u041E\u0411\u04B2\u041E \u0411\u0410 \u04B2\u0418\u0421\u041E\u0411 \u0413\u0418\u0420\u0418\u0424\u0422\u0410 \u041D\u0410\u041C\u0415\u0428\u0410\u0412\u0410\u041D\u0414",
      "placeholders.longText": "\u042D\u0437\u043E\u04B3\u0438 \u0448\u0443\u043C\u043E",
      "placeholders.shortText": "\u042D\u0437\u043E\u04B3\u0438 \u0448\u0443\u043C\u043E",
      "plural.answers.im": [
        "\u04B7\u0430\u0432\u043E\u0431",
        "\u04B7\u0430\u0432\u043E\u0431",
        "\u04B7\u0430\u0432\u043E\u0431",
        "\u04B7\u0430\u0432\u043E\u0431"
      ],
      "plural.answers.ro": [
        "\u04B7\u0430\u0432\u043E\u0431",
        "\u04B7\u0430\u0432\u043E\u0431",
        "\u04B7\u0430\u0432\u043E\u0431",
        "\u04B7\u0430\u0432\u043E\u0431"
      ],
      "plural.ratingStars.labels": [
        "\u0441\u0438\u0442\u043E\u0440\u0430",
        "\u0441\u0438\u0442\u043E\u0440\u0430\u04B3\u043E",
        "\u0441\u0438\u0442\u043E\u0440\u0430\u04B3\u043E",
        ""
      ],
      "plural.seconds.im": [
        "\u0441\u043E\u043D\u0438\u044F",
        "\u0441\u043E\u043D\u0438\u044F",
        "\u0441\u043E\u043D\u0438\u044F",
        "\u0441\u043E\u043D\u0438\u044F"
      ],
      "plural.seconds.ro": [
        "\u0441\u043E\u043D\u0438\u044F",
        "\u0441\u043E\u043D\u0438\u044F",
        "\u0441\u043E\u043D\u0438\u044F",
        "\u0441\u043E\u043D\u0438\u044F"
      ],
      "questionModel.awful": "\u0414\u0430\u04B3\u0448\u0430\u0442\u043D\u043E\u043A",
      "questionModel.bad": "\u0411\u0430\u0434",
      "questionModel.dateLessThan": "\u0421\u0430\u043D\u0430 \u0430\u0437 %s \u043F\u0435\u0448\u0442\u0430\u0440 \u0431\u0443\u0434\u0430 \u043D\u0430\u043C\u0435\u0442\u0430\u0432\u043E\u043D\u0430\u0434",
      "questionModel.dateMoreThan": "\u0421\u0430\u043D\u0430 \u0430\u0437 %s \u0434\u0435\u0440\u0442\u0430\u0440 \u0431\u0443\u0434\u0430 \u043D\u0430\u043C\u0435\u0442\u0430\u0432\u043E\u043D\u0430\u0434",
      "questionModel.datePlaceholder": "\u0421\u0430\u043D\u0430\u0440\u043E \u0432\u043E\u0440\u0438\u0434 \u043A\u0443\u043D\u0435\u0434",
      "questionModel.insufficientAnswers": [
        "\u041A\u0430\u043C\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0430\u0440\u0434\u0435\u0434",
        "\u041A\u0430\u043C\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0430\u0440\u0434\u0435\u0434",
        "\u041A\u0430\u043C\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0430\u0440\u0434\u0435\u0434",
        ""
      ],
      "questionModel.lessThan": "\u0428\u0443\u043C\u043E\u0440\u0430 \u0430\u0437 %s \u043A\u0430\u043C\u0442\u0430\u0440 \u0431\u0443\u0434\u0430 \u043D\u0430\u043C\u0435\u0442\u0430\u0432\u043E\u043D\u0430\u0434",
      "questionModel.maxAnswerPerRowExceeded": "\u0428\u0443\u043C\u043E\u0440\u0430\u0438 \u04B7\u0430\u0432\u043E\u0431\u04B3\u043E\u0438 \u04B3\u0430\u0434\u0434\u0438 \u0430\u049B\u0430\u043B \u0434\u0430\u0440 \u0441\u0430\u0442\u0440 \u0430\u0437 \u04B3\u0430\u0434 \u0433\u0443\u0437\u0430\u0448\u0442\u0430\u0430\u0441\u0442",
      "questionModel.maxLenghtExceeded": "\u041C\u0438\u049B\u0434\u043E\u0440\u0438 \u0430\u043B\u043E\u043C\u0430\u0442\u04B3\u043E \u0430\u0437 \u04B3\u0443\u0434\u0443\u0434\u0438 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u04E3 \u0431\u0435\u0448\u0442\u0430\u0440 \u0430\u0437, \u043B\u0443\u0442\u0444\u0430\u043D, \u043C\u0430\u0442\u043D\u0440\u043E \u043A\u04EF\u0442\u043E\u04B3 \u043A\u0443\u043D\u0435\u0434",
      "questionModel.moreThan": "\u0428\u0443\u043C\u043E\u0440\u0430 \u0430\u0437 %s \u0431\u0435\u0448\u0442\u0430\u0440 \u0431\u0443\u0434\u0430 \u043D\u0430\u043C\u0435\u0442\u0430\u0432\u043E\u043D\u0430\u0434",
      "questionModel.normally": "\u041C\u0443\u049B\u0430\u0440\u0440\u0430\u0440\u04E3",
      "questionModel.notDate": "\u0421\u0430\u043D\u0430\u0438 \u043D\u043E\u0441\u0430\u04B3\u0435\u04B3 \u0432\u043E\u0440\u0438\u0434 \u043A\u0430\u0440\u0434\u0430 \u0448\u0443\u0434",
      "questionModel.notEmail": "\u0411\u043E\u044F\u0434 \u0431\u0430 \u0448\u0430\u043A\u043B\u0438 email \u043C\u0443\u0442\u043E\u0431\u0438\u049B\u0430\u0442 \u0434\u043E\u0448\u0442\u0430 \u0431\u043E\u0448\u0430\u0434",
      "questionModel.notFilled": "\u041C\u0430\u0442\u043D\u0440\u043E \u0432\u043E\u0440\u0438\u0434 \u043A\u0430\u0440\u0434\u0430\u043D \u043B\u043E\u0437\u0438\u043C",
      "questionModel.notNumber": "\u0422\u0430\u043D\u04B3\u043E \u0440\u0430\u049B\u0430\u043C\u04B3\u043E\u0440\u043E \u0434\u043E\u0448\u0442\u0430 \u043C\u0435\u0442\u0430\u0432\u043E\u043D\u0430\u0434",
      "questionModel.perfectly": "\u0410\u044A\u043B\u043E",
      "questionModel.picture": "\u0422\u0430\u0441\u0432\u0438\u0440 %s",
      "questionModel.requiredField": "\u0418\u043D \u0441\u0430\u0432\u043E\u043B\u0440\u043E \u0431\u0435\u04B7\u0430\u0432\u043E\u0431 \u043D\u0430\u0433\u0443\u0437\u043E\u0440\u0435\u0434",
      "questionModel.tooManyAnswers": [
        "\u0428\u0443\u043C\u043E \u0431\u0435\u0448\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0430\u0440\u0434\u0435\u0434",
        "\u0428\u0443\u043C\u043E \u0431\u0435\u0448\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0430\u0440\u0434\u0435\u0434",
        "\u0428\u0443\u043C\u043E \u0431\u0435\u0448\u0442\u0430\u0440 \u0430\u0437 %s \u04B7\u0430\u0432\u043E\u0431\u0440\u043E \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0430\u0440\u0434\u0435\u0434",
        ""
      ],
      "questionModel.well": "\u0425\u0443\u0431",
      "sidebyside.option": "\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u0438 %s",
      "templates.options.age.age18_24": "18\u201324 \u0441\u043E\u043B\u0430",
      "templates.options.age.age25_34": "25\u201334 \u0441\u043E\u043B\u0430",
      "templates.options.age.age35_44": "35\u201344 \u0441\u043E\u043B\u0430",
      "templates.options.age.age45_54": "45\u201354 \u0441\u043E\u043B\u0430",
      "templates.options.age.age55_over": "55 \u0441\u043E\u043B\u0430 \u0451 \u043A\u0438 \u043A\u0430\u043B\u043E\u043D\u0442\u0430\u0440",
      "templates.options.sex.sex_female": "\u0417\u0430\u043D\u043E\u043D\u0430",
      "templates.options.sex.sex_male": "\u041C\u0430\u0440\u0434\u043E\u043D\u0430",
      "templates.questions.age": "\u0421\u0438\u043D\u043D\u0443 \u0441\u043E\u043B\u0438 \u043F\u0443\u0440\u0440\u0430\u0438 \u0445\u0443\u0434\u0440\u043E \u043D\u0438\u0448\u043E\u043D \u0434\u0438\u04B3\u0435\u0434",
      "templates.questions.sex": "\u04B6\u0438\u043D\u0441\u0438 \u0445\u0443\u0434\u0440\u043E \u043D\u0438\u0448\u043E\u043D \u0434\u0438\u04B3\u0435\u0434",
      "ux.stepPaginator.stepTitle": "\u049A\u0430\u0434\u0430\u043C\u0438 %s/%s",
      "video.holdBtn": "\u0412\u0430\u049B\u0442\u0438 \u0434\u0438\u0434\u0430\u043D\u0438 \u0431\u0440\u0435\u043D\u0434 \u0434\u043E\u0448\u0442\u0430 \u0438\u0441\u0442\u0435\u0434",
      "video.statusBarTitle": "\u0411\u0440\u0435\u043D\u0434 \u0430\u0437 %1 \u0441\u043E\u043D\u0438\u044F \u0442\u043E %2 \u0441\u043E\u043D\u0438\u044F \u043D\u0430\u043C\u043E\u0451\u043D \u0431\u0443\u0434"
    }
  },
  tr: {
    poll: {
      "attach.image.notLess": "G\xF6rsele en az %1 bak\u0131n ve birka\xE7 soruyu yan\u0131tlay\u0131n",
      "attach.image.notMore": "G\xF6rsele %1 bak\u0131n ve birka\xE7 soruyu yan\u0131tlay\u0131n",
      "attach.text.notLess": "Metne en az %1 bak\u0131n ve birka\xE7 soruyu yan\u0131tlay\u0131n",
      "attach.text.notMore": "Metni %1 i\xE7inde okuyup birka\xE7 soruyu yan\u0131tlay\u0131n",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "Videoyu en az %1 boyunca izleyip birka\xE7 soruyu yan\u0131tlay\u0131n",
      "attach.video.notMore": "Videoyu %1 boyunca izleyip birka\xE7 soruyu yan\u0131tlay\u0131n",
      "attach.video.waitEnd": "Videoyu sonuna kadar izleyip birka\xE7 soruyu yan\u0131tlay\u0131n",
      "attach.watch": "\u0130zle",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "Di\u011Fer...",
      "commonComponents.choice.chooseLessEqualMore": [
        "%s yan\u0131t se\xE7in",
        "%s\xA0yan\u0131t se\xE7in",
        "% yan\u0131t se\xE7in",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "En az %s yan\u0131t se\xE7in",
        "En az %s yan\u0131t se\xE7in",
        "En az %s yan\u0131t se\xE7in",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "En az %s ve en fazla %s yan\u0131t se\xE7in",
      "commonComponents.choice.chooseNoMore": [
        "En fazla %s yan\u0131t se\xE7in",
        "En fazla %s yan\u0131t se\xE7in",
        "En fazla %s yan\u0131t se\xE7in",
        ""
      ],
      "commonComponents.choice.enterText": "Metni girin",
      "commonComponents.choice.yourComment": "Yorumunuz...",
      "commonComponents.scale.chooseRate": "De\u011Ferlendirme se\xE7in",
      "commonComponents.scale.firstElement": "\u0130lk a\u015F\u0131r\u0131 se\xE7enek %s anlam\u0131na geliyor",
      "commonComponents.scale.lastElement": "Son a\u015F\u0131r\u0131 se\xE7enek %s anlam\u0131na geliyor",
      "commonComponents.table.chooseNoMore": [
        "Sat\u0131rda en fazla %s yan\u0131t se\xE7in",
        "Sat\u0131rda en fazla %s yan\u0131t se\xE7in",
        "Sat\u0131rda en fazla %s yan\u0131t se\xE7in",
        ""
      ],
      "defaults.agree": "Kesinlikle kat\u0131l\u0131yorum",
      "defaults.back": "Geri",
      "defaults.datePlaceholder": "gg.aa.yyyy",
      "defaults.disagree": "Kesinlikle kat\u0131lm\u0131yorum",
      "defaults.dualChoice.label": "Onay kutusu",
      "defaults.emoji1": "\xC7ok k\xF6t\xFC",
      "defaults.emoji2": "K\xF6t\xFC",
      "defaults.emoji3": "Normal",
      "defaults.emoji4": "\u0130yi",
      "defaults.emoji5": "\xC7ok iyi",
      "defaults.next": "\u0130leri",
      "defaults.noAnswer": "Yukar\u0131dakilerden hi\xE7biri",
      "defaults.noOpinionAnswer": "Yan\u0131tlamakta zorlan\u0131yorum",
      "defaults.otherAnswer": "Di\u011Fer",
      "defaults.otherAnswerWithText": "Di\u011Fer (serbest yan\u0131t verin)",
      "defaults.template.age.label": "Ya\u015F\u0131n\u0131z\u0131 belirtin",
      "defaults.template.age.option.age_17_under": "18 ya\u015F\u0131ndan k\xFC\xE7\xFCk",
      "defaults.template.age.option.age_18_24": "18-24 ya\u015F aras\u0131",
      "defaults.template.age.option.age_25_34": "25-34 ya\u015F aras\u0131",
      "defaults.template.age.option.age_35_44": "35-44 ya\u015F aras\u0131",
      "defaults.template.age.option.age_45_54": "45-54 ya\u015F aras\u0131",
      "defaults.template.age.option.age_55_over": "55 ya\u015F ve \xFCzeri",
      "defaults.template.sex.label": "Cinsiyetinizi belirtin",
      "defaults.template.sex.option.sex_female": "Kad\u0131n",
      "defaults.template.sex.option.sex_male": "Erkek",
      "defaults.widget.label": "Text",
      "errors.page.default": "Hata olu\u015Ftu :(",
      "errors.page.notFound": "Sayfa bulunamad\u0131",
      "errors.server.default": "Sunucu hatas\u0131 olu\u015Ftu",
      "errors.survey.alreadyFinished": "Bu anketi daha \xF6nce tamamlad\u0131n\u0131z",
      "errors.survey.closed": "Ne yaz\u0131k ki bu ara\u015Ft\u0131rma sona erdi",
      "errors.survey.notFound": "Sayfa bulunamad\u0131",
      "errors.survey.paused": "Anket durduruldu",
      "final.thanks": "Te\u015Fekk\xFCrler!",
      "footer.default.confidential.text": "Gizlilik",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "Gizlilik",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex LLC",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex LLC",
      "footer.default.createby.text": "Bu anket, Yandex Surveys teknolojisi ile haz\u0131rlanm\u0131\u015Ft\u0131r",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Dahili Yandex anketi",
      "footer.default.responsibility": "\xDC\xE7\xFCnc\xFC taraflar\u0131n olu\u015Fturdu\u011Fu anketlerle Yandex'in hi\xE7bir ilgisi yoktur; dolay\u0131s\u0131yla Yandex bu t\xFCr anketlerin i\xE7eriklerinden sorumlu de\u011Fildir.",
      "footer.default.termsofuse.text": "Kullan\u0131m ko\u015Fullar\u0131",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "Gizlilik Politikas\u0131",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "Kullan\u0131c\u0131 S\xF6zle\u015Fmesi",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "Anket tamamland\u0131. Te\u015Fekk\xFCrler!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "Geri",
      "page.buttonNext": "Devam",
      "page.buttonSkip": "Atla",
      "page.title": "Ankete kat\u0131l",
      "page.watermark": "\xD6N\u0130ZLEMED\u0130R YANITLAR HESAPLANMAZ \xD6N\u0130ZLEMED\u0130R YANITLAR HESAPLANMAZ \xD6N\u0130ZLEMED\u0130R YANITLAR HESAPLANMAZ",
      "placeholders.longText": "Yorumunuz",
      "placeholders.shortText": "Yorumunuz",
      "plural.answers.im": [
        "yan\u0131t",
        "yan\u0131t",
        "yan\u0131t",
        "yan\u0131t"
      ],
      "plural.answers.ro": [
        "yan\u0131t",
        "yan\u0131t",
        "yan\u0131t",
        "yan\u0131t"
      ],
      "plural.ratingStars.labels": [
        "y\u0131ld\u0131z",
        "y\u0131ld\u0131z",
        "y\u0131ld\u0131z",
        ""
      ],
      "plural.seconds.im": [
        "saniye",
        "saniye",
        "saniye",
        "saniye"
      ],
      "plural.seconds.ro": [
        "saniye",
        "saniye",
        "saniye",
        "saniye"
      ],
      "questionModel.awful": "\xC7ok k\xF6t\xFC",
      "questionModel.bad": "K\xF6t\xFC",
      "questionModel.dateLessThan": "%s tarihinden daha erken bir tarih girilemez",
      "questionModel.dateMoreThan": "%s tarihinden daha ge\xE7 bir tarih girilemez",
      "questionModel.datePlaceholder": "Select a date",
      "questionModel.insufficientAnswers": [
        "Se\xE7ti\u011Finiz yan\u0131tlar\u0131n say\u0131s\u0131 %s adetten az",
        "Se\xE7ti\u011Finiz yan\u0131tlar\u0131n say\u0131s\u0131 %s adetten az",
        "Se\xE7ti\u011Finiz yan\u0131tlar\u0131n say\u0131s\u0131 %s adetten az",
        ""
      ],
      "questionModel.lessThan": "Say\u0131 en az %s olabilir",
      "questionModel.maxAnswerPerRowExceeded": "Sat\u0131r i\xE7in izin verilen maksimum yan\u0131t say\u0131s\u0131 a\u015F\u0131ld\u0131",
      "questionModel.maxLenghtExceeded": "Karakter say\u0131s\u0131 izin verilen maksimum de\u011Feri a\u015F\u0131yor, l\xFCtfen metni k\u0131salt\u0131n",
      "questionModel.moreThan": "Say\u0131 en fazla %s olabilir",
      "questionModel.normally": "Normal",
      "questionModel.notDate": "Tarih hatal\u0131 girildi",
      "questionModel.notEmail": "E-posta format\u0131na uygun olmal\u0131d\u0131r",
      "questionModel.notFilled": "Metin girmelisiniz",
      "questionModel.notNumber": "Sadece rakam girin",
      "questionModel.perfectly": "\xC7ok iyi",
      "questionModel.picture": "G\xF6rsel %s",
      "questionModel.requiredField": "Bu sorunun yan\u0131tlanmas\u0131 zorunludur",
      "questionModel.tooManyAnswers": [
        "%s \xFCzerinde yan\u0131t se\xE7tiniz",
        "%s \xFCzerinde yan\u0131t se\xE7tiniz",
        "%s \xFCzerinde yan\u0131t se\xE7tiniz",
        ""
      ],
      "questionModel.well": "\u0130yi",
      "sidebyside.option": "Se\xE7enek %s",
      "templates.options.age.age18_24": "18-24 ya\u015F aras\u0131",
      "templates.options.age.age25_34": "25-34 ya\u015F aras\u0131",
      "templates.options.age.age35_44": "35-44 ya\u015F aras\u0131",
      "templates.options.age.age45_54": "45-54 ya\u015F aras\u0131",
      "templates.options.age.age55_over": "55 ya\u015F ve \xFCzeri",
      "templates.options.sex.sex_female": "Kad\u0131n",
      "templates.options.sex.sex_male": "Erkek",
      "templates.questions.age": "Ya\u015F\u0131n\u0131z\u0131 belirtin",
      "templates.questions.sex": "Cinsiyetinizi belirtin",
      "ux.stepPaginator.stepTitle": "Ad\u0131m %s/%s",
      "video.holdBtn": "Markay\u0131 g\xF6rd\xFC\u011F\xFCn\xFCz s\xFCrece bas\u0131l\u0131 tutun",
      "video.statusBarTitle": "Marka %1 - %2 saniyeler aras\u0131nda g\xF6r\xFCld\xFC"
    }
  },
  ur: {
    poll: {
      "attach.image.notLess": "\u06A9\u0645 \u0627\u0632 \u06A9\u0645 %1 \u06A9\u06D2 \u0644\u06CC\u06D2 \u062A\u0635\u0648\u06CC\u0631 \u06A9\u0648 \u062F\u06CC\u06A9\u06BE\u06CC\u06BA \u0627\u0648\u0631 \u0686\u0646\u062F \u0633\u0648\u0627\u0644\u0627\u062A \u06A9\u06D2 \u062C\u0648\u0627\u0628 \u062F\u06CC\u06BA",
      "attach.image.notMore": "%1 \u06A9\u06D2 \u0644\u06CC\u06D2 \u062A\u0635\u0648\u06CC\u0631 \u06A9\u0648 \u062F\u06CC\u06A9\u06BE\u06CC\u06BA \u0627\u0648\u0631 \u0686\u0646\u062F \u0633\u0648\u0627\u0644\u0627\u062A \u06A9\u06D2 \u062C\u0648\u0627\u0628 \u062F\u06CC\u06BA",
      "attach.text.notLess": "\u06A9\u0645 \u0627\u0632 \u06A9\u0645 %1 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0645\u062A\u0646 \u06A9\u0648 \u062F\u06CC\u06A9\u06BE\u06CC\u06BA \u0627\u0648\u0631 \u0686\u0646\u062F \u0633\u0648\u0627\u0644\u0627\u062A \u06A9\u06D2 \u062C\u0648\u0627\u0628 \u062F\u06CC\u06BA",
      "attach.text.notMore": "%1 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0645\u062A\u0646 \u067E\u0691\u06BE\u06CC\u06BA \u0627\u0648\u0631 \u0686\u0646\u062F \u0633\u0648\u0627\u0644\u0627\u062A \u06A9\u06D2 \u062C\u0648\u0627\u0628\u0627\u062A \u062F\u06CC\u06BA",
      "attach.text.widgetHidden": "The question is hidden unless logic is activated",
      "attach.video.notLess": "\u06A9\u0645 \u0627\u0632 \u06A9\u0645 %1 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0648\u06CC\u0688\u06CC\u0648 \u062F\u06CC\u06A9\u06BE\u06CC\u06BA \u0627\u0648\u0631 \u0686\u0646\u062F \u0633\u0648\u0627\u0644\u0627\u062A \u06A9\u06D2 \u062C\u0648\u0627\u0628 \u062F\u06CC\u06BA",
      "attach.video.notMore": "%1 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0648\u06CC\u0688\u06CC\u0648 \u062F\u06CC\u06A9\u06BE\u06CC\u06BA \u0627\u0648\u0631 \u0686\u0646\u062F \u0633\u0648\u0627\u0644\u0627\u062A \u06A9\u06D2 \u062C\u0648\u0627\u0628 \u062F\u06CC\u06BA",
      "attach.video.waitEnd": "\u0648\u06CC\u0688\u06CC\u0648 \u06A9\u0648 \u0622\u062E\u0631 \u062A\u06A9 \u062F\u06CC\u06A9\u06BE\u06CC\u06BA \u0627\u0648\u0631 \u0686\u0646\u062F \u0633\u0648\u0627\u0644\u0627\u062A \u06A9\u06D2 \u062C\u0648\u0627\u0628 \u062F\u06CC\u06BA",
      "attach.watch": "\u062F\u06CC\u06A9\u06BE\u06CC\u06BA",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "Unsure",
      "commonComponents.choice.anythingElse": "\u06A9\u062C\u06BE \u0627\u0648\u0631...",
      "commonComponents.choice.chooseLessEqualMore": [
        "\u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA\u06D4%s \u062C\u0648\u0627\u0628",
        "\u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA\u06D4%s\u062C\u0648\u0627\u0628\u0627\u062A",
        "\u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA\u06D4 % \u062C\u0648\u0627\u0628\u0627\u062A",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "\u06A9\u0645 \u0627\u0632 \u06A9\u0645 %s \u062C\u0648\u0627\u0628 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA",
        "\u06A9\u0645 \u0627\u0632 \u06A9\u0645 %s \u062C\u0648\u0627\u0628\u0627\u062A \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA",
        "\u06A9\u0645 \u0627\u0632 \u06A9\u0645 %s \u062C\u0648\u0627\u0628\u0627\u062A \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "%s \u0633\u06D2 \u06A9\u0645 \u0627\u0648\u0631 %s \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u0646\u06C1 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA",
      "commonComponents.choice.chooseNoMore": [
        "\u0628\u0631\u0627\u0626\u06D2 \u0645\u06C1\u0631\u0628\u0627\u0646\u06CC \u0635\u0631\u0641 %s \u062C\u0648\u0627\u0628 \u06A9\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0631\u06CC\u06BA",
        "\u0628\u0631\u0627\u0626\u06D2 \u0645\u06C1\u0631\u0628\u0627\u0646\u06CC %s \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u062C\u0648\u0627\u0628\u0627\u062A \u06A9\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u0646\u06C1 \u06A9\u0631\u06CC\u06BA",
        "",
        ""
      ],
      "commonComponents.choice.enterText": "\u0645\u062A\u0646 \u062F\u0631\u062C \u06A9\u0631\u06CC\u06BA",
      "commonComponents.choice.yourComment": "\u0627\u067E\u0646\u0627 \u062A\u0628\u0635\u0631\u06C1 \u062F\u0631\u062C \u06A9\u0631\u06CC\u06BA...",
      "commonComponents.scale.chooseRate": "\u0628\u0631\u0627\u0626\u06D2 \u0645\u06C1\u0631\u0628\u0627\u0646\u06CC \u062F\u0631\u062C\u06C1 \u0628\u0646\u062F\u06CC \u06A9\u0631\u06CC\u06BA",
      "commonComponents.scale.firstElement": "\u067E\u06C1\u0644\u0627 \u0622\u067E\u0634\u0646  %s \u0645\u0637\u0644\u0628",
      "commonComponents.scale.lastElement": "\u0622\u062E\u0631\u06CC \u0622\u067E\u0634\u0646%s \u0645\u0637\u0644\u0628",
      "commonComponents.table.chooseNoMore": [
        "\u0627\u06CC\u06A9 \u0642\u0637\u0627\u0631 \u0645\u06CC\u06BA %s \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u062C\u0648\u0627\u0628 \u0646\u06C1 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA",
        "\u0644\u06AF\u0627\u062A\u0627\u0631 %s \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u062C\u0648\u0627\u0628 \u0646\u06C1 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA",
        "\u0644\u06AF\u0627\u062A\u0627\u0631 %s \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u062C\u0648\u0627\u0628 \u0646\u06C1 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA",
        ""
      ],
      "defaults.agree": "\u067E\u0648\u0631\u06CC \u0637\u0631\u062D \u0645\u062A\u0641\u0642",
      "defaults.back": "\u067E\u06CC\u0686\u06BE\u06D2",
      "defaults.datePlaceholder": "\u062A\u0627\u0631\u06CC\u062E\u06D4\u0645\u06C1\u06CC\u0646\u06C1\u06D4\u0633\u0627\u0644",
      "defaults.disagree": "\u0645\u06A9\u0645\u0644 \u0637\u0648\u0631 \u067E\u0631 \u0645\u062A\u0641\u0642 \u0646\u06C1\u06CC\u06BA",
      "defaults.dualChoice.label": "\u0686\u06CC\u06A9 \u0628\u0627\u06A9\u0633  ",
      "defaults.emoji1": "\u0646\u0627\u06AF\u0648\u0627\u0631",
      "defaults.emoji2": "\u0628\u0631\u0627",
      "defaults.emoji3": "\u0639\u0627\u0645",
      "defaults.emoji4": "\u0627\u0686\u06BE\u0627",
      "defaults.emoji5": "\u0632\u0628\u0631\u062F\u0633\u062A",
      "defaults.next": "\u0627\u06AF\u0644\u0627",
      "defaults.noAnswer": "\u0645\u0646\u062F\u0631\u062C\u06C1 \u0628\u0627\u0644\u0627 \u0645\u06CC\u06BA \u0633\u06D2 \u06A9\u0648\u0626\u06CC \u0628\u06BE\u06CC \u0646\u06C1\u06CC\u06BA",
      "defaults.noOpinionAnswer": "\u0628\u06D2 \u06CC\u0642\u06CC\u0646\u06CC",
      "defaults.otherAnswer": "\u062F\u06CC\u06AF\u0631",
      "defaults.otherAnswerWithText": "\u062F\u06CC\u06AF\u0631 (\u0645\u0641\u062A \u062C\u0648\u0627\u0628)",
      "defaults.template.age.label": "\u0622\u067E \u06A9\u06CC \u0639\u0645\u0631 \u06A9\u06CC\u0627 \u06C1\u06D2\u061F",
      "defaults.template.age.option.age_17_under": "18 \u0633\u06D2 \u06A9\u0645 \u0639\u0645\u0631",
      "defaults.template.age.option.age_18_24": "18 \u0633\u06D2 24 \u0633\u0627\u0644",
      "defaults.template.age.option.age_25_34": "25 \u0633\u06D2 34 \u0633\u0627\u0644",
      "defaults.template.age.option.age_35_44": "35 \u0633\u06D2 44 \u0633\u0627\u0644",
      "defaults.template.age.option.age_45_54": "45 \u0633\u06D2 54 \u0633\u0627\u0644",
      "defaults.template.age.option.age_55_over": "55 \u0633\u0627\u0644 \u06CC\u0627 \u0627\u0633 \u0633\u06D2 \u0632\u0627\u0626\u062F",
      "defaults.template.sex.label": "\u0622\u067E \u06A9\u06CC \u062C\u0646\u0633 \u06A9\u06CC\u0627 \u06C1\u06D2\u061F",
      "defaults.template.sex.option.sex_female": "\u0639\u0648\u0631\u062A",
      "defaults.template.sex.option.sex_male": "\u0645\u0631\u062F",
      "defaults.widget.label": "Text",
      "errors.page.default": "\u0627\u0641\u0648\u06C1\u060C \u0627\u06CC\u06A9 \u0646\u0642\u0635 \u0648\u0627\u0642\u0639 \u06C1\u0648\u0627 \u06C1\u06D2",
      "errors.page.notFound": "\u0635\u0641\u062D\u06C1 \u0646\u06C1\u06CC\u06BA \u0645\u0644\u0627",
      "errors.server.default": "\u0633\u0631\u0648\u0631 \u06A9\u0627 \u0646\u0642\u0635",
      "errors.survey.alreadyFinished": "\u0622\u067E \u06CC\u06C1 \u0633\u0631\u0648\u06D2 \u067E\u06C1\u0644\u06D2 \u06C1\u06CC \u0645\u06A9\u0645\u0644 \u06A9\u0631 \u0686\u06A9\u06D2 \u06C1\u06CC\u06BA",
      "errors.survey.closed": "\u0628\u062F\u0642\u0633\u0645\u062A\u06CC \u0633\u06D2\u060C \u06CC\u06C1 \u062A\u062D\u0642\u06CC\u0642 \u062E\u062A\u0645 \u06C1\u0648 \u06AF\u0626\u06CC \u06C1\u06D2",
      "errors.survey.notFound": "\u0635\u0641\u062D\u06C1 \u0646\u06C1\u06CC\u06BA \u0645\u0644\u0627",
      "errors.survey.paused": "\u0633\u0631\u0648\u06D2 \u0631\u0648\u06A9 \u062F\u06CC\u0627 \u06AF\u06CC\u0627",
      "final.thanks": "\u0622\u067E \u06A9\u0627 \u0634\u06A9\u0631\u06CC\u06C1!",
      "footer.default.confidential.text": "\u0631\u0627\u0632\u062F\u0627\u0631\u0627\u0646\u06C1",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "\u0631\u0627\u0632\u062F\u0627\u0631\u06CC",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.default.copyright.text": "\xA9 %s Yandex",
      "footer.default.copyrightInternal.text": "\xA9 %s Yandex",
      "footer.default.createby.text": "\u06CC\u06C1 \u0633\u0631\u0648\u06D2 Yandex Surveys \u0679\u06CC\u06A9\u0646\u0627\u0644\u0648\u062C\u06CC\u0632 \u06A9\u06CC \u062C\u0627\u0646\u0628 \u0633\u06D2 \u062A\u0642\u0648\u06CC\u062A \u06CC\u0627\u0641\u062A\u06C1 \u06C1\u06D2",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Yandex \u06A9\u0627 \u0627\u0646\u062F\u0631\u0648\u0646\u06CC \u0633\u0631\u0648\u06D2",
      "footer.default.responsibility": "\u06A9\u0686\u06BE \u0633\u0631\u0648\u06D2 \u0641\u0631\u06CC\u0642 \u062B\u0627\u0644\u062B \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06C1 \u062A\u062E\u0644\u06CC\u0642 \u06A9\u06CC\u06D2 \u062C\u0627\u062A\u06D2 \u06C1\u06CC\u06BA\u06D4 Yandex \u0627\u0646 \u06A9\u06D2 \u0645\u0648\u0627\u062F \u06A9\u06CC \u062C\u0627\u0646\u0686 \u06CC\u0627 \u062A\u0648\u062B\u06CC\u0642 \u0646\u06C1\u06CC\u06BA \u06A9\u0631\u062A\u0627 \u0627\u0648\u0631 \u0646\u06C1 \u06C1\u06CC \u0627\u0646 \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u0648\u0626\u06CC \u0630\u0645\u06C1 \u062F\u0627\u0631\u06CC \u0642\u0628\u0648\u0644 \u06A9\u0631\u062A\u0627 \u06C1\u06D2\u06D4",
      "footer.default.termsofuse.text": "\u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC \u0634\u0631\u0627\u0626\u0637",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/?lang=en",
      "footer.odnaco.confpolicy.text": "\u0631\u0627\u0632\u062F\u0627\u0631\u06CC",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=en",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "\u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC \u0634\u0631\u0627\u0626\u0637",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/en.html",
      "info.survey.thanks": "\u0633\u0631\u0648\u06D2 \u0645\u06A9\u0645\u0644 \u06C1\u0648 \u06AF\u06CC\u0627 \u06C1\u06D2\u06D4 \u0634\u06A9\u0631\u06CC\u06C1!",
      "labels.columnHidden": "The column is hidden until logic is activated",
      "labels.hiddenQuestionsActivated": "Hidden questions are displayed",
      "labels.hiddenQuestionsDeactivated": "Hidden questions are hidden",
      "labels.optionHidden": "The answer is hidden until logic is activated",
      "labels.page": "Page",
      "labels.questionHidden": "The question is hidden unless logic is activated",
      "labels.rotationGroup": "Group",
      "labels.rowHidden": "The row is hidden until logic is activated",
      "labels.screening": "Screening question",
      "labels.showHiddenQuestions": "Show hidden questions",
      "labels.widgetHidden": "The text is hidden until logic is activated",
      "page.buttonBack": "\u067E\u06CC\u0686\u06BE\u06D2",
      "page.buttonNext": "\u0627\u06AF\u0644\u0627",
      "page.buttonSkip": "\u0686\u06BE\u0648\u0691\u06CC\u06BA",
      "page.title": "\u0633\u0631\u0648\u06D2 \u06A9\u0631\u06CC\u06BA",
      "page.watermark": "\u067E\u06CC\u0634\u0650 \u0645\u0646\u0638\u0631 \u06A9\u06D2 \u062C\u0648\u0627\u0628\u0627\u062A \u06A9\u0648 \u0634\u0645\u0627\u0631 \u0646\u06C1\u06CC\u06BA \u06A9\u06CC\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2 \u067E\u06CC\u0634\u0650 \u0645\u0646\u0638\u0631 \u06A9\u06D2 \u062C\u0648\u0627\u0628\u0627\u062A \u06A9\u0648 \u0634\u0645\u0627\u0631 \u0646\u06C1\u06CC\u06BA \u06A9\u06CC\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2 \u067E\u06CC\u0634\u0650 \u0645\u0646\u0638\u0631 \u06A9\u06D2 \u062C\u0648\u0627\u0628\u0627\u062A \u06A9\u0648 \u0634\u0645\u0627\u0631 \u0646\u06C1\u06CC\u06BA \u06A9\u06CC\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2",
      "placeholders.longText": "\u0627\u067E\u0646\u0627 \u062A\u0628\u0635\u0631\u06C1 \u062F\u0631\u062C \u06A9\u0631\u06CC\u06BA",
      "placeholders.shortText": "\u0627\u067E\u0646\u0627 \u062A\u0628\u0635\u0631\u06C1 \u062F\u0631\u062C \u06A9\u0631\u06CC\u06BA",
      "plural.answers.im": [
        "\u062C\u0648\u0627\u0628",
        "\u062C\u0648\u0627\u0628\u0627\u062A",
        "\u062C\u0648\u0627\u0628\u0627\u062A",
        "\u062C\u0648\u0627\u0628\u0627\u062A"
      ],
      "plural.answers.ro": [
        "\u062C\u0648\u0627\u0628",
        "\u062C\u0648\u0627\u0628\u0627\u062A",
        "\u062C\u0648\u0627\u0628\u0627\u062A",
        "\u062C\u0648\u0627\u0628\u0627\u062A"
      ],
      "plural.ratingStars.labels": [
        "\u0633\u062A\u0627\u0631\u06C1",
        "\u0633\u062A\u0627\u0631\u06D2",
        "\u0633\u062A\u0627\u0631\u06D2",
        ""
      ],
      "plural.seconds.im": [
        "\u0633\u06CC\u06A9\u0646\u0688",
        "\u0633\u06CC\u06A9\u0646\u0688\u0632",
        "\u0633\u06CC\u06A9\u0646\u0688\u0632",
        "\u0633\u06CC\u06A9\u0646\u0688\u0632"
      ],
      "plural.seconds.ro": [
        "\u0633\u06CC\u06A9\u0646\u0688\u0632",
        "\u0633\u06CC\u06A9\u0646\u0688\u0632",
        "\u0633\u06CC\u06A9\u0646\u0688\u0632",
        "\u0633\u06CC\u06A9\u0646\u0688\u0632"
      ],
      "questionModel.awful": "\u0646\u0627\u06AF\u0648\u0627\u0631",
      "questionModel.bad": "\u0628\u0631\u0627",
      "questionModel.dateLessThan": "\u062A\u0627\u0631\u06CC\u062E %s \u0633\u06D2 \u067E\u06C1\u0644\u06D2 \u06A9\u06CC \u0646\u06C1\u06CC\u06BA \u06C1\u0648 \u0633\u06A9\u062A\u06CC",
      "questionModel.dateMoreThan": "\u062A\u0627\u0631\u06CC\u062E %s \u0633\u06D2 \u0628\u0639\u062F \u06A9\u06CC \u0646\u06C1\u06CC\u06BA \u06C1\u0648 \u0633\u06A9\u062A\u06CC",
      "questionModel.datePlaceholder": "Select a date",
      "questionModel.insufficientAnswers": [
        "\u0622\u067E \u0646\u06D2 %s \u0633\u06D2 \u06A9\u0645 \u062C\u0648\u0627\u0628 \u0645\u0646\u062A\u062E\u0628 \u06A9\u06CC\u0627 \u06C1\u06D2",
        "\u0622\u067E \u0646\u06D2 %s \u0633\u06D2 \u06A9\u0645 \u062C\u0648\u0627\u0628 \u0645\u0646\u062A\u062E\u0628 \u06A9\u06CC\u0627 \u06C1\u06D2",
        "\u0622\u067E \u0646\u06D2 %s \u0633\u06D2 \u06A9\u0645 \u062C\u0648\u0627\u0628 \u0645\u0646\u062A\u062E\u0628 \u06A9\u06CC\u0627 \u06C1\u06D2",
        ""
      ],
      "questionModel.lessThan": "\u0639\u062F\u062F %s \u0633\u06D2 \u06A9\u0645 \u0646\u06C1\u06CC\u06BA \u06C1\u0648 \u0633\u06A9\u062A\u0627 \u06C1\u06D2",
      "questionModel.maxAnswerPerRowExceeded": "\u0622\u067E \u0646\u06D2 \u0644\u06AF\u0627\u062A\u0627\u0631 \u062C\u0648\u0627\u0628\u0627\u062A \u06A9\u06CC \u0632\u06CC\u0627\u062F\u06C1 \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u062A\u0639\u062F\u0627\u062F \u06A9\u0648 \u0639\u0628\u0648\u0631 \u06A9\u0631 \u0644\u06CC\u0627 \u06C1\u06D2",
      "questionModel.maxLenghtExceeded": "\u062D\u0631\u0648\u0641 \u06A9\u06CC \u062D\u062F \u0633\u06D2 \u062A\u062C\u0627\u0648\u0632 \u06A9\u0631 \u06AF\u06CC\u0627\u06D4  \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u0627 \u062C\u0648\u0627\u0628 \u0645\u062E\u062A\u0635\u0631 \u06A9\u0631\u06CC\u06BA\u06D4",
      "questionModel.moreThan": "\u0639\u062F\u062F %s \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u0646\u06C1\u06CC\u06BA \u06C1\u0648 \u0633\u06A9\u062A\u0627 \u06C1\u06D2",
      "questionModel.normally": "\u0639\u0627\u0645",
      "questionModel.notDate": "\u063A\u0644\u0637 \u062A\u0627\u0631\u06CC\u062E",
      "questionModel.notEmail": "\u0627\u06CC \u0645\u06CC\u0644 \u0641\u0627\u0631\u0645\u06CC\u0679 \u0644\u0627\u0632\u0645\u0627\u064B \u0645\u0645\u0627\u062B\u0644 \u06C1\u0648\u0646\u0627 \u0686\u0627\u06C1\u0626\u06CC\u06D2",
      "questionModel.notFilled": "\u0628\u0631\u0627\u0626\u06D2 \u0645\u06C1\u0631\u0628\u0627\u0646\u06CC \u0627\u067E\u0646\u0627 \u062C\u0648\u0627\u0628 \u06CC\u06C1\u0627\u06BA \u062F\u0631\u062C \u06A9\u0631\u06CC\u06BA",
      "questionModel.notNumber": "\u0635\u0631\u0641 \u0627\u0639\u062F\u0627\u062F \u067E\u0631 \u0645\u0634\u062A\u0645\u0644 \u06C1\u0648 \u0633\u06A9\u062A\u0627 \u06C1\u06D2",
      "questionModel.perfectly": "\u0632\u0628\u0631\u062F\u0633\u062A",
      "questionModel.picture": "\u062A\u0635\u0648\u06CC\u0631 %s",
      "questionModel.requiredField": "\u0628\u0631\u0627\u0626\u06D2 \u0645\u06C1\u0631\u0628\u0627\u0646\u06CC \u0627\u0633 \u0633\u0648\u0627\u0644 \u06A9\u0648 \u062C\u0648\u0627\u0628 \u062F\u0626\u06CC\u06D2 \u0628\u063A\u06CC\u0631 \u0645\u062A \u0686\u06BE\u0648\u0691\u06CC\u06BA",
      "questionModel.tooManyAnswers": [
        "%s \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u062C\u0648\u0627\u0628 \u06A9\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u06CC\u0627 \u06AF\u06CC\u0627",
        "%s \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u062C\u0648\u0627\u0628\u0627\u062A \u06A9\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u06CC\u0627 \u06AF\u06CC\u0627",
        "",
        ""
      ],
      "questionModel.well": "\u0627\u0686\u06BE\u0627",
      "sidebyside.option": "\u0627\u062E\u062A\u06CC\u0627\u0631 %s",
      "templates.options.age.age18_24": "18 \u0633\u06D2 24 \u0633\u0627\u0644",
      "templates.options.age.age25_34": "25 \u0633\u06D2 34 \u0633\u0627\u0644",
      "templates.options.age.age35_44": "35 \u0633\u06D2 44 \u0633\u0627\u0644",
      "templates.options.age.age45_54": "45 \u0633\u06D2 54 \u0633\u0627\u0644",
      "templates.options.age.age55_over": "55 \u0633\u0627\u0644 \u06CC\u0627 \u0627\u0633 \u0633\u06D2 \u0632\u0627\u0626\u062F",
      "templates.options.sex.sex_female": "\u0639\u0648\u0631\u062A",
      "templates.options.sex.sex_male": "\u0645\u0631\u062F",
      "templates.questions.age": "\u0622\u067E \u06A9\u06CC \u0639\u0645\u0631 \u06A9\u06CC\u0627 \u06C1\u06D2\u061F",
      "templates.questions.sex": "\u0622\u067E \u06A9\u06CC \u062C\u0646\u0633 \u06A9\u06CC\u0627 \u06C1\u06D2\u061F",
      "ux.stepPaginator.stepTitle": "\u0645\u0631\u062D\u0644\u06C1%s \u06A9\u0627%s",
      "video.holdBtn": "\u062C\u0628 \u0622\u067E \u0628\u0631\u0627\u0646\u0688 \u06A9\u0648 \u062F\u06CC\u06A9\u06BE\u06CC\u06BA \u062A\u0648 \u062F\u0628\u0627 \u06A9\u0631 \u062F\u0628\u0627\u0626\u06D2 \u0631\u06A9\u06BE\u06CC\u06BA",
      "video.statusBarTitle": "\u0628\u0631\u0627\u0646\u0688 %1 \u0633\u06CC\u06A9\u0646\u0688 \u0633\u06D2 %2 \u0633\u06CC\u06A9\u0646\u0688 \u062A\u06A9 \u062F\u06A9\u06BE\u0627\u0626\u06CC \u062F\u06D2 \u0631\u06C1\u0627 \u062A\u06BE\u0627"
    }
  },
  uz: {
    poll: {
      "attach.image.notLess": "Rasmni kamida %1 marta ko\u2019ring va bir nechta savolga javob bering",
      "attach.image.notMore": "Rasmni %1 davomida ko\u2019ring va bir nechta savolga javob bering",
      "attach.text.notLess": "Matnni kamida %1 marta ko\u2019ring va bir nechta savolga javob bering",
      "attach.text.notMore": "Matnni kamida %1 marta o\u2019qing va bir nechta savolga javob bering",
      "attach.text.widgetHidden": "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "attach.video.notLess": "Videorolikni kamida %1 marta ko\u2019ring va bir nechta savolga javob bering",
      "attach.video.notMore": "Videorolikni %1 davomida ko\u2019ring va bir nechta savolga javob bering",
      "attach.video.waitEnd": "Videorolikni oxirigacha ko\u2019ring va bir nechta savolga javob bering",
      "attach.watch": "Ko\u2019rish",
      "brandlift.defaults.invitation.choices": [
        "\u041F\u043E\u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E",
        "\u0412 \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437",
        null,
        null
      ],
      "brandlift.defaults.invitation.label": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u043D\u0430 3 \u0432\u043E\u043F\u0440\u043E\u0441\u0430.",
      "brandlift.defaults.invitation.labelTomOnly": "\u0412\u0430\u0448\u0438 \u043E\u0442\u0432\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0441\u0442\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u044E\u0449\u0438\u043C\u0438. \u041E\u0442\u0432\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435\u0433\u043E \u043D\u0430 1 \u0432\u043E\u043F\u0440\u043E\u0441.",
      "brandlift.defaults.noOpinionAnswerTom": "\u041D\u0435 \u043C\u043E\u0433\u0443 \u043D\u0430\u0437\u0432\u0430\u0442\u044C",
      "commonComponents.choice.anythingElse": "Yana nimadir...",
      "commonComponents.choice.chooseLessEqualMore": [
        "%s ta javobni tanlang",
        "%s ta javobni tanlang",
        "% ta javobni tanlang",
        ""
      ],
      "commonComponents.choice.chooseNoLess": [
        "Kamida %s ta javobni tanlang",
        "Kamida %s ta javobni tanlang",
        "Kamida %s ta javobni tanlang",
        ""
      ],
      "commonComponents.choice.chooseNoLessNoMore": "Kamida %s ta va maksimal %s ta",
      "commonComponents.choice.chooseNoMore": [
        "Maksimal %s ta javobni tanlang",
        "Maksimal %s ta javobni tanlang",
        "Maksimal %s ta javobni tanlang",
        ""
      ],
      "commonComponents.choice.enterText": "Matnni kiriting",
      "commonComponents.choice.yourComment": "Sizning sharhingiz...",
      "commonComponents.scale.chooseRate": "Bahoni tanlang",
      "commonComponents.scale.firstElement": "Birinchi chetki %s varianti anglatadi",
      "commonComponents.scale.lastElement": "Oxirgi chetki %s varianti anglatadi",
      "commonComponents.table.chooseNoMore": [
        "Qatordagi maksimal %s ta javobni tanlang",
        "Qatordagi maksimal %s ta javobni tanlang",
        "Qatordagi maksimal %s ta javobni tanlang",
        ""
      ],
      "defaults.agree": "To\u02BBliq qo\u02BBshilaman",
      "defaults.back": "Orqaga",
      "defaults.datePlaceholder": "kk.oo.yyyy",
      "defaults.disagree": "Mutlaqo qo\u02BBshilmayman",
      "defaults.dualChoice.label": "Belgilash katagi",
      "defaults.emoji1": "Rasvo",
      "defaults.emoji2": "Yomon",
      "defaults.emoji3": "O\u2019rtacha",
      "defaults.emoji4": "Yaxshi",
      "defaults.emoji5": "A\u2019lo",
      "defaults.next": "Keyingisi",
      "defaults.noAnswer": "Sanalganlardan hech qaysinisi",
      "defaults.noOpinionAnswer": "Javob berishim qiyin",
      "defaults.otherAnswer": "Boshqa",
      "defaults.otherAnswerWithText": "Boshqa (o\u02BBz variantingizni yozing)",
      "defaults.template.age.label": "Necha yoshdasiz",
      "defaults.template.age.option.age_17_under": "18 yoshdan kichik",
      "defaults.template.age.option.age_18_24": "18-24 yosh",
      "defaults.template.age.option.age_25_34": "25-34 yosh",
      "defaults.template.age.option.age_35_44": "35-44 yosh",
      "defaults.template.age.option.age_45_54": "45-54 yosh",
      "defaults.template.age.option.age_55_over": "55 yosh va undan katta",
      "defaults.template.sex.label": "Jinsingiz",
      "defaults.template.sex.option.sex_female": "Ayol",
      "defaults.template.sex.option.sex_male": "Erkak",
      "defaults.widget.label": "\u0422\u0435\u043A\u0441\u0442",
      "errors.page.default": "Xatolik yuz berdi :(",
      "errors.page.notFound": "Sahifa topilmadi",
      "errors.server.default": "Serverda xatolik",
      "errors.survey.alreadyFinished": "Siz bu so\u2019rovnomani yakunladingiz",
      "errors.survey.closed": "Afsuski, tadqiqot yakunlandi",
      "errors.survey.notFound": "Sahifa topilmadi",
      "errors.survey.paused": "So\u2019rovnoma to\u2019xtatildi",
      "final.thanks": "Rahmat!",
      "footer.default.confidential.text": "Sir saqlanadi",
      "footer.default.confidential.url": "https://wiki.yandex-team.ru/security/nda/",
      "footer.default.confpolicy.text": "Maxfiylik",
      "footer.default.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.default.copyright.text": "\xA9 %s  \u201CYandex\u201D MCHJ",
      "footer.default.copyrightInternal.text": "\xA9 %s \u041E\u041E\u041E \u201CYandex\u201D",
      "footer.default.createby.text": "So\u02BBrovnoma Yandex Survey texnologiyasi asosida ishlab chiqilgan",
      "footer.default.createby.url": "https://surveys.yandex-team.ru/landing",
      "footer.default.internalSurvey": "Yandex ichki so\u02BBrovi",
      "footer.default.responsibility": "Yandexning uchinchi shaxslar tomonidan yaratilgan so\u2019rovnomalarga aloqasi yo\u2019q va ularning mazmuni uchun javobgarlikni zimmasiga olmaydi.",
      "footer.default.termsofuse.text": "Foydalanish shartlari",
      "footer.default.termsofuse.url": "https://yandex.ru/legal/poll/",
      "footer.odnaco.confpolicy.text": "Maxfiylik siyosati",
      "footer.odnaco.confpolicy.url": "https://yandex.ru/legal/confidential/?lang=ru",
      "footer.odnaco.copyright.text": "",
      "footer.odnaco.responsibility": "",
      "footer.odnaco.termsofuse.text": "Foydalanuvchi bilan kelishuv",
      "footer.odnaco.termsofuse.url": "https://odna.co/termsofuse/index.html",
      "info.survey.thanks": "So\u2019rovnoma yakunlandi. Rahmat!",
      "labels.columnHidden": "\u0421\u0442\u043E\u043B\u0431\u0435\u0446 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.hiddenQuestionsActivated": "\u0421\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u044E\u0442\u0441\u044F",
      "labels.hiddenQuestionsDeactivated": "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0441\u043A\u0440\u044B\u0442\u044B\u0445 \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432 \u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
      "labels.optionHidden": "\u041E\u0442\u0432\u0435\u0442 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.page": "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
      "labels.questionHidden": "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.rotationGroup": "\u0413\u0440\u0443\u043F\u043F\u0430",
      "labels.rowHidden": "\u0421\u0442\u0440\u043E\u043A\u0430 \u0441\u043A\u0440\u044B\u0442\u0430 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "labels.screening": "\u0421\u043A\u0440\u0438\u043D\u0438\u0440\u0443\u044E\u0449\u0438\u0439 \u0432\u043E\u043F\u0440\u043E\u0441",
      "labels.showHiddenQuestions": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u043A\u0440\u044B\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
      "labels.widgetHidden": "\u0422\u0435\u043A\u0441\u0442 \u0441\u043A\u0440\u044B\u0442 \u0434\u043E \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043B\u043E\u0433\u0438\u043A\u0438",
      "page.buttonBack": "Orqaga",
      "page.buttonNext": "Keyingisi",
      "page.buttonSkip": "O\u2019tkazib yuborish",
      "page.title": "So\u2019rovnomadan o\u2019tish",
      "page.watermark": "JAVOBLARGA RAZM SOLISH HISOBGA OLINMAYDI JAVOBLARGA RAZM SOLISH HISOBGA OLINMAYDI JAVOBLARGA RAZM SOLISH HISOBGA OLINMAYDI",
      "placeholders.longText": "Sizning sharhingiz",
      "placeholders.shortText": "Sizning sharhingiz",
      "plural.answers.im": [
        "ta javob",
        "ta javob",
        "ta javob",
        "ta javob"
      ],
      "plural.answers.ro": [
        "ta javob",
        "ta javob",
        "ta javob",
        "ta javob"
      ],
      "plural.ratingStars.labels": [
        "ta yulduz",
        "ta yulduz",
        "ta yulduz",
        ""
      ],
      "plural.seconds.im": [
        "soniya",
        "soniya",
        "soniya",
        "soniya"
      ],
      "plural.seconds.ro": [
        "soniya",
        "soniya",
        "soniya",
        "soniya"
      ],
      "questionModel.awful": "Rasvo",
      "questionModel.bad": "Yomon",
      "questionModel.dateLessThan": "Sana %s dan oldin bo\u02BBlishi mumkin emas",
      "questionModel.dateMoreThan": "Sana %s dan keyin bo\u02BBlishi mumkin emas",
      "questionModel.datePlaceholder": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u0442\u0443",
      "questionModel.insufficientAnswers": [
        "Siz %s tadan kam javobni tanladingiz",
        "Siz %s tadan kam javobni tanladingiz",
        "Siz %s tadan kam javobni tanladingiz",
        ""
      ],
      "questionModel.lessThan": "Son %s dan kichik bo\u2019lmasin",
      "questionModel.maxAnswerPerRowExceeded": "Qatordagi maksimal ruxsat berilgan javoblar sonidan oshib ketdi",
      "questionModel.maxLenghtExceeded": "Belgilar soni maksimal chegaradan oshib ketdi, matnni qisqartiring",
      "questionModel.moreThan": "Son %s dan katta bo\u2019lmasin",
      "questionModel.normally": "O\u2019rtacha",
      "questionModel.notDate": "Xato sana kiritildi",
      "questionModel.notEmail": "Elektron pochta formatiga mos kelsin",
      "questionModel.notFilled": "Matnni kiritish lozim",
      "questionModel.notNumber": "Faqat raqamlarni kiritish mumkin",
      "questionModel.perfectly": "A\u2019lo",
      "questionModel.picture": "Rasm %s",
      "questionModel.requiredField": "Bu savolni javobsiz qoldirmang",
      "questionModel.tooManyAnswers": [
        "Siz %s tadan ko\u2019p javobni tanladingiz",
        "Siz %s tadan ko\u2019p javobni tanladingiz",
        "Siz %s tadan ko\u2019p javobni tanladingiz",
        ""
      ],
      "questionModel.well": "Yaxshi",
      "sidebyside.option": "Variant %s",
      "templates.options.age.age18_24": "18-24 yosh",
      "templates.options.age.age25_34": "25-34 yosh",
      "templates.options.age.age35_44": "35-44 yosh",
      "templates.options.age.age45_54": "45-54 yosh",
      "templates.options.age.age55_over": "55 yosh va undan katta",
      "templates.options.sex.sex_female": "Ayol",
      "templates.options.sex.sex_male": "Erkak",
      "templates.questions.age": "Necha yoshdasiz",
      "templates.questions.sex": "Jinsingiz",
      "ux.stepPaginator.stepTitle": "Qadam: %s/%s",
      "video.holdBtn": "Brend ko\u2019rinmaguncha bosib turing",
      "video.statusBarTitle": "Brend %1 soniyadan %2 soniyagacha ko\u2019rindi"
    }
  }
};

// src/i18n/translations.ts
var { unflatten } = _flat2.default;
var translations_default = Object.keys(surveys_default).reduce((acc, lang) => {
  acc[lang] = unflatten(surveys_default[lang].poll);
  return acc;
}, {});

// src/i18n/index.ts
function getKey(data, path, count) {
  try {
    const value = path.reduce((prev, curr) => {
      return prev[curr];
    }, data);
    if (value === void 0) {
      throw new Error();
    }
    if (count !== void 0) {
      count = Math.abs(count);
      const pluralizer = get_pluralized_form_default[i18n.lang] || get_pluralized_form_default.default;
      const formIndex = pluralizer(count);
      return value[formIndex];
    }
    return value;
  } catch (e) {
    throw new Error(`Not value for translation: ${path.join(" -> ")}`);
  }
}
function i18n(prefix) {
  return function(args = [], count) {
    return getKey(i18n.translations, [].concat.call([i18n.lang], prefix, args), count);
  };
}
i18n.translations = translations_default;
i18n.setLang = function setLang(lang) {
  i18n.lang = lang;
};



exports.i18n = i18n;
//# sourceMappingURL=chunk-R624SQFF.js.map